/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 234);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(43)('wks');
var uid = __webpack_require__(32);
var Symbol = __webpack_require__(2).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(92);
var isBuffer = __webpack_require__(188);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(1);
var ctx = __webpack_require__(23);
var hide = __webpack_require__(17);
var has = __webpack_require__(18);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(28);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(174);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(178);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(28);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(106);


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onError", function() { return onError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observer", function() { return observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Observer", function() { return Observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderReporter", function() { return renderReporter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentByNodeRegistery", function() { return componentByNodeRegistery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trackComponents", function() { return trackComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStaticRendering", function() { return useStaticRendering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// These functions can be stubbed out in specific environments
var unstable_batchedUpdates$1 = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
    function EventEmitter() {
        classCallCheck(this, EventEmitter);
        this.listeners = [];
    }

    createClass(EventEmitter, [{
        key: "on",
        value: function on(cb) {
            var _this = this;

            this.listeners.push(cb);
            return function () {
                var index = _this.listeners.indexOf(cb);
                if (index !== -1) _this.listeners.splice(index, 1);
            };
        }
    }, {
        key: "emit",
        value: function emit(data) {
            this.listeners.forEach(function (fn) {
                return fn(data);
            });
        }
    }]);
    return EventEmitter;
}();

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
            rest[_key - 6] = arguments[_key];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else {
                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
            }
        });
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") {
        return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") {
        return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
    }

    return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
    if (Array.isArray(propValue)) {
        return "array";
    }
    if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
    }
    if (isSymbol(propType, propValue)) {
        return "symbol";
    }
    return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) {
            return "date";
        } else if (propValue instanceof RegExp) {
            return "regexp";
        }
    }
    return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker = void 0;
            switch (mobxType) {
                case "Array":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableArray"];
                    break;
                case "Object":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableObject"];
                    break;
                case "Map":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableMap"];
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
            rest[_key2 - 5] = arguments[_key2];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            }
            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
            if (error instanceof Error) return error;
            var propValue = props[propName];
            for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
            }
            return null;
        });
    });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
    mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
    contextTypes: {
        get: function get$$1() {
            return injectorContextTypes;
        },
        set: function set$$1(_) {
            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
        },
        configurable: true,
        enumerable: false
    },
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }

    /**
     * Store Injection
     */
};function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp2;

    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
    if (injectNames) displayName += "-with-" + injectNames;

    var Injector = (_temp2 = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            var _ref;

            var _temp, _this, _ret;

            classCallCheck(this, Injector);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(Injector, [{
            key: "render",
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key2 in additionalProps) {
                    newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                    newProps.ref = this.storeRef;
                }

                return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, newProps);
            }
        }]);
        return Injector;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = displayName, _temp2);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === "function") {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // supress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
        };
    }
}

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function findDOMNode$2(component) {
    if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
        } catch (e) {
            // findDOMNode will throw in react-test-renderer, see:
            // See https://github.com/mobxjs/mobx-react/issues/216
            // Is there a better heuristic?
            return null;
        }
    }
    return null;
}

function reportRendering(component) {
    var node = findDOMNode$2(component);
    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);

    renderReporter.emit({
        event: "render",
        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
        totalTime: Date.now() - component.__$mobRenderStart,
        component: component,
        node: node
    });
}

function trackComponents() {
    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillMount: function componentWillMount() {
        var _this = this;

        if (isUsingStaticRendering === true) return;
        // Generate friendly name for debugging
        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;

        /**
         * If props are shallowly modified, react will render anyway,
         * so atom.reportChanged() should not result in yet another re-render
         */
        var skipRender = false;
        /**
         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
         * so detect these changes
         */
        var isForcingUpdate = false;

        function makePropertyObservableReference(propName) {
            var valueHolder = this[propName];
            var atom = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Atom"]("reactive " + propName);
            Object.defineProperty(this, propName, {
                configurable: true,
                enumerable: true,
                get: function get$$1() {
                    atom.reportObserved();
                    return valueHolder;
                },
                set: function set$$1(v) {
                    if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
                        valueHolder = v;
                        skipRender = true;
                        atom.reportChanged();
                        skipRender = false;
                    } else {
                        valueHolder = v;
                    }
                }
            });
        }

        // make this.props an observable reference, see #124
        makePropertyObservableReference.call(this, "props");
        // make state an observable reference
        makePropertyObservableReference.call(this, "state");

        // wire up reactive render
        var baseRender = this.render.bind(this);
        var reaction = null;
        var isRenderingPending = false;

        var initialRender = function initialRender() {
            reaction = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Reaction"](initialName + "#" + rootNodeID + ".render()", function () {
                if (!isRenderingPending) {
                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                    // See #85 / Pull #44
                    isRenderingPending = true;
                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
                    if (_this.__$mobxIsUnmounted !== true) {
                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                        // However, people also claim this migth happen during unit tests..
                        var hasError = true;
                        try {
                            isForcingUpdate = true;
                            if (!skipRender) __WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.forceUpdate.call(_this);
                            hasError = false;
                        } finally {
                            isForcingUpdate = false;
                            if (hasError) reaction.dispose();
                        }
                    }
                }
            });
            reaction.reactComponent = _this;
            reactiveRender.$mobx = reaction;
            _this.render = reactiveRender;
            return reactiveRender();
        };

        var reactiveRender = function reactiveRender() {
            isRenderingPending = false;
            var exception = undefined;
            var rendering = undefined;
            reaction.track(function () {
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderStart = Date.now();
                }
                try {
                    rendering = __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].allowStateChanges(false, baseRender);
                } catch (e) {
                    exception = e;
                }
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderEnd = Date.now();
                }
            });
            if (exception) {
                errorsReporter.emit(exception);
                throw exception;
            }
            return rendering;
        };

        this.render = initialRender;
    },

    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) return;
        this.render.$mobx && this.render.$mobx.dispose();
        this.__$mobxIsUnmounted = true;
        if (isDevtoolsEnabled) {
            var node = findDOMNode$2(this);
            if (node && componentByNodeRegistery) {
                componentByNodeRegistery.delete(node);
            }
            renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
            });
        }
    },

    componentDidMount: function componentDidMount() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return !shallowEqual(this.props, nextProps);
    }

    /**
     * Observer function / decorator
     */
};function observer(arg1, arg2) {
    if (typeof arg1 === "string") {
        throw new Error("Store names should be provided as array");
    }
    if (Array.isArray(arg1)) {
        // component needs stores
        if (!warnedAboutObserverInjectDeprecation) {
            warnedAboutObserverInjectDeprecation = true;
            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
        }
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return observer(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(observer(arg2));
        }
    }
    var componentClass = arg1;

    if (componentClass.isMobxInjector === true) {
        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    }

    // Stateless function component:
    // If it is function but doesn't seem to be a react class constructor,
    // wrap it to a react class automatically
    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_1_react__["Component"].isPrototypeOf(componentClass)) {
        var _class, _temp;

        return observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: "render",
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    }

    if (!componentClass) {
        throw new Error("Please pass a valid component to 'observer'");
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    return componentClass;
}

function mixinLifecycleEvents(target) {
    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
        patch(target, funcName);
    });
    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    }
}

// TODO: support injection somehow as well?
var Observer = observer(function (_ref) {
    var children = _ref.children,
        observerInject = _ref.inject,
        render = _ref.render;

    var component = children || render;
    if (typeof component === "undefined") {
        return null;
    }
    if (!observerInject) {
        return component();
    }
    var InjectComponent = inject(observerInject)(component);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InjectComponent, null);
});

Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
    }

    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
        return;
    }
    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
    render: ObserverPropsCheck,
    children: ObserverPropsCheck
};

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
    inherits(Provider, _Component);

    function Provider() {
        classCallCheck(this, Provider);
        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    createClass(Provider, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) for (var key in baseStores) {
                stores[key] = baseStores[key];
            }
            // add own stores
            for (var _key in this.props) {
                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
            }return {
                mobxStores: stores
            };
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
            }
        }
    }]);
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.contextTypes = {
    mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
    mobxStores: objectOrObservableObject.isRequired
}, _temp);

if (!__WEBPACK_IMPORTED_MODULE_1_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_0_mobx__["extras"]) throw new Error("mobx-react requires mobx to be available");

if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].setReactionScheduler(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"]);else if (typeof unstable_batchedUpdates$1 === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].setReactionScheduler(unstable_batchedUpdates$1);

var onError = function onError(fn) {
    return errorsReporter.on(fn);
};

/* DevTool support */
// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
    var mobx$1 = { spy: __WEBPACK_IMPORTED_MODULE_0_mobx__["spy"], extras: __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"] };
    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
}




/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(61);
var toPrimitive = __webpack_require__(36);
var dP = Object.defineProperty;

exports.f = __webpack_require__(16) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(21)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var createDesc = __webpack_require__(30);
module.exports = __webpack_require__(16) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(62);
var defined = __webpack_require__(37);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(108);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _focus = __webpack_require__(137);

var _focus2 = _interopRequireDefault(_focus);

var _func = __webpack_require__(78);

var _func2 = _interopRequireDefault(_func);

var _keyCode = __webpack_require__(138);

var _keyCode2 = _interopRequireDefault(_keyCode);

var _pickAttrs = __webpack_require__(139);

var _pickAttrs2 = _interopRequireDefault(_pickAttrs);

var _scrollbar = __webpack_require__(140);

var _scrollbar2 = _interopRequireDefault(_scrollbar);

var _support = __webpack_require__(141);

var _support2 = _interopRequireDefault(_support);

var _log = __webpack_require__(143);

var _log2 = _interopRequireDefault(_log);

var _pickOthers = __webpack_require__(144);

var _pickOthers2 = _interopRequireDefault(_pickOthers);

var _object = __webpack_require__(145);

var _object2 = _interopRequireDefault(_object);

var _children = __webpack_require__(146);

var _children2 = _interopRequireDefault(_children);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    focus: _focus2['default'],
    func: _func2['default'],
    keyCode: _keyCode2['default'],
    pickAttrs: _pickAttrs2['default'],
    scrollbar: _scrollbar2['default'],
    support: _support2['default'],
    log: _log2['default'],
    pickOthers: _pickOthers2['default'],
    obj: _object2['default'],
    children: _children2['default']
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(29);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(67);
var enumBugKeys = __webpack_require__(44);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(89);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(163);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(14).f;
var has = __webpack_require__(18);
var TAG = __webpack_require__(3)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(136);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _icon2['default'];
module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(15);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(31);
var createDesc = __webpack_require__(30);
var toIObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(36);
var has = __webpack_require__(18);
var IE8_DOM_DEFINE = __webpack_require__(61);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(16) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(110)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(65)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(8);
var dPs = __webpack_require__(112);
var enumBugKeys = __webpack_require__(44);
var IE_PROTO = __webpack_require__(42)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(35)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(69).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(43)('keys');
var uid = __webpack_require__(32);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(1);
var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(25) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(37);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(116);
var global = __webpack_require__(2);
var hide = __webpack_require__(17);
var Iterators = __webpack_require__(26);
var TO_STRING_TAG = __webpack_require__(3)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(29);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extras", function() { return extras; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reaction", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "untracked", function() { return untracked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IDerivationState", function() { return IDerivationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Atom", function() { return Atom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseAtom", function() { return BaseAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStrict", function() { return useStrict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStrictModeEnabled", function() { return isStrictModeEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spy", function() { return spy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "comparer", function() { return comparer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asReference", function() { return asReference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asFlat", function() { return asFlat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asStructure", function() { return asStructure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asMap", function() { return asMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isModifierDescriptor", function() { return isModifierDescriptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableObject", function() { return isObservableObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBoxedObservable", function() { return isObservableValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableArray", function() { return isObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableMap", function() { return ObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableMap", function() { return isObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transaction", function() { return transaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computed", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservable", function() { return isObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isComputed", function() { return isComputed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendObservable", function() { return extendObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendShallowObservable", function() { return extendShallowObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observe", function() { return observe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intercept", function() { return intercept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorun", function() { return autorun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorunAsync", function() { return autorunAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "when", function() { return when; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reaction", function() { return reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "action", function() { return action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAction", function() { return isAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runInAction", function() { return runInAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expr", function() { return expr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toJS", function() { return toJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTransformer", function() { return createTransformer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "whyRun", function() { return whyRun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trace", function() { return trace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayLike", function() { return isArrayLike; });
/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var BaseAtom = /** @class */ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function BaseAtom(name) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        this.name = name;
        this.isPendingUnobservation = true; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    BaseAtom.prototype.onBecomeUnobserved = function () {
        // noop
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     */
    BaseAtom.prototype.reportObserved = function () {
        reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    BaseAtom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    BaseAtom.prototype.toString = function () {
        return this.name;
    };
    return BaseAtom;
}());
var Atom = /** @class */ (function (_super) {
    __extends(Atom, _super);
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
        if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
        var _this = _super.call(this, name) || this;
        _this.name = name;
        _this.onBecomeObservedHandler = onBecomeObservedHandler;
        _this.onBecomeUnobservedHandler = onBecomeUnobservedHandler;
        _this.isPendingUnobservation = false; // for effective unobserving.
        _this.isBeingTracked = false;
        return _this;
    }
    Atom.prototype.reportObserved = function () {
        startBatch();
        _super.prototype.reportObserved.call(this);
        if (!this.isBeingTracked) {
            this.isBeingTracked = true;
            this.onBecomeObservedHandler();
        }
        endBatch();
        return !!globalState.trackingDerivation;
        // return doesn't really give useful info, because it can be as well calling computed which calls atom (no reactions)
        // also it could not trigger when calculating reaction dependent on Atom because Atom's value was cached by computed called by given reaction.
    };
    Atom.prototype.onBecomeUnobserved = function () {
        this.isBeingTracked = false;
        this.onBecomeUnobservedHandler();
    };
    return Atom;
}(BaseAtom));
var isAtom = createInstanceofPredicate("Atom", BaseAtom);

function hasInterceptors(interceptable) {
    return interceptable.interceptors && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = objectAssign({}, event, { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(objectAssign({}, change, END_EVENT));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        var idx = globalState.spyListeners.indexOf(listener);
        if (idx !== -1)
            globalState.spyListeners.splice(idx, 1);
    });
}

function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}
var IS_ITERATING_MARKER = "__$$iterating";
function arrayAsIterator(array) {
    // returning an array for entries(), values() etc for maps was a mis-interpretation of the specs..,
    // yet it is quite convenient to be able to use the response both as array directly and as iterator
    // it is suboptimal, but alas...
    invariant(array[IS_ITERATING_MARKER] !== true, "Illegal state: cannot recycle array as iterator");
    addHiddenFinalProp(array, IS_ITERATING_MARKER, true);
    var idx = -1;
    addHiddenFinalProp(array, "next", function next() {
        idx++;
        return {
            done: idx >= this.length,
            value: idx < this.length ? this[idx] : undefined
        };
    });
    return array;
}
function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = /** @class */ (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.interceptors = null;
        this.changeListeners = null;
        this.atom = new BaseAtom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = [];
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, [index, deleteCount].concat(newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
        var _a;
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = /** @class */ (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            _this.spliceWithArray(0, 0, initialValues);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = oldItems.slice(0, fromIndex).concat(oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = oldItems.slice(0, toIndex).concat([
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
                .values
                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    return arrayAsIterator(this.slice());
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            // TODO: Check `this`?, see #752?
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}

var UNCHANGED = {};
var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.dehancer = undefined;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", object: _this, newValue: _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    object: this,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue ? newValue : UNCHANGED;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(BaseAtom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

var messages = {
    m001: "It is not allowed to assign new values to @action fields",
    m002: "`runInAction` expects a function",
    m003: "`runInAction` expects a function without arguments",
    m004: "autorun expects a function",
    m005: "Warning: attempted to pass an action to autorun. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m006: "Warning: attempted to pass an action to autorunAsync. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m007: "reaction only accepts 2 or 3 arguments. If migrating from MobX 2, please provide an options object",
    m008: "wrapping reaction expression in `asReference` is no longer supported, use options object instead",
    m009: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'. It looks like it was used on a property.",
    m010: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'",
    m011: "First argument to `computed` should be an expression. If using computed as decorator, don't pass it arguments",
    m012: "computed takes one or two arguments if used as function",
    m013: "[mobx.expr] 'expr' should only be used inside other reactive functions.",
    m014: "extendObservable expected 2 or more arguments",
    m015: "extendObservable expects an object as first argument",
    m016: "extendObservable should not be used on maps, use map.merge instead",
    m017: "all arguments of extendObservable should be objects",
    m018: "extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540",
    m019: "[mobx.isObservable] isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.",
    m020: "modifiers can only be used for individual object properties",
    m021: "observable expects zero or one arguments",
    m022: "@observable can not be used on getters, use @computed instead",
    m024: "whyRun() can only be used if a derivation is active, or by passing an computed value / reaction explicitly. If you invoked whyRun from inside a computation; the computation is currently suspended but re-evaluating because somebody requested its value.",
    m025: "whyRun can only be used on reactions and computed values",
    m026: "`action` can only be invoked on functions",
    m028: "It is not allowed to set `useStrict` when a derivation is running",
    m029: "INTERNAL ERROR only onBecomeUnobserved shouldn't be called twice in a row",
    m030a: "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: ",
    m030b: "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ",
    m031: "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: ",
    m032: "* This computation is suspended (not in use by any reaction) and won't run automatically.\n	Didn't expect this computation to be suspended at this point?\n	  1. Make sure this computation is used by a reaction (reaction, autorun, observer).\n	  2. Check whether you are using this computation synchronously (in the same stack as they reaction that needs it).",
    m033: "`observe` doesn't support the fire immediately property for observable maps.",
    m034: "`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead",
    m035: "Cannot make the designated object observable; it is not extensible",
    m036: "It is not possible to get index atoms from arrays",
    m037: "Hi there! I'm sorry you have just run into an exception.\nIf your debugger ends up here, know that some reaction (like the render() of an observer component, autorun or reaction)\nthrew an exception and that mobx caught it, to avoid that it brings the rest of your application down.\nThe original cause of the exception (the code that caused this reaction to run (again)), is still in the stack.\n\nHowever, more interesting is the actual stack trace of the error itself.\nHopefully the error is an instanceof Error, because in that case you can inspect the original stack of the error from where it was thrown.\nSee `error.stack` property, or press the very subtle \"(...)\" link you see near the console.error message that probably brought you here.\nThat stack is more interesting than the stack of this console.error itself.\n\nIf the exception you see is an exception you created yourself, make sure to use `throw new Error(\"Oops\")` instead of `throw \"Oops\"`,\nbecause the javascript environment will only preserve the original stack trace in the first form.\n\nYou can also make sure the debugger pauses the next time this very same exception is thrown by enabling \"Pause on caught exception\".\n(Note that it might pause on many other, unrelated exception as well).\n\nIf that all doesn't help you out, feel free to open an issue https://github.com/mobxjs/mobx/issues!\n",
    m038: "Missing items in this list?\n    1. Check whether all used values are properly marked as observable (use isObservable to verify)\n    2. Make sure you didn't dereference values too early. MobX observes props, not primitives. E.g: use 'person.name' instead of 'name' in your computation.\n"
};
function getMessage(id) {
    return messages[id];
}

function createAction(actionName, fn) {
    invariant(typeof fn === "function", getMessage("m026"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    res.originalFn = fn;
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            fn: fn,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd({ time: Date.now() - runInfo.startTime });
}
function useStrict(strict) {
    invariant(globalState.trackingDerivation === null, getMessage("m028"));
    globalState.strictMode = strict;
    globalState.allowStateChanges = !strict;
}
function isStrictModeEnabled() {
    return globalState.strictMode;
}
function allowStateChanges(allowStateChanges, func) {
    // TODO: deprecate / refactor this function in next major
    // Currently only used by `@observer`
    // Proposed change: remove first param, rename to `forbidStateChanges`,
    // require error callback instead of the hardcoded error message now used
    // Use `inAction` instead of allowStateChanges in derivation.ts to check strictMode
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}

/**
 * Constructs a decorator, that normalizes the differences between
 * TypeScript and Babel. Mainly caused by the fact that legacy-decorator cannot assign
 * values during instance creation to properties that have a getter setter.
 *
 * - Sigh -
 *
 * Also takes care of the difference between @decorator field and @decorator(args) field, and different forms of values.
 * For performance (cpu and mem) reasons the properties are always defined on the prototype (at least initially).
 * This means that these properties despite being enumerable might not show up in Object.keys() (but they will show up in for...in loops).
 */
function createClassPropertyDecorator(
/**
 * This function is invoked once, when the property is added to a new instance.
 * When this happens is not strictly determined due to differences in TS and Babel:
 * Typescript: Usually when constructing the new instance
 * Babel, sometimes Typescript: during the first get / set
 * Both: when calling `runLazyInitializers(instance)`
 */
onInitialize, get, set, enumerable, 
/**
 * Can this decorator invoked with arguments? e.g. @decorator(args)
 */
allowCustomArguments) {
    function classPropertyDecorator(target, key, descriptor, customArgs, argLen) {
        if (argLen === void 0) { argLen = 0; }
        invariant(allowCustomArguments || quacksLikeADecorator(arguments), "This function is a decorator, but it wasn't invoked like a decorator");
        if (!descriptor) {
            // typescript (except for getter / setters)
            var newDescriptor = {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true)
                        typescriptInitializeProperty(this, key, undefined, onInitialize, customArgs, descriptor);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true) {
                        typescriptInitializeProperty(this, key, v, onInitialize, customArgs, descriptor);
                    }
                    else {
                        set.call(this, key, v);
                    }
                }
            };
            if (arguments.length < 3 || (arguments.length === 5 && argLen < 3)) {
                // Typescript target is ES3, so it won't define property for us
                // or using Reflect.decorate polyfill, which will return no descriptor
                // (see https://github.com/mobxjs/mobx/issues/333)
                Object.defineProperty(target, key, newDescriptor);
            }
            return newDescriptor;
        }
        else {
            // babel and typescript getter / setter props
            if (!hasOwnProperty(target, "__mobxLazyInitializers")) {
                addHiddenProp(target, "__mobxLazyInitializers", (target.__mobxLazyInitializers && target.__mobxLazyInitializers.slice()) || [] // support inheritance
                );
            }
            var value_1 = descriptor.value, initializer_1 = descriptor.initializer;
            target.__mobxLazyInitializers.push(function (instance) {
                onInitialize(instance, key, initializer_1 ? initializer_1.call(instance) : value_1, customArgs, descriptor);
            });
            return {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    set.call(this, key, v);
                }
            };
        }
    }
    if (allowCustomArguments) {
        /** If custom arguments are allowed, we should return a function that returns a decorator */
        return function () {
            /** Direct invocation: @decorator bla */
            if (quacksLikeADecorator(arguments))
                return classPropertyDecorator.apply(null, arguments);
            /** Indirect invocation: @decorator(args) bla */
            var outerArgs = arguments;
            var argLen = arguments.length;
            return function (target, key, descriptor) {
                return classPropertyDecorator(target, key, descriptor, outerArgs, argLen);
            };
        };
    }
    return classPropertyDecorator;
}
function typescriptInitializeProperty(instance, key, v, onInitialize, customArgs, baseDescriptor) {
    if (!hasOwnProperty(instance, "__mobxInitializedProps"))
        addHiddenProp(instance, "__mobxInitializedProps", {});
    instance.__mobxInitializedProps[key] = true;
    onInitialize(instance, key, v, customArgs, baseDescriptor);
}
function runLazyInitializers(instance) {
    if (instance.__mobxDidRunLazyInitializers === true)
        return;
    if (instance.__mobxLazyInitializers) {
        addHiddenProp(instance, "__mobxDidRunLazyInitializers", true);
        instance.__mobxDidRunLazyInitializers &&
            instance.__mobxLazyInitializers.forEach(function (initializer) { return initializer(instance); });
    }
}
function quacksLikeADecorator(args) {
    return (args.length === 2 || args.length === 3) && typeof args[1] === "string";
}

var actionFieldDecorator = createClassPropertyDecorator(function (target, key, value, args, originalDescriptor) {
    var actionName = args && args.length === 1 ? args[0] : value.name || key || "<unnamed action>";
    var wrappedAction = action(actionName, value);
    addHiddenProp(target, key, wrappedAction);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, true);
var boundActionDecorator = createClassPropertyDecorator(function (target, key, value) {
    defineBoundAction(target, key, value);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, false);
var action = function action(arg1, arg2, arg3, arg4) {
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    return namedActionDecorator(arg2).apply(null, arguments);
};
action.bound = function boundAction(arg1, arg2, arg3) {
    if (typeof arg1 === "function") {
        var action_1 = createAction("<not yet bound action>", arg1);
        action_1.autoBind = true;
        return action_1;
    }
    return boundActionDecorator.apply(null, arguments);
};
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor && typeof descriptor.value === "function") {
            // TypeScript @action method() { }. Defined on proto before being decorated
            // Don't use the field decorator if we are just decorating a method
            descriptor.value = createAction(name, descriptor.value);
            descriptor.enumerable = false;
            descriptor.configurable = true;
            return descriptor;
        }
        if (descriptor !== undefined && descriptor.get !== undefined) {
            throw new Error("[mobx] action is not expected to be used with getters");
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function runInAction(arg1, arg2, arg3) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    var scope = typeof arg1 === "function" ? arg2 : arg3;
    invariant(typeof fn === "function", getMessage("m002"));
    invariant(fn.length === 0, getMessage("m003"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    return executeAction(actionName, fn, scope, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    var res = function () {
        return executeAction(propertyName, fn, target, arguments);
    };
    res.isMobxAction = true;
    addHiddenProp(target, propertyName, res);
}

var toString = Object.prototype.toString;
function deepEqual(a, b) {
    return eq(a, b);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    return deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys = Object.keys(a), key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has(b, key) && eq(a[key], b[key], aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.peek();
    if (isObservableMap(a))
        return a.entries();
    if (isES6Map(a))
        return iteratorToArray(a.entries());
    return a;
}
function has(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};

function autorun(arg1, arg2, arg3) {
    var name, view, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        view = arg2;
        scope = arg3;
    }
    else {
        name = arg1.name || "Autorun@" + getNextId();
        view = arg1;
        scope = arg2;
    }
    invariant(typeof view === "function", getMessage("m004"));
    invariant(isAction(view) === false, getMessage("m005"));
    if (scope)
        view = view.bind(scope);
    var reaction = new Reaction(name, function () {
        this.track(reactionRunner);
    });
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
function when(arg1, arg2, arg3, arg4) {
    var name, predicate, effect, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        predicate = arg2;
        effect = arg3;
        scope = arg4;
    }
    else {
        name = "When@" + getNextId();
        predicate = arg1;
        effect = arg2;
        scope = arg3;
    }
    var disposer = autorun(name, function (r) {
        if (predicate.call(scope)) {
            r.dispose();
            var prevUntracked = untrackedStart();
            effect.call(scope);
            untrackedEnd(prevUntracked);
        }
    });
    return disposer;
}
function autorunAsync(arg1, arg2, arg3, arg4) {
    var name, func, delay, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        func = arg2;
        delay = arg3;
        scope = arg4;
    }
    else {
        name = arg1.name || "AutorunAsync@" + getNextId();
        func = arg1;
        delay = arg2;
        scope = arg3;
    }
    invariant(isAction(func) === false, getMessage("m006"));
    if (delay === void 0)
        delay = 1;
    if (scope)
        func = func.bind(scope);
    var isScheduled = false;
    var r = new Reaction(name, function () {
        if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                if (!r.isDisposed)
                    r.track(reactionRunner);
            }, delay);
        }
    });
    function reactionRunner() {
        func(r);
    }
    r.schedule();
    return r.getDisposer();
}
function reaction(expression, effect, arg3) {
    if (arguments.length > 3) {
        fail(getMessage("m007"));
    }
    if (isModifierDescriptor(expression)) {
        fail(getMessage("m008"));
    }
    var opts;
    if (typeof arg3 === "object") {
        opts = arg3;
    }
    else {
        opts = {};
    }
    opts.name =
        opts.name || expression.name || effect.name || "Reaction@" + getNextId();
    opts.fireImmediately = arg3 === true || opts.fireImmediately === true;
    opts.delay = opts.delay || 0;
    opts.compareStructural = opts.compareStructural || opts.struct || false;
    // TODO: creates ugly spy events, use `effect = (r) => runInAction(opts.name, () => effect(r))` instead
    effect = action(opts.name, opts.context ? effect.bind(opts.context) : effect);
    if (opts.context) {
        expression = expression.bind(opts.context);
    }
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    var r = new Reaction(opts.name, function () {
        if (firstTime || opts.delay < 1) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                reactionRunner();
            }, opts.delay);
        }
    });
    function reactionRunner() {
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effect(value, r);
        if (!firstTime && changed === true)
            effect(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce an new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(derivation, scope, equals, name, setter) {
        this.derivation = derivation;
        this.scope = scope;
        this.equals = equals;
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        this.name = name || "ComputedValue@" + getNextId();
        if (setter)
            this.setter = createAction(name + "-setter", setter);
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        clearObserving(this);
        this.value = undefined;
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        invariant(!this.isComputing, "Cycle detected in computation " + this.name, this.derivation);
        if (globalState.inBatch === 0) {
            // This is an minor optimization which could be omitted to simplify the code
            // The computedValue is accessed outside of any mobx stuff. Batch observing should be enough and don't need
            // tracking as it will never be called again inside this batch.
            startBatch();
            if (shouldCompute(this)) {
                if (this.isTracing !== TraceMode.NONE) {
                    console.log("[mobx.trace] '" + this
                        .name + "' is being read outside a reactive context and doing a full recompute");
                }
                this.value = this.computeValue(false);
            }
            endBatch();
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this
                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "[ComputedValue '" + this
                .name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                fn: this.derivation
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = (this.value = this.computeValue(true));
        return (wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue));
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            try {
                res = this.derivation.call(this.scope);
            }
            catch (e) {
                res = new CaughtException(e);
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype.whyRun = function () {
        var isTracking = Boolean(globalState.trackingDerivation);
        var observing = unique(this.isComputing ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        var observers = unique(getObservers(this).map(function (dep) { return dep.name; }));
        return ("\nWhyRun? computation '" + this.name + "':\n * Running because: " + (isTracking
            ? "[active] the value of this computation is needed by a reaction"
            : this.isComputing
                ? "[get] The value of this computed was requested outside a reaction"
                : "[idle] not running at the moment") + "\n" +
            (this.dependenciesState === IDerivationState.NOT_TRACKING
                ? getMessage("m032")
                : " * This computation will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this.isComputing && isTracking
                    ? " (... or any observable accessed during the remainder of the current run)"
                    : "") + "\n    " + getMessage("m038") + "\n\n  * If the outcome of this computation changes, the following observers will be re-run:\n    " + joinStrings(observers) + "\n"));
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, name) {
        this.target = target;
        this.name = name;
        this.values = {};
        this.changeListeners = null;
        this.interceptors = null;
    }
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name) {
    if (isObservableObject(target) && target.hasOwnProperty("$mobx"))
        return target.$mobx;
    invariant(Object.isExtensible(target), getMessage("m035"));
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, name);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservablePropertyFromDescriptor(adm, propName, descriptor, defaultEnhancer) {
    if (adm.values[propName] && !isComputedValue(adm.values[propName])) {
        // already observable property
        invariant("value" in descriptor, "The property " + propName + " in " + adm.name + " is already observable, cannot redefine it as computed property");
        adm.target[propName] = descriptor.value; // the property setter will make 'value' reactive if needed.
        return;
    }
    // not yet observable property
    if ("value" in descriptor) {
        // not a computed value
        if (isModifierDescriptor(descriptor.value)) {
            // x : ref(someValue)
            var modifierDescriptor = descriptor.value;
            defineObservableProperty(adm, propName, modifierDescriptor.initialValue, modifierDescriptor.enhancer);
        }
        else if (isAction(descriptor.value) && descriptor.value.autoBind === true) {
            defineBoundAction(adm.target, propName, descriptor.value.originalFn);
        }
        else if (isComputedValue(descriptor.value)) {
            // x: computed(someExpr)
            defineComputedPropertyFromComputedValue(adm, propName, descriptor.value);
        }
        else {
            // x: someValue
            defineObservableProperty(adm, propName, descriptor.value, defaultEnhancer);
        }
    }
    else {
        // get x() { return 3 } set x(v) { }
        defineComputedProperty(adm, propName, descriptor.get, descriptor.set, comparer.default, true);
    }
}
function defineObservableProperty(adm, propName, newValue, enhancer) {
    assertPropertyConfigurable(adm.target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: adm.target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(adm.target, propName, generateObservablePropConfig(propName));
    notifyPropertyAddition(adm, adm.target, propName, newValue);
}
function defineComputedProperty(adm, propName, getter, setter, equals, asInstanceProperty) {
    if (asInstanceProperty)
        assertPropertyConfigurable(adm.target, propName);
    adm.values[propName] = new ComputedValue(getter, adm.target, equals, adm.name + "." + propName, setter);
    if (asInstanceProperty) {
        Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
    }
}
function defineComputedPropertyFromComputedValue(adm, propName, computedValue) {
    var name = adm.name + "." + propName;
    computedValue.name = name;
    if (!computedValue.scope)
        computedValue.scope = adm.target;
    adm.values[propName] = computedValue;
    Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = {};
var computedPropertyConfigs = {};
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                setPropertyValue(this, propName, v);
            }
        }));
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: true,
            enumerable: false,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                return this.$mobx.values[propName].set(v);
            }
        }));
}
function setPropertyValue(instance, name, newValue) {
    var adm = instance.$mobx;
    var observable = adm.values[name];
    // intercept
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            type: "update",
            object: instance,
            name: name,
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    newValue = observable.prepareNewValue(newValue);
    // notify spy & observers
    if (newValue !== UNCHANGED) {
        var notify = hasListeners(adm);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy
            ? {
                type: "update",
                object: instance,
                oldValue: observable.value,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        observable.setNewValue(newValue);
        if (notify)
            notifyListeners(adm, change);
        if (notifySpy)
            spyReportEnd();
    }
}
function notifyPropertyAddition(adm, object, name, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: name,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart(change);
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

/**
 * Returns true if the provided value is reactive.
 * @param value object, function or array
 * @param property if property is specified, checks whether value.property is reactive.
 */
function isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableArray(value) || isObservableMap(value))
            throw new Error(getMessage("m019"));
        else if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value.$mobx ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}

function createDecoratorForEnhancer(enhancer) {
    invariant(!!enhancer, ":(");
    return createClassPropertyDecorator(function (target, name, baseValue, _, baseDescriptor) {
        assertPropertyConfigurable(target, name);
        invariant(!baseDescriptor || !baseDescriptor.get, getMessage("m022"));
        var adm = asObservableObject(target, undefined);
        defineObservableProperty(adm, name, baseValue, enhancer);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        setPropertyValue(this, name, value);
    }, true, false);
}

function extendObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, deepEnhancer, properties);
}
function extendShallowObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, referenceEnhancer, properties);
}
function extendObservableHelper(target, defaultEnhancer, properties) {
    invariant(arguments.length >= 2, getMessage("m014"));
    invariant(typeof target === "object", getMessage("m015"));
    invariant(!isObservableMap(target), getMessage("m016"));
    properties.forEach(function (propSet) {
        invariant(typeof propSet === "object", getMessage("m017"));
        invariant(!isObservable(propSet), getMessage("m018"));
    });
    var adm = asObservableObject(target);
    var definedProps = {};
    // Note could be optimised if properties.length === 1
    for (var i = properties.length - 1; i >= 0; i--) {
        var propSet = properties[i];
        for (var key in propSet)
            if (definedProps[key] !== true && hasOwnProperty(propSet, key)) {
                definedProps[key] = true;
                if (target === propSet && !isPropertyConfigurable(target, key))
                    continue; // see #111, skip non-configurable or non-writable props for `observable(object)`.
                var descriptor = Object.getOwnPropertyDescriptor(propSet, key);
                defineObservablePropertyFromDescriptor(adm, key, descriptor, defaultEnhancer);
            }
    }
    return target;
}

var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var deepStructDecorator = createDecoratorForEnhancer(deepStructEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v) {
    if (v === void 0) { v = undefined; }
    // @observable someProp;
    if (typeof arguments[1] === "string")
        return deepDecorator.apply(null, arguments);
    invariant(arguments.length <= 1, getMessage("m021"));
    invariant(!isModifierDescriptor(v), getMessage("m020"));
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = deepEnhancer(v, undefined, undefined);
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    return observable.box(v);
}
var observableFactories = {
    box: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        return new ObservableValue(value, deepEnhancer, name);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        return new ObservableValue(value, referenceEnhancer, name);
    },
    array: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        return new ObservableArray(initialValues, deepEnhancer, name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        return new ObservableArray(initialValues, referenceEnhancer, name);
    },
    map: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        return new ObservableMap(initialValues, deepEnhancer, name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        return new ObservableMap(initialValues, referenceEnhancer, name);
    },
    object: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("object");
        var res = {};
        // convert to observable object
        asObservableObject(res, name);
        // add properties
        extendObservable(res, props);
        return res;
    },
    shallowObject: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowObject");
        var res = {};
        asObservableObject(res, name);
        extendShallowObservable(res, props);
        return res;
    },
    ref: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(referenceEnhancer, arguments[0]);
        }
        else {
            return refDecorator.apply(null, arguments);
        }
    },
    shallow: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(shallowEnhancer, arguments[0]);
        }
        else {
            return shallowDecorator.apply(null, arguments);
        }
    },
    deep: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepEnhancer, arguments[0]);
        }
        else {
            return deepDecorator.apply(null, arguments);
        }
    },
    struct: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepStructEnhancer, arguments[0]);
        }
        else {
            return deepStructDecorator.apply(null, arguments);
        }
    }
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
observable.deep.struct = observable.struct;
observable.ref.struct = function () {
    if (arguments.length < 2) {
        return createModifierDescriptor(refStructEnhancer, arguments[0]);
    }
    else {
        return refStructDecorator.apply(null, arguments);
    }
};
function incorrectlyUsedAsDecorator(methodName) {
    fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

function isModifierDescriptor(thing) {
    return typeof thing === "object" && thing !== null && thing.isMobxModifierDescriptor === true;
}
function createModifierDescriptor(enhancer, initialValue) {
    invariant(!isModifierDescriptor(initialValue), "Modifiers cannot be nested");
    return {
        isMobxModifierDescriptor: true,
        initialValue: initialValue,
        enhancer: enhancer
    };
}
function deepEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, name);
    if (isPlainObject(v))
        return observable.object(v, name);
    if (isES6Map(v))
        return observable.map(v, name);
    return v;
}
function shallowEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
        return v;
    if (Array.isArray(v))
        return observable.shallowArray(v, name);
    if (isPlainObject(v))
        return observable.shallowObject(v, name);
    if (isES6Map(v))
        return observable.shallowMap(v, name);
    return fail("The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function deepStructEnhancer(v, oldValue, name) {
    // don't confuse structurally compare enhancer with ref enhancer! The latter is probably
    // more suited for immutable objects
    if (deepEqual(v, oldValue))
        return oldValue;
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return new ObservableArray(v, deepStructEnhancer, name);
    if (isES6Map(v))
        return new ObservableMap(v, deepStructEnhancer, name);
    if (isPlainObject(v)) {
        var res = {};
        asObservableObject(res, name);
        extendObservableHelper(res, deepStructEnhancer, [v]);
        return res;
    }
    return v;
}
function refStructEnhancer(v, oldValue, name) {
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

var ObservableMapMarker = {};
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._data = Object.create(null);
        this._hasMap = Object.create(null); // hasMap, not hashMap >-).
        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
        this.interceptors = null;
        this.changeListeners = null;
        this.dehancer = undefined;
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return typeof this._data[key] !== "undefined";
    };
    ObservableMap.prototype.has = function (key) {
        if (!this.isValidKey(key))
            return false;
        key = "" + key;
        if (this._hasMap[key])
            return this._hasMap[key].get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap.prototype.set = function (key, value) {
        this.assertValidKey(key);
        key = "" + key;
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        this.assertValidKey(key);
        key = "" + key;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data[key].value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            transaction(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable$$1 = _this._data[key];
                observable$$1.setNewValue(undefined);
                _this._data[key] = undefined;
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap[key];
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = this._hasMap[key] = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
        }
        return entry;
    };
    ObservableMap.prototype._updateValue = function (name, newValue) {
        var observable$$1 = this._data[name];
        newValue = observable$$1.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable$$1.value,
                    name: name,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (name, newValue) {
        var _this = this;
        transaction(function () {
            var observable$$1 = (_this._data[name] = new ObservableValue(newValue, _this.enhancer, _this.name + "." + name, false));
            newValue = observable$$1.value; // value might have been changed
            _this._updateHasMapEntry(name, true);
            _this._keys.push(name);
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        key = "" + key;
        if (this.has(key))
            return this.dehanceValue(this._data[key].get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        return arrayAsIterator(this._keys.slice());
    };
    ObservableMap.prototype.values = function () {
        return arrayAsIterator(this._keys.map(this.get, this));
    };
    ObservableMap.prototype.entries = function () {
        var _this = this;
        return arrayAsIterator(this._keys.map(function (key) { return [key, _this.get(key)]; }));
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this.keys().forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                _this.keys().forEach(_this.delete, _this);
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = _this.keys();
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values might still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        var _this = this;
        var res = {};
        this.keys().forEach(function (key) { return (res[key] = _this.get(key)); });
        return res;
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableMap.prototype.isValidKey = function (key) {
        if (key === null || key === undefined)
            return false;
        if (typeof key === "string" || typeof key === "number" || typeof key === "boolean")
            return true;
        return false;
    };
    ObservableMap.prototype.assertValidKey = function (key) {
        if (!this.isValidKey(key))
            throw new Error("[mobx.map] Invalid key: '" + key + "', only strings, numbers and booleans are accepted as key in observable maps.");
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            this.keys().map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        invariant(fireImmediately !== true, getMessage("m033"));
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
function map(initialValues) {
    deprecated("`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead");
    return observable.map(initialValues);
}
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
function getGlobal() {
    return typeof window !== "undefined" ? window : global;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message, thing) {
    invariant(false, message, thing);
    throw "X"; // unreachable
}
function invariant(check, message, thing) {
    if (!check)
        throw new Error("[mobx] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ""));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg) {
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function joinStrings(things, limit, separator) {
    if (limit === void 0) { limit = 100; }
    if (separator === void 0) { separator = " - "; }
    if (!things)
        return "";
    var sliced = things.slice(0, limit);
    return "" + sliced.join(separator) + (things.length > limit
        ? " (... and " + (things.length - limit) + "more)"
        : "");
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function objectAssign() {
    var res = arguments[0];
    for (var i = 1, l = arguments.length; i < l; i++) {
        var source = arguments[i];
        for (var key in source)
            if (hasOwnProperty(source, key)) {
                res[key] = source[key];
            }
    }
    return res;
}
var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(object, propName) {
    return prototypeHasOwnProperty.call(object, propName);
}
function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    invariant(isPropertyConfigurable(object, prop), "Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function getMapLikeKeys(map$$1) {
    if (isPlainObject(map$$1))
        return Object.keys(map$$1);
    if (Array.isArray(map$$1))
        return map$$1.map(function (_a) {
            var key = _a[0];
            return key;
        });
    if (isES6Map(map$$1))
        return Array.from(map$$1.keys());
    if (isObservableMap(map$$1))
        return map$$1.keys();
    return fail("Cannot get keys from " + map$$1);
}
function iteratorToArray(it) {
    var res = [];
    while (true) {
        var r = it.next();
        if (r.done)
            break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol() {
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = ["mobxGuid", "resetId", "spyListeners", "strictMode", "runId"];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.strictMode = false;
        /**
         * Used by createTransformer to detect that the global state has been reset.
         */
        this.resetId = 0;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
    }
    return MobXGlobals;
}());
var globalState = new MobXGlobals();
var shareGlobalStateCalled = false;
var runInIsolationCalled = false;
var warnedAboutMultipleInstances = false;
{
    var global_1 = getGlobal();
    if (!global_1.__mobxInstanceCount) {
        global_1.__mobxInstanceCount = 1;
    }
    else {
        global_1.__mobxInstanceCount++;
        setTimeout(function () {
            if (!shareGlobalStateCalled && !runInIsolationCalled && !warnedAboutMultipleInstances) {
                warnedAboutMultipleInstances = true;
                console.warn("[mobx] Warning: there are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
            }
        }, 1);
    }
}
function isolateGlobalState() {
    runInIsolationCalled = true;
    getGlobal().__mobxInstanceCount--;
}
function shareGlobalState() {
    // TODO: remove in 4.0; just use peer dependencies instead.
    deprecated("Using `shareGlobalState` is not recommended, use peer dependencies instead. See https://github.com/mobxjs/mobx/issues/1082 for details.");
    shareGlobalStateCalled = true;
    var global = getGlobal();
    var ownState = globalState;
    /**
     * Backward compatibility check
     */
    if (global.__mobservableTrackingStack || global.__mobservableViewStack)
        throw new Error("[mobx] An incompatible version of mobservable is already loaded.");
    if (global.__mobxGlobal && global.__mobxGlobal.version !== ownState.version)
        throw new Error("[mobx] An incompatible version of mobx is already loaded.");
    if (global.__mobxGlobal)
        globalState = global.__mobxGlobal;
    else
        global.__mobxGlobal = ownState;
}
function getGlobalState() {
    return globalState;
}

/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    globalState.resetId++;
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.strictMode;
}

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            invariant(property === undefined, getMessage("m036"));
            return thing.$mobx.atom;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom(anyThing._keys);
            var observable = anyThing._data[property] || anyThing._hasMap[property];
            invariant(!!observable, "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072 // TODO: remove in 4.0
        if (isObservableObject(thing)) {
            if (!property)
                return fail("please specify a property");
            var observable = thing.$mobx.values[property];
            invariant(!!observable, "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail("Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    invariant(thing, "Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    runLazyInitializers(thing);
    if (thing.$mobx)
        return thing.$mobx;
    invariant(false, "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (!observable.isPendingUnobservation) {
        // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                observable.onBecomeUnobserved();
                // NOTE: onBecomeUnobserved might push to `pendingUnobservations`
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
        }
    }
    else if (observable.observers.length === 0) {
        queueForUnobservation(observable);
    }
}
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    try {
                        obj.get();
                    }
                    catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            return false;
        }
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers$$1)
        fail(getMessage("m031") + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && hasObservers$$1)
        fail(getMessage(globalState.strictMode ? "m030a" : "m030b") + atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    try {
        result = f.call(context);
    }
    catch (e) {
        result = new CaughtException(e);
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

function log(msg) {
    console.log(msg);
    return msg;
}
function whyRun(thing, prop) {
    deprecated("`whyRun` is deprecated in favor of `trace`");
    thing = getAtomFromArgs(arguments);
    if (!thing)
        return log(getMessage("m024"));
    if (isComputedValue(thing) || isReaction(thing))
        return log(thing.whyRun());
    return fail(getMessage("m025"));
}
function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                this.onInvalidate();
                if (this._isTrackPending && isSpyEnabled()) {
                    // onInvalidate didn't trigger track right away..
                    spyReport({
                        object: this,
                        type: "scheduled-reaction"
                    });
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                object: this,
                type: "reaction",
                fn: fn
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        var messageToUser = getMessage("m037");
        console.error(message || messageToUser /* latter will not be true, make sure uglify doesn't remove */, error);
        /** If debugging brought you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                message: message,
                error: error,
                object: this
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        r.onError = registerErrorHandler;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.whyRun = function () {
        var observing = unique(this._isRunning ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        return "\nWhyRun? reaction '" + this.name + "':\n * Status: [" + (this.isDisposed
            ? "stopped"
            : this._isRunning ? "running" : this.isScheduled() ? "scheduled" : "idle") + "]\n * This reaction will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this._isRunning
            ? " (... or any observable accessed during the remainder of the current run)"
            : "") + "\n\t" + getMessage("m038") + "\n";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function registerErrorHandler(handler) {
    invariant(this && this.$mobx && isReaction(this.$mobx), "Invalid `this`");
    invariant(!this.$mobx.errorHandler, "Only one onErrorHandler can be registered");
    this.$mobx.errorHandler = handler;
}
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function asReference(value) {
    deprecated("asReference is deprecated, use observable.ref instead");
    return observable.ref(value);
}
function asStructure(value) {
    deprecated("asStructure is deprecated. Use observable.struct, computed.struct or reaction options instead.");
    return observable.struct(value);
}
function asFlat(value) {
    deprecated("asFlat is deprecated, use observable.shallow instead");
    return observable.shallow(value);
}
function asMap(data) {
    deprecated("asMap is deprecated, use observable.map or observable.shallowMap instead");
    return observable.map(data || {});
}

function createComputedDecorator(equals) {
    return createClassPropertyDecorator(function (target, name, _, __, originalDescriptor) {
        invariant(typeof originalDescriptor !== "undefined", getMessage("m009"));
        invariant(typeof originalDescriptor.get === "function", getMessage("m010"));
        var adm = asObservableObject(target, "");
        defineComputedProperty(adm, name, originalDescriptor.get, originalDescriptor.set, equals, false);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        this.$mobx.values[name].set(value);
    }, false, false);
}
var computedDecorator = createComputedDecorator(comparer.default);
var computedStructDecorator = createComputedDecorator(comparer.structural);
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        return computedDecorator.apply(null, arguments);
    }
    invariant(typeof arg1 === "function", getMessage("m011"));
    invariant(arguments.length < 3, getMessage("m012"));
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.setter = typeof arg2 === "function" ? arg2 : opts.setter;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    return new ComputedValue(arg1, opts.context, equals, opts.name || arg1.name || "", opts.setter);
};
computed.struct = computedStructDecorator;
computed.equals = createComputedDecorator;

function isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

/**
 * expr can be used to create temporarily views inside views.
 * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
 *
 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
 * instead it will only rerenders when the current todo is (de)selected.
 *
 * reactiveComponent((props) => {
 *     const todo = props.todo;
 *     const isSelected = mobx.expr(() => props.viewState.selection === todo);
 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
 * });
 *
 */
function expr(expr, scope) {
    if (!isComputingDerivation())
        console.warn(getMessage("m013"));
    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
    return computed(expr, { context: scope }).get();
}

function toJS(source, detectCycles, __alreadySeen) {
    if (detectCycles === void 0) { detectCycles = true; }
    if (__alreadySeen === void 0) { __alreadySeen = []; }
    // optimization: using ES6 map would be more efficient!
    // optimization: lift this function outside toJS, this makes recursion expensive
    function cache(value) {
        if (detectCycles)
            __alreadySeen.push([source, value]);
        return value;
    }
    if (isObservable(source)) {
        if (detectCycles && __alreadySeen === null)
            __alreadySeen = [];
        if (detectCycles && source !== null && typeof source === "object") {
            for (var i = 0, l = __alreadySeen.length; i < l; i++)
                if (__alreadySeen[i][0] === source)
                    return __alreadySeen[i][1];
        }
        if (isObservableArray(source)) {
            var res = cache([]);
            var toAdd = source.map(function (value) { return toJS(value, detectCycles, __alreadySeen); });
            res.length = toAdd.length;
            for (var i = 0, l = toAdd.length; i < l; i++)
                res[i] = toAdd[i];
            return res;
        }
        if (isObservableObject(source)) {
            var res = cache({});
            for (var key in source)
                res[key] = toJS(source[key], detectCycles, __alreadySeen);
            return res;
        }
        if (isObservableMap(source)) {
            var res_1 = cache({});
            source.forEach(function (value, key) { return (res_1[key] = toJS(value, detectCycles, __alreadySeen)); });
            return res_1;
        }
        if (isObservableValue(source))
            return toJS(source.get(), detectCycles, __alreadySeen);
    }
    return source;
}

function createTransformer(transformer, onCleanup) {
    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
    // Memoizes: object id -> reactive view that applies transformer to the object
    var objectCache = {};
    // If the resetId changes, we will clear the object cache, see #163
    // This construction is used to avoid leaking refs to the objectCache directly
    var resetId = globalState.resetId;
    // Local transformer class specifically for this transformer
    var Transformer = /** @class */ (function (_super) {
        __extends(Transformer, _super);
        function Transformer(sourceIdentifier, sourceObject) {
            var _this = _super.call(this, function () { return transformer(sourceObject); }, undefined, comparer.default, "Transformer-" + transformer.name + "-" + sourceIdentifier, undefined) || this;
            _this.sourceIdentifier = sourceIdentifier;
            _this.sourceObject = sourceObject;
            return _this;
        }
        Transformer.prototype.onBecomeUnobserved = function () {
            var lastValue = this.value;
            _super.prototype.onBecomeUnobserved.call(this);
            delete objectCache[this.sourceIdentifier];
            if (onCleanup)
                onCleanup(lastValue, this.sourceObject);
        };
        return Transformer;
    }(ComputedValue));
    return function (object) {
        if (resetId !== globalState.resetId) {
            objectCache = {};
            resetId = globalState.resetId;
        }
        var identifier = getMemoizationId(object);
        var reactiveTransformer = objectCache[identifier];
        if (reactiveTransformer)
            return reactiveTransformer.get();
        // Not in cache; create a reactive view
        reactiveTransformer = objectCache[identifier] = new Transformer(identifier, object);
        return reactiveTransformer.get();
    };
}
function getMemoizationId(object) {
    if (typeof object === "string" || typeof object === "number")
        return object;
    if (object === null || typeof object !== "object")
        throw new Error("[mobx] transform expected some kind of object or primitive value, got: " + object);
    var tid = object.$transformId;
    if (tid === undefined) {
        tid = getNextId();
        addHiddenProp(object, "$transformId", tid);
    }
    return tid;
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail("InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail("Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail("An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

/**
 * (c) Michel Weststrate 2015 - 2016
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
var extras = {
    allowStateChanges: allowStateChanges,
    deepEqual: deepEqual,
    getAtom: getAtom,
    getDebugName: getDebugName,
    getDependencyTree: getDependencyTree,
    getAdministration: getAdministration,
    getGlobalState: getGlobalState,
    getObserverTree: getObserverTree,
    interceptReads: interceptReads,
    isComputingDerivation: isComputingDerivation,
    isSpyEnabled: isSpyEnabled,
    onReactionError: onReactionError,
    reserveArrayBuffer: reserveArrayBuffer,
    resetGlobalState: resetGlobalState,
    isolateGlobalState: isolateGlobalState,
    shareGlobalState: shareGlobalState,
    spyReport: spyReport,
    spyReportEnd: spyReportEnd,
    spyReportStart: spyReportStart,
    setReactionScheduler: setReactionScheduler
};
var everything = {
    Reaction: Reaction,
    untracked: untracked,
    Atom: Atom,
    BaseAtom: BaseAtom,
    useStrict: useStrict,
    isStrictModeEnabled: isStrictModeEnabled,
    spy: spy,
    comparer: comparer,
    asReference: asReference,
    asFlat: asFlat,
    asStructure: asStructure,
    asMap: asMap,
    isModifierDescriptor: isModifierDescriptor,
    isObservableObject: isObservableObject,
    isBoxedObservable: isObservableValue,
    isObservableArray: isObservableArray,
    ObservableMap: ObservableMap,
    isObservableMap: isObservableMap,
    map: map,
    transaction: transaction,
    observable: observable,
    computed: computed,
    isObservable: isObservable,
    isComputed: isComputed,
    extendObservable: extendObservable,
    extendShallowObservable: extendShallowObservable,
    observe: observe,
    intercept: intercept,
    autorun: autorun,
    autorunAsync: autorunAsync,
    when: when,
    reaction: reaction,
    action: action,
    isAction: isAction,
    runInAction: runInAction,
    expr: expr,
    toJS: toJS,
    createTransformer: createTransformer,
    whyRun: whyRun,
    isArrayLike: isArrayLike,
    extras: extras
};
var warnedAboutDefaultExport = false;
var _loop_1 = function (p) {
    var val = everything[p];
    Object.defineProperty(everything, p, {
        get: function () {
            if (!warnedAboutDefaultExport) {
                warnedAboutDefaultExport = true;
                console.warn("Using default export (`import mobx from 'mobx'`) is deprecated " +
                    "and won’t work in mobx@4.0.0\n" +
                    "Use `import * as mobx from 'mobx'` instead");
            }
            return val;
        }
    });
};
for (var p in everything) {
    _loop_1(p);
}
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({ spy: spy, extras: extras });
}

/* harmony default export */ __webpack_exports__["default"] = (everything);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(76)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _button = __webpack_require__(77);

var _button2 = _interopRequireDefault(_button);

var _group = __webpack_require__(79);

var _group2 = _interopRequireDefault(_group);

var _split = __webpack_require__(147);

var _split2 = _interopRequireDefault(_split);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_button2['default'].Group = _group2['default'];
_button2['default'].Split = _split2['default'];

exports['default'] = _button2['default'];
module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlay = __webpack_require__(80);

var _overlay2 = _interopRequireDefault(_overlay);

var _gateway = __webpack_require__(83);

var _gateway2 = _interopRequireDefault(_gateway);

var _position = __webpack_require__(82);

var _position2 = _interopRequireDefault(_position);

var _popup = __webpack_require__(153);

var _popup2 = _interopRequireDefault(_popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_overlay2['default'].Gateway = _gateway2['default'];
_overlay2['default'].Position = _position2['default'];
_overlay2['default'].Popup = _popup2['default'];

exports['default'] = _overlay2['default'];
module.exports = exports['default'];

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    classList: __webpack_require__(149),
    events: __webpack_require__(150),
    position: __webpack_require__(151),
    style: __webpack_require__(81)
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _nextOverlay = __webpack_require__(50);

var _nextOverlay2 = _interopRequireDefault(_nextOverlay);

var _nextUtil = __webpack_require__(22);

var _nextDom = __webpack_require__(51);

var _classnames2 = __webpack_require__(12);

var _classnames3 = _interopRequireDefault(_classnames2);

var _inner = __webpack_require__(84);

var _inner2 = _interopRequireDefault(_inner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PropTypes = _react2['default'].PropTypes,
    noop = function noop() {},
    limitTabRange = _nextUtil.focus.limitTabRange,
    makeChain = _nextUtil.func.makeChain,
    parseComboOption = function parseComboOption(option) {
    if (option === true || option === false) {
        return option;
    }
    var res = {};
    option.split(',').forEach(function (o) {
        var key = o.replace(/^\s*|\s*$/g, '');
        res[key] = true;
    });
    return res;
};

var hasScroll = function hasScroll() {
    var doc = document.documentElement;
    return doc.scrollHeight > doc.clientHeight;
};
// <Dialog>
//      <Dialog.Header></Dialog.Header>
//      <Dialog.Body></Dialog.Body>
//      <Dialog.Footer></Dialog.Footer>
// </Dialog>

var Dialog = (_temp = _class = function (_React$Component) {
    _inherits(Dialog, _React$Component);

    Dialog.prototype.getPrefix = function getPrefix() {
        return this.context.prefix || this.props.prefix;
    };

    function Dialog(props, context) {
        _classCallCheck(this, Dialog);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.adjustPosition = _this.adjustPosition.bind(_this);
        _this.onClose = _this.onClose.bind(_this);
        _this.onCloseButtonClick = _this.onCloseButtonClick.bind(_this);
        _this.beforeOpen = _this.beforeOpen.bind(_this);
        _this.afterClose = _this.afterClose.bind(_this);
        _this.beforePosition = _this.beforePosition.bind(_this);
        _this.onWindowResize = _this.onWindowResize.bind(_this);
        return _this;
    }

    Dialog.prototype.componentDidMount = function componentDidMount() {
        _nextDom.events.on(document, 'keydown', this.onKeyDown);
        _nextDom.events.on(window, 'resize', this.onWindowResize);
        this.adjustPosition();
    };

    Dialog.prototype.componentDidUpdate = function componentDidUpdate() {
        this.adjustPosition();
    };

    Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
        _nextDom.events.off(document, 'keydown', this.onKeyDown);
        _nextDom.events.off(window, 'resize', this.onWindowResize);
        this.afterClose();
    };

    Dialog.prototype.onWindowResize = function onWindowResize() {
        this._hasWindowResize = true;
    };

    Dialog.prototype.render = function render() {
        var _classnames;

        /* eslint-disable no-unused-vars, react/prop-types */
        var _props = this.props,
            prefix = _props.prefix,
            closable = _props.closable,
            children = _props.children,
            className = _props.className,
            footerAlign = _props.footerAlign,
            onClose = _props.onClose,
            style = _props.style,
            role = _props.role,
            wrapperClassName = _props.wrapperClassName,
            others = _objectWithoutProperties(_props, ['prefix', 'closable', 'children', 'className', 'footerAlign', 'onClose', 'style', 'role', 'wrapperClassName']),
            props = _extends({
            align: 'cc cc'
        }, others, this.mapClosableToConfig(closable)),
            onPosition = makeChain(this.onPosition, this.props.onPosition);

        delete props.closable;

        var wrapperClassNameMix = (0, _classnames3['default'])((_classnames = {}, _defineProperty(_classnames, this.getPrefix() + 'dialog-wrapper', true), _defineProperty(_classnames, wrapperClassName, wrapperClassName), _classnames));

        props.wrapperClassName = wrapperClassNameMix;

        var beforeOpen = makeChain(this.beforeOpen, this.props.beforeOpen),
            afterClose = makeChain(this.afterClose, this.props.afterClose);

        others = (0, _nextUtil.pickAttrs)(others);

        return _react2['default'].createElement(
            _nextOverlay2['default'],
            _extends({}, props, {
                onRequestClose: this.onClose,
                beforeOpen: beforeOpen,
                afterClose: afterClose,
                onPosition: this.adjustPosition,
                beforePosition: this.beforePosition,
                canCloseByOutSideClick: false,
                needAdjust: false,
                ref: 'overlay' }),
            _react2['default'].createElement(
                _inner2['default'],
                _extends({}, others, {
                    onClose: this.onCloseButtonClick,
                    className: className,
                    footerAlign: footerAlign,
                    closable: closable,
                    style: style,
                    role: role,
                    'aria-hidden': !this.props.visible }),
                children
            )
        );
    };

    Dialog.prototype.beforeOpen = function beforeOpen() {
        var value = {
            overflowY: 'hidden'
        };
        if (hasScroll()) {
            value.paddingRight = (0, _nextUtil.scrollbar)().width + 'px';
        }
        _nextDom.style.set(document.body, value);
    };

    Dialog.prototype.afterClose = function afterClose() {
        _nextDom.style.set(document.body, {
            overflowY: 'auto',
            paddingRight: 0
        });
    };

    Dialog.prototype.onClose = function onClose() {
        this.props.onClose('fromKeyboard');
    };

    Dialog.prototype.onCloseButtonClick = function onCloseButtonClick() {
        var res = this.mapClosableToConfig(this.props.closable);

        if (res.canCloseByCloseClick) {
            this.props.onClose('fromCloseBtn');
        }
    };

    Dialog.prototype.onKeyDown = function onKeyDown(e) {
        var node = this.refs.overlay.getContentNode();
        if (node) {
            limitTabRange(node, e);
        }
    };

    Dialog.prototype.beforePosition = function beforePosition() {
        if (this.props.visible) {
            var content = this.refs.overlay ? this.refs.overlay.getContent() : '';
            if (content) {
                var body = content.getBody();
                var node = this.refs.overlay.getContentNode();
                if (this._hasWindowResize) {
                    this.revertSize(node, body);
                    this._hasWindowResize = false;
                }
            }
        }
    };

    Dialog.prototype.adjustPosition = function adjustPosition() {
        var minMargin = this.props.minMargin;

        if (this.props.visible) {
            var content = this.refs.overlay ? this.refs.overlay.getContent() : '',
                dialogHeight = void 0;

            if (content) {
                var body = content.getBody();
                var node = this.refs.overlay.getContentNode();
                var top = _nextDom.style.get(node, 'top');
                var height = _nextDom.style.get(node, 'height'),
                    clientHeight = window.innerHeight || document.documentElement.clientHeight;

                if (top <= minMargin) {
                    _nextDom.style.set(node, 'top', minMargin + 'px');
                    if (clientHeight <= height + minMargin) {
                        dialogHeight = clientHeight - minMargin * 2;
                        this.adjustSize(node, dialogHeight);
                    } else if (body.scrollHeight === body.clientHeight) {
                        this.revertSize(node, body);
                    }
                } else if (clientHeight <= height + top) {
                    dialogHeight = clientHeight - top;
                    this.adjustSize(node, dialogHeight);
                }
            }
        }
    };

    Dialog.prototype.adjustSize = function adjustSize(node, dialogHeight) {
        var content = this.refs.overlay.getContent(),
            body = content.getBody(),
            header = content.getHeader(),
            footer = content.getFooter();

        var headerHeight = 0,
            footerHeight = 0;

        if (header) {
            headerHeight = _nextDom.style.get(header, 'height');
        }
        if (footer) {
            footerHeight = _nextDom.style.get(footer, 'height');
        }
        var dialogPadding = _nextDom.style.get(node, 'padding-top') + _nextDom.style.get(node, 'padding-bottom'),
            maxBodyHeight = dialogHeight - headerHeight - footerHeight - dialogPadding;

        if (maxBodyHeight < 0) {
            maxBodyHeight = 1;
        }
        _nextDom.style.set(body, {
            'max-height': maxBodyHeight + 'px',
            'overflow-y': 'auto'
        });
    };

    Dialog.prototype.revertSize = function revertSize(node, body) {

        _nextDom.style.set(node, 'height', 'auto');
        _nextDom.style.set(body, {
            'max-height': 'none'
        });
    };

    Dialog.prototype.mapClosableToConfig = function mapClosableToConfig(closable) {
        var res = {},
            map = ['esc', 'outSide', 'close', 'mask'];

        closable = parseComboOption(closable);
        map.forEach(function (o) {
            var value = closable === true ? true : closable[o] || false;
            var key = o.charAt(0).toUpperCase() + o.substr(1);
            if (o === 'esc' || o === 'mask') {
                res['canCloseBy' + key] = value;
            } else {
                res['canCloseBy' + key + 'Click'] = value;
            }
        });
        return res;
    };

    return Dialog;
}(_react2['default'].Component), _class.propTypes = {
    prefix: PropTypes.string,
    hasMask: PropTypes.bool,
    onClose: PropTypes.func,
    closable: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    minMargin: PropTypes.number
}, _class.defaultProps = {
    prefix: 'next-',
    hasMask: true,
    animation: {
        'in': 'zoomIn',
        out: 'zoomOut'
    },
    onClose: noop,
    closable: 'esc,close',
    autoFocus: true,
    minMargin: 40
}, _class.contextTypes = {
    prefix: PropTypes.string
}, _temp);
Dialog.displayName = 'Dialog';
exports['default'] = Dialog;
module.exports = exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PropTypes = _react2['default'].PropTypes,
    toUpperCase = function toUpperCase(str) {
    return str.charAt(0).toUpperCase() + str.substr(1);
};

['header', 'footer', 'body'].forEach(function (cls) {
    var _class, _temp;

    exports[toUpperCase(cls)] = (_temp = _class = function (_Component) {
        _inherits(_class, _Component);

        function _class() {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, _Component.apply(this, arguments));
        }

        _class.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                others = _objectWithoutProperties(_props, ['children']);

            var prefix = this.context.prefix || this.props.prefix;
            return _react2['default'].createElement(
                'div',
                _extends({}, others, { className: prefix + 'dialog-' + cls }),
                children
            );
        };

        return _class;
    }(_react.Component), _class.propTypes = {
        prefix: PropTypes.string,
        children: PropTypes.any
    }, _class.defaultProps = {
        prefix: 'next-'
    }, _class.contextTypes = {
        prefix: PropTypes.string
    }, _class.dialogMark = cls, _temp);
});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(3);


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(1);
var LIBRARY = __webpack_require__(25);
var wksExt = __webpack_require__(54);
var defineProperty = __webpack_require__(14).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(4);
var normalizeHeaderName = __webpack_require__(190);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(93);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(93);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(5));
	else if(typeof define === 'function' && define.amd)
		define("aps", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["aps"] = factory(require("react"), require("react-dom"));
	else
		root["aps"] = factory(root["React"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_42__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 105);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var req = __webpack_require__(136);
req.keys().forEach(function (key) {
  var info = /^\.\/([a-z0-9\-]+)\.js$/i.exec(key);
  if (!info || !info[1] || info[1] == 'index') return;
  exports[info[1]] = req(key);
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(129);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(34);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var req = __webpack_require__(112);
req.keys().forEach(function (key) {
  var info = /^\.\/([a-z0-9\-]+)\/index\.js$/i.exec(key);
  if (!info) return;
  exports[info[1]] = req(key);
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(170)();
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; //组件样式


__webpack_require__(174);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Icon, _ComBase);

  function Icon() {
    (0, _classCallCheck3.default)(this, Icon);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Icon.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        type = _props.type,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        spin = _props.spin;

    var classString = (0, _common.cname)((_cname = {
      icon: true,
      aniTransition: true,
      widget: true
    }, _cname['icon-' + type] = true, _cname.iconSpin = !!spin || type === 'loading', _cname), className);
    return _react2.default.createElement('i', (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: classString }));
  };

  return Icon;
}(_common.ComBase), _class.defaultProps = {
  spin: false
}, _temp);
exports.default = Icon;
module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(51)('wks');
var uid = __webpack_require__(38);
var Symbol = __webpack_require__(11).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(9);
var ctx = __webpack_require__(30);
var hide = __webpack_require__(20);
var has = __webpack_require__(21);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(107), __esModule: true };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(14);
var IE8_DOM_DEFINE = __webpack_require__(67);
var toPrimitive = __webpack_require__(47);
var dP = Object.defineProperty;

exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(23)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _regenerator = __webpack_require__(28);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(29);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _Proxy2 = __webpack_require__(27);

var _Proxy3 = _interopRequireDefault(_Proxy2);

var _Overlay2 = __webpack_require__(92);

var _Overlay3 = _interopRequireDefault(_Overlay2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(181);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_ALLOWED_DIRECTION = ['bottom', 'top', 'right', 'left'];

var DEFAULT_ALLOWED_V_ALIGN = ['top', 'middle', 'bottom'];

var DEFAULT_ALLOWED_H_ALIGN = ['left', 'center', 'right'];

var Popover = function (_ComBase) {
  (0, _inherits3.default)(Popover, _ComBase);

  function Popover() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Popover.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        className = _props.className,
        inside = _props.inside,
        dock = _props.dock,
        overlay = _props.overlay,
        follow = _props.follow;

    var names = (0, _common.cname)((_cname = {
      popover: true,
      aniTransition: true,
      widget: true,
      widgetShadow: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      dock: !!dock,
      hasOverlay: overlay,
      follow: !!follow,
      fixed: !!this.state.fixed,
      stateHidden: !this.isVisable(),
      stateVisible: this.isVisable()
    }, _cname['dock-' + dock] = !!dock, _cname['direction-' + this.state.direction] = !!this.state.direction, _cname['align-' + this.state.align] = !!this.state.align, _cname.inside = inside, _cname), className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: names }),
      _react2.default.createElement(_Overlay3.default, { onClick: this.props.onOverlayClick,
        inside: inside && dock,
        visible: this.props.overlay && this.props.visible }),
      this.props.children,
      _react2.default.createElement(_Proxy3.default, { target: document.defaultView,
        capture: true,
        onScroll: this.reflow.bind(this) })
    );
  };

  /**
   * 在属性有更新新时
   * @param {Object} nextProps 新的属性 map
   * @returns {void} 无返回
   */


  Popover.prototype.componentWillReceiveProps = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(nextProps) {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _common.sleep)(0);

            case 2:
              this.applyFollow(nextProps.follow);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function componentWillReceiveProps(_x) {
      return _ref.apply(this, arguments);
    }

    return componentWillReceiveProps;
  }();

  /**
   * 在组件挂载时
   * @returns {void} 无返回
   */


  Popover.prototype.componentDidMount = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var _props2, inside, dock;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _props2 = this.props, inside = _props2.inside, dock = _props2.dock;

              if (!inside) {
                _common.shadow.add(this.domNode);
              }
              if (inside && dock) {
                this._overlay = this.domNode.querySelector('.' + (0, _common.cname)('overlay'));
                this.domNode.parentNode.appendChild(this._overlay);
              }
              _context2.next = 5;
              return (0, _common.sleep)(0);

            case 5:
              this.applyFollow(this.props.follow);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function componentDidMount() {
      return _ref2.apply(this, arguments);
    }

    return componentDidMount;
  }();

  Popover.prototype.reflow = function reflow() {
    if (!this.props.visible) return;
    this.applyFollow(this.props.follow);
  };

  Popover.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props3 = this.props,
        inside = _props3.inside,
        dock = _props3.dock;

    if (!inside) {
      _common.shadow.remove(this.domNode);
    }
    if (inside && dock && this._overlay) {
      this.domNode.appendChild(this._overlay);
    }
  };

  Popover.prototype.calcInside = function calcInside() {
    if (this.props.inside != 'auto') return;
    if (this.props.visible) {
      _common.shadow.add(this.domNode);
    } else {
      _common.shadow.remove(this.domNode);
    }
  };

  //应用跟随


  Popover.prototype.applyFollow = function applyFollow(target) {
    //检查是否挂载
    var panel = this.domNode;
    if (!panel) return;
    this.setState({ followApplyed: false });
    if (_common.utils.isFunction(target)) target = target();
    if (!target) return this.clearFollow(panel);
    this.calcInside();
    //确定坐标
    var targetOffset = void 0;
    if (this.props.onFollow) {
      targetOffset = this.props.onFollow(new _common.EventArgs(this, target));
    } else if (_common.utils.isString(target)) {
      return this.applyFollow(document.querySelector(target));
    } else if (_common.utils.isComponent(target)) {
      return this.applyFollow(this.findDOMNode(target));
    } else if (_common.utils.isElement(target)) {
      this.setState({ fixed: _common.utils.isFixed(target) });
      return this.applyFollow(_common.utils.getOffset(target));
    } else {
      targetOffset = target;
    }
    this.calcLocation(panel, targetOffset);
  };

  //清清跟随


  Popover.prototype.clearFollow = function clearFollow(panel) {
    panel.style.left = null;
    panel.style.top = null;
  };

  //兼容处理 offset


  Popover.prototype.compatibleOffset = function compatibleOffset(offset) {
    offset.left = offset.left || offset.x || 0;
    offset.top = offset.top || offset.y || 0;
    offset.width = offset.width || 0;
    offset.height = offset.height || 0;
    return offset;
  };

  //计算位置


  Popover.prototype.calcLocation = function calcLocation(panel, offset) {
    var targetOffset = this.compatibleOffset(offset);
    var panelOffset = this.compatibleOffset(_common.utils.getOffset(panel));
    var windowSize = _common.utils.getWindowSize();
    this.calcDirectionAndAlign({
      targetOffset: targetOffset,
      panelOffset: panelOffset,
      panel: panel,
      windowSize: windowSize
    });
  };

  //计算方向和对齐方式


  Popover.prototype.calcDirectionAndAlign = function calcDirectionAndAlign(opts) {
    //方向和对齐
    var direction = this.props.direction || this.calcDirection(opts);
    var align = this.props.align || this.calcAlign(direction, opts);
    //--
    this.setDirection(direction, opts);
    this.setAlign(direction, align, opts);
    //--
    this.setState({ followApplyed: true, direction: direction, align: align });
  };

  //自动确定 follow 方向


  Popover.prototype.calcDirection = function calcDirection(opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        windowSize = opts.windowSize;

    var allowedDirection = this.props.allowedDirection || DEFAULT_ALLOWED_DIRECTION;

    if (allowedDirection.includes('bottom') && windowSize.height - (targetOffset.top + targetOffset.height) > panelOffset.height) {
      return 'bottom';
    } else if (allowedDirection.includes('top') && targetOffset.top > panelOffset.height) {
      return 'top';
    } else if (allowedDirection.includes('right') && windowSize.width - (targetOffset.left + targetOffset.width) > panelOffset.width) {
      return 'right';
    } else if (allowedDirection.includes('left') && targetOffset.left > panelOffset.width) {
      return 'left';
    } else {
      return allowedDirection[0] || 'bottom';
    }
  };

  //自动计算对齐方式


  Popover.prototype.calcAlign = function calcAlign(direction, opts) {
    if (['top', 'bottom'].includes(direction)) {
      return this.calcHAlign(opts);
    } else {
      return this.calcVAlign(opts);
    }
  };

  //计算水平对齐


  Popover.prototype.calcHAlign = function calcHAlign(opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        windowSize = opts.windowSize;

    var allowedHAlign = this.props.allowedHAlign || DEFAULT_ALLOWED_H_ALIGN;
    if (allowedHAlign.includes('left') && windowSize.width - targetOffset.left > panelOffset.width) {
      return 'left';
    } else if (allowedHAlign.includes('right') && targetOffset.left + targetOffset.width > panelOffset.width) {
      return 'right';
    } else {
      return allowedHAlign[0] || 'left';
    }
  };

  //计算水平对齐


  Popover.prototype.calcVAlign = function calcVAlign(opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        windowSize = opts.windowSize;

    var allowedVAlign = this.props.allowedVAlign || DEFAULT_ALLOWED_V_ALIGN;
    if (allowedVAlign.includes('top') && windowSize.height - targetOffset.top > panelOffset.height) {
      return 'top';
    } else if (allowedVAlign.includes('bottom') && targetOffset.top + targetOffset.height > panelOffset.height) {
      return 'bottom';
    } else {
      return allowedVAlign[0] || 'top';
    }
  };

  //设定所在的方向


  Popover.prototype.setDirection = function setDirection(direction, opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        panel = opts.panel;

    switch (direction) {
      case 'top':
        {
          var top = targetOffset.top - panelOffset.height;
          panel.style.top = top + 'px';
          break;
        }
      case 'right':
        {
          var left = targetOffset.left + targetOffset.width;
          panel.style.left = left + 'px';
          break;
        }
      case 'bottom':
        {
          var _top = targetOffset.top + targetOffset.height;
          panel.style.top = _top + 'px';
          break;
        }
      case 'left':
        {
          var _left = targetOffset.left - panelOffset.width;
          panel.style.left = _left + 'px';
          break;
        }
      default:
        throw new _common.Error('Popover invalid direction "' + direction + '"');
    }
  };

  //设定对齐方式


  Popover.prototype.setAlign = function setAlign(direction, align, opts) {
    if (['top', 'bottom'].includes(direction)) {
      this.setHAlign(align, opts);
    } else {
      this.setVAlign(align, opts);
    }
  };

  //设置水平对齐


  Popover.prototype.setHAlign = function setHAlign(align, opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        panel = opts.panel;

    switch (align) {
      case 'left':
        {
          panel.style.left = targetOffset.left + 'px';
          break;
        }
      case 'center':
        {
          var left = targetOffset.left + targetOffset.width / 2 - panelOffset.width / 2;
          panel.style.left = left + 'px';
          break;
        }
      case 'right':
        {
          var _left2 = targetOffset.left + targetOffset.width - panelOffset.width;
          panel.style.left = _left2 + 'px';
          break;
        }
      default:
        throw new _common.Error('Popover invalid align "' + align + '"');
    }
  };

  //设置垂直对齐


  Popover.prototype.setVAlign = function setVAlign(align, opts) {
    var targetOffset = opts.targetOffset,
        panelOffset = opts.panelOffset,
        panel = opts.panel;

    switch (align) {
      case 'top':
        {
          panel.style.top = targetOffset.top + 'px';
          break;
        }
      case 'middle':
        {
          var top = targetOffset.top + targetOffset.height / 2 - panelOffset.height / 2;
          panel.style.top = top + 'px';
          break;
        }
      case 'bottom':
        {
          var _top2 = targetOffset.top + targetOffset.height - panelOffset.height;
          panel.style.top = _top2 + 'px';
          break;
        }
      default:
        throw new _common.Error('Popover invalid align "' + align + '"');
    }
  };

  //检查是否显示


  Popover.prototype.isVisable = function isVisable() {
    if (!this.props.follow || this.state.followApplyed) {
      return this.props.visible;
    } else {
      return false;
    }
  };

  return Popover;
}(_common.ComBase);

exports.default = Popover;
module.exports = exports['default'];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var createDesc = __webpack_require__(37);
module.exports = __webpack_require__(18) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(138);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(69);
var defined = __webpack_require__(48);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(113);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(77);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(141), __esModule: true };

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_NAME = /^on/;

var Proxy = function (_ComBase) {
  (0, _inherits3.default)(Proxy, _ComBase);

  function Proxy() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Proxy);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.oldValues = {}, _this.events = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Proxy.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        target = _props.target,
        capture = _props.capture,
        props = (0, _objectWithoutProperties3.default)(_props, ['target', 'capture']);

    target = target || document;
    target.$proxyStack = target.$proxyStack || [];
    _common.utils.each(props, function (name, value) {
      if (EVENT_NAME.test(name)) {
        var eventName = name.slice(2).toLowerCase();
        target.addEventListener(eventName, value, capture || false);
        _this2.events[name] = value;
      } else {
        _this2.oldValues[name] = target[name];
        target[name] = value;
      }
    });
    target.$proxyStack.push(this);
  };

  Proxy.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        target = _props2.target,
        capture = _props2.capture;

    target = target || document;
    target.$proxyStack = target.$proxyStack || [];
    var index = target.$proxyStack.indexOf(this);
    var nextItem = target.$proxyStack[index + 1];
    _common.utils.each(this.oldValues, function (name, value) {
      if (nextItem) {
        nextItem.oldValues[name] = value;
      } else {
        target[name] = value;
      }
    });
    _common.utils.each(this.events, function (name, handler) {
      if (EVENT_NAME.test(name)) {
        var eventName = name.slice(2).toLowerCase();
        target.removeEventListener(eventName, handler, capture || false);
      }
    });
    target.$proxyStack.splice(index, 1);
  };

  return Proxy;
}(_common.ComBase);

exports.default = Proxy;
module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(177);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(44);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(36);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(68);
var enumBugKeys = __webpack_require__(52);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(133), __esModule: true };

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(179), __esModule: true };

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(16).f;
var has = __webpack_require__(21);
var TAG = __webpack_require__(12)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_42__;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _for = __webpack_require__(144);

var _for2 = _interopRequireDefault(_for);

var _symbol = __webpack_require__(77);

var _symbol2 = _interopRequireDefault(_symbol);

var _ntils = __webpack_require__(84);

var _ntils2 = _interopRequireDefault(_ntils);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRANSFORM_MATRIX = /matrix\([\-\.\d]+, [\-\.\d]+, [\-\.\d]+, [\-\.\d]+, ([\-\.\d]+), ([\-\.\d]+)\)/;

//检查是否是一个 React 组件
_ntils2.default.isComponent = function (obj) {
  return obj instanceof _react2.default.Component;
};

//检查是否是 JSX 元素
_ntils2.default.isReactElement = function (obj) {
  if (!obj || !_ntils2.default.isObject(obj)) return false;
  if (typeof _symbol2.default === 'function' && _for2.default && (0, _for2.default)('react.element') == obj.$$typeof) {
    return true;
  }
  return '$$typeof' in obj && (obj.$$typeof.toString() == 'Symbol(react.element)' || obj.$$typeof.toString() === '60103');
};

_ntils2.default.getStyle = function (element) {
  return window.getComputedStyle ? window.getComputedStyle(element, null) : element.currentStyle;
};

_ntils2.default.getTransformOffset = function (element) {
  var offset = { left: 0, top: 0 };
  var transform = this.getStyle(element).transform;
  var offsetInfo = TRANSFORM_MATRIX.exec(transform);
  if (offsetInfo && offsetInfo.length > 2) {
    offset = {
      left: parseInt(offsetInfo[1]),
      top: parseInt(offsetInfo[2])
    };
  }
  var parentElement = element.parentElement;
  if (parentElement && parentElement != document.body) {
    var parentOffset = this.getTransformOffset(parentElement);
    offset.left += parentOffset.left;
    offset.top += parentOffset.top;
    offset.top -= parentElement.scrollTop;
    offset.left -= parentElement.scrollLeft;
  }
  return offset;
};

//获取一个元素的 offset
_ntils2.default.getPositionOffset = function (element, opts) {
  opts = (0, _assign2.default)({}, opts);
  if (element == document.body) {
    return { left: 0, top: 0, width: 0, height: 0 };
  }
  var offset = {
    left: parseInt(element.offsetLeft || 0),
    top: parseInt(element.offsetTop || 0)
  };
  if (opts.parent !== false && element.offsetParent) {
    var parentStyle = this.getStyle(element.offsetParent);
    offset.left += parseInt(parentStyle.borderLeftWidth || 0);
    offset.top += parseInt(parentStyle.borderTopWidth || 0);
    var parentOffset = this.getPositionOffset(element.offsetParent, opts);
    offset.left += parentOffset.left;
    offset.top += parentOffset.top;
  }
  (0, _assign2.default)(offset, {
    left: offset.left || 0,
    top: offset.top || 0,
    width: element.offsetWidth || 0,
    height: element.offsetHeight || 0
  });
  return offset;
};

_ntils2.default.getOffset = function (element, opts) {
  opts = (0, _assign2.default)({}, opts);
  var positionOffset = this.getPositionOffset(element, opts);
  if (opts.transform !== false) {
    var transformOffset = this.getTransformOffset(element, opts);
    positionOffset.left += transformOffset.left;
    positionOffset.top += transformOffset.top;
  }
  return positionOffset;
};

//获取窗口大小
_ntils2.default.getWindowSize = function () {
  var size = {};
  // 获取窗口宽度
  if (window.innerWidth) size.width = window.innerWidth;else if (document.body && document.body.clientWidth) size.width = document.body.clientWidth;
  // 获取窗口高度
  if (window.innerHeight) size.height = window.innerHeight;else if (document.body && document.body.clientHeight) size.height = document.body.clientHeight;
  // 通过深入 Document 内部对 body 进行检测，获取窗口大小
  if (document.documentElement && document.documentElement.clientHeight && document.documentElement.clientWidth) {
    size.height = document.documentElement.clientHeight;
    size.width = document.documentElement.clientWidth;
  }
  return size;
};

_ntils2.default.isFixed = function (element) {
  if (!this.isElement(element)) return false;
  var style = this.getStyle(element);
  if (style.position == 'fixed') return true;
  if (element.parentNode) return this.isFixed(element.parentNode);
  return false;
};

//通过 type 查找 jsx 元素
_ntils2.default.findChildren = function (type, children) {
  var result = [];
  _react2.default.Children.forEach(children, function (child) {
    if (!child) return;
    if (!type || child.type == type) result.push(child);
  });
  return result;
};

//去重，元素是object的话通过key去重
_ntils2.default.filterDuplicate = function (list) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';

  var out = [];
  var values = [];

  if (list && _ntils2.default.isArray(list) && list.length) {
    list.forEach(function (item) {
      if (out && out.length) {
        if (values.indexOf(typeof item === 'string' ? item : item[key]) === -1) {
          out.push(item);
        }
        values.push(typeof item === 'string' ? item : item[key]);
      } else {
        values.push(typeof item === 'string' ? item : item[key]);
        out.push(item);
      }
    });
  }
  return out;
};

/**
 * dom是否包含其他元素
 * 
 * @param {Element} container 容器
 * @param {Element} element        子元素
 * @return {Boolean} 是否包含
 */
_ntils2.default.contains = function (container, element) {
  if (!container || !element) return false;
  if (_ntils2.default.isComponent(container)) container = container.domNode;
  if (_ntils2.default.isString(container)) container = document.querySelector(container);
  if (_ntils2.default.isComponent(element)) element = element.domNode;
  if (_ntils2.default.isString(element)) element = document.querySelector(element);
  if (container.compareDocumentPosition) return container === element || !!(container.compareDocumentPosition(element) & 16);
  if (container.contains && element.nodeType === 1) {
    return container.contains(element) && container !== element;
  }
  while (element = element.parentNode) {
    if (element === container) return true;
  }return false;
};

exports.default = _ntils2.default;
module.exports = exports['default'];

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(151), __esModule: true };

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(187);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Input, _ComBase);

  function Input() {
    (0, _classCallCheck3.default)(this, Input);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Input.prototype.handleKeyDown = function handleKeyDown(event) {
    var _props = this.props,
        onPressEnter = _props.onPressEnter,
        onKeyDown = _props.onKeyDown;

    if (event.keyCode === _common.KeyCode.ENTER && onPressEnter) {
      onPressEnter(new _common.EventArgs(this, null, event));
    }
    if (onKeyDown) {
      onKeyDown(new _common.EventArgs(this, event.keyCode, event));
    }
  };

  Input.prototype.renderInputWithIcon = function renderInputWithIcon(input) {
    var _props2 = this.props,
        prefix = _props2.prefix,
        suffix = _props2.suffix;

    if (!prefix && !suffix) return input;

    var preEle = prefix ? _react2.default.createElement(
      'span',
      { className: (0, _common.cname)({ prefix: true }) },
      prefix
    ) : null;

    var sufEle = suffix ? _react2.default.createElement(
      'span',
      { className: (0, _common.cname)({ suffix: true }) },
      suffix
    ) : null;

    return _react2.default.createElement(
      'span',
      { className: (0, _common.cname)('inputWrapper') },
      preEle,
      input,
      sufEle
    );
  };

  Input.prototype.render = function render() {
    var _cname;

    var _props3 = this.props,
        type = _props3.type,
        size = _props3.size,
        className = _props3.className,
        readOnly = _props3.readOnly,
        value = _props3.value,
        defaultValue = _props3.defaultValue,
        multiple = _props3.multiple,
        rows = _props3.rows,
        maxLength = _props3.maxLength,
        other = (0, _objectWithoutProperties3.default)(_props3, ['type', 'size', 'className', 'readOnly', 'value', 'defaultValue', 'multiple', 'rows', 'maxLength']);


    var cls = (0, _common.cname)((_cname = {
      aniTransition: true,
      widget: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      input: true,
      inputMultiple: multiple
    }, _cname['size-' + size] = !multiple, _cname), className);

    return this.renderInputWithIcon(multiple ? _react2.default.createElement('textarea', (0, _extends3.default)({}, (0, _common.transportProps)(other), {
      className: cls,
      rows: rows,
      readOnly: readOnly,
      value: value,
      defaultValue: defaultValue,
      onKeyDown: this.handleKeyDown.bind(this),
      maxLength: maxLength
    })) : _react2.default.createElement('input', (0, _extends3.default)({}, (0, _common.transportProps)(other), {
      type: type,
      className: cls,
      readOnly: readOnly,
      value: value,
      defaultValue: defaultValue,
      onKeyDown: this.handleKeyDown.bind(this),
      maxLength: maxLength
    })));
  };

  return Input;
}(_common.ComBase), _class.propTypes = {
  /**
   * 类型
   */
  type: _propTypes2.default.oneOf(['text', 'number', 'password']),
  /**
   * 值
   */
  value: _propTypes2.default.any,
  /**
   * 默认值
   */
  defaultValue: _propTypes2.default.any,
  /**
   * 大小
   */
  size: _propTypes2.default.oneOf(['large', 'medium', 'small']),
  /**
   * 是否只读
   */
  readOnly: _propTypes2.default.bool,
  /**
   * 输入回车时的回调
   */
  onPressEnter: _propTypes2.default.func,
  /**
   * 前缀图标
   */
  prefix: _propTypes2.default.object,
  /**
   * 后缀图标
   */
  suffix: _propTypes2.default.object,
  /**
   * 多行模式
   */
  multiple: _propTypes2.default.bool,
  /**
   * 多行模式可见行数
   */
  rows: _propTypes2.default.number
}, _class.defaultProps = {
  type: 'text',
  size: 'medium',
  readOnly: false,
  multiple: false
}, _temp);
exports.default = Input;
module.exports = exports['default'];

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var document = __webpack_require__(11).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(17);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(51)('keys');
var uid = __webpack_require__(38);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 53 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(48);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(14);
var dPs = __webpack_require__(117);
var enumBugKeys = __webpack_require__(52);
var IE_PROTO = __webpack_require__(50)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(46)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(75).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(12);


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(9);
var LIBRARY = __webpack_require__(40);
var wksExt = __webpack_require__(56);
var defineProperty = __webpack_require__(16).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = {"name":"aps","env":"prod"}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _promise = __webpack_require__(44);

var _promise2 = _interopRequireDefault(_promise);

exports.getRootContainer = getRootContainer;
exports.add = add;
exports.remove = remove;
exports.render = render;
exports.unmount = unmount;

var _reactDom = __webpack_require__(42);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(43);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRootContainer() {
  return document.body;
}

function add(element) {
  if (!element) return;
  var root = getRootContainer();
  if (element.parentNode == root) return;
  element.$parentNode = element.parentNode;
  return root.appendChild(element);
}

function remove(element) {
  if (!element) return;
  var root = getRootContainer();
  if (element.parentNode == root) {
    root.removeChild(element);
  }
  if (element.$parentNode) {
    element.$parentNode.appendChild(element);
  }
  element.$parentNode = null;
}

function render(vDom, parentNode) {
  if (!vDom) return;
  var root = getRootContainer();
  if (!parentNode) {
    parentNode = document.createElement('div');
    root.appendChild(parentNode);
  }
  if (_utils2.default.isString(parentNode)) {
    parentNode = document.querySelector(parentNode);
  }
  return new _promise2.default(function (resolve) {
    _reactDom2.default.render(vDom, parentNode, function () {
      this.$container = parentNode;
      resolve(this);
    });
  });
}

function unmount(instance) {
  if (!instance) return;
  var container = instance.$container;
  var domNode = instance.domNode;
  if (domNode.parentNode != container) {
    container.appendChild(domNode);
  }
  _reactDom2.default.unmountComponentAtNode(container);
  container.parentNode.removeChild(container);
}

exports.default = {
  render: render, unmount: unmount, add: add, remove: remove, getRootContainer: getRootContainer
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(36);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(184);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckBox = (_dec = (0, _common.meta)({
  valuePropName: 'checked',
  valuePath: 'target.checked'
}), _dec(_class = function (_ComBase) {
  (0, _inherits3.default)(CheckBox, _ComBase);

  function CheckBox() {
    (0, _classCallCheck3.default)(this, CheckBox);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  /**
   * 组件挂载后
   * @returns {void} 无返回
   */
  CheckBox.prototype.componentDidMount = function componentDidMount() {
    if (this.props.indeterminate === true) {
      this._setIndeterminate(true);
    }
  };

  /**
   * 组件更新时（属性发生变化）
   * @param {object} previousProps 更新的属性
   * @returns {void} 无返回
   */


  CheckBox.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    if (previousProps.indeterminate !== this.props.indeterminate) {
      this._setIndeterminate(this.props.indeterminate);
    }
  };

  /**
   * 设置 indeterminate
   * @param {boolean} indeterminate indeterminate 的值
   * @returns {void} 无返回
   */


  CheckBox.prototype._setIndeterminate = function _setIndeterminate(indeterminate) {
    var node = this.domNode.querySelector('input');
    node.indeterminate = indeterminate;
    if (indeterminate) {
      node.setAttribute('indeterminate', 'indeterminate');
    } else {
      node.removeAttribute('indeterminate');
    }
  };

  /**
   * 渲染组件 dom
   * @returns {object} 组件 dom
   */


  CheckBox.prototype.render = function render() {
    /*eslint-disable*/
    var _props = this.props,
        indeterminate = _props.indeterminate,
        type = _props.type,
        className = _props.className,
        style = _props.style,
        others = (0, _objectWithoutProperties3.default)(_props, ['indeterminate', 'type', 'className', 'style']);
    /*eslint-enable*/

    var wrapperNames = (0, _common.cname)({
      checkBox: true,
      aniTransition: true,
      widget: true,
      stateHidden: this.props.visible === false,
      stateVisible: this.props.visible !== false
    }, className);
    var innerNames = (0, _common.cname)({
      checkBoxInner: true,
      aniTransition: true
    });
    return _react2.default.createElement(
      'label',
      { className: wrapperNames, style: style },
      _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox' }, (0, _common.transportProps)(others))),
      _react2.default.createElement(
        'span',
        { className: innerNames },
        _react2.default.createElement(_Icon3.default, { type: 'right1',
          className: (0, _common.cname)('aniTransition check-box-checked') }),
        _react2.default.createElement('i', { className: (0, _common.cname)('aniTransition icon check-box-indeterminate') })
      )
    );
  };

  return CheckBox;
}(_common.ComBase)) || _class);
exports.default = CheckBox;
module.exports = exports['default'];

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateEntity = function () {
  function DateEntity(value) {
    (0, _classCallCheck3.default)(this, DateEntity);

    if (value instanceof DateEntity) {
      return new DateEntity(value.value);
    } else if (_common.utils.isDate(value)) {
      this.value = new Date(value);
    } else if (_common.utils.isString(value) || _common.utils.isNumber(value)) {
      this.value = new Date(value);
    } else if (_common.utils.isObject(value)) {
      var _value$year = value.year,
          year = _value$year === undefined ? 1970 : _value$year,
          _value$month = value.month,
          month = _value$month === undefined ? 1 : _value$month,
          _value$date = value.date,
          date = _value$date === undefined ? 1 : _value$date,
          _value$hours = value.hours,
          hours = _value$hours === undefined ? 0 : _value$hours,
          _value$minutes = value.minutes,
          minutes = _value$minutes === undefined ? 0 : _value$minutes,
          _value$seconds = value.seconds,
          seconds = _value$seconds === undefined ? 0 : _value$seconds;

      this.value = new Date(year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds);
    } else {
      this.value = new Date();
    }
  }

  DateEntity.prototype.addMonth = function addMonth(num) {
    this.date = 1;
    this.month += num;
    return this;
  };

  DateEntity.prototype.addYear = function addYear(num) {
    this.year += num;
    return this;
  };

  DateEntity.prototype.format = function format(str) {
    str = str || 'yyyy-MM-dd hh:mm:ss';
    return _common.utils.formatDate(this.value, str);
  };

  DateEntity.prototype.toString = function toString(str) {
    return this.format(str);
  };

  (0, _createClass3.default)(DateEntity, [{
    key: 'year',
    get: function get() {
      return this.value.getFullYear();
    },
    set: function set(value) {
      this.value.setFullYear(value);
    }
  }, {
    key: 'month',
    get: function get() {
      return this.value.getMonth() + 1;
    },
    set: function set(value) {
      this.value.setMonth(value - 1);
    }
  }, {
    key: 'date',
    get: function get() {
      return this.value.getDate();
    },
    set: function set(value) {
      this.value.setDate(value);
    }
  }, {
    key: 'hours',
    get: function get() {
      return this.value.getHours();
    },
    set: function set(value) {
      this.value.setHours(value);
    }
  }, {
    key: 'minutes',
    get: function get() {
      return this.value.getMinutes();
    },
    set: function set(value) {
      this.value.setMinutes(value);
    }
  }, {
    key: 'seconds',
    get: function get() {
      return this.value.getSeconds();
    },
    set: function set(value) {
      this.value.setSeconds(value);
    }
  }, {
    key: 'milliseconds',
    get: function get() {
      return this.value.getMilliseconds();
    },
    set: function set(value) {
      this.value.setMilliseconds(value);
    }
  }, {
    key: 'day',
    get: function get() {
      return this.value.getDay();
    },
    set: function set(value) {
      this.value.setDay(value);
    }
  }]);
  return DateEntity;
}();

exports.default = DateEntity;
module.exports = exports['default'];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

var rules = {
  required: /.+/,
  email: /[a-z0-9\-\_\.]+\@[a-z0-9\-\_\.]+/,
  number: function number(num) {
    return !isNaN(num);
  },
  len: function len(min, max) {
    return function (str) {
      return str && str.length >= min && str.length <= max;
    };
  },
  range: function range(min, max) {
    return function (num) {
      return num >= min && num <= max;
    };
  }
};

function validate(value, rule) {
  if (!rule) return true;
  if (_common.utils.isFunction(rule.test)) {
    return rule.test(value);
  } else if (_common.utils.isFunction(rule)) {
    return validate(value, { test: rule });
  } else if (_common.utils.isString(rule) && rule.includes('(')) {
    var ruleFunc = new Function('rules', 'return rules.' + rule)(rules);
    return validate(value, ruleFunc);
  } else if (_common.utils.isString(rule)) {
    return validate(value, rules[rule]);
  } else if (_common.utils.isArray(rule)) {
    return !rule.some(function (item) {
      return !validate(value, item);
    });
  } else {
    return true;
  }
}

validate.rules = rules;

exports.default = validate;
module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _Proxy2 = __webpack_require__(27);

var _Proxy3 = _interopRequireDefault(_Proxy2);

var _Input2 = __webpack_require__(45);

var _Input3 = _interopRequireDefault(_Input2);

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _Popover2 = __webpack_require__(19);

var _Popover3 = _interopRequireDefault(_Popover2);

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(225);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

var _constants = __webpack_require__(101);

var _option = __webpack_require__(226);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = function (_ComBase) {
  (0, _inherits3.default)(Select, _ComBase);

  function Select(props) {
    (0, _classCallCheck3.default)(this, Select);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    var dataSource = _this.getDataSource();
    var value = _this.getDefaultValue(props, dataSource);
    if (_this.props.mode === _constants.SelectMode.MULTIPLE) {
      value = _this.getValues(value);
    }
    _this.updateNodeWidth = _this.updateNodeWidth.bind(_this);

    if (!(typeof _this.updateNodeWidth === 'function')) {
      throw new TypeError('Value of "this.updateNodeWidth" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.updateNodeWidth));
    }

    _this.onBlurFromDomHandler = _this.onBlurFromDomHandler.bind(_this);

    if (!(typeof _this.onBlurFromDomHandler === 'function')) {
      throw new TypeError('Value of "this.onBlurFromDomHandler" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onBlurFromDomHandler));
    }

    _this.state = {
      selectFocused: false,
      selectOpened: false,
      dataSource: dataSource,
      filterDataSource: null,
      searchInput: '',
      value: value
    };
    return _this;
  }

  Select.prototype.getDefaultValue = function getDefaultValue(props, dataSource) {
    //value取值按照 `state.value > props.value > props.defaultValue > dataSource[0].value` 的优先级
    if (!_common.utils.isNull(props.value)) {
      return props.value;
    }
    if (!_common.utils.isNull(props.defaultValue)) {
      return props.defaultValue;
    }
    if (dataSource && dataSource.length > 0) {
      return dataSource[0].value || '';
    }
  };

  Select.prototype.getDataSource = function getDataSource(props) {
    props = props || this.props;
    var data = [];
    var _props = props,
        dataSource = _props.dataSource;

    var options = this.findChildren(_option2.default);
    if (dataSource) {
      dataSource.forEach(function (item, index) {
        if (item.hasOwnProperty('text')) {
          item.label = item.text;
        }
        data.push({
          value: !_common.utils.isNull(item.value) ? item.value : item,
          label: !_common.utils.isNull(item.label) ? item.label : item.value || item,
          disabled: !!item.disabled,
          id: index
        });
      });
      data = _common.utils.filterDuplicate(data, 'value');
    } else if (options && options.length) {
      options.forEach(function (item, index) {
        data.push({
          value: !_common.utils.isNull(item.props.value) ? item.props.value : item.props.children,
          label: !_common.utils.isNull(item.props.children) ? item.props.children : item.props.label || item.props.text || item.props.label,
          disabled: !!item.props.disabled,
          id: index
        });
      });
      data = _common.utils.filterDuplicate(data, 'value');
    }
    return data;
  };

  Select.prototype.onBlurFromDomHandler = function onBlurFromDomHandler(e) {
    if (!this.popover) return;
    if (!_common.utils.contains(this.domNode, e.target) && !_common.utils.contains(this.popover.domNode, e.target)) {
      this.setState({
        selectOpened: false,
        selectFocused: false
      });
    }
  };

  Select.prototype.onClickSelection = function onClickSelection() {
    if (this.props.disabled) return;
    var showSearch = this.props.showSearch;

    this.setState({
      selectOpened: showSearch ? true : !this.state.selectOpened,
      selectFocused: true,
      showSearchInput: showSearch
    });
    return true;
  };

  Select.prototype.onSelectOption = function onSelectOption(param) {
    if (this.props.disabled) return;
    var selectedValue = param.value;
    var _props2 = this.props,
        onChange = _props2.onChange,
        onSelect = _props2.onSelect,
        mode = _props2.mode,
        showSearch = _props2.showSearch,
        dropdownAutoHide = _props2.dropdownAutoHide;
    var _state = this.state,
        dataSource = _state.dataSource,
        filterDataSource = _state.filterDataSource;

    var stateValue = {};
    var isFilter = showSearch && filterDataSource;
    var value = this.valueFactory(dataSource, selectedValue);
    if (mode === _constants.SelectMode.MULTIPLE) {
      stateValue = {
        selectFocused: false,
        selectOpened: !dropdownAutoHide
      };
    } else {
      stateValue = {
        selectOpened: false,
        selectFocused: false
      };
    }
    stateValue.value = value;
    if (isFilter || showSearch) {
      stateValue.searchInput = '';
      stateValue.showSearchInput = false, stateValue.filterDataSource = null;
    }
    this.setState(stateValue);
    onChange && onChange(new _common.EventArgs(this, value));
    onSelect && onSelect(new _common.EventArgs(this, value));
  };

  Select.prototype.updateNodeWidth = function updateNodeWidth() {
    this.setState({
      nodeWidth: this.domNode.offsetWidth
    });
  };

  Select.prototype.componentDidMount = function componentDidMount() {
    this.updateNodeWidth();
  };

  Select.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var dataSource = this.getDataSource(nextProps);
    var newState = void 0;

    if (nextProps) {
      if (nextProps.value !== undefined && nextProps.value !== this.state.value) {
        newState = newState || {};
        newState.value = nextProps.value;
      }
      if (dataSource && dataSource !== this.state.dataSource) {
        newState = newState || {};
        newState.dataSource = dataSource;
      }
      if (newState) {
        this.setState(newState);
      }
    }
  };

  Select.prototype.onDeleteSelectedItem = function onDeleteSelectedItem(val) {
    var _props3 = this.props,
        onChange = _props3.onChange,
        onDeselect = _props3.onDeselect,
        disabled = _props3.disabled,
        mode = _props3.mode;

    if (disabled) return false;
    var dataSource = this.state.dataSource;
    var value = this.valueFactory(dataSource, val);
    this.setState({
      value: value
    });
    onChange && onChange(new _common.EventArgs(this, value));
    if (mode === _constants.SelectMode.MULTIPLE || mode === _constants.SelectMode.TAGS) {
      onDeselect && onDeselect(new _common.EventArgs(this, value));
    }
    return false;
  };

  Select.prototype.getValues = function getValues(value) {
    var values = [];
    if (_common.utils.isArray(value)) {
      value.forEach(function (item) {
        values.push(typeof item === 'string' ? item : item.value);
      });
    } else if (typeof value === 'string') {
      values = value.split(',');
    } else if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && value.value) {
      values.push(value.value);
    }
    return values;
  };

  Select.prototype.valueFactory = function valueFactory(dataSource, selectedValue) {
    var outValue = '';
    var mode = this.props.mode;
    var value = this.state.value;


    if (dataSource && dataSource.length) {
      if (mode === _constants.SelectMode.MULTIPLE) {
        outValue = value.concat([]);
        if (outValue.length == 0) {
          outValue.push(selectedValue);
        } else if (outValue.indexOf(selectedValue) > -1) {
          //删除
          outValue.splice(outValue.indexOf(selectedValue), 1);
        } else {
          outValue.push(selectedValue);
        }
      } else {
        outValue = selectedValue;
      }
    }
    return outValue;
  };

  Select.prototype.getValueAndLabels = function getValueAndLabels(dataSource, value) {
    var out = [];
    if (dataSource && dataSource.length) {
      if (_common.utils.isArray(value)) {
        value.forEach(function (vItem) {
          dataSource.forEach(function (item) {
            if (item.value === vItem) {
              out.push(item);
            }
          });
        });
      } else {
        dataSource.forEach(function (item) {
          if (item.value === value) {
            out = item;
          }
        });
      }
    }
    return out;
  };

  Select.prototype.getPopoverWrapper = function getPopoverWrapper(value, dataSource) {
    var _this2 = this;

    var _props4 = this.props,
        size = _props4.size,
        showSearch = _props4.showSearch,
        showTagMenu = _props4.showTagMenu,
        extendRender = _props4.extendRender,
        mode = _props4.mode,
        _props4$allowedDirect = _props4.allowedDirection,
        allowedDirection = _props4$allowedDirect === undefined ? ['bottom', 'top'] : _props4$allowedDirect;
    var _state2 = this.state,
        selectOpened = _state2.selectOpened,
        nodeWidth = _state2.nodeWidth;

    var sizeNames = (0, _common.cname)({
      selectLg: size && size === _constants.SelectSize.LARGE,
      selectMd: !size || size === _constants.SelectSize.MEDIUM,
      selectSm: size && size === _constants.SelectSize.SMALL
    });
    var showInput = showSearch || mode === _constants.SelectMode.COMBOBOX;
    dataSource = showInput && this.state.filterDataSource || dataSource;
    var dropdownNames = (0, _common.cname)({
      selectDropdown: true
    });
    var dropdownMenuNames = (0, _common.cname)({
      selectDropdownMenu: true,
      stateHidden: !selectOpened,
      tagMenu: showTagMenu
    });
    var isVisible = selectOpened && dataSource.length;
    if (isVisible && nodeWidth <= 0) {
      setTimeout(function () {
        return _this2.updateNodeWidth();
      }, 0);
    }
    return _react2.default.createElement(
      _Popover3.default,
      {
        ref: function ref(_ref) {
          return _this2.popover = _ref;
        },
        follow: this.selection,
        overlay: false,
        allowedDirection: allowedDirection,
        visible: isVisible,
        style: { width: nodeWidth },
        className: (0, _common.cname)([dropdownNames, sizeNames], 'dropdown') },
      _react2.default.createElement(
        'div',
        { className: dropdownMenuNames },
        _react2.default.createElement(
          'ul',
          null,
          dataSource.map(function (item, index) {
            var optSelected = _common.utils.isArray(value) ? value.indexOf(item.value) > -1 : showSearch ? value && item.value.indexOf(value) > -1 : value === item.value;
            return _react2.default.createElement(
              _option2.default,
              {
                id: item.id,
                disabled: item.disabled,
                selected: optSelected,
                tagMenu: showTagMenu,
                value: item.value,
                key: index,
                size: size,
                onSelect: _this2.onSelectOption.bind(_this2)
              },
              item.label
            );
          })
        ),
        extendRender && extendRender(dataSource)
      )
    );
  };

  Select.prototype.getSelectedValueNode = function getSelectedValueNode(mode, valueAndLabel) {
    var _this3 = this;

    return mode === _constants.SelectMode.MULTIPLE && _common.utils.isArray(valueAndLabel) ? valueAndLabel.map(function (item, index) {
      return _react2.default.createElement(
        'span',
        { key: index, className: (0, _common.cname)('selected-value-item') },
        item.label,
        _react2.default.createElement(_Icon3.default, {
          type: 'close',
          className: (0, _common.cname)('selected-close'),
          onClick: _this3.onDeleteSelectedItem.bind(_this3, item.value)
        })
      );
    }) : valueAndLabel.label;
  };

  Select.prototype.onInputChange = function onInputChange(e) {
    e.stopPropagation();
    var value = e.target.value;
    var _props5 = this.props,
        showSearch = _props5.showSearch,
        mode = _props5.mode,
        onChange = _props5.onChange,
        onSearch = _props5.onSearch;

    var dataSource = this.state.dataSource.filter(function (item) {
      return item.value.indexOf(value) > -1;
    });
    this.setState({
      filterDataSource: dataSource,
      searchInput: e.target.value
    });

    if (mode === _constants.SelectMode.COMBOBOX) {
      onChange && onChange(new _common.EventArgs(this, value));
    } else if (showSearch) {
      onSearch && onSearch(new _common.EventArgs(this, value));
    }
  };

  Select.prototype.render = function render() {
    var _this4 = this;

    var dataSource = this.getDataSource();
    var value = this.props.showSearch && this.state.searchInput || this.state.value;
    var valueAndLabel = this.getValueAndLabels(dataSource, value);
    var _props6 = this.props,
        visible = _props6.visible,
        className = _props6.className,
        size = _props6.size,
        disabled = _props6.disabled,
        mode = _props6.mode,
        hasArrow = _props6.hasArrow,
        showSearch = _props6.showSearch,
        resultRender = _props6.resultRender,
        placeholder = _props6.placeholder;
    var _state3 = this.state,
        selectFocused = _state3.selectFocused,
        selectOpened = _state3.selectOpened;

    var showInput = showSearch || mode === _constants.SelectMode.COMBOBOX;
    var names = (0, _common.cname)({
      widget: true,
      select: true,
      selectLg: size && size === _constants.SelectSize.LARGE,
      selectMd: !size || size === _constants.SelectSize.MEDIUM,
      selectSm: size && size === _constants.SelectSize.SMALL,
      selectFocused: selectFocused,
      selectOpened: selectOpened,
      stateHidden: this.props.hasOwnProperty('visible') && !visible,
      stateDisabled: !!disabled
    }, className);
    var barNames = (0, _common.cname)({
      selection: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      selectedClose: true
    });
    var selectedValueNode = !showSearch && resultRender ? resultRender(valueAndLabel) : this.getSelectedValueNode(mode, valueAndLabel);

    selectedValueNode = selectedValueNode || this.props.defaultValue;

    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), {
        className: names,
        style: this.props.style
      }),
      _react2.default.createElement(
        'div',
        {
          ref: function ref(selection) {
            _this4.selection = selection;
          },
          className: barNames,
          onClick: this.onClickSelection.bind(this)
        },
        showInput ? _react2.default.createElement(_Input3.default, {
          type: 'text',
          className: (0, _common.cname)('select-search'),
          size: size,
          value: value || '',
          placeholder: placeholder,
          autofocus: 'autofocus',
          onChange: this.onInputChange.bind(this)
        }) : _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('selected-value') },
          selectedValueNode
        ),
        hasArrow ? _react2.default.createElement(_Icon3.default, {
          type: 'arrow-down',
          className: (0, _common.cname)('select-arrow ani-transition')
        }) : null
      ),
      this.getPopoverWrapper(value, dataSource),
      _react2.default.createElement(_Proxy3.default, { target: document, onClick: this.onBlurFromDomHandler }),
      _react2.default.createElement(_Proxy3.default, { target: window, onResize: this.updateNodeWidth })
    );
  };

  return Select;
}(_common.ComBase);

Select.defaultProps = {
  mode: _constants.SelectMode.NORMAL,
  size: _constants.SelectSize.MEDIUM,
  hasArrow: true,
  resultRender: null,
  extendRender: null,
  dropdownAutoHide: false
};

Select.Option = _option2.default;
exports.default = Select;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

exports.default = new _common.Locale({
  zh: {
    alert: '提示',
    confirm: '确认',
    ok: '确定',
    cancel: '取消'
  },
  en: {
    alert: 'Alert',
    confirm: 'Confirm',
    ok: 'Ok',
    cancel: 'Cancel'
  }
});
module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(18) && !__webpack_require__(23)(function () {
  return Object.defineProperty(__webpack_require__(46)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(21);
var toIObject = __webpack_require__(24);
var arrayIndexOf = __webpack_require__(110)(false);
var IE_PROTO = __webpack_require__(50)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(32);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(49);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(135);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = function (_ComBase) {
  (0, _inherits3.default)(Alert, _ComBase);

  function Alert() {
    (0, _classCallCheck3.default)(this, Alert);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Alert.prototype.render = function render() {
    var _cname;

    var names = (0, _common.cname)((_cname = {
      widget: true,
      aniTransition: true,
      widgetShadow: this.props.shadow,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      alert: true
    }, _cname['alert-' + (this.props.type || 'success')] = true, _cname.stateHidden = this.props.visible === false, _cname.stateVisible = this.props.visible !== false, _cname), this.props.className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: names }),
      this.props.children
    );
  };

  return Alert;
}(_common.ComBase);

exports.default = Alert;
module.exports = exports['default'];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(115)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(73)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(40);
var $export = __webpack_require__(13);
var redefine = __webpack_require__(74);
var hide = __webpack_require__(20);
var Iterators = __webpack_require__(33);
var $iterCreate = __webpack_require__(116);
var setToStringTag = __webpack_require__(41);
var getPrototypeOf = __webpack_require__(118);
var ITERATOR = __webpack_require__(12)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(20);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(11).document;
module.exports = document && document.documentElement;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(119);
var global = __webpack_require__(11);
var hide = __webpack_require__(20);
var Iterators = __webpack_require__(33);
var TO_STRING_TAG = __webpack_require__(12)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(122), __esModule: true };

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(11);
var has = __webpack_require__(21);
var DESCRIPTORS = __webpack_require__(18);
var $export = __webpack_require__(13);
var redefine = __webpack_require__(74);
var META = __webpack_require__(123).KEY;
var $fails = __webpack_require__(23);
var shared = __webpack_require__(51);
var setToStringTag = __webpack_require__(41);
var uid = __webpack_require__(38);
var wks = __webpack_require__(12);
var wksExt = __webpack_require__(56);
var wksDefine = __webpack_require__(57);
var enumKeys = __webpack_require__(124);
var isArray = __webpack_require__(125);
var anObject = __webpack_require__(14);
var isObject = __webpack_require__(17);
var toIObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(47);
var createDesc = __webpack_require__(37);
var _create = __webpack_require__(55);
var gOPNExt = __webpack_require__(126);
var $GOPD = __webpack_require__(80);
var $DP = __webpack_require__(16);
var $keys = __webpack_require__(31);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(79).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(39).f = $propertyIsEnumerable;
  __webpack_require__(53).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(40)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(20)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(68);
var hiddenKeys = __webpack_require__(52).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(39);
var createDesc = __webpack_require__(37);
var toIObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(47);
var has = __webpack_require__(21);
var IE8_DOM_DEFINE = __webpack_require__(67);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(18) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {



/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.log = log;
exports.info = info;
exports.warn = warn;
exports.error = error;

var _$config = __webpack_require__(59);

var _$config2 = _interopRequireDefault(_$config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_PROD = _$config2.default.env != 'dev';

/**
 * 打印 log
 * @param {argument} args 参数
 * @returns {void} 无返回
 */
function log() {
  var _console;

  if (IS_PROD) return;
  return (_console = console).log.apply(_console, arguments); //eslint-disable-line
}

/**
 * 打印 info 
 * @param {argument} args 参数
 * @returns {void} 无返回
 */
function info() {
  var _console2;

  if (IS_PROD) return;
  return (_console2 = console).info.apply(_console2, arguments); //eslint-disable-line
}

/**
 * 打印 warn 
 * @param {argument} args 参数
 * @returns {void} 无返回
 */
function warn() {
  var _console3;

  if (IS_PROD) return;
  return (_console3 = console).warn.apply(_console3, arguments); //eslint-disable-line
}

/**
 * 打印 error 
 * @param {argument} args 参数
 * @returns {void} 无返回
 */
function error() {
  var _console4;

  if (IS_PROD) return;
  return (_console4 = console).error.apply(_console4, arguments); //eslint-disable-line
}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _utils = __webpack_require__(43);

var _utils2 = _interopRequireDefault(_utils);

var _$config = __webpack_require__(59);

var _$config2 = _interopRequireDefault(_$config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function create(prefix) {

  function convert(name, addPrefix) {
    if (!name) {
      return '';
    } else if (_utils2.default.isString(name) && name.includes(' ')) {
      return convert(name.split(' '), addPrefix);
    } else if (_utils2.default.isString(name) && name.includes(',')) {
      return convert(name.split(','), addPrefix);
    } else if (_utils2.default.isArray(name)) {
      return name.map(function (item) {
        return convert(item, addPrefix);
      }).join(' ').trim();
    } else if (_utils2.default.isObject(name)) {
      return convert((0, _keys2.default)(name).filter(function (key) {
        return name[key];
      }), addPrefix);
    } else if (_utils2.default.startWith(name, prefix)) {
      return name;
    } else {
      var trimedName = name.trim().replace(/([A-Z])/g, '-$1').toLowerCase();
      if (!trimedName) return '';
      return addPrefix ? prefix + '-' + trimedName : trimedName;
    }
  }

  function cname(name, literal) {
    if (literal === true || literal === false) {
      return convert(name, literal);
    } else {
      var convertNames = convert(name, true);
      if (literal) {
        convertNames += ' ' + convert(literal, false);
      }
      return convertNames;
    }
  }

  return cname;
}

var func = create(_$config2.default.name);
func.create = create;

exports.default = func;
module.exports = exports['default'];

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

(function (ntils) {

  /**
   * 空函数
   */
  ntils.noop = function () { };

  /**
   * 验证一个对象是否为NULL
   * @method isNull
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isNull = function (obj) {
    return obj === null || typeof obj === "undefined";
  };

  /**
   * 除去字符串两端的空格
   * @method trim
   * @param  {String} str 源字符串
   * @return {String}     结果字符串
   * @static
   */
  ntils.trim = function (str) {
    if (this.isNull(str)) return str;
    if (str.trim) {
      return str.trim();
    } else {
      return str.replace(/(^[\\s]*)|([\\s]*$)/g, "");
    }
  };

  /**
   * 替换所有
   * @method replace
   * @param {String} str 源字符串
   * @param {String} str1 要替换的字符串
   * @param {String} str2 替换为的字符串
   * @static
   */
  ntils.replace = function (str, str1, str2) {
    if (this.isNull(str)) return str;
    return str.replace(new RegExp(str1, 'g'), str2);
  };

  /**
   * 从字符串开头匹配
   * @method startWith
   * @param {String} str1 源字符串
   * @param {String} str2 要匹配的字符串
   * @return {Boolean} 匹配结果
   * @static
   */
  ntils.startWith = function (str1, str2) {
    if (this.isNull(str1) || this.isNull(str2)) return false;
    return str1.indexOf(str2) === 0;
  };

  /**
   * 是否包含
   * @method contains
   * @param {String} str1 源字符串
   * @param {String} str2 检查包括字符串
   * @return {Boolean} 结果
   * @static
   */
  ntils.contains = function (str1, str2) {
    var self = this;
    if (this.isNull(str1) || this.isNull(str2)) return false;
    return str1.indexOf(str2) > -1;
  };

  /**
   * 从字符串结束匹配
   * @method endWidth
   * @param {String} str1 源字符串
   * @param {String} str2 匹配字符串
   * @return {Boolean} 匹配结果
   * @static
   */
  ntils.endWith = function (str1, str2) {
    if (this.isNull(str1) || this.isNull(str2)) return false;
    return str1.indexOf(str2) === (str1.length - str2.length);
  };

  /**
   * 是否包含属性
   * @method hasProperty
   * @param  {Object}  obj  对象
   * @param  {String}  name 属性名
   * @return {Boolean}      结果
   * @static
   */
  ntils.has = ntils.hasProperty = function (obj, name) {
    if (this.isNull(obj) || this.isNull(name)) return false;
    return (name in obj) || (obj.hasOwnProperty(name));
  };

  /**
   * 验证一个对象是否为Function
   * @method isFunction
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isFunction = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === "function";
  };

  /**
   * 验证一个对象是否为String
   * @method isString
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isString = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === 'string' || obj instanceof String;
  };

  /**
   * 验证一个对象是否为Number
   * @method isNumber
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isNumber = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === 'number' || obj instanceof Number;
  };

  /**
   * 验证一个对象是否为Boolean
   * @method isBoolean
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isBoolean = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === 'boolean' || obj instanceof Boolean;
  };

  /**
   * 验证一个对象是否为HTML Element
   * @method isElement
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isElement = function (obj) {
    if (this.isNull(obj)) return false;
    if (window.Element) {
      return obj instanceof Element;
    } else {
      return (obj.tagName && obj.nodeType && obj.nodeName && obj.attributes && obj.ownerDocument);
    }
  };

  /**
   * 验证一个对象是否为HTML Text Element
   * @method isText
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isText = function (obj) {
    if (this.isNull(obj)) return false;
    return obj instanceof Text;
  };

  /**
   * 验证一个对象是否为Object
   * @method isObject
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isObject = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === "object";
  };

  /**
   * 验证一个对象是否为Array或伪Array
   * @method isArray
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isArray = function (obj) {
    if (this.isNull(obj)) return false;
    var v1 = Object.prototype.toString.call(obj) === '[object Array]';
    var v2 = obj instanceof Array;
    var v3 = !this.isString(obj) && this.isNumber(obj.length) && this.isFunction(obj.splice);
    var v4 = !this.isString(obj) && this.isNumber(obj.length) && obj[0];
    return v1 || v2 || v3 || v4;
  };

  /**
   * 验证是不是一个日期对象
   * @method isDate
   * @param {Object} val   要检查的对象
   * @return {Boolean}           结果
   * @static
   */
  ntils.isDate = function (val) {
    if (this.isNull(val)) return false;
    return val instanceof Date;
  };

  /**
   * 验证是不是一个正则对象
   * @method isDate
   * @param {Object} val   要检查的对象
   * @return {Boolean}           结果
   * @static
   */
  ntils.isRegexp = function (val) {
    return val instanceof RegExp;
  };

  /**
   * 转换为数组
   * @method toArray
   * @param {Array|Object} array 伪数组
   * @return {Array} 转换结果数组
   * @static
   */
  ntils.toArray = function (array) {
    if (this.isNull(array)) return [];
    return Array.prototype.slice.call(array);
  };

  /**
   * 转为日期格式
   * @method toDate
   * @param {Number|String} val 日期字符串或整型数值
   * @return {Date} 日期对象
   * @static
   */
  ntils.toDate = function (val) {
    var self = this;
    if (self.isNumber(val))
      return new Date(val);
    else if (self.isString(val))
      return new Date(self.replace(self.replace(val, '-', '/'), 'T', ' '));
    else if (self.isDate(val))
      return val;
    else
      return null;
  };

  /**
   * 遍历一个对像或数组
   * @method each
   * @param  {Object or Array}   obj  要遍历的数组或对象
   * @param  {Function} fn            处理函数
   * @return {void}                   无返回值
   * @static
   */
  ntils.each = function (list, handler, scope) {
    if (this.isNull(list) || this.isNull(handler)) return;
    if (this.isArray(list)) {
      var listLength = list.length;
      for (var i = 0; i < listLength; i++) {
        var rs = handler.call(scope || list[i], i, list[i]);
        if (!this.isNull(rs)) return rs;
      }
    } else {
      for (var key in list) {
        var rs = handler.call(scope || list[key], key, list[key]);
        if (!this.isNull(rs)) return rs;
      }
    }
  };

  /**
   * 格式化日期
   * @method formatDate
   * @param {Date|String|Number} date 日期
   * @param {String} format 格式化字符串
   * @param {object} dict 反译字典
   * @return {String} 格式化结果
   * @static
   */
  ntils.formatDate = function (date, format, dict) {
    if (this.isNull(format) || this.isNull(date)) return date;
    date = this.toDate(date);
    dict = dict || {};
    var placeholder = {
      "M+": date.getMonth() + 1, //month
      "d+": date.getDate(), //day
      "h+": date.getHours(), //hour
      "m+": date.getMinutes(), //minute
      "s+": date.getSeconds(), //second
      "w+": date.getDay(), //week
      "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
      "S": date.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var key in placeholder) {
      if (new RegExp("(" + key + ")").test(format)) {
        var value = placeholder[key];
        value = dict[value] || value;
        format = format.replace(RegExp.$1, RegExp.$1.length == 1
          ? value : ("00" + value).substr(("" + value).length));
      }
    }
    return format;
  };

  /**
   * 拷贝对象
   * @method copy
   * @param {Object} src 源对象
   * @param {Object} dst 目标对象
   * @static
   */
  ntils.copy = function (src, dst, igonres) {
    dst = dst || (this.isArray(src) ? [] : {});
    this.each(src, function (key) {
      if (igonres && igonres.indexOf(key) > -1) return;
      delete dst[key];
      if (Object.getOwnPropertyDescriptor) {
        try {
          Object.defineProperty(dst, key, Object.getOwnPropertyDescriptor(src, key));
        } catch (ex) {
          dst[key] = src[key];
        }
      } else {
        dst[key] = src[key];
      }
    })
    return dst;
  };

  /**
   * 深度克隆对象
   * @method clone
   * @param {Object} src 源对象
   * @return {Object} 新对象
   * @static
   */
  ntils.clone = function (src, igonres) {
    if (this.isNull(src) ||
      this.isString(src) ||
      this.isNumber(src) ||
      this.isBoolean(src) ||
      this.isDate(src)) {
      return src;
    }
    var objClone = src;
    try {
      objClone = new src.constructor();
    } catch (ex) { }
    this.each(src, function (key, value) {
      if (objClone[key] != value && !this.contains(igonres, key)) {
        if (this.isObject(value)) {
          objClone[key] = this.clone(value, igonres);
        } else {
          objClone[key] = value;
        }
      }
    }, this);
    ['toString', 'valueOf'].forEach(function (key) {
      if (this.contains(igonres, key)) return;
      this.defineFreezeProp(objClone, key, src[key]);
    }, this);
    return objClone;
  };

  /**
   * 合并对象
   * @method mix
   * @return 合并后的对象
   * @param {Object} dst 目标对象
   * @param {Object} src 源对象
   * @param {Array} igonres 忽略的属性名,
   * @param {Number} mode 模式
   */
  ntils.mix = function (dst, src, igonres, mode, igonreNull) {
    //根据模式来判断，默认是Obj to Obj的  
    if (mode) {
      switch (mode) {
        case 1: // proto to proto  
          return ntils.mix(dst.prototype, src.prototype, igonres, 0);
        case 2: // object to object and proto to proto  
          ntils.mix(dst.prototype, src.prototype, igonres, 0);
          break; // pass through  
        case 3: // proto to static  
          return ntils.mix(dst, src.prototype, igonres, 0);
        case 4: // static to proto  
          return ntils.mix(dst.prototype, src, igonres, 0);
        default: // object to object is what happens below  
      }
    }
    //---
    src = src || {};
    dst = dst || (this.isArray(src) ? [] : {});
    this.keys(src).forEach(function (key) {
      if (this.contains(igonres, key)) return;
      if (igonreNull && this.isNull(src[key])) return;
      if (this.isObject(src[key]) &&
        (src[key].constructor == Object ||
          src[key].constructor == Array ||
          src[key].constructor == null)) {
        dst[key] = ntils.mix(dst[key], src[key], igonres, 0, igonreNull);
      } else {
        dst[key] = src[key];
      }
    }, this);
    return dst;
  };

  /**
   * 定义不可遍历的属性
   **/
  ntils.defineFreezeProp = function (obj, name, value) {
    try {
      Object.defineProperty(obj, name, {
        value: value,
        enumerable: false,
        configurable: true, //能不能重写定义
        writable: false //能不能用「赋值」运算更改
      });
    } catch (err) {
      obj[name] = value;
    }
  };

  /**
   * 获取所有 key 
   */
  ntils.keys = function (obj) {
    if (Object.keys) return Object.keys(obj);
    var keys = [];
    this.each(obj, function (key) {
      keys.push(key);
    });
    return keys;
  };

  /**
   * 创建一个对象
   */
  ntils.create = function (proto, props) {
    if (Object.create) return Object.create(proto, props);
    var Cotr = function () { };
    Cotr.prototype = proto;
    var obj = new Cotr();
    if (props) this.copy(props, obj);
    return obj;
  };

  /**
   * 设置 proto
   * 在不支持 setPrototypeOf 也不支持 __proto__ 的浏览器
   * 中，会采用 copy 方式
   */
  ntils.setPrototypeOf = function (obj, proto) {
    if (Object.setPrototypeOf) {
      return Object.setPrototypeOf(obj, proto || this.create(null));
    } else {
      if (!('__proto__' in Object)) this.copy(proto, obj);
      obj.__proto__ = proto;
    }
  };

  /**
   * 获取 proto
   */
  ntils.getPrototypeOf = function (obj) {
    if (obj.__proto__) return obj.__proto__;
    if (Object.getPrototypeOf) return Object.getPrototypeOf(obj);
    if (obj.constructor) return obj.constructor.prototype;
  };

  /**
   * 是否深度相等
   */
  ntils.deepEqual = function (a, b) {
    if (a === b) return true;
    if (!this.isObject(a) || !this.isObject(b)) return false;
    var aKeys = this.keys(a);
    var bKeys = this.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    var allKeys = aKeys.concat(bKeys);
    var checkedMap = this.create(null);
    var result = true;
    this.each(allKeys, function (i, key) {
      if (checkedMap[key]) return;
      if (!this.deepEqual(a[key], b[key])) result = false;
      checkedMap[key] = true;
    }, this);
    return result;
  };

  /**
   * 从一个数值循环到别一个数
   * @param {number} fromNum 开始数值
   * @param {Number} toNum 结束数值
   * @param {Number} step 步长值
   * @param {function} handler 执行函数
   * @returns {void} 无返回
   */
  ntils.fromTo = function (fromNum, toNum, step, handler) {
    if (!handler) handler = [step, step = handler][0];
    step = Math.abs(step || 1);
    if (fromNum < toNum) {
      for (var i = fromNum; i <= toNum; i += step) handler(i);
    } else {
      for (var i = fromNum; i >= toNum; i -= step) handler(i);
    }
  };

  /**
   * 生成一个Guid
   * @method newGuid
   * @return {String} GUID字符串
   * @static
   */
  ntils.newGuid = function () {
    var S4 = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
  };

  /**
   * 对象变换
   **/
  ntils.map = function (list, fn) {
    var buffer = this.isArray(list) ? [] : {};
    this.each(list, function (name, value) {
      buffer[name] = fn(name, value);
    });
    return buffer;
  };

  /**
   * 通过路径设置属性值
   */
  ntils.setByPath = function (obj, path, value) {
    if (this.isNull(obj) || this.isNull(path) || path === '') {
      return;
    }
    if (!this.isArray(path)) {
      path = path.replace(/\[/, '.').replace(/\]/, '.').split('.');
    }
    this.each(path, function (index, name) {
      if (this.isNull(name) || name.length < 1) return;
      if (index === path.length - 1) {
        obj[name] = value;
      } else {
        obj[name] = obj[name] || {};
        obj = obj[name];
      }
    }, this);
  };

  /**
   * 通过路径获取属性值
   */
  ntils.getByPath = function (obj, path) {
    if (this.isNull(obj) || this.isNull(path) || path === '') {
      return obj;
    }
    if (!this.isArray(path)) {
      path = path.replace(/\[/, '.').replace(/\]/, '.').split('.');
    }
    this.each(path, function (index, name) {
      if (this.isNull(name) || name.length < 1) return;
      if (!this.isNull(obj)) obj = obj[name];
    }, this);
    return obj;
  };

  /**
   * 数组去重
   **/
  ntils.unique = function (array) {
    if (this.isNull(array)) return array;
    var newArray = [];
    this.each(array, function (i, value) {
      if (newArray.indexOf(value) > -1) return;
      newArray.push(value);
    });
    return newArray;
  };

  /**
   * 解析 function 的参数列表
   **/
  ntils.getFunctionArgumentNames = function (fn) {
    if (!fn) return [];
    var src = fn.toString();
    var parts = src.split(')')[0].split('=>')[0].split('(');
    return (parts[1] || parts[0]).split(',').map(function (name) {
      return name.trim();
    }).filter(function (name) {
      return name != 'function';
    });
  };

  /**
   * 缩短字符串
   */
  ntils.short = function (str, maxLength) {
    if (!str) return str;
    maxLength = maxLength || 40;
    var strLength = str.length;
    var trimLength = maxLength / 2;
    return strLength > maxLength ? str.substr(0, trimLength) + '...' + str.substr(strLength - trimLength) : str;
  };

  /**
   * 首字母大写
   */
  ntils.firstUpper = function (str) {
    if (this.isNull(str)) return;
    return str.substring(0, 1).toUpperCase() + str.substring(1);
  };

  /**
   * 编码正则字符串
   */
  ntils.escapeRegExp = function (str) {
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  };

  /**
   * 解析字符串为 dom 
   * @param {string} str 字符串
   * @returns {HTMLNode} 解析后的 DOM 
   */
  ntils.parseDom = function (str) {
    this._PDD_ = this._PDD_ || document.createElement('div');
    this._PDD_.innerHTML = ntils.trim(str);
    var firstNode = this._PDD_.childNodes[0];
    //先 clone 一份再通过 innerHTML 清空
    //否则 IE9 下，清空时会导出返回的 DOM 没有子结点
    if (firstNode) firstNode = firstNode.cloneNode(true);
    this._PDD_.innerHTML = '';
    return firstNode;
  };

})(( false) ? (window.ntils = {}) : exports);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _$config = __webpack_require__(59);

var _$config2 = _interopRequireDefault(_$config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TheError = function (_Error) {
  (0, _inherits3.default)(TheError, _Error);

  function TheError(message) {
    (0, _classCallCheck3.default)(this, TheError);

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, _Error.call.apply(_Error, [this, '[' + _$config2.default.name + ']: ' + message].concat(args)));
  }

  return TheError;
}(Error);

exports.default = TheError;
module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(32);
var TAG = __webpack_require__(12)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(14);
var aFunction = __webpack_require__(36);
var SPECIES = __webpack_require__(12)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(30);
var invoke = __webpack_require__(158);
var html = __webpack_require__(75);
var cel = __webpack_require__(46);
var global = __webpack_require__(11);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(32)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(14);
var isObject = __webpack_require__(17);
var newPromiseCapability = __webpack_require__(61);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(175);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(42);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Button, _ComBase);

  function Button() {
    (0, _classCallCheck3.default)(this, Button);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Button.prototype.getType = function getType() {
    var shape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'normal';
    var type = arguments[1];

    var typeMap = {
      ghost: {
        primary: 'dark',
        secondary: 'dark',
        normal: 'light',
        dark: 'dark',
        light: 'light'
      },
      warning: {
        primary: 'primary',
        secondary: 'normal',
        normal: 'normal',
        dark: 'primary',
        light: 'normal'
      },
      normal: {
        primary: 'primary',
        secondary: 'secondary',
        normal: 'normal',
        dark: 'primary',
        light: 'normal'
      }
    };
    var shapeMap = typeMap[shape] || typeMap.normal;
    return shapeMap[type];
  };

  Button.prototype.onMouseUp = function onMouseUp(e) {
    _reactDom2.default.findDOMNode(this).blur();

    if (this.props.onMouseUp) {
      this.props.onMouseUp(e);
    }
  };

  Button.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        component = _props.component,
        children = _props.children,
        shape = _props.shape,
        shadow = _props.shadow,
        size = _props.size,
        type = _props.type,
        htmlType = _props.htmlType,
        className = _props.className,
        others = (0, _objectWithoutProperties3.default)(_props, ['component', 'children', 'shape', 'shadow', 'size', 'type', 'htmlType', 'className']);

    var realType = this.getType(shape, type);
    var btnCls = (0, _common.cname)((_cname = {
      aniTransition: true,
      widget: true,
      widgetShadow: shadow,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      btn: true
    }, _cname['btn-' + realType] = realType, _cname['btn-' + shape] = shape, _cname['size-' + size] = size, _cname), className);
    var finalAttrs = {
      type: htmlType,
      className: btnCls
    };
    if (component === 'a') {
      var _props2 = this.props,
          href = _props2.href,
          target = _props2.target;

      delete finalAttrs.type;
      finalAttrs['href'] = href;
      finalAttrs['target'] = target;
    }
    var TagName = component;
    return _react2.default.createElement(
      TagName,
      (0, _extends3.default)({}, (0, _common.transportProps)(others), finalAttrs, {
        onMouseUp: this.onMouseUp.bind(this) }),
      children
    );
  };

  return Button;
}(_common.ComBase), _class.propTypes = {
  /**
   * 按钮的类型
   */
  type: _propTypes2.default.oneOf(['primary', 'secondary', 'normal', 'dark', 'light']),
  /**
   * 按钮的尺寸
   */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /**
   * 按钮的形状
   */
  shape: _propTypes2.default.oneOf(['ghost', 'text', 'warning']),
  /**
   * 设置 `button` 标签的原生 `type` 值
   */
  htmlType: _propTypes2.default.string
}, _class.defaultProps = {
  type: 'normal',
  size: 'medium',
  htmlType: 'button',
  component: 'button',
  onClick: function onClick() {}
}, _temp);
exports.default = Button;
module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = __webpack_require__(28);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(29);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(180);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//内部私有遮罩实现
var OverlayInner = function (_ComBase) {
  (0, _inherits3.default)(OverlayInner, _ComBase);

  /**
   * 构造一个 OverlayInner 实例
   * @param {arguments} args 参数
   * @returns {void} 无返回
   */
  function OverlayInner() {
    (0, _classCallCheck3.default)(this, OverlayInner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args)));

    _this.state = { visible: false };
    _this.activeList = [];

    _this.show = _this.show.bind(_this);

    if (!(typeof _this.show === 'function')) {
      throw new TypeError('Value of "this.show" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.show));
    }

    _this.hide = _this.hide.bind(_this);

    if (!(typeof _this.hide === 'function')) {
      throw new TypeError('Value of "this.hide" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.hide));
    }

    _this.onClick = _this.onClick.bind(_this);

    if (!(typeof _this.onClick === 'function')) {
      throw new TypeError('Value of "this.onClick" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.onClick));
    }

    return _this;
  }

  /**
   * 渲染 dom
   * @returns {object} dom
   */


  OverlayInner.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        _props$visible = _props.visible,
        visible = _props$visible === undefined ? this.state.visible : _props$visible,
        inside = _props.inside;

    var names = (0, _common.cname)({
      widget: true,
      aniTransition: true,
      overlay: true,
      stateHidden: !visible,
      stateVisible: !!visible,
      inside: inside
    }, className);
    return _react2.default.createElement('div', { className: names,
      onClick: this.onClick });
  };

  /**
   * 单击时的处理方法，在此方法中处理 opts.onClick
   * @returns {void} 无返回
   */


  OverlayInner.prototype.onClick = function onClick() {
    var _this2 = this;

    var onClick = this.props.onClick;

    if (_common.utils.isFunction(onClick)) onClick(new _common.EventArgs(this.owner || this));
    this.activeList.filter(function (item) {
      return _common.utils.isFunction(item.onClick);
    }).forEach(function (item) {
      return item.onClick(new _common.EventArgs(item.target || _this2));
    });
  };

  /**
   * 显示 overlay
   * @param {any} opts 显示选项
   * @returns {function} overlay 的引用标识 
   */


  OverlayInner.prototype.show = function show(opts) {
    var _this3 = this;

    if (!opts) return this.setState({ visible: true });
    opts = (0, _extends3.default)({}, opts);
    opts.id = opts.id || _common.utils.newGuid();
    var foundItem = this.activeList.find(function (item) {
      return item.id == opts.id;
    });
    if (foundItem) return foundItem.ref;
    this.setState({ visible: true });
    opts.ref = function () {
      _this3.hide(opts.id);
    };
    opts.ref.id = opts.id;
    this.activeList.push(opts);
    return opts.ref;
  };

  /**
   * 隐藏 overlay
   * @param {object} ref 已显示的 overlay 的引用
   * @returns {void} 无返回
   */


  OverlayInner.prototype.hide = function hide(ref) {
    if (!ref) return this.setState({ visible: false });
    var id = ref.id || ref;
    var index = this.activeList.findIndex(function (item) {
      return item.id == id;
    });
    if (index < 0) return;
    this.activeList.splice(index, 1);
    if (this.activeList.length < 1) {
      this.setState({ visible: false });
    }
  };

  return OverlayInner;
}(_common.ComBase);

//创建 overlayInner 唯一实例


var overlayInner = void 0;

function getOverlayInner() {
  if (!overlayInner) overlayInner = (0, _common.render)(_react2.default.createElement(OverlayInner, null));
  return overlayInner;
}

// Overlay 组件类

var Overlay = function (_ComBase2) {
  (0, _inherits3.default)(Overlay, _ComBase2);

  /**
   * 构造一个 OverlayInner 实例
   * @param {arguments} args 参数
   * @returns {void} 无返回
   */
  function Overlay() {
    (0, _classCallCheck3.default)(this, Overlay);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var _this4 = (0, _possibleConstructorReturn3.default)(this, _ComBase2.call.apply(_ComBase2, [this].concat(args)));

    _this4.id = _common.utils.newGuid();
    return _this4;
  }

  Overlay.prototype.render = function render() {
    if (this.props.inside) {
      return _react2.default.createElement(OverlayInner, (0, _extends3.default)({}, this.props, { owner: this }));
    } else {
      return _react2.default.createElement('span', { className: (0, _common.cname)('state-hidden') });
    }
  };

  /**
   * 在属性有更新新时通过 update 方法执行 overlayInner 的动作
   * @param {Object} nextProps 新的属性 map
   * @returns {void} 无返回
   */


  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.inside) return;
    this.update(nextProps);
  };

  /**
   * 在组件挂载时通过 update 方法执行 overlayInner 的动作
   * @returns {void} 无返回
   */


  Overlay.prototype.componentDidMount = function componentDidMount() {
    if (this.props.inside) return;
    this.update(this.props);
  };

  Overlay.prototype.componentWillUnmount = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var overlayInner;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.props.inside) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return getOverlayInner();

            case 4:
              overlayInner = _context.sent;

              overlayInner.hide(this.id);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function componentWillUnmount() {
      return _ref.apply(this, arguments);
    }

    return componentWillUnmount;
  }();

  /**
   * 通过 opts 执行 overlayInner 的动作
   * @param {object} opts 选项
   * @returns {void} 无返回
   */


  Overlay.prototype.update = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(opts) {
      var overlayInner;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.props.inside) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return');

            case 2:
              _context2.next = 4;
              return getOverlayInner();

            case 4:
              overlayInner = _context2.sent;

              if (opts.visible) {
                opts = (0, _extends3.default)({}, opts, { id: this.id, target: this });
                overlayInner.show(opts);
              } else {
                overlayInner.hide(this.id);
              }

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function update(_x) {
      return _ref2.apply(this, arguments);
    }

    return update;
  }();

  return Overlay;
}(_common.ComBase);

//挂载静态方法


Overlay.show = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
    var overlayInner,
        _args3 = arguments;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getOverlayInner();

          case 2:
            overlayInner = _context3.sent;
            return _context3.abrupt('return', overlayInner.show.apply(overlayInner, _args3));

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function () {
    return _ref3.apply(this, arguments);
  };
}();

Overlay.hide = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
    var overlayInner,
        _args4 = arguments;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getOverlayInner();

          case 2:
            overlayInner = _context4.sent;
            return _context4.abrupt('return', overlayInner.hide.apply(overlayInner, _args4));

          case 4:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function () {
    return _ref4.apply(this, arguments);
  };
}();

//导出组件
exports.default = Overlay;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _CheckBox2 = __webpack_require__(62);

var _CheckBox3 = _interopRequireDefault(_CheckBox2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(185);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroup = function (_ComBase) {
  (0, _inherits3.default)(RadioGroup, _ComBase);

  function RadioGroup() {
    (0, _classCallCheck3.default)(this, RadioGroup);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  RadioGroup.prototype.getClassNames = function getClassNames() {
    var _cname;

    var _props = this.props,
        layout = _props.layout,
        type = _props.type;

    return (0, _common.cname)((_cname = {
      checkBoxGroup: true,
      widget: true,
      aniTransition: true,
      stateHidden: this.props.visible === false,
      stateVisible: this.props.visible !== false
    }, _cname['layout-' + layout] = !!layout, _cname['type-' + type] = !!type, _cname), this.props.className);
  };

  RadioGroup.prototype.getItems = function getItems() {
    var items = this.props.dataSource || this.props.items || [];
    items = items.map(function (item) {
      if (_common.utils.isObject(item)) return item;
      return { text: item, value: item };
    });
    return items;
  };

  RadioGroup.prototype.getName = function getName() {
    return this.props.name || _common.utils.newGuid();
  };

  RadioGroup.prototype.getSelectedItems = function getSelectedItems() {
    var selectedItems = this.props.value || this.selectedItems || [];
    if (!_common.utils.isArray(selectedItems)) selectedItems = [selectedItems];
    return selectedItems;
  };

  RadioGroup.prototype.itemChange = function itemChange(event) {
    var _props2 = this.props,
        onChange = _props2.onChange,
        single = _props2.single;

    if (!_common.utils.isFunction(onChange)) return;
    var items = this.getSelectedItems().slice(0);
    if (event.target.checked && single) {
      items = [event.target.value];
    } else if (event.target.checked) {
      items.push(event.target.value);
    } else {
      var index = items.indexOf(event.target.value);
      items.splice(index, 1);
    }
    onChange(new _common.EventArgs(this, single ? items[0] : items));
  };

  RadioGroup.prototype.isSelected = function isSelected(item) {
    var selectedItems = this.getSelectedItems();
    return selectedItems == item.value || selectedItems.some(function (value) {
      return value == item.value;
    });
  };

  //渲染内容


  RadioGroup.prototype.render = function render() {
    var _this2 = this;

    var items = this.getItems();
    var groupName = this.getName();
    var _props3 = this.props,
        _props3$control = _props3.control,
        control = _props3$control === undefined ? _CheckBox3.default : _props3$control,
        _props3$Control = _props3.Control,
        Control = _props3$Control === undefined ? control : _props3$Control,
        disabled = _props3.disabled;

    return _react2.default.createElement(
      'ul',
      { className: this.getClassNames() },
      items.map(function (item, index) {
        return _react2.default.createElement(
          'li',
          { key: index, disabled: disabled },
          _react2.default.createElement(Control, { id: groupName + '-' + index,
            className: (0, _common.cname)('checkBoxGroupControl'),
            checked: _this2.isSelected(item),
            onChange: _this2.itemChange.bind(_this2),
            disabled: disabled,
            value: item.value }),
          _react2.default.createElement(
            'label',
            { className: (0, _common.cname)({
                checkBoxGroupLabel: true,
                stateActive: _this2.isSelected(item)
              }),
              disabled: disabled,
              style: { width: _this2.props.itemWidth },
              htmlFor: groupName + '-' + index },
            item.text
          )
        );
      })
    );
  };

  return RadioGroup;
}(_common.ComBase);

exports.default = RadioGroup;
module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _row = __webpack_require__(190);

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__(95);

var _col2 = _interopRequireDefault(_col);

__webpack_require__(191);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Grid = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Grid, _ComBase);

  function Grid() {
    (0, _classCallCheck3.default)(this, Grid);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Grid.prototype.wrapChildren = function wrapChildren(children) {
    var _props = this.props,
        cellPadding = _props.cellPadding,
        rowSpacing = _props.rowSpacing,
        colPadding = _props.colPadding;

    if (_common.utils.isNull(cellPadding) && _common.utils.isNull(rowSpacing) && _common.utils.isNull(colPadding)) {
      return children;
    }
    if (cellPadding && !_common.utils.isNumber(cellPadding)) cellPadding = 0;
    if (colPadding && !_common.utils.isNumber(colPadding)) colPadding = 0;
    if (rowSpacing && !_common.utils.isNumber(rowSpacing)) rowSpacing = 0;
    var rows = this.findChildren(_row2.default);
    return rows.map(function (row, index) {
      return _react2.default.cloneElement(row, {
        key: index,
        spacing: _common.utils.isNull(row.props.spacing) ? rowSpacing : row.props.spacing,
        cellPadding: _common.utils.isNull(row.props.cellPadding) ? cellPadding : row.props.cellPadding,
        colPadding: _common.utils.isNull(row.props.colPadding) ? colPadding : row.props.colPadding
      });
    });
  };

  Grid.prototype.render = function render() {
    var _props2 = this.props,
        fluid = _props2.fluid,
        visible = _props2.visible,
        className = _props2.className,
        children = _props2.children,
        othesProps = (0, _objectWithoutProperties3.default)(_props2, ['fluid', 'visible', 'className', 'children']);

    var names = (0, _common.cname)({
      widget: true,
      aniTransition: true,
      grid: true,
      gridFluid: !!fluid,
      stateHidden: visible === false,
      stateVisible: visible !== false
    }, className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(othesProps), { className: names }),
      this.wrapChildren(children)
    );
  };

  return Grid;
}(_common.ComBase), _class.Row = _row2.default, _class.Col = _col2.default, _temp);
exports.default = Grid;
module.exports = exports['default'];

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = function (_ComBase) {
  (0, _inherits3.default)(Alert, _ComBase);

  function Alert() {
    (0, _classCallCheck3.default)(this, Alert);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Alert.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        className = _props.className,
        visible = _props.visible,
        padding = _props.padding,
        children = _props.children,
        style = _props.style,
        span = _props.span,
        _props$xs = _props.xs,
        xs = _props$xs === undefined ? span : _props$xs,
        _props$sm = _props.sm,
        sm = _props$sm === undefined ? span : _props$sm,
        _props$md = _props.md,
        md = _props$md === undefined ? span : _props$md,
        _props$lg = _props.lg,
        lg = _props$lg === undefined ? span : _props$lg,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'visible', 'padding', 'children', 'style', 'span', 'xs', 'sm', 'md', 'lg']);

    var names = (0, _common.cname)((_cname = {
      aniTransition: true,
      gridCol: true
    }, _cname['gridColXs-' + xs] = !!xs, _cname['gridColSm-' + sm] = !!sm, _cname['gridColMd-' + md] = !!md, _cname['gridColLg-' + lg] = !!lg, _cname.stateHidden = visible === false, _cname.stateVisible = visible !== false, _cname), className);
    var element = _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(otherProps), {
        style: style,
        className: names }),
      children
    );
    if (!_common.utils.isNull(padding)) {
      element = _react2.default.cloneElement(element, {
        style: (0, _extends3.default)({ padding: padding }, style)
      });
    }
    return element;
  };

  return Alert;
}(_common.ComBase);

exports.default = Alert;
module.exports = exports['default'];

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

exports.default = new _common.Locale({
  zh: {
    format: {
      date: 'yyyy-MM-dd',
      datetime: 'yyyy-MM-dd hh:mm:ss',
      month: 'yyyy-MM'
    },
    weeks: [{ text: '一', value: 1 }, { text: '二', value: 2 }, { text: '三', value: 3 }, { text: '四', value: 4 }, { text: '五', value: 5 }, { text: '六', value: 6 }, { text: '日', value: 0 }],
    today: '今天',
    ok: '确定',
    time: '时间',
    hours: '时',
    minutes: '分',
    seconds: '秒'
  },
  en: {
    format: {
      date: 'MM-dd-yyyy',
      datetime: 'MM-dd-yyyy hh:mm:ss',
      month: 'MM-yyyy'
    },
    weeks: [{ text: 'Sun', value: 0 }, { text: 'Mon', value: 1 }, { text: 'Tue', value: 2 }, { text: 'Wed', value: 3 }, { text: 'Thu', value: 4 }, { text: 'Fri', value: 5 }, { text: 'Sat', value: 6 }],
    today: 'Now',
    ok: 'Ok',
    time: 'Time',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds'
  }
});
module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _Button2 = __webpack_require__(91);

var _Button3 = _interopRequireDefault(_Button2);

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _Popover2 = __webpack_require__(19);

var _Popover3 = _interopRequireDefault(_Popover2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(194);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dialog = function (_ComBase) {
  (0, _inherits3.default)(Dialog, _ComBase);

  function Dialog() {
    (0, _classCallCheck3.default)(this, Dialog);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  //渲染内容
  Dialog.prototype.render = function render() {
    var _props = this.props,
        modal = _props.modal,
        className = _props.className,
        props = (0, _objectWithoutProperties3.default)(_props, ['modal', 'className']);

    var names = (0, _common.cname)({
      dialog: true,
      widget: true
    }, className);
    return _react2.default.createElement(
      _Popover3.default,
      (0, _extends3.default)({}, props, {
        className: names,
        visible: this.isVisible(),
        dock: 'center',
        overlay: modal !== false }),
      this.renderClose(),
      this.renderHeader(),
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('content') },
        this.props.children
      ),
      this.renderFooter()
    );
  };

  Dialog.prototype.renderClose = function renderClose() {
    if (this.props.close === false) return null;
    return _react2.default.createElement(_Icon3.default, { type: 'close', className: (0, _common.cname)('close'),
      onClick: this.close.bind(this) });
  };

  Dialog.prototype.renderHeader = function renderHeader() {
    if (this.props.title === false) return null;
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('header') },
      _react2.default.createElement(
        'span',
        { className: (0, _common.cname)('title') },
        this.props.title
      )
    );
  };

  Dialog.prototype.renderFooter = function renderFooter() {
    var _this2 = this;

    var buttons = this.props.buttons;
    if (buttons === false) return null;
    buttons = (buttons || []).map(function (item) {
      if (_common.utils.isString(item)) {
        item = { text: item };
      }
      item.size = item.size || 'small';
      return item;
    });
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('footer') },
      buttons.map(function (item, index) {
        return _react2.default.createElement(
          _Button3.default,
          (0, _extends3.default)({}, item, {
            key: index,
            onClick: _this2.onButtonClick.bind(_this2, index, item) }),
          item.text
        );
      })
    );
  };

  Dialog.prototype.isVisible = function isVisible() {
    if ('visible' in this.props) {
      return this.props.visible;
    }
    return !!(this.state && this.state.visible);
  };

  Dialog.prototype.onButtonClick = function onButtonClick(index, item, event) {
    var onButtonClick = this.props.onButtonClick;

    if (onButtonClick) {
      onButtonClick(new _common.EventArgs(this, index, event));
    }
    if (item.onClick) item.onClick(event);
  };

  Dialog.prototype.show = function show(event) {
    this.setState({ visible: true });
    var onShow = this.props.onShow;

    if (onShow) {
      onShow(new _common.EventArgs(this, null, event));
    }
  };

  Dialog.prototype.close = function close(event) {
    this.setState({ visible: false });
    var onClose = this.props.onClose;

    if (onClose) {
      onClose(new _common.EventArgs(this, null, event));
    }
  };

  return Dialog;
}(_common.ComBase);

exports.default = Dialog;
module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _form = __webpack_require__(195);

var _form2 = _interopRequireDefault(_form);

var _item = __webpack_require__(99);

var _item2 = _interopRequireDefault(_item);

var _message = __webpack_require__(198);

var _message2 = _interopRequireDefault(_message);

var _control = __webpack_require__(199);

var _control2 = _interopRequireDefault(_control);

var _validate = __webpack_require__(64);

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_form2.default.Item = _item2.default;
_form2.default.FormItem = _item2.default;

_form2.default.Message = _message2.default;
_form2.default.FormMessage = _message2.default;

_form2.default.Control = _control2.default;
_form2.default.FormControl = _control2.default;

_form2.default.validate = _validate2.default;
_form2.default.rules = _validate2.default.rules;

exports.default = _form2.default;
module.exports = exports['default'];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(197);

var _common = __webpack_require__(0);

var _validate = __webpack_require__(64);

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = function (_ComBase) {
  (0, _inherits3.default)(FormItem, _ComBase);

  function FormItem() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FormItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { invalid: false }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  FormItem.prototype.wrapChildren = function wrapChildren(children, parentKey) {
    var _this2 = this;

    if (!children || !_common.utils.isObject(children)) return children;
    parentKey = parentKey || 'root';
    var _props = this.props,
        value = _props.value,
        onChange = _props.onChange,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['value', 'onChange']);

    var foundChildren = this.findChildren(null, children);
    return foundChildren.map(function (child, index) {
      var _React$cloneElement;

      if (!child || !child.type || _common.utils.isString(child.type)) return child;
      var selfKey = parentKey + '.' + index;
      var childProps = child.props || {};
      if (child.type == FormItem) {
        return _react2.default.cloneElement(child, { key: selfKey });
      }

      var _Object$assign = (0, _assign2.default)({}, otherProps, child.type),
          _Object$assign$valueP = _Object$assign.valuePropName,
          valuePropName = _Object$assign$valueP === undefined ? 'value' : _Object$assign$valueP,
          _Object$assign$valueP2 = _Object$assign.valuePath,
          valuePath = _Object$assign$valueP2 === undefined ? 'target.value' : _Object$assign$valueP2,
          _Object$assign$change = _Object$assign.changePropName,
          changePropName = _Object$assign$change === undefined ? 'onChange' : _Object$assign$change;

      var selfValue = valuePropName in childProps ? childProps[valuePropName] : value;
      return _react2.default.cloneElement(child, (_React$cloneElement = {
        key: selfKey,
        children: _this2.wrapChildren(childProps.children, selfKey)
      }, _React$cloneElement[valuePropName] = selfValue, _React$cloneElement[changePropName] = function (event) {
        if (event.stopPropagation) event.stopPropagation();
        if (childProps[changePropName]) {
          childProps[changePropName](event);
        }
        var value = _common.utils.getByPath(event, valuePath);
        var invalid = !(0, _validate2.default)(value, _this2.props.rule);
        _this2.setState({ invalid: invalid });
        if (onChange) onChange(new _common.EventArgs(_this2, {
          value: value, invalid: invalid
        }, event));
      }, _React$cloneElement));
    });
  };

  FormItem.prototype.renderLabel = function renderLabel() {
    if (this.props.label === false) return;
    return _react2.default.createElement(
      'label',
      { className: (0, _common.cname)('formItemLabel') },
      this.props.label
    );
  };

  FormItem.prototype.renderControl = function renderControl() {
    var controls = this.wrapChildren(this.props.children);
    if (this.props.label === false) return controls;
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('formItemControl') },
      controls
    );
  };

  FormItem.prototype.render = function render() {
    var names = (0, _common.cname)({
      widget: true,
      formItem: true,
      aniTransition: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      stateHidden: this.props.visible === false,
      stateVisible: this.props.visible !== false,
      formItemNoLabel: this.props.label === false,
      formItemInvalid: !_common.utils.isNull(this.props.invalid) ? this.props.invalid : this.state.invalid
    }, this.props.className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), {
        className: names }),
      this.renderLabel(),
      this.renderControl()
    );
  };

  return FormItem;
}(_common.ComBase);

exports.default = FormItem;
module.exports = exports['default'];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Menu, _ComBase);

  function Menu() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {
      selectedKeys: _this.props.selectedKeys || _this.props.defaultSelectedKeys || []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Menu.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var props = {};
    if ('selectedKeys' in nextProps) {
      props.selectedKeys = nextProps.selectedKeys || [];
    }
    this.setState(props);
  };

  Menu.prototype.onSelect = function onSelect(e) {
    var key = e.detail.key;
    var selectMode = this.props.selectMode;

    var selectedKeys = this.state.selectedKeys;
    if (selectMode === 'multiple') {
      selectedKeys = selectedKeys.concat([key]);
    } else {
      selectedKeys = [key];
    }
    if (!('selectedKeys' in this.props)) {
      this.setState({
        selectedKeys: selectedKeys
      });
    }
    e.detail.selectedKeys = selectedKeys;
    this.props.onSelect(e);
  };

  Menu.prototype.onDeselect = function onDeselect(e) {
    var key = e.detail.key;

    var selectedKeys = this.state.selectedKeys;
    var index = selectedKeys.indexOf(key);
    index !== -1 && selectedKeys.splice(index, 1);
    if (!('selectedKeys' in this.props)) {
      this.setState({
        selectedKeys: selectedKeys
      });
    }
    e.detail.selectedKeys = selectedKeys;
    this.props.onDeselect(e);
  };

  Menu.prototype.renderMenuItem = function renderMenuItem(child) {
    var selectedKeys = this.state.selectedKeys;

    var isSelected = !child.props.disabled && selectedKeys.indexOf(child.key) > -1;
    var _props = this.props,
        selectMode = _props.selectMode,
        onClick = _props.onClick,
        mode = _props.mode;

    var newProps = {
      itemKey: child.key,
      disabled: child.props.disabled,
      selected: isSelected,
      mode: mode,
      selectMode: selectMode,
      selectedKeys: selectedKeys,
      onClick: onClick,
      onSelect: this.onSelect.bind(this),
      onDeselect: this.onDeselect.bind(this),
      onTitleClick: child.props.onTitleClick
    };
    return _react2.default.cloneElement(child, newProps);
  };

  Menu.prototype.render = function render() {
    var _cname;

    var _props2 = this.props,
        className = _props2.className,
        style = _props2.style,
        children = _props2.children;


    var cls = (0, _common.cname)((_cname = {
      widget: true,
      widgetShadow: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      menu: true
    }, _cname['menu-' + this.props.mode] = !!this.props.mode, _cname), className);

    return _react2.default.createElement(
      'ul',
      {
        style: style,
        className: cls
      },
      _react2.default.Children.map(children, this.renderMenuItem.bind(this))
    );
  };

  return Menu;
}(_common.ComBase), _class.propTypes = {
  /**
   * 展示模式
   */
  mode: _propTypes2.default.oneOf(['vertical', 'horizontal', 'inline']),
  /**
   * 选择模式
   */
  selectMode: _propTypes2.default.oneOf(['single', 'multiple']),
  /**
   * 当前选中的菜单项
   */
  selectedKeys: _propTypes2.default.array,
  /**
   * 默认选中的菜单项
   */
  defaultSelectedKeys: _propTypes2.default.any,
  /**
   * 点击菜单项时的回调
   */
  onClick: _propTypes2.default.func,
  /**
   * 选中菜单项时的回调
   */
  onSelect: _propTypes2.default.func,
  /**
   * 取消选中菜单项的回调
   */
  onDeselect: _propTypes2.default.func
}, _class.defaultProps = {
  mode: 'vertical',
  selectMode: 'single',
  onClick: function onClick() {},
  onSelect: function onSelect() {},
  onDeselect: function onDeselect() {}
}, _temp2);
exports.default = Menu;
module.exports = exports['default'];

/***/ }),
/* 101 */
/***/ (function(module, exports) {

exports.SelectMode = {
  MULTIPLE: 'multiple',
  TAGS: 'tags',
  COMBOBOX: 'combobox',
  NORMAL: 'normal'
};

exports.SelectSize = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small'
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;

__webpack_require__(230);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * radio的类型
   */
  type: _propTypes2.default.oneOf(['radio']),
  /**
   * 设置 `input` 标签的原生 `type` 值
   */
  htmlType: _propTypes2.default.string,
  /**
   * 是否默认选中
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * 是否选中
   */
  checked: _propTypes2.default.bool,
  /**
   * 是否默认可用
   */
  disabled: _propTypes2.default.bool,
  /**
   * 选中后 input 的 value 属性
   */
  value: _propTypes2.default.string
};

var defaultProps = {
  type: 'radio',
  htmlType: 'radio',
  defaultChecked: false,
  disabled: false,
  onChange: function onChange() {}
};

var Radio = (_dec = (0, _common.meta)({
  valuePropName: 'checked',
  valuePath: 'target.checked'
}), _dec(_class = (_temp = _class2 = function (_ComBase) {
  (0, _inherits3.default)(Radio, _ComBase);

  function Radio(props) {
    (0, _classCallCheck3.default)(this, Radio);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _initialiseProps.call(_this);

    var checked = void 0;
    if ('checked' in props) {
      checked = props.checked;
    } else {
      checked = props.defaultChecked;
    }
    _this.state = {
      checked: checked
    };
    return _this;
  }

  Radio.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({
        checked: nextProps.checked
      });
    }
  };

  Radio.prototype.stateCheck = function stateCheck(checked, disabled) {
    var radioCls = (0, _common.cname)('radio') + ' ';
    var checkedCls = (0, _common.cname)('radio-checked') + ' ';
    var disabledCls = (0, _common.cname)('radio-disabled') + ' ';
    if (disabled && checked) {
      return radioCls + checkedCls + disabledCls;
    }
    if (disabled) {
      return radioCls + disabledCls;
    }
    if (checked) {
      return radioCls + checkedCls;
    }
    return radioCls;
  };

  Radio.prototype.renderLabel = function renderLabel() {
    var children = this.props.children;

    return children ? _react2.default.createElement(
      'span',
      null,
      children
    ) : null;
  };

  Radio.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        value = _props.value,
        id = _props.id,
        disabled = _props.disabled,
        htmlType = _props.htmlType,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['value', 'id', 'disabled', 'htmlType', 'className']);


    var labelCls = (0, _common.cname)((_cname = {
      aniTransition: true,
      widget: true
    }, _cname['radio-warpper'] = true, _cname), className);
    var radioIptCls = (0, _common.cname)('radio-input');
    var innerCls = (0, _common.cname)('radio-inner');

    var checked = this.state.checked;

    return _react2.default.createElement(
      'label',
      (0, _extends3.default)({ className: labelCls }, otherProps),
      _react2.default.createElement(
        'span',
        { className: this.stateCheck(checked, disabled) },
        _react2.default.createElement('input', { id: id,
          className: radioIptCls,
          type: htmlType,
          disabled: disabled,
          checked: checked,
          onChange: this.onChange,
          value: value }),
        _react2.default.createElement('span', { className: innerCls })
      ),
      this.renderLabel()
    );
  };

  return Radio;
}(_common.ComBase), _class2.propTypes = propTypes, _class2.defaultProps = defaultProps, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onChange = function (event) {
    event.preventDefault();
    event.stopPropagation();
    var checked = event.target.checked;
    if (_this2.state.checked !== checked) {
      if (!('checked' in _this2.props)) {
        _this2.setState({ checked: checked });
      }
      _this2.props.onChange(new _common.EventArgs(_this2, event.target.value, event));
    }
  };
}, _temp)) || _class);
exports.default = Radio;
module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(249);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  className: _propTypes2.default.string,
  closable: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object
};

var defaultProps = {
  closable: false
};

var Tag = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Tag, _ComBase);

  function Tag(props) {
    (0, _classCallCheck3.default)(this, Tag);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.close = function (e, otherProps) {
      var onClose = _this.props.onClose;

      if (onClose) {
        onClose(e, otherProps);
      }

      if (e.defaultPrevented) {
        return;
      }

      _this.setState({
        closed: true
      });
    };

    _this.state = {
      closed: false
    };
    return _this;
  }

  Tag.prototype.render = function render() {
    var _this2 = this,
        _cname;

    var _props = this.props,
        closable = _props.closable,
        colorField = _props.colorField,
        className = _props.className,
        children = _props.children,
        style = _props.style,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['closable', 'colorField', 'className', 'children', 'style']);

    var closeIcon = closable ? _react2.default.createElement(
      'span',
      { onClick: function onClick(e) {
          _this2.close(e, otherProps);
        }, className: 'aps-tag-cross' },
      'x'
    ) : '';

    var names = (0, _common.cname)((_cname = {}, _cname['tag'] = true, _cname['tag-has-color'] = !!colorField, _cname.stateHidden = this.state.closed, _cname.aniTransition = true, _cname[className] = true, _cname));

    var tagStyle = (0, _extends3.default)({
      backgroundColor: colorField ? colorField : null
    }, style);

    return _react2.default.createElement(
      'div',
      { className: names, style: tagStyle },
      _react2.default.createElement(
        'span',
        null,
        children
      ),
      closeIcon
    );
  };

  return Tag;
}(_common.ComBase), _class.propTypes = propTypes, _class.defaultProps = defaultProps, _temp);
exports.default = Tag;
module.exports = exports['default'];

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _promise = __webpack_require__(44);

var _promise2 = _interopRequireDefault(_promise);

var _create = __webpack_require__(34);

var _create2 = _interopRequireDefault(_create);

var _regenerator = __webpack_require__(28);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(29);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Dialog2 = __webpack_require__(97);

var _Dialog3 = _interopRequireDefault(_Dialog2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

var _i18n = __webpack_require__(66);

var _i18n2 = _interopRequireDefault(_i18n);

var _ntils = __webpack_require__(84);

var _ntils2 = _interopRequireDefault(_ntils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_DELAY = 25;
var DISTORY_DELAY = 500;

var Alert = function (_ComBase) {
  (0, _inherits3.default)(Alert, _ComBase);

  function Alert() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Alert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { visible: false, time: -1 }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Alert.prototype.render = function render() {
    return _react2.default.createElement(
      _Dialog3.default,
      (0, _extends3.default)({}, this.props, {
        className: (0, _common.cname)('notificationAlert', this.props.className),
        visible: this.state.visible }),
      this.renderContent()
    );
  };

  Alert.prototype.renderContent = function renderContent() {
    var content = this.props.content;

    return _ntils2.default.isFunction(content) ? content(this.state) : content;
  };

  Alert.prototype.countDown = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(time) {
      var onClose;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onClose = this.props.onClose;

              if (!(time <= 0)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', onClose ? onClose() : null);

            case 3:
              this.setState({ time: time });
              _context.next = 6;
              return (0, _common.sleep)(1000);

            case 6:
              this.countDown(--time);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function countDown(_x) {
      return _ref.apply(this, arguments);
    }

    return countDown;
  }();

  Alert.prototype.componentDidMount = function componentDidMount() {
    var duration = this.props.duration;

    if (duration > 0) this.countDown(duration);
  };

  Alert.prototype.show = function show() {
    this.setState({ visible: true });
  };

  Alert.prototype.close = function close() {
    this.setState({ visible: false });
  };

  return Alert;
}(_common.ComBase);

exports.default = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(content, opts) {
    var _this2 = this;

    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            opts = opts || (0, _create2.default)(null);
            if (opts.title !== false) opts.title = opts.title || _i18n2.default.current.alert;
            if (opts.buttons !== false) opts.buttons = opts.buttons || [{
              text: _i18n2.default.current.ok,
              type: 'primary'
            }];
            opts.content = content || '';
            return _context5.abrupt('return', new _promise2.default(function () {
              var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(resolve) {
                var alertInstance, closeAndDistory;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        alertInstance = void 0;
                        //关闭并且销毁

                        closeAndDistory = function () {
                          var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(btnIndex) {
                            return _regenerator2.default.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    resolve(btnIndex);
                                    alertInstance.close();
                                    _context2.next = 4;
                                    return (0, _common.sleep)(DISTORY_DELAY);

                                  case 4:
                                    (0, _common.unmount)(alertInstance);

                                  case 5:
                                  case 'end':
                                    return _context2.stop();
                                }
                              }
                            }, _callee2, _this2);
                          }));

                          return function closeAndDistory(_x5) {
                            return _ref4.apply(this, arguments);
                          };
                        }();

                        opts.onClose = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                          return _regenerator2.default.wrap(function _callee3$(_context3) {
                            while (1) {
                              switch (_context3.prev = _context3.next) {
                                case 0:
                                  return _context3.abrupt('return', closeAndDistory(-1));

                                case 1:
                                case 'end':
                                  return _context3.stop();
                              }
                            }
                          }, _callee3, _this2);
                        }));
                        opts.onButtonClick = function (event) {
                          return closeAndDistory(event.detail);
                        };
                        _context4.next = 6;
                        return (0, _common.render)(_react2.default.createElement(Alert, opts));

                      case 6:
                        alertInstance = _context4.sent;
                        _context4.next = 9;
                        return (0, _common.sleep)(SHOW_DELAY);

                      case 9:
                        alertInstance.show();

                      case 10:
                      case 'end':
                        return _context4.stop();
                    }
                  }
                }, _callee4, _this2);
              }));

              return function (_x4) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 5:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  function alert(_x2, _x3) {
    return _ref2.apply(this, arguments);
  }

  return alert;
}();

module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(106);


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _index = __webpack_require__(6);

var _index2 = _interopRequireDefault(_index);

var _common = __webpack_require__(0);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//注意不要改动上边的 components 引入代码
//因为 babel-import-plugin 有点问题，只能这样写

exports.default = (0, _extends3.default)({}, _index2.default, { common: _common2.default });
module.exports = exports['default'];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
module.exports = __webpack_require__(9).Object.assign;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(13);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(109) });


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(31);
var gOPS = __webpack_require__(53);
var pIE = __webpack_require__(39);
var toObject = __webpack_require__(54);
var IObject = __webpack_require__(69);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(23)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(24);
var toLength = __webpack_require__(70);
var toAbsoluteIndex = __webpack_require__(111);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Alert/index.js": 71,
	"./Breadcrumb/index.js": 168,
	"./Button/index.js": 91,
	"./Cascader/index.js": 176,
	"./CheckBox/index.js": 62,
	"./CheckBoxGroup/index.js": 93,
	"./DatePicker/index.js": 186,
	"./Dialog/index.js": 97,
	"./Form/index.js": 98,
	"./Grid/index.js": 94,
	"./HyperText/index.js": 200,
	"./Icon/index.js": 10,
	"./Input/index.js": 45,
	"./InputNumber/index.js": 202,
	"./Layout/index.js": 205,
	"./Loading/index.js": 210,
	"./Menu/index.js": 213,
	"./Overlay/index.js": 92,
	"./Pagination/index.js": 217,
	"./Popover/index.js": 19,
	"./Progress/index.js": 228,
	"./Proxy/index.js": 27,
	"./Radio/index.js": 102,
	"./RadioGroup/index.js": 231,
	"./SchemaForm/index.js": 232,
	"./Select/index.js": 65,
	"./Slider/index.js": 233,
	"./Sort/index.js": 235,
	"./Steps/index.js": 237,
	"./Table/index.js": 243,
	"./Tabs/index.js": 245,
	"./Tag/index.js": 103,
	"./Tags/index.js": 250,
	"./Tooltip/index.js": 252,
	"./Upload/index.js": 254,
	"./Validator/index.js": 256,
	"./index.js": 6,
	"./notification/index.js": 259
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(114), __esModule: true };

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(72);
__webpack_require__(76);
module.exports = __webpack_require__(56).f('iterator');


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49);
var defined = __webpack_require__(48);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(55);
var descriptor = __webpack_require__(37);
var setToStringTag = __webpack_require__(41);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(20)(IteratorPrototype, __webpack_require__(12)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var anObject = __webpack_require__(14);
var getKeys = __webpack_require__(31);

module.exports = __webpack_require__(18) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(21);
var toObject = __webpack_require__(54);
var IE_PROTO = __webpack_require__(50)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(120);
var step = __webpack_require__(121);
var Iterators = __webpack_require__(33);
var toIObject = __webpack_require__(24);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(73)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78);
__webpack_require__(81);
__webpack_require__(127);
__webpack_require__(128);
module.exports = __webpack_require__(9).Symbol;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(38)('meta');
var isObject = __webpack_require__(17);
var has = __webpack_require__(21);
var setDesc = __webpack_require__(16).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(23)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(31);
var gOPS = __webpack_require__(53);
var pIE = __webpack_require__(39);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(32);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(24);
var gOPN = __webpack_require__(79).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('asyncIterator');


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('observable');


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(130), __esModule: true };

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(131);
module.exports = __webpack_require__(9).Object.setPrototypeOf;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(13);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(132).set });


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(17);
var anObject = __webpack_require__(14);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(30)(Function.call, __webpack_require__(80).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134);
var $Object = __webpack_require__(9).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(13);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(55) });


/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ComBase.js": 137,
	"./Error.js": 85,
	"./EventArgs.js": 146,
	"./KeyCode.js": 147,
	"./Locale.js": 148,
	"./cname.js": 83,
	"./console.js": 82,
	"./index.js": 0,
	"./meta.js": 149,
	"./render.js": 150,
	"./shadow.js": 60,
	"./sleep.js": 165,
	"./transportProps.js": 166,
	"./unmount.js": 167,
	"./utils.js": 43
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(58);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(42);

var _console = __webpack_require__(82);

var console = _interopRequireWildcard(_console);

var _cname = __webpack_require__(83);

var _cname2 = _interopRequireDefault(_cname);

var _common = __webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComBase = function (_React$Component) {
  (0, _inherits3.default)(ComBase, _React$Component);

  function ComBase() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ComBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.console = console, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  ComBase.prototype.render = function render() {
    return _react2.default.createElement('span', { className: (0, _cname2.default)('state-hidden') });
  };

  ComBase.prototype.findDOMNode = function findDOMNode(ref) {
    return (0, _reactDom.findDOMNode)(ref);
  };

  ComBase.prototype.findChildren = function findChildren(type, children) {
    return _common.utils.findChildren(type, children || this.props.children);
  };

  (0, _createClass3.default)(ComBase, [{
    key: 'domNode',
    get: function get() {
      try {
        return this.findDOMNode(this);
      } catch (ex) {
        //eslint-disable-line
        return null;
      }
    }
  }]);
  return ComBase;
}(_react2.default.Component);

exports.default = ComBase;
module.exports = exports['default'];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(139), __esModule: true };

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(140);
var $Object = __webpack_require__(9).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(13);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', { defineProperty: __webpack_require__(16).f });


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(142);
module.exports = __webpack_require__(9).Object.keys;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(54);
var $keys = __webpack_require__(31);

__webpack_require__(143)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(13);
var core = __webpack_require__(9);
var fails = __webpack_require__(23);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(145), __esModule: true };

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(78);
module.exports = __webpack_require__(9).Symbol['for'];


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _Error = __webpack_require__(85);

var _Error2 = _interopRequireDefault(_Error);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventArgs = function EventArgs(sender, detail, map) {
  var _this = this;

  (0, _classCallCheck3.default)(this, EventArgs);

  if (!sender) throw new _Error2.default('EventArgs constructor Parameter missing');
  _common.utils.each(map, function (name, value) {
    if (name in _this) return;
    if (_common.utils.isFunction(value)) {
      value = value.bind(map);
    }
    _this[name] = value;
  });
  this.sender = (0, _assign2.default)({}, sender);
  this.detail = detail;
  this.value = detail;
  this.sender.value = detail;
  if (!this.target) this.target = this.sender;
};

exports.default = EventArgs;
module.exports = exports['default'];

/***/ }),
/* 147 */
/***/ (function(module, exports) {

exports.__esModule = true;
exports.default = {
  ZERO: 48,
  NINE: 57,

  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,

  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,

  ARROW_UP: 38,
  ARROW_DOWN: 40
};
module.exports = exports["default"];

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BROWSER_LANG = navigator.language || navigator.userLanguage || navigator.languages && navigator.languages[0];

var Locale = function () {
  function Locale(map) {
    (0, _classCallCheck3.default)(this, Locale);

    (0, _assign2.default)(this, map);
  }

  (0, _createClass3.default)(Locale, [{
    key: 'defaultLanguage',
    get: function get() {
      return this._defaultLanguage || 'en';
    },
    set: function set(value) {
      this._defaultLanguage = value;
    }
  }, {
    key: 'language',
    get: function get() {
      return this._language || Locale.language || BROWSER_LANG || this.defaultLanguage;
    },
    set: function set(value) {
      this._language = value;
    }
  }, {
    key: 'current',
    get: function get() {
      var lang = this.language.toLowerCase().split('-')[0];
      return this[this.language] || this[lang] || this[this.defaultLanguage];
    }
  }]);
  return Locale;
}();

exports.default = Locale;
module.exports = exports['default'];

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.default = function (opts) {
  return function (T) {
    (0, _assign2.default)(T, opts);
    T.$meta = true;
  };
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports["default"];

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _shadow = __webpack_require__(60);

var _shadow2 = _interopRequireDefault(_shadow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shadow2.default.render;
module.exports = exports['default'];

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(81);
__webpack_require__(72);
__webpack_require__(76);
__webpack_require__(152);
__webpack_require__(163);
__webpack_require__(164);
module.exports = __webpack_require__(9).Promise;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(40);
var global = __webpack_require__(11);
var ctx = __webpack_require__(30);
var classof = __webpack_require__(86);
var $export = __webpack_require__(13);
var isObject = __webpack_require__(17);
var aFunction = __webpack_require__(36);
var anInstance = __webpack_require__(153);
var forOf = __webpack_require__(154);
var speciesConstructor = __webpack_require__(87);
var task = __webpack_require__(88).set;
var microtask = __webpack_require__(159)();
var newPromiseCapabilityModule = __webpack_require__(61);
var perform = __webpack_require__(89);
var promiseResolve = __webpack_require__(90);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(12)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(160)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(41)($Promise, PROMISE);
__webpack_require__(161)(PROMISE);
Wrapper = __webpack_require__(9)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(162)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(30);
var call = __webpack_require__(155);
var isArrayIter = __webpack_require__(156);
var anObject = __webpack_require__(14);
var toLength = __webpack_require__(70);
var getIterFn = __webpack_require__(157);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(14);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(33);
var ITERATOR = __webpack_require__(12)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(86);
var ITERATOR = __webpack_require__(12)('iterator');
var Iterators = __webpack_require__(33);
module.exports = __webpack_require__(9).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var macrotask = __webpack_require__(88).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(32)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(20);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var core = __webpack_require__(9);
var dP = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(18);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(12)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(13);
var core = __webpack_require__(9);
var global = __webpack_require__(11);
var speciesConstructor = __webpack_require__(87);
var promiseResolve = __webpack_require__(90);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(13);
var newPromiseCapability = __webpack_require__(61);
var perform = __webpack_require__(89);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _promise = __webpack_require__(44);

var _promise2 = _interopRequireDefault(_promise);

exports.default = sleep;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * sleep 函数，用于等待指定的时间后继续执行
 * 示例: await sleep(1000);
 * @param {int} ms 延迟的毫秒数
 * @returns {promise} promise 对象
 */
function sleep(ms) {
  return new _promise2.default(function (resolve) {
    setTimeout(function () {
      resolve();
    }, ms || 0);
  });
}
module.exports = exports["default"];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = transport;

var _utils = __webpack_require__(43);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//默认支的事件，后续补完整
var ALLOWED_REGEXPS = [/^data\-/, /^aria\-/, 'style', 'name', 'id', 'for', 'htmlFor', 'disabled', 'checked', 'value', 'placeholder', 'onClick', 'onContextMenu', 'onDoubleClick', 'onWheel', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onDrag', 'onDrop', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onCopy', 'onCut', 'onPaste', 'onChange', 'onInput', 'onSubmit', 'onFocus', 'onBlur', 'onScroll', 'defaultChecked', 'defaultValue', 'alt', 'title', 'href', 'src', 'type', 'readOnly', 'placeholder', 'accept'];

function transport(map) {
  var result = {};
  _utils2.default.each(map, function (name, value) {
    if (!ALLOWED_REGEXPS.some(function (regexp) {
      return regexp === name || regexp.test && regexp.test(name);
    })) {
      return;
    }
    result[name] = value;
  });
  return result;
}
module.exports = exports['default'];

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _shadow = __webpack_require__(60);

var _shadow2 = _interopRequireDefault(_shadow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shadow2.default.unmount;
module.exports = exports['default'];

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(169);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _index = __webpack_require__(10);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  breadcrumbData: _propTypes2.default.array,
  /**
   * @param {srting} type 分隔符的类型，使用icon
   */
  type: _propTypes2.default.string
};

var defaultProps = {
  breadcrumbData: [],
  type: 'arrow-right'
};

var Breadcrumb = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Breadcrumb, _ComBase);

  function Breadcrumb(props) {
    (0, _classCallCheck3.default)(this, Breadcrumb);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.renderTitle = function (item) {
      var _cname;

      var title = void 0;
      var cls = (0, _common.cname)((_cname = {
        aniTransition: true
      }, _cname['breadcrum-item-text'] = true, _cname));
      if (item.link) {
        title = _react2.default.createElement(
          'a',
          { className: cls, href: item.link },
          _react2.default.createElement(
            'span',
            null,
            item.title
          )
        );
      } else {
        title = _react2.default.createElement(
          'span',
          { className: cls },
          item.title
        );
      }
      return title;
    };

    _this.renderSeparator = function (index, type) {
      var breadcrumbData = _this.props.breadcrumbData;

      var num = breadcrumbData.length;
      return _react2.default.createElement(
        'span',
        { className: (0, _common.cname)('breadcrumb-separator') },
        num === index + 1 ? null : _react2.default.createElement(_index2.default, { type: type })
      );
    };

    _this.state = {};
    return _this;
  }

  Breadcrumb.prototype.render = function render() {
    var _cname2,
        _this2 = this;

    var _props = this.props,
        className = _props.className,
        breadcrumbData = _props.breadcrumbData,
        type = _props.type;


    var warpCls = (0, _common.cname)((_cname2 = {
      widget: true
    }, _cname2['breadcrumb'] = true, _cname2), className);

    return _react2.default.createElement(
      'div',
      { className: warpCls },
      breadcrumbData.map(function (item, index) {
        return _react2.default.createElement(
          'div',
          { key: index, className: (0, _common.cname)('breadcrumb-item') },
          _this2.renderTitle(item),
          _this2.renderSeparator(index, type)
        );
      })
    );
  };

  return Breadcrumb;
}(_common.ComBase), _class.propTypes = propTypes, _class.defaultProps = defaultProps, _temp);
exports.default = Breadcrumb;
module.exports = exports['default'];

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(171);
var invariant = __webpack_require__(172);
var ReactPropTypesSecret = __webpack_require__(173);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _Proxy2 = __webpack_require__(27);

var _Proxy3 = _interopRequireDefault(_Proxy2);

var _Popover2 = __webpack_require__(19);

var _Popover3 = _interopRequireDefault(_Popover2);

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

__webpack_require__(182);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

var _constants = __webpack_require__(183);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cascader = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Cascader, _ComBase);

  function Cascader(props) {
    (0, _classCallCheck3.default)(this, Cascader);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.transformFromValueToIndex = function (valueList, options) {
      var indexArr = [];
      var layerData = options;
      valueList.forEach(function (item) {
        var idx = layerData.findIndex(function (data) {
          return data.value === item;
        });
        if (idx < 0) {
          return null;
        }
        indexArr.push(idx);
        layerData = layerData[idx].children;
      });

      return indexArr;
    };

    _this.transformFromIndexToValue = function (indexList, options) {
      var valueArr = [];
      var layerData = options;
      indexList.forEach(function (item) {
        valueArr.push(layerData[item]);
        layerData = layerData[item].children;
      });
      return valueArr;
    };

    _this.onClickCascader = function () {
      if (_this.props.disabled) return;
      _this.setState({
        cascaderOpened: !_this.state.cascaderOpened,
        cascaderFocused: true,
        temporaryValue: _this.state.cascaderOpened ? _this.state.temporaryValue : []
      });
      return true;
    };

    _this.onBlurFromDomHandler = function (e) {
      if (!_this.popover) return;
      if (!_common.utils.contains(_this.domNode, e.target) && !_common.utils.contains(_this.popover.domNode, e.target)) {
        _this.setState({
          cascaderOpened: false,
          cascaderFocused: false,
          temporaryValue: []
        });
      }
    };

    _this.renderOptions = function (items, selectedIndex, layer) {
      var trigger = _this.props.trigger;

      return _react2.default.createElement(
        'ul',
        { key: 'layer_' + layer, className: (0, _common.cname)('option-list') },
        items.map(function (item, index) {
          var timer = void 0;
          return _react2.default.createElement(
            'li',
            {
              key: item.value,
              className: (0, _common.cname)({
                option: true,
                selected: index === selectedIndex,
                disabled: item.disabled
              }),
              onMouseEnter: function onMouseEnter() {
                if (trigger === 'hover' && !item.disabled) {
                  timer = setTimeout(function () {
                    if (timer && item.children && item.children.length) {
                      _this.selectItem(layer, index, !item.children || !item.children.length);
                    }
                  }, 300);
                }
              },
              onClick: function onClick() {
                if (!item.disabled && (trigger === 'click' || !item.children || !item.children.length)) {
                  _this.selectItem(layer, index, !item.children || !item.children.length);
                }
              },
              onMouseLeave: function onMouseLeave() {
                if (trigger === 'hover') {
                  clearTimeout(timer);
                }
              } },
            _react2.default.createElement(
              'div',
              { className: (0, _common.cname)('option-content') },
              item.children && item.children.length ? _react2.default.createElement(_Icon3.default, { type: 'arrow-right', className: (0, _common.cname)('option-arrow') }) : null,
              item.label || item.text || item.value
            )
          );
        })
      );
    };

    _this.renderPopover = function () {
      var options = _this.props.options;
      var _this$state = _this.state,
          cascaderOpened = _this$state.cascaderOpened,
          selectedValue = _this$state.selectedValue,
          temporaryValue = _this$state.temporaryValue;


      var content = [];
      var layer = 0;
      var deepFind = function deepFind(options, selected) {
        if (!selected || !options || !options.length) return;

        content.push(_this.renderOptions(options, selected[0], layer));
        layer++;

        selected[0] >= 0 && options[selected[0]] && deepFind(options[selected[0]].children, selected.slice(1));
      };
      deepFind(options, cascaderOpened && temporaryValue.length ? temporaryValue : selectedValue);

      return _react2.default.createElement(
        _Popover3.default,
        {
          ref: function ref(popover) {
            _this.popover = popover;
          },
          className: (0, _common.cname)('cascader-drop-down'),
          follow: _this.cascaderInner,
          overlay: false,
          allowedDirection: ['bottom', 'top'],
          visible: cascaderOpened },
        _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('option-list-wrapper') },
          content
        )
      );
    };

    _this.selectItem = function (layer, value, end) {
      var _this$state2 = _this.state,
          temporaryValue = _this$state2.temporaryValue,
          selectedValue = _this$state2.selectedValue;

      var current = temporaryValue && temporaryValue.length ? temporaryValue.concat() : selectedValue.concat();
      current[layer] = value;
      if (current.length - 1 > layer) {
        current.splice(layer + 1);
      }
      _this.setState({
        temporaryValue: current
      });

      if (end) {
        _this.setState({
          selectedValue: current,
          cascaderFocused: false,
          cascaderOpened: false
        });

        if (_this.props.onChange) {
          var eventArgs = new _common.EventArgs(_this, _this.transformFromIndexToValue(current, _this.props.options).map(function (item) {
            return item.value;
          }));
          _this.props.onChange(eventArgs);
        }
      }
    };

    _this.state = {
      cascaderFocused: false,
      cascaderOpened: false,
      selectedValue: _this.props.value ? _this.transformFromValueToIndex(_this.props.value, _this.props.options) : [],
      temporaryValue: []
    };
    return _this;
  }

  Cascader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        selectedValue: this.transformFromValueToIndex(nextProps.value, nextProps.options) || []
      });
    }
  };

  Cascader.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        className = _props.className,
        size = _props.size,
        options = _props.options,
        resultRender = _props.resultRender;
    var _state = this.state,
        cascaderFocused = _state.cascaderFocused,
        cascaderOpened = _state.cascaderOpened,
        selectedValue = _state.selectedValue;

    var names = (0, _common.cname)({
      widget: true,
      cascader: true,
      cascaderLg: size && size === _constants.SelectSize.LARGE,
      cascaderMd: !size || size === _constants.SelectSize.MEDIUM,
      cascaderSm: size && size === _constants.SelectSize.SMALL,
      cascaderFocused: cascaderFocused,
      cascaderOpened: cascaderOpened
    }, className);

    var currentResult = resultRender(this.transformFromIndexToValue(selectedValue, options));

    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: names, style: this.props.style }),
      _react2.default.createElement(
        'div',
        {
          ref: function ref(cascaderInner) {
            _this2.cascaderInner = cascaderInner;
          },
          className: (0, _common.cname)('cascader-inner'),
          onClick: this.onClickCascader },
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)('selected-value') },
          currentResult
        ),
        _react2.default.createElement(_Icon3.default, { type: 'arrow-down', className: (0, _common.cname)('select-arrow ani-transition') })
      ),
      this.renderPopover(),
      _react2.default.createElement(_Proxy3.default, { target: document, onClick: this.onBlurFromDomHandler })
    );
  };

  return Cascader;
}(_common.ComBase), _class.propTypes = {
  value: _propTypes2.default.array,
  options: _propTypes2.default.array.isRequired,
  onChange: _propTypes2.default.func,
  resultRender: _propTypes2.default.func,
  trigger: _propTypes2.default.oneOf(['click', 'hover'])
}, _temp);


Cascader.defaultProps = {
  size: _constants.SelectSize.MEDIUM,
  trigger: 'click',
  resultRender: function resultRender(values) {
    var str = '';
    values.forEach(function (item, index) {
      str += '' + (item.label || item.text || item.value) + (index + 1 === values.length ? '' : ' / ');
    });
    return str;
  }
};

exports.default = Cascader;
module.exports = exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(178);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 178 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(9);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

exports.SelectSize = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small'
};

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _Proxy2 = __webpack_require__(27);

var _Proxy3 = _interopRequireDefault(_Proxy2);

var _Popover2 = __webpack_require__(19);

var _Popover3 = _interopRequireDefault(_Popover2);

var _Input2 = __webpack_require__(45);

var _Input3 = _interopRequireDefault(_Input2);

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(188);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

var _picker = __webpack_require__(189);

var _picker2 = _interopRequireDefault(_picker);

var _dateEntity = __webpack_require__(63);

var _dateEntity2 = _interopRequireDefault(_dateEntity);

var _i18n = __webpack_require__(96);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePicker = (_dec = (0, _common.meta)({
  valuePropName: 'value',
  valuePath: 'detail'
}), _dec(_class = (_temp2 = _class2 = function (_ComBase) {
  (0, _inherits3.default)(DatePicker, _ComBase);

  function DatePicker() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { pickerVisible: false, defaultValue: null }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  DatePicker.prototype.render = function render() {
    var _this2 = this;

    var names = (0, _common.cname)({
      widget: true,
      aniTransition: true,
      widgetShadow: this.props.shadow,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      datePicker: true,
      stateHidden: this.props.visible === false,
      stateVisible: this.props.visible !== false
    }, this.props.className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), { className: names }),
      _react2.default.createElement(_Input3.default, { ref: function ref(_ref) {
          _this2.input = _ref;
        },
        className: (0, _common.cname)('datePickerInput'),
        suffix: _react2.default.createElement(_Icon3.default, { onClick: this.onInputClick.bind(this),
          type: 'clock' }),
        value: this.value && this.value.format(this.format),
        readOnly: true,
        size: this.props.size,
        onClick: this.onInputClick.bind(this) }),
      _react2.default.createElement(
        _Popover3.default,
        { className: (0, _common.cname)('datePickerPanel'),
          ref: function ref(panel) {
            _this2.panel = panel;
          },
          follow: this.input,
          overlay: false,
          inside: this.props.inside,
          allowedDirection: ['bottom', 'top'],
          visible: this.state.pickerVisible },
        _react2.default.createElement(_picker2.default, { onChange: this.onChange.bind(this),
          onDayClick: this.props.onDayClick,
          value: this.value,
          format: this.format,
          type: this.props.type,
          defaultType: this.props.defaultType,
          onSwitch: this.onSwitch.bind(this),
          visible: this.state.pickerVisible })
      ),
      _react2.default.createElement(_Proxy3.default, { onClick: this.onDocumentClick.bind(this) })
    );
  };

  DatePicker.prototype._hasValue = function _hasValue() {
    return 'value' in this.props;
  };

  DatePicker.prototype.componentDidMount = function componentDidMount() {
    var defaultValue = this.props.defaultValue || this.state.defaultValue;
    this.setState({ defaultValue: defaultValue });
  };

  DatePicker.prototype.onDocumentClick = function onDocumentClick(event) {
    if (_common.utils.contains(this.domNode, event.target) || _common.utils.contains(this.findDOMNode(this.panel), event.target)) {
      return;
    }
    if (this.state.pickerVisible) this.onClose();
  };

  DatePicker.prototype.onInputClick = function onInputClick() {
    this.setState({ pickerVisible: true });
  };

  DatePicker.prototype.onChange = function onChange(event, close) {
    if (!this._hasValue()) {
      this.setState({
        defaultValue: event.detail
      });
    }
    var type = this.props.type || this.props.defaultType;
    var onChange = this.props.onChange;

    if (_common.utils.isFunction(onChange)) onChange(event);
    if (type === 'datetime' && close !== true) return;
    this.onOk();
    this.onClose();
  };

  DatePicker.prototype.onClose = function onClose() {
    var event = new _common.EventArgs(this, new _dateEntity2.default(this.value));
    this.setState({ pickerVisible: false });
    var onClose = this.props.onClose;

    if (_common.utils.isFunction(onClose)) onClose(event);
  };

  DatePicker.prototype.onOk = function onOk() {
    var event = new _common.EventArgs(this, new _dateEntity2.default(this.value));
    this.setState({ pickerVisible: false });
    var onOk = this.props.onOk;

    if (_common.utils.isFunction(onOk)) onOk(event);
  };

  DatePicker.prototype.onSwitch = function onSwitch() {
    this.panel.reflow();
  };

  (0, _createClass3.default)(DatePicker, [{
    key: 'value',
    get: function get() {
      var value = this.props.value || this.state.defaultValue;
      if (!value) return '';
      return new _dateEntity2.default(value);
    }
  }, {
    key: 'format',
    get: function get() {
      var builtInformat = _i18n2.default.current.format;
      var _props = this.props,
          type = _props.type,
          defaultType = _props.defaultType,
          format = _props.format;

      if (format) return format;
      type = type || defaultType;
      switch (type) {
        case 'year':
          return 'yyyy';
        case 'month':
          return builtInformat.month;
        case 'datetime':
          return builtInformat.datetime;
        case 'date':
        default:
          return builtInformat.date;
      }
    }
  }]);
  return DatePicker;
}(_common.ComBase), _class2.i18n = _i18n2.default, _class2.DateEntity = _dateEntity2.default, _temp2)) || _class);
exports.default = DatePicker;
module.exports = exports['default'];

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _regenerator = __webpack_require__(28);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(29);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Grid2 = __webpack_require__(94);

var _Grid3 = _interopRequireDefault(_Grid2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(192);

var _common = __webpack_require__(0);

var _dateUtil = __webpack_require__(193);

var _i18n = __webpack_require__(96);

var _i18n2 = _interopRequireDefault(_i18n);

var _components = __webpack_require__(6);

var _dateEntity = __webpack_require__(63);

var _dateEntity2 = _interopRequireDefault(_dateEntity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = _Grid3.default.Row,
    Col = _Grid3.default.Col;


var METHOD_OF_TYPE = {
  date: 'renderMonth',
  year: 'renderYears',
  month: 'renderMonths',
  time: 'renderTime',
  datetime: 'renderMonth'
};

var DatePicker = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(DatePicker, _ComBase);

  function DatePicker() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { showValue: null, showType: null }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  DatePicker.prototype.componentDidMount = function componentDidMount() {
    this.propsToState(this.props);
  };

  DatePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.propsToState(nextProps);
  };

  DatePicker.prototype.propsToState = function propsToState(props) {
    var value = props.value,
        defaultValue = props.defaultValue,
        type = props.type,
        defaultType = props.defaultType;

    var showValue = new _dateEntity2.default(value || this.state.showValue || defaultValue);
    var showType = type || this.state.showType || defaultType;
    this.setState({ showValue: showValue, showType: showType });
  };

  DatePicker.prototype.renderMonthWeeks = function renderMonthWeeks() {
    var weeks = _i18n2.default.current.weeks;

    var thList = weeks.map(function (item) {
      return _react2.default.createElement(
        'th',
        { key: item.value, className: (0, _common.cname)('disabled') },
        item.text
      );
    });
    return _react2.default.createElement(
      'tr',
      { className: (0, _common.cname)('datePickerWeeks') },
      thList
    );
  };

  DatePicker.prototype.renderMoathCell = function renderMoathCell(item, index) {
    var date = item.date;

    var tdNames = (0, _common.cname)({
      exceeding: !item.isCurrent,
      stateActive: this.value.format('yyyy/M/d') == item.format('yyyy/M/d')
    });
    var onDayClick = this.onDayClick.bind(this, item);
    return _react2.default.createElement(
      'td',
      { className: tdNames,
        onClick: onDayClick,
        key: index },
      date
    );
  };

  DatePicker.prototype.renderMonthCells = function renderMonthCells(_ref) {
    var _this2 = this;

    var year = _ref.year,
        month = _ref.month;
    var weeks = _i18n2.default.current.weeks;

    var prevDates = (0, _dateUtil.getNearDates)(year, month, -1);
    var nextDates = (0, _dateUtil.getNearDates)(year, month, 1);
    var firstDay = (0, _dateUtil.getFirstDay)(year, month);
    var dates = (0, _dateUtil.getDates)(year, month);
    var leftPad = void 0;
    if (weeks[0].value == 0) {
      leftPad = prevDates.slice(prevDates.length - firstDay);
    } else {
      if (firstDay == 0) firstDay = 7;
      leftPad = prevDates.slice(prevDates.length - (firstDay - 1));
    }
    dates.unshift.apply(dates, leftPad);
    var rightPad = nextDates.slice(0, 42 - dates.length);
    dates.push.apply(dates, rightPad);
    var dateIndex = 0;
    var trList = [];
    _common.utils.fromTo(0, 5, function (line) {
      var tdList = weeks.map(function () {
        var date = dates[dateIndex];
        date.isCurrent = date.month === month;
        return _this2.renderMoathCell(date, dateIndex++);
      });
      trList.push(_react2.default.createElement(
        'tr',
        { key: line },
        tdList
      ));
    });
    return trList;
  };

  DatePicker.prototype.renderMonth = function renderMonth(_ref2) {
    var year = _ref2.year,
        month = _ref2.month;

    var locales = _i18n2.default.current;
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('datePickerHead') },
        _react2.default.createElement(_Icon3.default, { onClick: this.prevMonth.bind(this),
          type: 'arrow-left', className: (0, _common.cname)('pull-left') }),
        _react2.default.createElement(
          'a',
          { onClick: this.switchShowType.bind(this, 'year') },
          this.showValue.format('yyyy')
        ),
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)('datePickerSeparater') },
          '/'
        ),
        _react2.default.createElement(
          'a',
          { onClick: this.switchShowType.bind(this, 'month') },
          this.showValue.format('MM')
        ),
        _react2.default.createElement(_Icon3.default, { onClick: this.nextMonth.bind(this),
          type: 'arrow-right', className: (0, _common.cname)('pull-right') })
      ),
      _react2.default.createElement(
        'table',
        null,
        _react2.default.createElement(
          'thead',
          null,
          this.renderMonthWeeks()
        ),
        _react2.default.createElement(
          'tbody',
          null,
          this.renderMonthCells({ year: year, month: month })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('datePickerFoot') },
        this.renderTimeAndOk(),
        _react2.default.createElement(
          'a',
          { className: (0, _common.cname)({ pullLeft: this.showType === 'datetime' }),
            onClick: this.onTodayClick.bind(this) },
          locales.today
        )
      )
    );
  };

  DatePicker.prototype.renderTimeAndOk = function renderTimeAndOk() {
    if (this.showType !== 'datetime') return;
    var locales = _i18n2.default.current;
    return [_react2.default.createElement(
      'a',
      { key: 'time', className: (0, _common.cname)('time'),
        onClick: this.switchShowType.bind(this, 'time') },
      this.showValue.format('hh:mm:ss')
    ), _react2.default.createElement(
      'a',
      { key: 'ok', className: (0, _common.cname)('pull-right'),
        onClick: this.onOkClick.bind(this) },
      locales.ok
    )];
  };

  DatePicker.prototype.renderYears = function renderYears(_ref3) {
    var _this3 = this;

    var year = _ref3.year;

    var beginYear = year - 5;
    var endYear = year + 6;
    var years = [];
    _common.utils.fromTo(beginYear, endYear, function (year) {
      var names = (0, _common.cname)({
        stateActive: year == _this3.value.year
      });
      years.push(_react2.default.createElement(
        'li',
        { key: year,
          className: names,
          onClick: _this3.onYearClick.bind(_this3, { year: year }) },
        year
      ));
    });
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('datePickerHead') },
        _react2.default.createElement(_Icon3.default, { onClick: this.nextYears.bind(this, -12),
          type: 'arrow-left', className: (0, _common.cname)('pull-left') }),
        _react2.default.createElement(
          'a',
          null,
          beginYear
        ),
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)('datePickerSeparater') },
          '-'
        ),
        _react2.default.createElement(
          'a',
          null,
          endYear
        ),
        _react2.default.createElement(_Icon3.default, { onClick: this.nextYears.bind(this, 12),
          type: 'arrow-right', className: (0, _common.cname)('pull-right') })
      ),
      _react2.default.createElement(
        'ul',
        { className: (0, _common.cname)('datePickerYears') },
        years
      )
    );
  };

  DatePicker.prototype.renderMonths = function renderMonths(_ref4) {
    var _this4 = this;

    var year = _ref4.year;

    var months = [];
    _common.utils.fromTo(1, 12, function (month) {
      var names = (0, _common.cname)({
        stateActive: month == _this4.value.month
      });
      months.push(_react2.default.createElement(
        'li',
        { key: month,
          className: names,
          onClick: _this4.onMonthClick.bind(_this4, { year: year, month: month }) },
        month
      ));
    });
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('datePickerHead') },
        _react2.default.createElement(_Icon3.default, { onClick: this.nextYears.bind(this, -1),
          type: 'arrow-left', className: (0, _common.cname)('pull-left') }),
        _react2.default.createElement(
          'a',
          null,
          year
        ),
        _react2.default.createElement(_Icon3.default, { onClick: this.nextYears.bind(this, 1),
          type: 'arrow-right', className: (0, _common.cname)('pull-right') })
      ),
      _react2.default.createElement(
        'ul',
        { className: (0, _common.cname)('datePickerMonths') },
        months
      )
    );
  };

  DatePicker.prototype.onTimeClick = function onTimeClick(name, value) {
    this.showValue[name] = value;
    this.setState({ showValue: new _dateEntity2.default(this.showValue) });
    this.onChange(this.showValue, event);
  };

  DatePicker.prototype.createNumList = function createNumList(from, to, name) {
    var _this5 = this;

    var items = [];
    var value = this.showValue[name];
    _common.utils.fromTo(from, to, function (num) {
      var itemNames = (0, _common.cname)({
        aniTransition: true,
        stateActive: value == num
      });
      items.push(_react2.default.createElement(
        'li',
        { className: itemNames,
          onClick: _this5.onTimeClick.bind(_this5, name, num),
          key: num },
        num
      ));
    });
    return _react2.default.createElement(
      'ul',
      { className: (0, _common.cname)({ aniTransition: true }),
        style: { marginTop: -28 * (value - 3) } },
      items
    );
  };

  DatePicker.prototype.onTimeWhell = function onTimeWhell(name, event) {
    var range = {
      hours: { min: 0, max: 23 },
      minutes: { min: 0, max: 59 },
      seconds: { min: 0, max: 59 }
    }[name];
    var value = this.showValue[name];
    value += parseInt(event.deltaY / 4);
    if (value < range.min) value = range.min;
    if (value > range.max) value = range.max;
    this.showValue[name] = value;
    this.setState({ showValue: new _dateEntity2.default(this.showValue) });
    this.onChange(this.showValue, event);
  };

  DatePicker.prototype.onTimeOkClick = function onTimeOkClick() {
    var entity = new _dateEntity2.default(this.showValue);
    this.setState(entity);
    var type = this.props.type || this.props.defaultType;
    if (type !== 'time') {
      return this.switchShowType(type);
    }
  };

  DatePicker.prototype.renderTime = function renderTime() {
    var locales = _i18n2.default.current;
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('timePanel') },
      _react2.default.createElement(
        _Grid3.default,
        { fluid: true, cellPadding: 10 },
        _react2.default.createElement(
          Row,
          { className: (0, _common.cname)('timeHead') },
          _react2.default.createElement(
            Col,
            { span: 8 },
            locales.hours
          ),
          _react2.default.createElement(
            Col,
            { span: 8 },
            locales.minutes
          ),
          _react2.default.createElement(
            Col,
            { span: 8 },
            locales.seconds
          )
        ),
        _react2.default.createElement(
          Row,
          { cellPadding: 0, className: (0, _common.cname)('timeBody') },
          _react2.default.createElement(
            Col,
            { span: 8, className: (0, _common.cname)('col col-h'),
              onWheel: this.onTimeWhell.bind(this, 'hours') },
            this.createNumList(0, 23, 'hours')
          ),
          _react2.default.createElement(
            Col,
            { span: 8, className: (0, _common.cname)('col col-m'),
              onWheel: this.onTimeWhell.bind(this, 'minutes') },
            this.createNumList(0, 59, 'minutes')
          ),
          _react2.default.createElement(
            Col,
            { span: 8, className: (0, _common.cname)('col col-s'),
              onWheel: this.onTimeWhell.bind(this, 'seconds') },
            this.createNumList(0, 59, 'seconds')
          )
        )
      ),
      _react2.default.createElement('div', { className: (0, _common.cname)('timeRule') }),
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('datePickerFoot') },
        _react2.default.createElement(
          'a',
          { onClick: this.onTimeOkClick.bind(this) },
          locales.ok
        )
      )
    );
  };

  DatePicker.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        visible = _props.visible,
        shadow = _props.shadow,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'visible', 'shadow']);

    var names = (0, _common.cname)({
      widget: true,
      widgetShadow: shadow,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      datePickerInline: true,
      stateHidden: visible === false,
      stateVisible: visible !== false
    }, className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(otherProps), { className: names }),
      this.renderMethod(this.showValue)
    );
  };

  DatePicker.prototype.onSwitch = function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
      var onSwitch;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onSwitch = this.props.onSwitch;

              if (_common.utils.isFunction(onSwitch)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:
              _context.next = 5;
              return (0, _common.sleep)(0);

            case 5:
              onSwitch(event);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function onSwitch(_x) {
      return _ref5.apply(this, arguments);
    }

    return onSwitch;
  }();

  DatePicker.prototype.nextMonth = function nextMonth(event) {
    var showValue = this.showValue.addMonth(1);
    this.setState({ showValue: showValue });
    this.onSwitch(event);
  };

  DatePicker.prototype.prevMonth = function prevMonth(event) {
    var showValue = this.showValue.addMonth(-1);
    this.setState({ showValue: showValue });
    this.onSwitch(event);
  };

  DatePicker.prototype.nextYears = function nextYears(num, event) {
    var showValue = this.showValue.addYear(num);
    this.setState({ showValue: showValue });
    this.onSwitch(event);
  };

  DatePicker.prototype.prevYears = function prevYears(num, event) {
    var showValue = this.showValue.addYear(-num);
    this.setState({ showValue: showValue });
    this.onSwitch(event);
  };

  DatePicker.prototype.onTodayClick = function onTodayClick(event) {
    var now = new _dateEntity2.default();
    this.onDayClick(now, event);
  };

  DatePicker.prototype.onChange = function onChange(value, event, close) {
    var _props2 = this.props,
        onChange = _props2.onChange,
        defaultType = _props2.defaultType;

    if (!_common.utils.isFunction(onChange)) return;
    var detail = void 0;
    if (defaultType !== 'datetime') {
      detail = new _dateEntity2.default(new _dateEntity2.default(value).format('yyyy/MM/dd'));
    } else {
      detail = new _dateEntity2.default(value);
    }
    onChange(new _common.EventArgs(this, detail), close);
  };

  DatePicker.prototype.onDayClick = function onDayClick(entity, event, close) {
    entity.hours = this.showValue.hours;
    entity.minutes = this.showValue.minutes;
    entity.seconds = this.showValue.seconds;
    this.setState(entity);
    //this.forceUpdate();
    this.onChange(entity, event, close);
    var onDayClick = this.props.onDayClick;

    if (!_common.utils.isFunction(onDayClick)) return;
    onDayClick(new _common.EventArgs(this, new _dateEntity2.default(entity)), close);
  };

  DatePicker.prototype.onOkClick = function onOkClick(event) {
    var now = new _dateEntity2.default(this.showValue);
    this.onDayClick(now, event, true);
  };

  DatePicker.prototype.switchShowType = function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(showType) {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _common.sleep)(0);

            case 2:
              this.setState({ showType: showType });

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function switchShowType(_x2) {
      return _ref6.apply(this, arguments);
    }

    return switchShowType;
  }();

  DatePicker.prototype.onYearClick = function onYearClick(_ref7, event) {
    var year = _ref7.year;

    var showValue = this.showValue;
    showValue.year = year;
    this.setState({ showValue: showValue });
    var type = this.props.type || this.props.defaultType;
    if (type !== 'year') {
      return this.switchShowType(type);
    }
    this.onChange(showValue, event);
  };

  DatePicker.prototype.onMonthClick = function onMonthClick(_ref8, event) {
    var year = _ref8.year,
        month = _ref8.month;

    var showValue = this.showValue;
    showValue.year = year;
    showValue.month = month;
    this.setState({ showValue: showValue });
    var type = this.props.type || this.props.defaultType;
    if (type !== 'month') {
      return this.switchShowType(type);
    }
    this.onChange(showValue, event);
  };

  (0, _createClass3.default)(DatePicker, [{
    key: 'value',
    get: function get() {
      return new _dateEntity2.default(this.props.value || this.state.showValue);
    }
  }, {
    key: 'showValue',
    get: function get() {
      if (!this.state.showValue) {
        this.state.showValue = new _dateEntity2.default();
      }
      return this.state.showValue;
    }
  }, {
    key: 'showType',
    get: function get() {
      var _props3 = this.props,
          type = _props3.type,
          defaultType = _props3.defaultType;

      return type || this.state.showType || defaultType || 'date';
    }
  }, {
    key: 'renderMethod',
    get: function get() {
      var name = METHOD_OF_TYPE[this.showType];
      return this[name];
    }
  }]);
  return DatePicker;
}(_common.ComBase), _class.i18n = _i18n2.default, _temp2);
exports.default = DatePicker;
module.exports = exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _col = __webpack_require__(95);

var _col2 = _interopRequireDefault(_col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = function (_ComBase) {
  (0, _inherits3.default)(Alert, _ComBase);

  function Alert() {
    (0, _classCallCheck3.default)(this, Alert);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Alert.prototype.wrapChildren = function wrapChildren(children) {
    var _props = this.props,
        cellPadding = _props.cellPadding,
        colPadding = _props.colPadding;

    if (_common.utils.isNull(cellPadding) && _common.utils.isNull(colPadding)) return children;
    if (cellPadding && !_common.utils.isNumber(cellPadding)) cellPadding = 0;
    var cols = this.findChildren(_col2.default);
    if (_common.utils.isNumber(colPadding)) {
      cellPadding = (cellPadding || 0) + 'px ' + colPadding + 'px';
    }
    return cols.map(function (col, index) {
      return _react2.default.cloneElement(col, {
        key: index,
        padding: _common.utils.isNull(col.props.padding) ? cellPadding : col.props.padding
      });
    });
  };

  Alert.prototype.render = function render() {
    var _props2 = this.props,
        visible = _props2.visible,
        className = _props2.className,
        spacing = _props2.spacing,
        children = _props2.children,
        style = _props2.style,
        otherProps = (0, _objectWithoutProperties3.default)(_props2, ['visible', 'className', 'spacing', 'children', 'style']);

    var names = (0, _common.cname)({
      aniTransition: true,
      gridRow: true,
      stateHidden: visible === false,
      stateVisible: visible !== false
    }, className);
    var element = _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(otherProps), {
        style: style,
        className: names }),
      this.wrapChildren(children)
    );
    if (_common.utils.isNumber(spacing)) {
      element = _react2.default.cloneElement(element, {
        style: (0, _extends3.default)({ margin: spacing + 'px 0' }, style)
      });
    }
    return element;
  };

  return Alert;
}(_common.ComBase);

exports.default = Alert;
module.exports = exports['default'];

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.NUM_OF_DAYS = undefined;
exports.isDivisible = isDivisible;
exports.isLeapYear = isLeapYear;
exports.numOfDays = numOfDays;
exports.getFirstDay = getFirstDay;
exports.getDates = getDates;
exports.getNearDates = getNearDates;

var _common = __webpack_require__(0);

var _dateEntity = __webpack_require__(63);

var _dateEntity2 = _interopRequireDefault(_dateEntity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NUM_OF_DAYS = exports.NUM_OF_DAYS = [{
  num: 31, months: [1, 3, 5, 7, 8, 10, 12]
}, {
  num: 30, months: [4, 6, 9, 11]
}, {
  num: 28, months: [2]
}];

function isDivisible(numerator, denominator) {
  return numerator % denominator === 0;
}

function isLeapYear(year) {
  return isDivisible(year, 4) && !isDivisible(year, 100) || isDivisible(year, 400);
}

function numOfDays(year, month) {
  var num = NUM_OF_DAYS.find(function (item) {
    return ~item.months.indexOf(month);
  }).num;
  if (isLeapYear(year) && month == 2) num++;
  return num;
}

function getFirstDay(year, month) {
  var date = new _dateEntity2.default(year + '/' + month + '/1');
  return date.day;
}

function getDates(year, month) {
  var dayCount = numOfDays(year, month);
  var dates = [];
  _common.utils.fromTo(1, dayCount, function (date) {
    dates.push(new _dateEntity2.default(year + '/' + month + '/' + date));
  });
  return dates;
}

function getNearDates(year, month, near) {
  var entity = new _dateEntity2.default(year + '/' + month + '/1');
  entity.month += near;
  return getDates(entity.year, entity.month);
}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _create = __webpack_require__(34);

var _create2 = _interopRequireDefault(_create);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(196);

var _common = __webpack_require__(0);

var _item = __webpack_require__(99);

var _item2 = _interopRequireDefault(_item);

var _validate = __webpack_require__(64);

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Form = (_dec = (0, _common.meta)({
  valuePropName: 'value',
  valuePath: 'detail.data'
}), _dec(_class = function (_ComBase) {
  (0, _inherits3.default)(Form, _ComBase);

  function Form() {
    (0, _classCallCheck3.default)(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args)));

    _this.state = { data: {} };

    _this.rules = {};
    return _this;
  }

  Form.prototype.getData = function getData() {
    var _props = this.props,
        vm = _props.vm,
        name = _props.name,
        value = _props.value,
        data = _props.data;

    var result = void 0;
    if (vm && name) {
      result = vm.state && vm.state[name] && vm.state[name].data;
    } else if (vm) {
      result = vm.state && vm.state.data;
    } else {
      result = value || data || this.state.data;
    }
    return (0, _assign2.default)({}, result);
  };

  Form.prototype.getUpdateMethod = function getUpdateMethod() {
    var _props2 = this.props,
        name = _props2.name,
        vm = _props2.vm,
        update = _props2.update;

    return function (state) {
      var _state;

      delete state.info;
      if (name) state = (_state = {}, _state[name] = state, _state);
      if (vm) {
        vm.setState(state);
      } else if (update) update(state);
    };
  };

  Form.prototype.wrapChildren = function wrapChildren(children, parentKey) {
    var _this2 = this;

    if (!children || !_common.utils.isObject(children)) return children;
    parentKey = parentKey || 'root';
    var data = this.getData();
    var _state2 = this.state,
        validate = _state2.validate,
        controledValidate = _state2.controledValidate;

    var foundChildren = this.findChildren(null, children);
    var wrappedChildren = foundChildren.map(function (child, index) {
      var selfKey = parentKey + '.' + index;
      if (child.type != _item2.default) {
        return _react2.default.cloneElement(child, {
          key: selfKey,
          children: _this2.wrapChildren(child.props.children, selfKey)
        });
      }
      var _child$props = child.props,
          name = _child$props.name,
          value = _child$props.value,
          rule = _child$props.rule;

      _this2.rules[name] = rule;
      return _react2.default.cloneElement(child, {
        key: selfKey,
        value: value || data[name],
        invalid: controledValidate && validate ? !validate.fields[name] : undefined,
        onChange: _this2.itemChange.bind(_this2, name),
        style: (0, _extends3.default)({}, child.props.style, {
          width: _this2.props.itemWidth
        })
      });
    });
    return wrappedChildren;
  };

  Form.prototype.validateData = function validateData(data) {
    var _this3 = this;

    var fields = {};
    var invalid = false;
    _common.utils.each(data, function (name, value) {
      fields[name] = (0, _validate2.default)(value, _this3.rules[name]);
      if (!fields[name]) invalid = true;
    });
    var result = { fields: fields, invalid: invalid };
    var onValidate = this.props.onValidate;

    if (onValidate) onValidate(new _common.EventArgs(this, result));
    return result;
  };

  Form.prototype.itemChange = function itemChange(name, event) {
    if (event.stopPropagation) event.stopPropagation();
    if (!event.detail) return;
    var detail = (0, _create2.default)(null);
    var data = this.getData();
    //info
    detail.info = {
      name: name,
      oldValue: data[name],
      newValue: event.detail.value,
      invalid: event.detail.invalid
    };
    //set
    data[name] = event.detail.value;
    detail.data = data;
    //validate
    detail.validate = this.validateData(detail.data);
    //update
    this.setState(detail);
    var onChange = this.props.onChange;

    if (onChange) onChange(new _common.EventArgs(this, detail, event));
    var update = this.getUpdateMethod();
    if (update) update(detail);
  };

  Form.prototype.verify = function verify() {
    var data = this.getData();
    var validate = this.validateData(data);
    this.setState({ validate: validate, controledValidate: true });
    return validate;
  };

  Form.prototype.componentDidMount = function componentDidMount() {
    var data = this.getData();
    var validate = this.validateData(data);
    var onChange = this.props.onChange;

    if (onChange) onChange(new _common.EventArgs(this, { validate: validate, data: data }));
    var update = this.getUpdateMethod();
    if (update) update({ validate: validate, data: data });
  };

  Form.prototype.render = function render() {
    var _cname;

    var layout = this.props.layout || 'block';
    var labelVAlign = this.props.labelVerticalAlign;
    var names = (0, _common.cname)((_cname = {
      widget: true,
      form: true,
      aniTransition: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      stateHidden: this.props.visible === false,
      stateVisible: this.props.visible !== false
    }, _cname['layout-' + layout] = !!layout, _cname.labelTop = this.props.labelTop, _cname['label-vertical-align-' + labelVAlign] = !!labelVAlign, _cname), this.props.className);
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), {
        className: names }),
      this.wrapChildren(this.props.children)
    );
  };

  return Form;
}(_common.ComBase)) || _class);
exports.default = Form;
module.exports = exports['default'];

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormMessage = function (_ComBase) {
  (0, _inherits3.default)(FormMessage, _ComBase);

  function FormMessage() {
    (0, _classCallCheck3.default)(this, FormMessage);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  FormMessage.prototype.render = function render() {
    var names = (0, _common.cname)({
      widget: true,
      aniTransition: true,
      formMessage: true
    }, this.props.className);
    return _react2.default.createElement(
      'span',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), {
        className: names }),
      this.props.children
    );
  };

  return FormMessage;
}(_common.ComBase);

exports.default = FormMessage;
module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormControl = function (_ComBase) {
  (0, _inherits3.default)(FormControl, _ComBase);

  function FormControl() {
    (0, _classCallCheck3.default)(this, FormControl);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  FormControl.prototype.render = function render() {
    var control = this.findChildren()[0];
    if (!control) return _react2.default.createElement('span', { className: (0, _common.cname)('state-hidden') });
    return _react2.default.cloneElement(control, {
      className: (0, _common.cname)('form-control', this.props.className)
    });
  };

  return FormControl;
}(_common.ComBase);

exports.default = FormControl;
module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(201);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HyperText = function (_ComBase) {
  (0, _inherits3.default)(HyperText, _ComBase);

  function HyperText() {
    (0, _classCallCheck3.default)(this, HyperText);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  //渲染内容
  HyperText.prototype.render = function render() {
    var _props = this.props,
        visible = _props.visible,
        className = _props.className,
        content = _props.content,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['visible', 'className', 'content']);

    var names = (0, _common.cname)({
      hyperText: true,
      widget: true,
      aniTransition: true,
      stateHidden: visible === false,
      stateVisible: visible !== false
    }, className);
    return _react2.default.createElement('div', (0, _extends3.default)({}, (0, _common.transportProps)(otherProps), { className: names,
      dangerouslySetInnerHTML: { __html: content } }));
  };

  return HyperText;
}(_common.ComBase);

exports.default = HyperText;
module.exports = exports['default'];

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; //公共样式


__webpack_require__(58);

__webpack_require__(203);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _Icon = __webpack_require__(10);

var _Icon2 = _interopRequireDefault(_Icon);

var _util = __webpack_require__(204);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixCls = 'ipt-num';
var SPEED = 200;

var InputNumber = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(InputNumber, _ComBase);

  function InputNumber(props) {
    (0, _classCallCheck3.default)(this, InputNumber);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    var value = void 0;

    if ('value' in props) {
      value = props.value;
    } else {
      value = props.defaultValue;
    }
    value = (0, _util.toNumber)(value);
    var _this$props = _this.props,
        min = _this$props.min,
        max = _this$props.max;


    if (value < min || value > max) {
      throw new Error('the value should be between min and max');
    }

    _this.onKeyDown = _this.onKeyDown.bind(_this);

    if (!(typeof _this.onKeyDown === 'function')) {
      throw new TypeError('Value of "this.onKeyDown" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.onKeyDown));
    }

    _this.onKeyUp = _this.onKeyUp.bind(_this);

    if (!(typeof _this.onKeyUp === 'function')) {
      throw new TypeError('Value of "this.onKeyUp" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.onKeyUp));
    }

    _this.down = _this.down.bind(_this);

    if (!(typeof _this.down === 'function')) {
      throw new TypeError('Value of "this.down" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.down));
    }

    _this.up = _this.up.bind(_this);

    if (!(typeof _this.up === 'function')) {
      throw new TypeError('Value of "this.up" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.up));
    }

    _this.step = _this.step.bind(_this);

    if (!(typeof _this.step === 'function')) {
      throw new TypeError('Value of "this.step" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.step));
    }

    _this.stop = _this.stop.bind(_this);

    if (!(typeof _this.stop === 'function')) {
      throw new TypeError('Value of "this.stop" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.stop));
    }

    _this.onChange = _this.onChange.bind(_this);

    if (!(typeof _this.onChange === 'function')) {
      throw new TypeError('Value of "this.onChange" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChange));
    }

    _this.onBlur = _this.onBlur.bind(_this);

    if (!(typeof _this.onBlur === 'function')) {
      throw new TypeError('Value of "this.onBlur" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.onBlur));
    }

    _this.onFocus = _this.onFocus.bind(_this);

    if (!(typeof _this.onFocus === 'function')) {
      throw new TypeError('Value of "this.onFocus" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onFocus));
    }

    _this.state = {
      inputValue: value,
      value: value,
      focused: props.autoFocus
    };
    return _this;
  }

  InputNumber.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        inputValue: nextProps.value,
        value: nextProps.value
      });
    }
  };

  InputNumber.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stop();
  };

  InputNumber.prototype.onKeyDown = function onKeyDown(e) {
    var onKeyDown = this.props.onKeyDown;

    if (e.keyCode === _common.KeyCode.ARROW_UP) {
      this.up(e);
      this.stop();
    } else if (e.keyCode === _common.KeyCode.ARROW_DOWN) {
      this.down(e);
      this.stop();
    }
    if (onKeyDown) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      onKeyDown.apply(undefined, [e].concat(args));
    }
  };

  InputNumber.prototype.onChange = function onChange(e) {
    var input = (0, _util.parser)(this.getValueFromEvent(e).trim());
    this.setState({ inputValue: input });
    this.props.onChange(this.toNumberWhenUserInput(input)); // valid number or invalid string
  };

  InputNumber.prototype.toNumberWhenUserInput = function toNumberWhenUserInput(num) {
    if ((/\.\d*0$/.test(num) || num.length > 16) && this.state.focused) {
      return num;
    }
    return (0, _util.toNumber)(num);
  };

  InputNumber.prototype.onFocus = function onFocus() {
    var _props;

    this.setState({
      focused: true
    });
    (_props = this.props).onFocus.apply(_props, arguments);
  };

  InputNumber.prototype.onBlur = function onBlur(e) {
    var _this2 = this;

    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    this.setState({
      focused: false
    });
    var value = this.getCurrentValidValue(this.state.inputValue);
    e.persist();
    this.setValue(value, function () {
      var _props2;

      (_props2 = _this2.props).onBlur.apply(_props2, [e].concat(args));
    });
  };

  InputNumber.prototype.getValueFromEvent = function getValueFromEvent(e) {
    return e.target.value;
  };

  InputNumber.prototype.getCurrentValidValue = function getCurrentValidValue(value) {
    var val = value;
    var props = this.props;
    if (val === '') {
      val = '';
    } else if (!(0, _util.isNotCompleteNumber)(val)) {
      val = Number(val);
      if (val < props.min) {
        val = props.min;
      }
      if (val > props.max) {
        val = props.max;
      }
    } else {
      val = this.state.value;
    }
    return (0, _util.toNumber)(val);
  };

  InputNumber.prototype.step = function step(type, e) {
    var ratio = 1;
    if (e) {
      e.preventDefault();
    }
    var _props3 = this.props,
        disabled = _props3.disabled,
        max = _props3.max,
        min = _props3.min;

    if (disabled) {
      return;
    }
    var value = this.getCurrentValidValue(this.state.inputValue) || 0;
    if ((0, _util.isNotCompleteNumber)(value)) {
      return;
    }
    var val = this[type + 'Step'](value, ratio);
    if (val > max) {
      val = max;
    } else if (val < min) {
      val = min;
    }
    this.setValue(val);
    this.setState({
      focused: true
    });
  };

  InputNumber.prototype.stop = function stop() {
    if (this.autoStepTimer) {
      clearTimeout(this.autoStepTimer);
    }
  };

  InputNumber.prototype.down = function down(e) {
    var _this3 = this;

    if (e.persist) {
      e.persist();
    }
    this.stop();
    this.step('down', e);
    this.autoStepTimer = setTimeout(function () {
      _this3.down(e, true);
    }, SPEED);
  };

  InputNumber.prototype.up = function up(e) {
    var _this4 = this;

    if (e.persist) {
      e.persist();
    }
    this.stop();
    this.step('up', e);
    this.autoStepTimer = setTimeout(function () {
      _this4.up(e, true);
    }, SPEED);
  };

  InputNumber.prototype.onKeyUp = function onKeyUp(e) {
    this.stop();
    var onKeyUp = this.props.onKeyUp;

    if (onKeyUp) {
      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      onKeyUp.apply(undefined, [e].concat(args));
    }
  };

  InputNumber.prototype.setValue = function setValue(v, callback) {
    var newValue = (0, _util.isNotCompleteNumber)(parseFloat(v, 10)) ? undefined : parseFloat(v, 10);
    var changed = newValue !== this.state.value;
    if (!('value' in this.props)) {
      this.setState({
        value: newValue,
        inputValue: this.toPrecisionAsStep(v)
      }, callback);
    } else {
      this.setState({
        inputValue: this.toPrecisionAsStep(this.state.value)
      }, callback);
    }
    if (changed) {
      this.props.onChange(newValue);
    }
  };

  InputNumber.prototype.upStep = function upStep(val, rat) {
    var _props4 = this.props,
        step = _props4.step,
        min = _props4.min;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = void 0;
    if (typeof val === 'number') {
      result = ((precisionFactor * val + precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    } else {
      result = min === -Infinity ? step : min;
    }
    return (0, _util.toNumber)(result);
  };

  InputNumber.prototype.downStep = function downStep(val, rat) {
    var _props5 = this.props,
        step = _props5.step,
        min = _props5.min;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = void 0;
    if (typeof val === 'number') {
      result = ((precisionFactor * val - precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    } else {
      result = min === -Infinity ? -step : min;
    }
    return (0, _util.toNumber)(result);
  };

  InputNumber.prototype.toPrecisionAsStep = function toPrecisionAsStep(num) {
    if ((0, _util.isNotCompleteNumber)(num) || num === '') {
      return num;
    }
    var precision = Math.abs(this.getMaxPrecision(num));
    if (!isNaN(precision)) {
      return Number(num).toFixed(precision);
    }
    return num.toString();
  };

  InputNumber.prototype.getPrecision = function getPrecision(value) {
    if ('precision' in this.props) {
      return this.props.precision;
    }
    var valueString = String(value).toString();
    if (valueString.indexOf('e-') >= 0) {
      return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
    }
    var precision = 0;
    if (valueString.indexOf('.') >= 0) {
      precision = valueString.length - valueString.indexOf('.') - 1;
    }
    return precision;
  };

  InputNumber.prototype.getMaxPrecision = function getMaxPrecision(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    if ('precision' in this.props) {
      return this.props.precision;
    }
    var step = this.props.step;

    var ratioPrecision = this.getPrecision(ratio);
    var stepPrecision = this.getPrecision(step);
    var currentValuePrecision = this.getPrecision(currentValue);
    if (!currentValue) {
      return ratioPrecision + stepPrecision;
    }
    return Math.max(currentValuePrecision, ratioPrecision + stepPrecision);
  };

  InputNumber.prototype.getPrecisionFactor = function getPrecisionFactor(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var precision = this.getMaxPrecision(currentValue, ratio);
    return Math.pow(10, precision);
  };

  InputNumber.prototype.getInputAttr = function getInputAttr() {
    var _cname;

    var props = this.props;
    var placeholder = props.placeholder,
        onClick = props.onClick,
        tabIndex = props.tabIndex,
        autoFocus = props.autoFocus,
        maxLength = props.maxLength,
        readOnly = props.readOnly,
        max = props.max,
        min = props.min,
        step = props.step,
        id = props.id,
        name = props.name;

    var disabled = this.disabled();

    var editable = !readOnly && !disabled;
    var inputDisplayValue = void 0;
    if (this.state.focused) {
      inputDisplayValue = this.state.inputValue;
    } else {
      inputDisplayValue = this.toPrecisionAsStep(this.state.value);
    }

    if (inputDisplayValue === undefined || inputDisplayValue === null) {
      inputDisplayValue = '';
    }
    var inputDisplayValueFormat = (0, _util.parser)(inputDisplayValue);
    var className = (0, _common.cname)((_cname = {}, _cname[prefixCls + '-input'] = true, _cname[prefixCls + '-input-disable'] = disabled, _cname));

    return {
      ref: 'input',
      placeholder: placeholder,
      onClick: onClick,
      className: className,
      tabIndex: tabIndex,
      autoComplete: 'off',
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      autoFocus: autoFocus,
      maxLength: maxLength,
      readOnly: readOnly,
      disabled: disabled,
      max: max,
      min: min,
      step: step,
      id: id,
      name: name,
      onKeyDown: editable ? this.onKeyDown : _util.noop,
      onKeyUp: editable ? this.onKeyUp : _util.noop,
      onChange: this.onChange,
      value: inputDisplayValueFormat
    };
  };

  InputNumber.prototype.getHandlerEvent = function getHandlerEvent() {
    var props = this.props;
    var readOnly = props.readOnly,
        max = props.max,
        min = props.min;

    var disabled = this.disabled();
    var editable = !readOnly && !disabled;
    var upDisabledClass = disabled ? prefixCls + '-handler-up-disabled' : '';
    var downDisabledClass = disabled ? prefixCls + '-handler-down-disabled' : '';
    var value = this.state.value;

    if (value) {
      if (!isNaN(value)) {
        var val = Number(value);
        if (val >= max) {
          upDisabledClass = prefixCls + '-handler-up-disabled';
        }
        if (val <= min) {
          downDisabledClass = prefixCls + '-handler-down-disabled';
        }
      } else {
        upDisabledClass = prefixCls + '-handler-up-disabled';
        downDisabledClass = prefixCls + '-handler-down-disabled';
      }
    }

    var upEvents = {
      onMouseDown: editable && !upDisabledClass ? this.up : _util.noop,
      onMouseUp: this.stop,
      onMouseLeave: this.stop
    };
    var downEvents = {
      onMouseDown: editable && !downDisabledClass ? this.down : _util.noop,
      onMouseUp: this.stop,
      onMouseLeave: this.stop
    };
    return { upEvents: upEvents, downEvents: downEvents, downDisabledClass: downDisabledClass, upDisabledClass: upDisabledClass };
  };

  InputNumber.prototype.disabled = function disabled() {
    var _props6 = this.props,
        max = _props6.max,
        min = _props6.min,
        disabled = _props6.disabled;

    return disabled || max === min;
  };

  InputNumber.prototype.render = function render() {
    var _cname2, _cname3;

    var props = this.props;
    var inputAttr = this.getInputAttr();

    var _getHandlerEvent = this.getHandlerEvent(),
        upEvents = _getHandlerEvent.upEvents,
        downEvents = _getHandlerEvent.downEvents,
        downDisabledClass = _getHandlerEvent.downDisabledClass,
        upDisabledClass = _getHandlerEvent.upDisabledClass;

    var wrapCls = (0, _common.cname)((_cname2 = {}, _cname2['' + prefixCls] = true, _cname2['input-number'] = true, _cname2[prefixCls + '-hide'] = !props.visible, _cname2[prefixCls + '-disable'] = this.disabled(), _cname2), props.className);
    var handerAttr = {
      title: '',
      role: 'button',
      href: 'javascript:void(0);'
    };
    var divProps = (0, _assign2.default)({}, this.props);
    delete divProps.unit;
    delete divProps.step;

    var unitClassName = (0, _common.cname)((_cname3 = {}, _cname3[prefixCls + '-unit'] = true, _cname3[prefixCls + '-unit-disable'] = this.disabled(), _cname3));
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, divProps, { className: wrapCls }),
      _react2.default.createElement(
        'a',
        (0, _extends3.default)({}, handerAttr, {
          className: (0, _common.cname)(prefixCls + '-handle ' + prefixCls + '-reduce ' + downDisabledClass)
        }, downEvents),
        _react2.default.createElement(_Icon2.default, { type: 'reduce', className: (0, _common.cname)(prefixCls + '-reduce-icon') })
      ),
      _react2.default.createElement('input', inputAttr),
      _react2.default.createElement(
        'span',
        { className: unitClassName },
        props.unit
      ),
      _react2.default.createElement(
        'a',
        (0, _extends3.default)({}, handerAttr, {
          className: (0, _common.cname)(prefixCls + '-handle ' + prefixCls + '-increase ' + upDisabledClass)
        }, upEvents),
        _react2.default.createElement(_Icon2.default, { type: 'add', className: (0, _common.cname)(prefixCls + '-icon') })
      )
    );
  };

  return InputNumber;
}(_common.ComBase), _class.propTypes = {
  min: _propTypes2.default.number,
  max: _propTypes2.default.number,
  value: _propTypes2.default.number,
  defaultValue: _propTypes2.default.number,
  step: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onChange: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['large', 'small', 'default']),
  placeholder: _propTypes2.default.string,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  unit: _propTypes2.default.string
}, _class.defaultProps = {
  step: 1,
  min: 1,
  defaultValue: 1,
  onBlur: _util.noop,
  onChange: _util.noop,
  onFocus: _util.noop,
  disabled: false,
  unit: '个'
}, _temp);
exports.default = InputNumber;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

exports.__esModule = true;
function isNotCompleteNumber(num) {
  return isNaN(num) || num === '' || num === null || num && num.toString().indexOf('.') === num.toString().length - 1;
}
function noop() {}
function parser(input) {
  return String(input).replace(/[^\w\.-]+/g, '');
}
exports.default = {
  noop: noop,
  parser: parser,
  isNotCompleteNumber: isNotCompleteNumber,
  toNumber: function toNumber(num, precision) {
    if (isNotCompleteNumber(num)) {
      return num;
    }
    if (precision) {
      return Number(Number(num).toFixed(this.props.precision));
    }
    return Number(num);
  }
};
module.exports = exports['default'];

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

__webpack_require__(206);

var _layout = __webpack_require__(207);

var _layout2 = _interopRequireDefault(_layout);

var _sider = __webpack_require__(208);

var _sider2 = _interopRequireDefault(_sider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_layout2.default.Sider = _sider2.default;
exports.default = _layout2.default;
module.exports = exports['default'];

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Basic = function (_Component) {
  (0, _inherits3.default)(Basic, _Component);

  function Basic() {
    (0, _classCallCheck3.default)(this, Basic);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  Basic.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        others = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);

    var hasSider = void 0;
    _react2.default.Children.forEach(children, function (element) {
      if (element && element.type && element.type.__APS_LAYOUT_SIDER) {
        hasSider = true;
      }
    });
    var divCls = hasSider ? (0, _common.cname)({
      layoutHasSider: hasSider
    }, className) : className;
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({ className: divCls }, others),
      children
    );
  };

  return Basic;
}(_react.Component);

function generator(props) {
  return function (BasicComponent) {
    return function (_Component2) {
      (0, _inherits3.default)(Adapter, _Component2);

      function Adapter() {
        (0, _classCallCheck3.default)(this, Adapter);
        return (0, _possibleConstructorReturn3.default)(this, _Component2.apply(this, arguments));
      }

      Adapter.prototype.render = function render() {
        var prefixCls = props.prefixCls;
        var _props2 = this.props,
            className = _props2.className,
            other = (0, _objectWithoutProperties3.default)(_props2, ['className']);

        var cls = className ? (0, _common.cname)(prefixCls, className) : (0, _common.cname)(prefixCls);
        return _react2.default.createElement(BasicComponent, (0, _extends3.default)({ className: cls }, other));
      };

      return Adapter;
    }(_react.Component);
  };
}

var Layout = generator({
  prefixCls: 'layout'
})(Basic);
var Header = generator({
  prefixCls: 'layout-header'
})(Basic);
var Content = generator({
  prefixCls: 'layout-content'
})(Basic);
var Footer = generator({
  prefixCls: 'layout-footer'
})(Basic);

Layout.Header = Header;
Layout.Content = Content;
Layout.Footer = Footer;

exports.default = Layout;
module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = __webpack_require__(209);

var _omit2 = _interopRequireDefault(_omit);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 和Grid组件保持一致
var dimensionMap = {
  xs: '768px',
  sm: '992px',
  md: '1200px',
  lg: '1600px'
};

// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
if (typeof window !== 'undefined') {
  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
    return {
      media: mediaQuery,
      matches: false,
      addListener: function addListener() {},
      removeListener: function removeListener() {}
    };
  };
  window.matchMedia = window.matchMedia || matchMediaPolyfill;
}

var Sider = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Sider, _Component);

  function Sider(props) {
    (0, _classCallCheck3.default)(this, Sider);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var matchMedia = void 0;
    if (typeof window !== 'undefined') {
      matchMedia = window.matchMedia;
    }
    if (matchMedia && props.breakpoint && props.breakpoint in dimensionMap) {
      _this.mql = matchMedia('(max-width: ' + dimensionMap[props.breakpoint] + ')');
    }
    var collapsed = void 0;
    if ('collapsed' in props) {
      collapsed = props.collapsed;
    } else {
      collapsed = props.defaultCollapsed;
    }
    _this.state = {
      collapsed: collapsed,
      below: false
    };
    return _this;
  }

  Sider.prototype.getChildContext = function getChildContext() {
    return {
      siderCollapsed: this.state.collapsed
    };
  };

  Sider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('collapsed' in nextProps) {
      this.setState({
        collapsed: nextProps.collapsed
      });
    }
  };

  Sider.prototype.componentDidMount = function componentDidMount() {
    if (this.mql) {
      this.mql.addListener(this.responsiveHandler);
      this.responsiveHandler(this.mql);
    }
  };

  Sider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.mql) {
      this.mql.removeListener(this.responsiveHandler);
    }
  };

  Sider.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        style = _props.style,
        width = _props.width,
        collapsedWidth = _props.collapsedWidth,
        others = (0, _objectWithoutProperties3.default)(_props, ['className', 'style', 'width', 'collapsedWidth']);

    var divProps = (0, _omit2.default)(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint']);
    var siderWidth = this.state.collapsed ? collapsedWidth : width;
    var divStyle = (0, _extends3.default)({}, style, {
      flex: '0 0 ' + siderWidth + 'px',
      maxWidth: siderWidth + 'px', // Fix width transition bug in IE11
      minWidth: siderWidth + 'px', // https://github.com/ant-design/ant-design/issues/6349
      width: siderWidth + 'px'
    });
    var prefixCls = 'layout-sider';
    var siderCls = (0, _common.cname)({
      layoutSider: true,
      layoutSiderCollapsed: !!this.state.collapsed,
      layoutSiderBelow: !!this.state.below,
      layoutSiderZeroWidth: siderWidth === 0 || siderWidth === '0'
    }, className);
    var childrenCls = (0, _common.cname)(prefixCls + '-children');
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({ className: siderCls }, divProps, { style: divStyle }),
      _react2.default.createElement(
        'div',
        { className: childrenCls },
        this.props.children
      )
    );
  };

  return Sider;
}(_react.Component), _class.__APS_LAYOUT_SIDER = true, _class.childContextTypes = {
  siderCollapsed: _propTypes2.default.bool
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.responsiveHandler = function (mql) {
    _this2.setState({ below: mql.matches });
    if (_this2.state.collapsed !== mql.matches) {
      _this2.setCollapsed(mql.matches, 'responsive');
    }
  };

  this.setCollapsed = function (collapsed, type) {
    if (!('collapsed' in _this2.props)) {
      _this2.setState({
        collapsed: collapsed
      });
    }
    var onCollapse = _this2.props.onCollapse;

    if (onCollapse) {
      onCollapse(collapsed, type);
    }
  };

  this.belowShowChange = function () {
    _this2.setState({ belowShow: !_this2.state.belowShow });
  };
}, _temp);


Sider.defaultProps = {
  defaultCollapsed: false,
  width: 200,
  collapsedWidth: 64,
  style: {}
};

Sider.propTypes = {
  className: _propTypes2.default.string,
  collapsed: _propTypes2.default.bool,
  defaultCollapsed: _propTypes2.default.bool,
  onCollapse: _propTypes2.default.func,
  width: _propTypes2.default.number,
  collapsedWidth: _propTypes2.default.number,
  breakpoint: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg'])
};

exports.default = Sider;
module.exports = exports['default'];

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function omit(obj, fields) {
  var shallowCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }
  return shallowCopy;
}

/* harmony default export */ __webpack_exports__["default"] = (omit);

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _regenerator = __webpack_require__(28);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _create = __webpack_require__(34);

var _create2 = _interopRequireDefault(_create);

var _asyncToGenerator2 = __webpack_require__(29);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _Popover2 = __webpack_require__(19);

var _Popover3 = _interopRequireDefault(_Popover2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

var _i18n = __webpack_require__(211);

var _i18n2 = _interopRequireDefault(_i18n);

__webpack_require__(212);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_DELAY = 25;
var DISTORY_DELAY = 500;

var Loading = function (_ComBase) {
  (0, _inherits3.default)(Loading, _ComBase);

  function Loading() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Loading);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { defaultVisiable: false }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Loading.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$content = _props.content,
        content = _props$content === undefined ? _i18n2.default.current.loading : _props$content,
        icon = _props.icon,
        className = _props.className,
        _props$dock = _props.dock,
        dock = _props$dock === undefined ? 'center' : _props$dock,
        _props$overlay = _props.overlay,
        overlay = _props$overlay === undefined ? true : _props$overlay,
        inside = _props.inside,
        _props$visible = _props.visible,
        visible = _props$visible === undefined ? this.state.defaultVisiable : _props$visible;

    icon = icon || Loading.icon;
    return _react2.default.createElement(
      _Popover3.default,
      (0, _extends3.default)({}, this.props, {
        className: (0, _common.cname)('loading', className),
        dock: dock,
        overlay: overlay,
        inside: inside,
        visible: visible }),
      icon,
      ' ',
      children || content
    );
  };

  Loading.prototype.show = function show() {
    var onShow = this.props.onShow;

    this.setState({ defaultVisiable: true });
    if (onShow) onShow(new _common.EventArgs(this));
  };

  Loading.prototype.close = function close() {
    var onClose = this.props.onClose;

    this.setState({ defaultVisiable: false });
    if (onClose) onClose(new _common.EventArgs(this));
  };

  return Loading;
}(_common.ComBase);

Loading.icon = _react2.default.createElement(_Icon3.default, { type: 'loading', spin: true });

Loading.show = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(content, opts) {
    var _this2 = this;

    var loadingInstance, closeAndDistory, initailOnClose;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            opts = opts || (0, _create2.default)(null);
            opts.content = content;
            loadingInstance = void 0;
            //关闭并且销毁

            closeAndDistory = function () {
              var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return (0, _common.sleep)(DISTORY_DELAY);

                      case 2:
                        (0, _common.unmount)(loadingInstance);

                      case 3:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this2);
              }));

              return function closeAndDistory() {
                return _ref2.apply(this, arguments);
              };
            }();

            initailOnClose = opts.onClose;

            opts.onClose = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
              return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (initailOnClose) initailOnClose();
                      closeAndDistory();

                    case 2:
                    case 'end':
                      return _context2.stop();
                  }
                }
              }, _callee2, _this2);
            }));
            _context3.next = 8;
            return (0, _common.render)(_react2.default.createElement(Loading, opts));

          case 8:
            loadingInstance = _context3.sent;
            _context3.next = 11;
            return (0, _common.sleep)(SHOW_DELAY);

          case 11:
            loadingInstance.show();
            return _context3.abrupt('return', loadingInstance);

          case 13:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = Loading;
module.exports = exports['default'];

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

exports.default = new _common.Locale({
  zh: {
    loading: '正在载入...'
  },
  en: {
    loading: 'Loading...'
  }
});
module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _menu = __webpack_require__(100);

var _menu2 = _interopRequireDefault(_menu);

var _item = __webpack_require__(214);

var _item2 = _interopRequireDefault(_item);

var _submenu = __webpack_require__(215);

var _submenu2 = _interopRequireDefault(_submenu);

__webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_menu2.default.Item = _item2.default;
_menu2.default.SubMenu = _submenu2.default;

exports.default = _menu2.default;
module.exports = exports['default'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _CheckBox2 = __webpack_require__(62);

var _CheckBox3 = _interopRequireDefault(_CheckBox2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Item, _ComBase);

  function Item() {
    (0, _classCallCheck3.default)(this, Item);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Item.prototype.onClick = function onClick(e) {
    var _props = this.props,
        itemKey = _props.itemKey,
        onClick = _props.onClick,
        selectMode = _props.selectMode,
        selected = _props.selected,
        onSelect = _props.onSelect,
        onDeselect = _props.onDeselect;

    onClick(new _common.EventArgs(this, itemKey, e));
    if (selectMode === 'multiple') {
      if (selected) {
        return onDeselect(new _common.EventArgs(this, { key: itemKey }, e));
      }
      return onSelect(new _common.EventArgs(this, { key: itemKey }, e));
    }
    onSelect(new _common.EventArgs(this, { key: itemKey }, e));
  };

  Item.prototype.render = function render() {
    var _props2 = this.props,
        selectMode = _props2.selectMode,
        disabled = _props2.disabled,
        selected = _props2.selected,
        className = _props2.className,
        children = _props2.children,
        other = (0, _objectWithoutProperties3.default)(_props2, ['selectMode', 'disabled', 'selected', 'className', 'children']);

    var multiple = selectMode === 'multiple';
    var cls = (0, _common.cname)({
      menuItem: true,
      multiple: multiple,
      stateDisabled: disabled,
      stateActive: selected
    }, className);
    var events = disabled ? { onClick: function onClick() {} } : { onClick: this.onClick.bind(this) };
    return _react2.default.createElement(
      'li',
      (0, _extends3.default)({}, (0, _common.transportProps)(other), { className: cls }, events),
      multiple ? _react2.default.createElement(_CheckBox3.default, { className: (0, _common.cname)('menu-item-checkbox'), checked: selected }) : null,
      children
    );
  };

  return Item;
}(_common.ComBase), _class.propTypes = {
  /**
   * 是否禁用
   */
  disabled: _propTypes2.default.bool
}, _class.defaultProps = {
  disabled: false,
  selected: false
}, _temp);
exports.default = Item;
module.exports = exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _Popover2 = __webpack_require__(19);

var _Popover3 = _interopRequireDefault(_Popover2);

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _menu = __webpack_require__(100);

var _menu2 = _interopRequireDefault(_menu);

var _components = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubMenu = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(SubMenu, _ComBase);

  function SubMenu() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SubMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {
      mouseInTitle: false,
      mouseInPopover: false,
      isSubOpen: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  SubMenu.prototype.onTitleClick = function onTitleClick(e) {
    var _props = this.props,
        itemKey = _props.itemKey,
        onTitleClick = _props.onTitleClick;

    onTitleClick(new _common.EventArgs(this, itemKey, e));
    this.setState(function (prev) {
      return { isSubOpen: !prev.isSubOpen };
    });
  };

  SubMenu.prototype.onMouseEnter = function onMouseEnter() {
    this.setState({ mouseInTitle: true });
  };

  SubMenu.prototype.onMouseLeave = function onMouseLeave() {
    this.setState({ mouseInTitle: false });
  };

  SubMenu.prototype.onMouseEnterPopover = function onMouseEnterPopover() {
    this.setState({ mouseInPopover: true });
  };

  SubMenu.prototype.onMouseLeavePopover = function onMouseLeavePopover() {
    this.setState({ mouseInPopover: false });
  };

  SubMenu.prototype.renderIcon = function renderIcon(mode) {
    var isSubOpen = this.state.isSubOpen;

    var inlineType = 'arrow-' + (isSubOpen ? 'up' : 'down');
    switch (mode) {
      case 'vertical':
        return _react2.default.createElement(_Icon3.default, { type: 'arrow-right', className: (0, _common.cname)('submenu-arrow') });
      case 'inline':
        return _react2.default.createElement(_Icon3.default, { type: inlineType, className: (0, _common.cname)('submenu-arrow') });
    }
  };

  SubMenu.prototype.renderChildren = function renderChildren(children) {
    var _props2 = this.props,
        mode = _props2.mode,
        selectMode = _props2.selectMode,
        selectedKeys = _props2.selectedKeys,
        onClick = _props2.onClick,
        onSelect = _props2.onSelect,
        onDeselect = _props2.onDeselect;
    var _state = this.state,
        mouseInPopover = _state.mouseInPopover,
        mouseInTitle = _state.mouseInTitle,
        isSubOpen = _state.isSubOpen;

    var open = mouseInPopover || mouseInTitle;
    var direction = {
      'vertical': 'right',
      'horizontal': 'bottom'
    };
    var align = {
      'vertical': 'top',
      'horizontal': 'center'
    };
    if (mode == 'inline') {
      var subcls = (0, _common.cname)({
        aniTransition: true,
        'menu-sub': true,
        'sub-open': isSubOpen,
        'sub-hidden': !isSubOpen
      });
      return _react2.default.createElement(
        _menu2.default,
        {
          mode: mode,
          selectMode: selectMode,
          selectedKeys: selectedKeys,
          onClick: onClick,
          onSelect: onSelect,
          onDeselect: onDeselect,
          className: subcls
        },
        children
      );
    }
    return _react2.default.createElement(
      _Popover3.default,
      { overlay: false,
        visible: open,
        follow: this.li,
        direction: direction[mode],
        align: align[mode],
        className: (0, _common.cname)('submenu-popover'),
        onMouseEnter: this.onMouseEnterPopover.bind(this),
        onMouseLeave: this.onMouseLeavePopover.bind(this)
      },
      _react2.default.createElement(
        _menu2.default,
        {
          selectMode: selectMode,
          selectedKeys: selectedKeys,
          onClick: onClick,
          onSelect: onSelect,
          onDeselect: onDeselect
        },
        children
      )
    );
  };

  SubMenu.prototype.render = function render() {
    var _cname,
        _this2 = this;

    var _props3 = this.props,
        mode = _props3.mode,
        title = _props3.title,
        disabled = _props3.disabled,
        style = _props3.style,
        className = _props3.className,
        children = _props3.children;
    var _state2 = this.state,
        mouseInPopover = _state2.mouseInPopover,
        mouseInTitle = _state2.mouseInTitle;

    var open = mouseInPopover || mouseInTitle;
    var cls = (0, _common.cname)((_cname = {
      submenu: true
    }, _cname['submenu-' + mode] = !!mode, _cname.stateDisabled = disabled, _cname.open = open, _cname), className);
    var titleCls = (0, _common.cname)({
      submenuTitle: true,
      stateDisabled: disabled
    });
    var titleEvents = disabled ? {} : {
      onClick: this.onTitleClick.bind(this),
      onMouseEnter: this.onMouseEnter.bind(this),
      onMouseLeave: this.onMouseLeave.bind(this)
    };
    return _react2.default.createElement(
      'li',
      { className: cls, ref: function ref(li) {
          _this2.li = li;
        } },
      _react2.default.createElement(
        'div',
        (0, _extends3.default)({ style: style, className: titleCls }, titleEvents),
        title,
        this.renderIcon(mode)
      ),
      this.renderChildren(children)
    );
  };

  return SubMenu;
}(_common.ComBase), _class.propTypes = {
  /**
   * 子菜单标题
   */
  title: _propTypes2.default.string,
  /**
   * 是否禁用
   */
  disabled: _propTypes2.default.bool,
  /**
   * 点击子菜单标题的回调
   */
  onTitleClick: _propTypes2.default.func
}, _class.defaultProps = {
  disabled: false,
  onTitleClick: function onTitleClick() {}
}, _temp2);
exports.default = SubMenu;
module.exports = exports['default'];

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps; //公共样式

// import Options from "./Options";


__webpack_require__(58);

__webpack_require__(218);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18n = __webpack_require__(219);

var _i18n2 = _interopRequireDefault(_i18n);

var _Pager = __webpack_require__(222);

var _Pager2 = _interopRequireDefault(_Pager);

var _input = __webpack_require__(223);

var _input2 = _interopRequireDefault(_input);

var _option = __webpack_require__(224);

var _option2 = _interopRequireDefault(_option);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixCls = 'pagination';
var wrapPrefixCls = 'pagination-full';

function noop() {}

function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function defaultItemRender(page, type) {
  return _react2.default.createElement(
    'a',
    null,
    type === 'page' ? page : ''
  );
}

var Pagination = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Pagination, _ComBase);

  function Pagination(props) {
    (0, _classCallCheck3.default)(this, Pagination);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _initialiseProps.call(_this);

    var current = props.defaultCurrent;

    if ('current' in props) {
      current = props.current;
    }

    var pageSize = props.defaultPageSize;
    if ('pageSize' in props) {
      pageSize = props.pageSize;
    }

    var totalPage = _this.calculatePage(pageSize);
    if (current > totalPage) {
      current = totalPage;
    }
    if (current < 1) {
      current = 1;
    }

    _this.state = {
      current: current,
      currentInputValue: current,
      pageSize: pageSize
    };
    return _this;
  }

  Pagination.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('current' in nextProps) {
      var current = nextProps.current;
      this.setState({
        current: current,
        currentInputValue: current
      });
    }

    if ('pageSize' in nextProps) {
      var newState = {};
      var _current = this.state.current;
      var newCurrent = this.calculatePage(nextProps.pageSize);
      _current = _current > newCurrent ? newCurrent : _current;
      if (!('current' in nextProps)) {
        newState.current = _current;
        newState.currentInputValue = _current;
      }
      newState.pageSize = nextProps.pageSize;
      this.setState(newState);
    }
  };

  Pagination.prototype.getJumpPrevPage = function getJumpPrevPage() {
    return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
  };

  /**
   *
   * @returns {Number} 要跳转的下一页
   * @memberof Pager
   */


  Pagination.prototype.getJumpNextPage = function getJumpNextPage() {
    return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
  };

  //计算需要显示总页数

  // 上一页

  // 下一页

  //跳到第一页

  //跳到最后一页


  /* eslint-disable */
  Pagination.prototype.render = function render() {
    var _this2 = this,
        _cname;

    var props = this.props;
    var _props = this.props,
        showLessItems = _props.showLessItems,
        showTitle = _props.showTitle,
        itemRender = _props.itemRender,
        selectComponentClass = _props.selectComponentClass,
        pageSizeOptions = _props.pageSizeOptions;


    var locale = this.locale;

    wrapPrefixCls = 'pagination-full';

    if (props.simple) {
      wrapPrefixCls = 'pagination-simple';
    }

    var _state = this.state,
        current = _state.current,
        pageSize = _state.pageSize;

    var allPages = this.calculatePage();
    var pagerList = [];
    var jumpPrev = null;
    var jumpNext = null;
    var firstPager = null;
    var lastPager = null;
    var totalText = null;

    var pageBufferSize = showLessItems ? 1 : 2;

    var prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
    var nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
    //返回每个页码的属性
    var getPagerAttr = function getPagerAttr(i) {
      return {
        locale: locale,
        active: current === i,
        showTitle: showTitle,
        rootPrefixCls: (0, _common.cname)('' + prefixCls),
        onClick: function onClick() {
          return _this2.handleChange(i);
        },
        onKeyPress: function onKeyPress(e) {
          return _this2.runIfEnter(e, _this2.handleChange, i);
        },
        key: i,
        page: i,
        itemRender: itemRender
      };
    };
    //获取中间部分页面的左右索引
    var getOffset = function getOffset() {
      var left = Math.max(1, current - pageBufferSize); //当前页码左侧的索引
      var right = Math.min(current + pageBufferSize, allPages); //当前页码右侧的索引

      // 如果页码很小，调整right的参数，使得显示的页码数量不会太少
      if (current - 1 <= pageBufferSize) {
        right = 1 + pageBufferSize * 2;
      }

      if (allPages - current <= pageBufferSize) {
        left = allPages - pageBufferSize * 2;
      }

      return { left: left, right: right };
    };

    //页数比较少，把页码全部显示出来
    if (allPages <= 5 + pageBufferSize * 2) {
      for (var i = 1; i <= allPages; i++) {
        pagerList.push(_react2.default.createElement(_Pager2.default, getPagerAttr(i)));
      }
    } else {
      // 第一部分的省略号
      jumpPrev = _react2.default.createElement(
        'li',
        {
          title: props.showTitle ? prevItemTitle : null,
          key: 'prev',
          tabIndex: '0',
          onClick: this.jumpPrev,
          onKeyPress: function onKeyPress(e) {
            return _this2.runIfEnter(e, _this2.jumpPrev);
          },
          className: (0, _common.cname)(prefixCls + '-jump-prev')
        },
        props.itemRender(this.getJumpPrevPage(), 'jump-prev')
      );
      // 第二部分的省略号
      jumpNext = _react2.default.createElement(
        'li',
        {
          title: props.showTitle ? nextItemTitle : null,
          key: 'next',
          tabIndex: '0',
          onClick: this.jumpNext,
          onKeyPress: function onKeyPress(e) {
            return _this2.runIfEnter(e, _this2.jumpNext);
          },
          className: (0, _common.cname)(prefixCls + '-jump-next')
        },
        props.itemRender(this.getJumpNextPage(), 'jump-next')
      );

      lastPager = _react2.default.createElement(_Pager2.default, getPagerAttr(allPages));
      firstPager = _react2.default.createElement(_Pager2.default, getPagerAttr(1));

      var _getOffset = getOffset(),
          left = _getOffset.left,
          right = _getOffset.right;

      for (var _i = left; _i <= right; _i++) {
        pagerList.push(_react2.default.createElement(_Pager2.default, getPagerAttr(_i)));
      }
      if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
        pagerList[0] = _react2.default.cloneElement(pagerList[0], {
          className: (0, _common.cname)(prefixCls + '-item-after-jump-prev')
        });
        pagerList.unshift(jumpPrev);
      }
      if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
        pagerList[pagerList.length - 1] = _react2.default.cloneElement(pagerList[pagerList.length - 1], {
          className: (0, _common.cname)(prefixCls + '-item-before-jump-next')
        });
        pagerList.push(jumpNext);
      }

      if (left !== 1) {
        if (left > 2) {
          firstPager = _react2.default.cloneElement(firstPager, {
            className: (0, _common.cname)(prefixCls + '-item-border')
          });
        }

        pagerList.unshift(firstPager);
      }
      if (right !== allPages) {
        pagerList.push(lastPager);
      }
    }
    //显示总数
    if (props.showTotal) {
      totalText = _react2.default.createElement(
        'li',
        { className: (0, _common.cname)(prefixCls + '-total-text') },
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)(prefixCls + '-total-items-text') },
          locale.totalItems(props.total, [(current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
        )
      );
    }
    //显示页码size
    if (pageSizeOptions) {
      var attr = {
        locale: locale,
        rootPrefixCls: prefixCls,
        changeSize: this.changePageSize,
        selectComponentClass: selectComponentClass,
        current: current,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions
      };
      totalText = _react2.default.createElement(
        'li',
        { className: (0, _common.cname)(prefixCls + '-total-text') },
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)(prefixCls + '-total-items-text') },
          locale.totalAndSize(props.total, [(current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
        ),
        _react2.default.createElement(_option2.default, attr)
      );
    }

    var prevDisabled = !this.hasPrev();
    var nextDisabled = !this.hasNext();
    var firstDisabled = this.isFirst();
    var lastDisabled = this.isLast();

    var prevPage = this.state.current - 1 > 0 ? this.state.current - 1 : 0;
    var nextPage = this.state.current + 1 < allPages ? this.state.current + 1 : allPages;

    // 跳到第一页
    var cls = (0, _common.cname)((!firstDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-jump-first');
    var jumpToFirst = _react2.default.createElement(
      'li',
      {
        title: props.showTitle ? nextItemTitle : null,
        key: 'first',
        tabIndex: '0',
        onClick: this.jumpToFirst,
        className: cls,
        'aria-disabled': firstDisabled
      },
      props.itemRender('', 'jump-first')
    );
    cls = (0, _common.cname)((!lastDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-jump-last');
    // 跳到最后一页
    var jumpToLast = _react2.default.createElement(
      'li',
      {
        title: props.showTitle ? nextItemTitle : null,
        key: 'last',
        tabIndex: '0',
        onClick: this.jumpToLast,
        className: cls,
        'aria-disabled': lastDisabled
      },
      props.itemRender('', 'jump-last')
    );
    cls = (0, _common.cname)((!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev');
    //上一页
    var jumpPrevButton = _react2.default.createElement(
      'li',
      {
        title: props.showTitle ? locale.prev_page : null,
        onClick: this.prev,
        tabIndex: '0',
        onKeyPress: function onKeyPress(e) {
          return _this2.runIfEnter(e, _this2.prev);
        },
        className: cls,
        'aria-disabled': prevDisabled
      },
      props.itemRender(prevPage, 'prev')
    );
    cls = (0, _common.cname)((!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next');
    // 下一页
    var jumpNextButton = _react2.default.createElement(
      'li',
      {
        title: props.showTitle ? locale.next_page : null,
        onClick: this.next,
        tabIndex: '0',
        onKeyPress: function onKeyPress(e) {
          return _this2.runIfEnter(e, _this2.next);
        },
        className: cls,
        'aria-disabled': nextDisabled
      },
      props.itemRender(nextPage, 'next')
    );

    var a = '' + prefixCls;
    var b = prefixCls + '-hide';
    var wrapCls = (0, _common.cname)((_cname = {}, _cname[a] = true, _cname['' + wrapPrefixCls] = true, _cname[b] = !props.visible, _cname), props.className);
    return _react2.default.createElement(
      'div',
      { className: wrapCls },
      _react2.default.createElement(
        'ul',
        {
          className: (0, _common.cname)(prefixCls + '-wrap'),
          style: props.style,
          unselectable: 'unselectable'
        },
        totalText,
        jumpPrevButton,
        pagerList,
        jumpNextButton
      ),
      _react2.default.createElement(_input2.default, {
        locale: locale,
        rootPrefixCls: prefixCls,
        current: this.state.current,
        quickGo: this.props.showQuickJumper ? this.handleChange : null
      })
    );
  };

  (0, _createClass3.default)(Pagination, [{
    key: 'locale',
    get: function get() {
      return this.props.locale || _i18n2.default.current || this.props.defaultLocale;
    }
  }]);
  return Pagination;
}(_common.ComBase), _class.propTypes = {
  simple: _propTypes2.default.bool,
  visible: _propTypes2.default.bool,
  current: _propTypes2.default.number,
  defaultCurrent: _propTypes2.default.number,
  total: _propTypes2.default.number,
  pageSize: _propTypes2.default.number,
  defaultPageSize: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  showLessItems: _propTypes2.default.bool,
  onPageSizeChange: _propTypes2.default.func,
  selectComponentClass: _propTypes2.default.func,
  showQuickJumper: _propTypes2.default.bool,
  showTitle: _propTypes2.default.bool,
  pageSizeOptions: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showTotal: _propTypes2.default.bool,
  locale: _propTypes2.default.object,
  style: _propTypes2.default.object,
  itemRender: _propTypes2.default.func
}, _class.defaultProps = {
  visible: true,
  defaultCurrent: 1,
  total: 0,
  defaultPageSize: 10,
  onChange: noop,
  className: '',
  selectComponentClass: null,
  showQuickJumper: false,
  showLessItems: false,
  showTitle: true,
  onPageSizeChange: noop,
  defaultLocale: _i18n2.default.current,
  style: {},
  simple: false,
  itemRender: defaultItemRender
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.calculatePage = function (p) {
    var pageSize = p;
    if (typeof pageSize === 'undefined') {
      pageSize = _this3.state.pageSize;
    }
    return Math.floor((_this3.props.total - 1) / pageSize) + 1;
  };

  this.isValid = function (page) {
    return isInteger(page) && page >= 1 && page !== _this3.state.current;
  };

  this.changePageSize = function (size) {
    var current = _this3.state.current;
    var newCurrent = _this3.calculatePage(size);
    current = current > newCurrent ? newCurrent : current;
    if (typeof size === 'number') {
      if (!('pageSize' in _this3.props)) {
        _this3.setState({
          pageSize: size
        });
      }
      if (!('current' in _this3.props)) {
        _this3.setState({
          current: current,
          currentInputValue: current
        });
      }
    }
    _this3.props.onPageSizeChange(current, size);
  };

  this.handleChange = function (p) {
    var page = p;
    if (_this3.isValid(page)) {
      if (page > _this3.calculatePage()) {
        page = _this3.calculatePage();
      }
      if (!('current' in _this3.props)) {
        _this3.setState({
          current: page,
          currentInputValue: page
        });
      }

      var pageSize = _this3.state.pageSize;
      _this3.props.onChange(page, pageSize);

      return page;
    }

    return _this3.state.current;
  };

  this.prev = function () {
    if (_this3.hasPrev()) {
      _this3.handleChange(_this3.state.current - 1);
    }
  };

  this.next = function () {
    if (_this3.hasNext()) {
      _this3.handleChange(_this3.state.current + 1);
    }
  };

  this.jumpPrev = function () {
    _this3.handleChange(_this3.getJumpPrevPage());
  };

  this.jumpNext = function () {
    _this3.handleChange(_this3.getJumpNextPage());
  };

  this.jumpToFirst = function () {
    _this3.handleChange(1);
  };

  this.jumpToLast = function () {
    _this3.handleChange(_this3.calculatePage());
  };

  this.isFirst = function () {
    return _this3.state.current === 1;
  };

  this.isLast = function () {
    return _this3.state.current === _this3.calculatePage();
  };

  this.hasPrev = function () {
    return _this3.state.current > 1;
  };

  this.hasNext = function () {
    return _this3.state.current < _this3.calculatePage();
  };

  this.runIfEnter = function (event, callback) {
    for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      restParams[_key - 2] = arguments[_key];
    }

    if (event.key === 'Enter' || event.charCode === 13) {
      return callback.apply(undefined, restParams);
    }
  };
}, _temp);
exports.default = Pagination;
module.exports = exports['default'];

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

var _en_US = __webpack_require__(220);

var _en_US2 = _interopRequireDefault(_en_US);

var _zh_CN = __webpack_require__(221);

var _zh_CN2 = _interopRequireDefault(_zh_CN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _common.Locale({ en: _en_US2.default, zh: _zh_CN2.default });
module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports) {

exports.__esModule = true;
exports.default = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Goto',
  page: '',
  go: 'Go',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages',
  totalItems: function totalItems(total) {
    return 'Total ' + total + ' items';
  },
  totalAndSize: function totalAndSize(total) {
    return 'Total ' + total + ' items\uFF0Cper page\uFF1A';
  }
};
module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports) {

exports.__esModule = true;
exports.default = {
  // Options.jsx
  items_per_page: '条/页',
  jump_to: '跳转至：',
  page: '页',
  go: '跳转',

  // Pagination.jsx
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前 5 页',
  next_5: '向后 5 页',
  prev_3: '向前 3 页',
  next_3: '向后 3 页',
  totalItems: function totalItems(total) {
    return '\u5171\u6709 ' + total + ' \u6761';
  },
  totalAndSize: function totalAndSize(total) {
    return '\u5171\u6709 ' + total + ' \u6761\uFF0C\u6BCF\u9875\u663E\u793A\uFF1A';
  }
};
module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pager = function Pager(props) {
  var prefixCls = props.rootPrefixCls + '-item';
  var cls = prefixCls + ' ' + prefixCls + '-' + props.page;

  if (props.active) {
    cls = (0, _common.cname)(cls + ' ' + prefixCls + '-active');
  }

  if (props.className) {
    cls = (0, _common.cname)(cls + ' ' + props.className);
  }

  return _react2.default.createElement(
    'li',
    {
      title: props.showTitle ? props.page : null,
      className: cls,
      onClick: props.onClick,
      onKeyPress: props.onKeyPress,
      tabIndex: '0'
    },
    props.itemRender(props.page, 'page')
  );
};

Pager.propTypes = {
  page: _propTypes2.default.number,
  active: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  showTitle: _propTypes2.default.bool,
  rootPrefixCls: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func,
  itemRender: _propTypes2.default.func
};

exports.default = Pager;
module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Input, _React$Component);

  function Input(props) {
    (0, _classCallCheck3.default)(this, Input);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

    _this.handleChange = function (e) {
      _this.setState({
        goInputText: e.target.value
      });
    };

    _this.change = function (e) {
      if (e.target.value === '') {
        return;
      }
      var val = Number(_this.state.goInputText);
      if (isNaN(val)) {
        val = _this.state.current;
      }
      if (e.keyCode === _common.KeyCode.ENTER) {
        _this.setState({
          goInputText: '',
          current: _this.props.quickGo(val)
        });
      }
    };

    _this.go = function (e) {
      if (e.target.value === '') {
        return;
      }
      var val = Number(_this.state.goInputText);
      if (isNaN(val)) {
        val = _this.state.current;
      }
      _this.setState({
        goInputText: '',
        current: _this.props.quickGo(val)
      });
    };

    _this.state = {
      current: props.current,
      goInputText: ''
    };
    return _this;
  }

  Input.prototype.render = function render() {
    var props = this.props;
    var state = this.state;
    var locale = props.locale || {};
    var prefixCls = props.rootPrefixCls + '-options';
    var quickGo = props.quickGo;
    var goInput = null;

    if (!quickGo) {
      return null;
    }

    goInput = _react2.default.createElement(
      'div',
      { className: (0, _common.cname)(prefixCls + '-quick-jumper') },
      _react2.default.createElement(
        'span',
        { className: (0, _common.cname)(prefixCls + '-quick-text') },
        locale.jump_to
      ),
      _react2.default.createElement('input', {
        type: 'text',
        value: state.goInputText,
        onChange: this.handleChange,
        onKeyUp: this.change
      })
    );

    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('' + prefixCls) },
      goInput,
      _react2.default.createElement(
        'a',
        { className: (0, _common.cname)(prefixCls + '-go'), onClick: this.go },
        locale.go || 'Go'
      )
    );
  };

  return Input;
}(_react2.default.Component), _class.propTypes = {
  quickGo: _propTypes2.default.func,
  current: _propTypes2.default.number,
  locale: _propTypes2.default.object
}, _temp);
exports.default = Input;
module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// import { Select } from "@ali/aps";


var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

var _Select = __webpack_require__(65);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _Select2.default.Option;

var Options = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Options, _React$Component);

  function Options(props) {
    (0, _classCallCheck3.default)(this, Options);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

    _this.buildOptionText = function (value) {
      return value;
    };

    _this.changeSize = function (value) {
      _this.props.changeSize(Number(value.value));
    };

    _this.state = {
      current: props.current,
      goInputText: ''
    };
    return _this;
  }

  Options.prototype.render = function render() {
    var props = this.props;
    var prefixCls = props.rootPrefixCls + '-options';
    var changeSize = props.changeSize;
    var buildOptionText = props.buildOptionText || this.buildOptionText;
    var changeSelect = null;

    if (!changeSize) {
      return null;
    }

    if (changeSize) {
      var pageSize = props.pageSize || props.pageSizeOptions[0];
      var options = props.pageSizeOptions.map(function (opt, i) {
        return _react2.default.createElement(
          Option,
          {
            key: i,
            value: opt,
            style: { fontSize: '12px' },
            className: 'opt'
          },
          buildOptionText(opt)
        );
      });

      changeSelect = _react2.default.createElement(
        _Select2.default,
        {
          prefixCls: props.selectPrefixCls,
          showSearch: false,
          className: (0, _common.cname)(prefixCls + '-size-changer'),
          optionLabelProp: 'children',
          dropdownMatchSelectWidth: false,
          value: pageSize.toString(),
          onChange: this.changeSize,
          size: 'small',
          hasArrow: true,
          getPopupContainer: function getPopupContainer(triggerNode) {
            return triggerNode.parentNode;
          }
        },
        options
      );
    }

    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('' + prefixCls) },
      changeSelect
    );
  };

  return Options;
}(_react2.default.Component), _class.propTypes = {
  changeSize: _propTypes2.default.func,
  selectComponentClass: _propTypes2.default.func,
  current: _propTypes2.default.number,
  pageSizeOptions: _propTypes2.default.arrayOf(_propTypes2.default.string),
  pageSize: _propTypes2.default.number,
  buildOptionText: _propTypes2.default.func,
  locale: _propTypes2.default.object
}, _class.defaultProps = {
  pageSizeOptions: ['10', '20', '30', '40']
}, _temp);
exports.default = Options;
module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(227);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _constants = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = function (_ComBase) {
  (0, _inherits3.default)(Option, _ComBase);

  function Option() {
    (0, _classCallCheck3.default)(this, Option);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Option.prototype.onClick = function onClick() {
    var _props = this.props,
        disabled = _props.disabled,
        label = _props.label,
        value = _props.value,
        id = _props.id,
        onSelect = _props.onSelect;

    if (!disabled) {
      onSelect({
        label: label || value,
        value: value,
        id: id || 0
      });
    }
  };

  Option.prototype.render = function render() {
    var _props2 = this.props,
        selected = _props2.selected,
        disabled = _props2.disabled,
        tagMenu = _props2.tagMenu,
        children = _props2.children,
        size = _props2.size;

    var names = (0, _common.cname)({
      option: true,
      optionLg: size && size === _constants.SelectSize.LARGE,
      optionMd: !size || size === _constants.SelectSize.MEDIUM,
      optionSm: size && size === _constants.SelectSize.SMALL,
      stateActive: selected,
      stateDisabled: disabled,
      tagMenu: tagMenu
    });
    return _react2.default.createElement(
      'li',
      { onClick: this.onClick.bind(this), className: names },
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)('option-content') },
        children
      )
    );
  };

  return Option;
}(_common.ComBase);

exports.default = Option;
module.exports = exports['default'];

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(229);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Progress = function (_ComBase) {
  (0, _inherits3.default)(Progress, _ComBase);

  function Progress(props) {
    (0, _classCallCheck3.default)(this, Progress);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));
  }

  Progress.prototype.render = function render() {
    var _cname, _cname2, _cname3;

    var _props = this.props,
        percent = _props.percent,
        visible = _props.visible;

    var percentStr = parseFloat(percent) * 100 + '%';
    var names = (0, _common.cname)((_cname = {
      stateHidden: this.props.hasOwnProperty('visible') && !visible,
      widget: true
    }, _cname[this.props.className] = !!this.props.className, _cname.progress = true, _cname.stateDisabled = !!this.props.disabled, _cname));
    var outerNames = (0, _common.cname)({
      progressOuter: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true
    });
    var innerNames = (0, _common.cname)((_cname2 = {
      progressInner: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true
    }, _cname2['size-' + this.props.size] = !!this.props.size, _cname2));
    var overlayNames = (0, _common.cname)((_cname3 = {
      progressOverlay: true
    }, _cname3['scene-' + this.props.status] = !!this.props.status, _cname3));

    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, (0, _common.transportProps)(this.props), {
        className: names,
        style: this.props.style }),
      _react2.default.createElement(
        'div',
        { className: outerNames },
        _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('progress-bar') },
          _react2.default.createElement(
            'div',
            { className: innerNames },
            _react2.default.createElement('div', { className: overlayNames,
              style: { width: percentStr } })
          )
        ),
        _react2.default.createElement(
          'span',
          { className: (0, _common.cname)(['progress-text', 'lh-' + this.props.size]) },
          this.props.status === 'success' ? _react2.default.createElement(_Icon3.default, { type: 'right1', className: (0, _common.cname)(['progress-status-icon', 'progress-status-icon-success']) }) : this.props.status === 'danger' ? _react2.default.createElement(_Icon3.default, { type: 'close', className: (0, _common.cname)(['progress-status-icon', 'progress-status-icon-error']) }) : percentStr
        )
      )
    );
  };

  return Progress;
}(_common.ComBase);

Progress.defaultProps = {
  percent: 0,
  status: 'info',
  size: 'medium'
};

exports.default = Progress;
module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _Radio2 = __webpack_require__(102);

var _Radio3 = _interopRequireDefault(_Radio2);

var _CheckBoxGroup2 = __webpack_require__(93);

var _CheckBoxGroup3 = _interopRequireDefault(_CheckBoxGroup2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroup = function (_ComBase) {
  (0, _inherits3.default)(RadioGroup, _ComBase);

  function RadioGroup() {
    (0, _classCallCheck3.default)(this, RadioGroup);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  RadioGroup.prototype.render = function render() {
    return _react2.default.createElement(_CheckBoxGroup3.default, (0, _extends3.default)({}, this.props, { control: _Radio3.default, single: true }));
  };

  return RadioGroup;
}(_common.ComBase);

exports.default = RadioGroup;
module.exports = exports['default'];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Select2 = __webpack_require__(65);

var _Select3 = _interopRequireDefault(_Select2);

var _Input2 = __webpack_require__(45);

var _Input3 = _interopRequireDefault(_Input2);

var _Form2 = __webpack_require__(98);

var _Form3 = _interopRequireDefault(_Form2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgets = _components2.default;
var Form = _Form3.default,
    Input = _Input3.default,
    Select = _Select3.default;

var SchemaForm = function (_ComBase) {
  (0, _inherits3.default)(SchemaForm, _ComBase);

  function SchemaForm() {
    (0, _classCallCheck3.default)(this, SchemaForm);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  SchemaForm.prototype.renderForm = function renderForm(schema) {
    var _this2 = this;

    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var fieldNames = (0, _keys2.default)(schema.properties);
    return _react2.default.createElement(
      Form,
      (0, _extends3.default)({}, props, {
        className: (0, _common.cname)('schemaForm', props.className) }),
      fieldNames.map(function (fieldName) {
        var fieldItem = schema.properties[fieldName];
        fieldItem.name = fieldName;
        fieldItem.title = fieldItem.title || fieldItem.description;
        return _react2.default.createElement(
          Form.Item,
          { key: fieldName,
            name: fieldName,
            rule: fieldItem.rule,
            label: fieldItem.title },
          _react2.default.createElement(
            Form.Control,
            null,
            _this2.renderItem(fieldItem)
          ),
          _react2.default.createElement(
            Form.Message,
            null,
            fieldItem.description
          )
        );
      })
    );
  };

  SchemaForm.prototype.renderItem = function renderItem(fieldItem) {
    if (fieldItem.type == 'object') {
      return this.renderForm(fieldItem);
    } else if (fieldItem.widget) {
      var Component = widgets[fieldItem.widget];
      return _react2.default.createElement(Component, fieldItem.props);
    } else {
      return fieldItem.enum ? _react2.default.createElement(Select, (0, _extends3.default)({}, fieldItem.props, { dataSource: fieldItem.enum })) : _react2.default.createElement(Input, fieldItem.props);
    }
  };

  SchemaForm.prototype.render = function render() {
    var schema = this.props.schema;

    return this.renderForm(schema, this.props);
  };

  (0, _createClass3.default)(SchemaForm, null, [{
    key: 'widgets',
    get: function get() {
      return widgets;
    }
  }]);
  return SchemaForm;
}(_common.ComBase);

exports.default = SchemaForm;
module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(234);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = function (_ComBase) {
  (0, _inherits3.default)(Slider, _ComBase);

  function Slider(props) {
    (0, _classCallCheck3.default)(this, Slider);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this2.getValueByWidth = _this2.getValueByWidth.bind(_this2);

    if (!(typeof _this2.getValueByWidth === 'function')) {
      throw new TypeError('Value of "this.getValueByWidth" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this2.getValueByWidth));
    }

    _this2.onMouseMoveEvents = _this2.onMouseMoveEvents.bind(_this2);

    if (!(typeof _this2.onMouseMoveEvents === 'function')) {
      throw new TypeError('Value of "this.onMouseMoveEvents" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this2.onMouseMoveEvents));
    }

    _this2.onMouseUpEvents = _this2.onMouseUpEvents.bind(_this2);

    if (!(typeof _this2.onMouseUpEvents === 'function')) {
      throw new TypeError('Value of "this.onMouseUpEvents" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this2.onMouseUpEvents));
    }

    _this2.changeValue = _this2.changeValue.bind(_this2);

    if (!(typeof _this2.changeValue === 'function')) {
      throw new TypeError('Value of "this.changeValue" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this2.changeValue));
    }

    _this2.state = {
      unmove: true,
      value: 0,
      maskWidth: {},
      barLeft: {},
      selectIndex: 0
    };
    return _this2;
  }

  // 初始时，获取默认值显示


  Slider.prototype.componentDidMount = function componentDidMount() {
    var value = this.props.value;

    if (typeof value !== 'undefined') {
      var _value = this.returnValue(parseInt(value));
      var _w = this.getWidthByValue(_value);
      var maskWidth = { width: _w + 'px' };
      var barLeft = { left: _w + 'px' };
      var unmove = true;
      this.setState({
        maskWidth: maskWidth,
        barLeft: barLeft,
        unmove: unmove
      });
    }
  };

  // 在外修改默认值改变数值滑动


  Slider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var value = nextProps.value;

    if (value !== this.state.value) {
      this.changeValue(value);
    }
  };

  Slider.prototype.changeValue = function changeValue(value) {
    var onChange = this.props.onChange;

    value = this.returnValue(parseInt(value));
    var _w = this.getWidthByValue(value);
    var maskWidth = { width: _w + 'px' };
    var barLeft = { left: _w + 'px' };
    var unmove = true;
    this.setState({
      maskWidth: maskWidth,
      barLeft: barLeft,
      unmove: unmove
    });
    onChange(value);
  };

  Slider.prototype.getSliderWidth = function getSliderWidth(props) {
    var type = props.type;

    var sliderWidth = 0;
    if (type === 'duration') {
      sliderWidth = 528;
    } else {
      sliderWidth = 412;
    }
    return sliderWidth;
  };

  Slider.prototype.getStepOption = function getStepOption(props) {
    var step = props.step,
        max = props.max,
        unit = props.unit;

    var options = [{ step: step, min: 0, max: Math.floor(max / 4), css: (0, _common.cname)('slider-l2') }, {
      step: step,
      min: Math.floor(max / 4),
      max: Math.floor(max / 2),
      css: (0, _common.cname)('slider-l1')
    }, {
      step: step,
      min: Math.floor(max / 2),
      max: max,
      css: (0, _common.cname)('slider-l1')
    }];
    options.map(function (item) {
      item.textLable = unit ? item.max + unit : item.max;
    });
    return options;
  };

  Slider.prototype.getWidthByCss = function getWidthByCss(css) {
    if (css == (0, _common.cname)('slider-l2')) {
      return 206 - 8;
    } else if (css == (0, _common.cname)('slider-l1')) {
      return 103;
    } else if (css == (0, _common.cname)('slider-mm')) {
      return 40;
    } else if (css == (0, _common.cname)('slider-yy')) {
      return 56;
    } else {
      return 0;
    }
  };

  //通过所选的宽度来获取值


  Slider.prototype.getValueByWidth = function getValueByWidth(w) {
    var _this3 = this;

    var max = this.props.max;

    var _stepOption = this._stepOption;
    var sliderWidth = this.getSliderWidth(this.props);

    if (w == 0) {
      return 0;
    }
    if (w == 1) {
      return max;
    }
    var _wd = w * sliderWidth; //选中的长度
    var _start = 0;
    var _end = 0;
    var keepGoing = true;
    var value = 0;

    _stepOption.map(function (o, i) {
      if (keepGoing) {
        _end = _start + _this3.getWidthByCss(o.css);
        if (_wd > _start && _wd <= _end) {
          value = o.min + (o.max - o.min) * (_wd - _start) / _this3.getWidthByCss(o.css);
          _this3.setState({
            selectIndex: i
          });
          keepGoing = false;
        }
        _start = _end;
        if (_wd > _end && i == _stepOption.length - 1) {
          value = max;
          keepGoing = false;
        }
      }
    });
    value = Math.ceil(value);
    value = this.returnValue(parseInt(value));
    return value;
  };

  Slider.prototype.getWidthByValue = function getWidthByValue(v) {
    var _this4 = this;

    var _stepOption = this._stepOption;
    var sliderWidth = this.getSliderWidth(this.props);

    if (v == 0) {
      return -9;
    }
    if (!v) {
      return sliderWidth - 10;
    }
    var keepGoing = true;
    var _width = 0;
    var width = 0;
    _stepOption.map(function (o, i) {
      if (keepGoing) {
        if (v > o.min && v <= o.max) {
          width = (v - o.min) / (o.max - o.min) * _this4.getWidthByCss(o.css) + _width;
          _this4.setState({
            selectIndex: i
          });
          keepGoing = false;
        }
        _width += _this4.getWidthByCss(o.css);
      }
    });
    return width > sliderWidth ? sliderWidth : width;
  };

  Slider.prototype.onMouseMoveEvents = function onMouseMoveEvents(e) {
    var _props = this.props,
        min = _props.min,
        max = _props.max;

    var sliderWidth = this.getSliderWidth(this.props);
    var _this = this;
    _this.setState({
      unmove: false
    });

    var _w = (e.pageX - 8 - this.sliderDom.offsetLeft) / sliderWidth;
    _w = _w > 0.99999 ? 1 : _w;
    _w = _w < 0.00001 ? 0 : _w;

    var _value = _this.getValueByWidth(_w);
    _value = this.returnValue(parseInt(_value));
    if (_value < min) {
      _value = min;
    }
    if (_value > max) {
      _value = max;
    }

    if (!!_value || _value == 0) {
      _this.setState({
        value: _value
      });
    }
    var maskWidth = { width: _w * sliderWidth + 'px' };
    var barLeft = { left: _w ? _w * sliderWidth : -9 + 'px' };
    _this.setState({
      maskWidth: maskWidth,
      barLeft: barLeft
    });
  };

  Slider.prototype.onMouseUpEvents = function onMouseUpEvents() {
    document.body.removeEventListener('mousemove', this.onMouseMoveEvents);
    document.body.removeEventListener('mouseup', this.onMouseUpEvents);
    this.changeValue(this.state.value);
  };

  Slider.prototype.returnValue = function returnValue(value) {
    var _props2 = this.props,
        min = _props2.min,
        max = _props2.max;

    this._stepOption.map(function (item) {
      if (item.step !== 1 && value <= item.max && value > item.min && value % item.step) {
        value = item.step - value % item.step + value;
      }
    });
    if (value < min) {
      value = min;
    } else if (value > max) {
      value = max;
    }
    return value;
  };

  Slider.prototype.down = function down(e) {
    var sliderWidth = this.getSliderWidth(this.props);

    var _width = (e.pageX - this.sliderDom.offsetLeft - 16) * 100 / sliderWidth;
    _width = _width >= 100 ? 100 : _width;
    var value = this.getValueByWidth(_width / 100);
    var maskWidth = { width: +_width + '%' };
    var barLeft = { left: _width + '%' };
    this.setState({
      value: value,
      maskWidth: maskWidth,
      barLeft: barLeft
    });
    this.sliderDomEvent = e;
    document.body.addEventListener('mousemove', this.onMouseMoveEvents);
    document.body.addEventListener('mouseup', this.onMouseUpEvents);
    e.preventDefault();
  };

  Slider.prototype.render = function render() {
    var _this5 = this;

    var _state = this.state;
    var _stepOption = this._stepOption = this.getStepOption(this.props);
    var _props3 = this.props,
        className = _props3.className,
        style = _props3.style;

    var selectIndex = _state.selectIndex;
    var sliderContainerClass = (0, _common.cname)({
      'slider-container': true,
      'slider-transition': _state.unmove
    });
    var sliderDragClass = (0, _common.cname)({
      'slider-drag': true,
      'slider-transition': _state.unmove
    });
    var apsSliderClass = (0, _common.cname)({
      slider: true
    }, className);
    return _react2.default.createElement(
      'div',
      {
        className: apsSliderClass,
        style: style,
        onMouseDown: this.down.bind(this),
        onKeyDown: this.down.bind(this),
        ref: function ref(refDom) {
          _this5.sliderDom = refDom;
        }
      },
      _react2.default.createElement(
        'span',
        { className: (0, _common.cname)('slider-range') },
        _stepOption.map(function (item, index) {
          var _cname;

          var boxLastClass = (0, _common.cname)({
            'slider-block-box': true,
            'aslider-block-box-last': index === _stepOption.length - 1,
            'select-action': index === selectIndex
          });
          var sliderBlockClass = (0, _common.cname)((_cname = {
            'slider-block': true
          }, _cname[item.css] = true, _cname));
          return _react2.default.createElement(
            'span',
            { className: sliderBlockClass, key: index },
            _react2.default.createElement(
              'span',
              { className: boxLastClass },
              _react2.default.createElement(
                'span',
                { className: (0, _common.cname)('slider-txt') },
                item.textLable
              )
            )
          );
        }),
        _react2.default.createElement(
          'span',
          { className: sliderContainerClass, style: _state.maskWidth },
          _react2.default.createElement(
            'span',
            { className: (0, _common.cname)('slider-current') },
            _stepOption.map(function (item, index) {
              var _cname2;

              var sliderUnitClass = (0, _common.cname)((_cname2 = {
                'slider-unit': true
              }, _cname2[item.css] = true, _cname2));
              var unitBoxClass = (0, _common.cname)({
                'slider-unit-box': true,
                'slider-unit-box-last': index === _stepOption.length - 1,
                'select-action': index === selectIndex
              });
              return _react2.default.createElement(
                'span',
                { className: sliderUnitClass, key: index },
                _react2.default.createElement(
                  'span',
                  { className: unitBoxClass },
                  _react2.default.createElement(
                    'span',
                    { className: (0, _common.cname)('slider-txt') },
                    item.textLable
                  )
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          'span',
          { className: sliderDragClass, style: _state.barLeft },
          _react2.default.createElement('i', null),
          _react2.default.createElement('i', null),
          _react2.default.createElement(
            'div',
            { style: { position: 'relative' } },
            _react2.default.createElement(
              'div',
              {
                className: (0, _common.cname)('tip-gray'),
                style: { display: _state.unmove ? 'none' : 'block' }
              },
              _react2.default.createElement(
                'span',
                null,
                _state.value
              ),
              _react2.default.createElement('span', { className: (0, _common.cname)('tip-arrow') })
            )
          )
        )
      )
    );
  };

  return Slider;
}(_common.ComBase);

exports.default = Slider;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

__webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sort = function (_ComBase) {
  (0, _inherits3.default)(Sort, _ComBase);

  function Sort() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Sort);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {}, _this.toggle = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          _this$props$defaultVa = _this$props.defaultValue,
          defaultValue = _this$props$defaultVa === undefined ? 'none' : _this$props$defaultVa,
          _this$props$value = _this$props.value,
          value = _this$props$value === undefined ? _this.state.value || defaultValue : _this$props$value;

      if (disabled) return;
      value = value == 'desc' ? 'asc' : 'desc';
      _this.setState({ value: value });
      if (!_common.utils.isFunction(onChange)) return;
      onChange(new _common.EventArgs(_this, value));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Sort.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        className = _props.className,
        disabled = _props.disabled,
        visible = _props.visible,
        _props$defaultValue = _props.defaultValue,
        defaultValue = _props$defaultValue === undefined ? 'none' : _props$defaultValue,
        _props$value = _props.value,
        value = _props$value === undefined ? this.state.value || defaultValue : _props$value;

    var classNames = (0, _common.cname)((_cname = {
      widget: true,
      aniTransition: true,
      sort: true
    }, _cname[value] = true, _cname.disabled = disabled, _cname.stateHidden = visible === false, _cname.stateVisible = visible !== false, _cname), className);
    return _react2.default.createElement(
      'span',
      { className: classNames, onClick: this.toggle },
      _react2.default.createElement(_Icon3.default, { className: (0, _common.cname)('sortBtn sortBtnUp'), type: 'shangjiantou' }),
      _react2.default.createElement(_Icon3.default, { className: (0, _common.cname)('sortBtn sortBtnDown'), type: 'xiajiantou' })
    );
  };

  return Sort;
}(_common.ComBase);

exports.default = Sort;
module.exports = exports['default'];

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _Steps = __webpack_require__(238);

var _Steps2 = _interopRequireDefault(_Steps);

var _Step = __webpack_require__(241);

var _Step2 = _interopRequireDefault(_Step);

__webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Steps2.default.Step = _Step2.default;
exports.default = _Steps2.default;
module.exports = exports['default'];

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(42);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = __webpack_require__(239);

var _lodash2 = _interopRequireDefault(_lodash);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Steps = function (_ComBase) {
  (0, _inherits3.default)(Steps, _ComBase);

  function Steps(props) {
    (0, _classCallCheck3.default)(this, Steps);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.calcStepOffsetWidth = function () {
      var domNode = _reactDom2.default.findDOMNode(_this);
      if (domNode.children.length > 0) {
        if (_this.calcTimeout) {
          clearTimeout(_this.calcTimeout);
        }
        _this.calcTimeout = setTimeout(function () {
          // +1 for fit edge bug of digit width, like 35.4px
          var lastStepOffsetWidth = (domNode.lastChild.offsetWidth || 0) + 1;
          // Reduce shake bug
          if (_this.state.lastStepOffsetWidth === lastStepOffsetWidth || Math.abs(_this.state.lastStepOffsetWidth - lastStepOffsetWidth) <= 3) {
            return;
          }
          _this.setState({ lastStepOffsetWidth: lastStepOffsetWidth });
        });
      }
    };

    _this.state = {
      lastStepOffsetWidth: 0
    };
    _this.calcStepOffsetWidth = (0, _lodash2.default)(_this.calcStepOffsetWidth, 150);
    return _this;
  }

  Steps.prototype.componentDidMount = function componentDidMount() {
    this.calcStepOffsetWidth();
  };

  Steps.prototype.componentDidUpdate = function componentDidUpdate() {
    this.calcStepOffsetWidth();
  };

  Steps.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.calcTimeout) {
      clearTimeout(this.calcTimeout);
    }
    if (this.calcStepOffsetWidth.cancel) {
      this.calcStepOffsetWidth.cancel();
    }
  };

  Steps.prototype.render = function render() {
    var _cname,
        _this2 = this;

    var props = this.props;
    var prefixCls = props.prefixCls,
        _props$style = props.style,
        style = _props$style === undefined ? {} : _props$style,
        className = props.className,
        children = props.children,
        direction = props.direction,
        labelPlacement = props.labelPlacement,
        status = props.status,
        size = props.size,
        current = props.current,
        type = props.type,
        restProps = (0, _objectWithoutProperties3.default)(props, ['prefixCls', 'style', 'className', 'children', 'direction', 'labelPlacement', 'status', 'size', 'current', 'type']);

    var childLength = children.length;
    var lastIndex = childLength - 1;
    var reLayouted = this.state.lastStepOffsetWidth > 0;
    var adjustedlabelPlacement = type == 'cicle' ? labelPlacement : 'vertical'; //箭头+点状必须为水平
    var classString = (0, _common.cname)((_cname = {}, _cname[prefixCls] = true, _cname[prefixCls + '-' + size] = size, _cname[prefixCls + '-' + direction] = true, _cname[prefixCls + '-label-' + adjustedlabelPlacement] = direction === 'horizontal', _cname[prefixCls + '-hidden'] = !reLayouted, _cname[prefixCls + '-dot'] = type == 'dot', _cname[prefixCls + '-arrow'] = type == 'arrow', _cname[className] = className, _cname));

    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({ className: classString, style: style }, restProps),
      _react2.default.Children.map(children, function (ele, idx) {
        var itemWidth = type == 'arrow' ? null : direction === 'vertical' || idx === lastIndex || !reLayouted ? null : 100 / lastIndex + '%';
        var adjustMarginRight = type == 'arrow' ? null : direction === 'vertical' || idx === lastIndex ? null : -Math.round(_this2.state.lastStepOffsetWidth / lastIndex + 1);
        var np = {
          stepNumber: (idx + 1).toString(),
          childLength: childLength,
          index: idx,
          itemWidth: itemWidth,
          adjustMarginRight: adjustMarginRight,
          prefixCls: prefixCls,
          wrapperStyle: style,
          type: type
        };
        // fix tail color
        if (status === 'error' && idx === current - 1) {
          np.className = props.prefixCls + '-next-error';
        }
        if (!ele.props.status) {
          if (idx === current) {
            np.status = status;
          } else if (idx < current) {
            np.status = 'finish';
          } else {
            np.status = 'wait';
          }
        }
        return _react2.default.cloneElement(ele, np);
      }, this)
    );
  };

  return Steps;
}(_common.ComBase);

exports.default = Steps;


Steps.propTypes = {
  prefixCls: _propTypes2.default.string,
  direction: _propTypes2.default.string,
  labelPlacement: _propTypes2.default.string,
  children: _propTypes2.default.any,
  status: _propTypes2.default.string,
  size: _propTypes2.default.string,
  type: _propTypes2.default.string
};

Steps.defaultProps = {
  prefixCls: 'aps-steps',
  direction: 'horizontal',
  labelPlacement: 'horizontal',
  current: 0,
  status: 'process',
  size: '',
  type: 'circle'
};
module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(240)))

/***/ }),
/* 240 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(6);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isString(str) {
  return typeof str === 'string';
}

var Step = function (_ComBase) {
  (0, _inherits3.default)(Step, _ComBase);

  function Step() {
    (0, _classCallCheck3.default)(this, Step);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  Step.prototype.render = function render() {
    var _cname, _cname2;

    var _props = this.props,
        className = _props.className,
        prefixCls = _props.prefixCls,
        style = _props.style,
        itemWidth = _props.itemWidth,
        _props$status = _props.status,
        status = _props$status === undefined ? 'wait' : _props$status,
        icon = _props.icon,
        wrapperStyle = _props.wrapperStyle,
        adjustMarginRight = _props.adjustMarginRight,
        stepNumber = _props.stepNumber,
        childLength = _props.childLength,
        index = _props.index,
        description = _props.description,
        title = _props.title,
        type = _props.type,
        restProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'prefixCls', 'style', 'itemWidth', 'status', 'icon', 'wrapperStyle', 'adjustMarginRight', 'stepNumber', 'childLength', 'index', 'description', 'title', 'type']);

    var iconClassName = (0, _common.cname)((_cname = {}, _cname[prefixCls + '-icon'] = true, _cname['icon'] = true, _cname['icon-' + icon] = icon && isString(icon), _cname['icon-check'] = !icon && status === 'finish', _cname['icon-cross'] = !icon && status === 'error', _cname));

    var iconNode = void 0;
    var iconDot = _react2.default.createElement('span', { className: prefixCls + '-icon-dot' });
    // `progressDot` enjoy the highest priority
    if (type == 'dot') {
      iconNode = _react2.default.createElement(
        'span',
        { className: prefixCls + '-icon' },
        iconDot
      );
    } else if (type == 'arrow') {
      //do nothing
    } else if (icon && !isString(icon)) {
      iconNode = _react2.default.createElement(
        'span',
        { className: prefixCls + '-icon' },
        icon
      );
    } else if (icon || status === 'finish' || status === 'error') {
      iconNode = _react2.default.createElement(
        'span',
        { className: iconClassName },
        _react2.default.createElement(_Icon3.default, { type: status === 'finish' ? 'right1' : 'close' })
      );
    } else {
      iconNode = _react2.default.createElement(
        'span',
        { className: prefixCls + '-icon' },
        stepNumber
      );
    }
    var classString = (0, _common.cname)((_cname2 = {}, _cname2[prefixCls + '-item'] = true, _cname2[prefixCls + '-item-first'] = index == 0, _cname2[prefixCls + '-item-last'] = index == childLength - 1, _cname2[prefixCls + '-status-' + status] = true, _cname2[prefixCls + '-custom'] = icon, _cname2[className] = !!className, _cname2));
    if (type == 'arrow') return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)(prefixCls + '-arrow-box'), style: { width: 100 / childLength + '%' } },
      _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, restProps, {
          className: classString,
          style: (0, _extends3.default)({ width: itemWidth, marginRight: adjustMarginRight }, style)
        }),
        _react2.default.createElement(
          'div',
          { className: 'title' },
          title
        )
      )
    );
    return _react2.default.createElement(
      'div',
      (0, _extends3.default)({}, restProps, {
        className: classString,
        style: (0, _extends3.default)({ width: itemWidth, marginRight: adjustMarginRight }, style)
      }),
      _react2.default.createElement(
        'div',
        {
          ref: 'tail',
          className: prefixCls + '-tail',
          style: { paddingRight: -adjustMarginRight }
        },
        _react2.default.createElement('i', null)
      ),
      _react2.default.createElement(
        'div',
        { className: prefixCls + '-step' },
        _react2.default.createElement(
          'div',
          {
            className: prefixCls + '-head',
            style: { background: wrapperStyle.background || wrapperStyle.backgroundColor }
          },
          _react2.default.createElement(
            'div',
            { className: prefixCls + '-head-inner' },
            iconNode
          )
        ),
        _react2.default.createElement(
          'div',
          { ref: 'main', className: prefixCls + '-main' },
          _react2.default.createElement(
            'div',
            {
              className: prefixCls + '-title',
              style: { background: wrapperStyle.background || wrapperStyle.backgroundColor }
            },
            title
          ),
          description ? _react2.default.createElement(
            'div',
            { className: prefixCls + '-description' },
            description
          ) : ''
        )
      )
    );
  };

  return Step;
}(_common.ComBase);

exports.default = Step;


Step.propTypes = {
  className: _propTypes2.default.string,
  prefixCls: _propTypes2.default.string,
  style: _propTypes2.default.object,
  wrapperStyle: _propTypes2.default.object,
  itemWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  status: _propTypes2.default.string,
  //iconPrefix: PropTypes.string,
  icon: _propTypes2.default.node,
  adjustMarginRight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  stepNumber: _propTypes2.default.string,
  description: _propTypes2.default.any,
  title: _propTypes2.default.any,
  type: _propTypes2.default.string
  // progressDot: PropTypes.oneOfType([
  //   PropTypes.bool,
  //   PropTypes.func,
  // ]),
};
module.exports = exports['default'];

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _class2, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Column = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Column, _ComBase);

  function Column() {
    (0, _classCallCheck3.default)(this, Column);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  return Column;
}(_common.ComBase), _class.propTypes = {
  field: _propTypes2.default.string.isRequired,
  align: _propTypes2.default.oneOf(['left', 'center', 'right'])
}, _temp);

var Empty = function (_ComBase2) {
  (0, _inherits3.default)(Empty, _ComBase2);

  function Empty() {
    (0, _classCallCheck3.default)(this, Empty);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase2.apply(this, arguments));
  }

  Empty.prototype.render = function render() {
    var children = this.props.children;

    return _react2.default.createElement(
      'div',
      null,
      children
    );
  };

  return Empty;
}(_common.ComBase);

var Table = (_temp2 = _class2 = function (_ComBase3) {
  (0, _inherits3.default)(Table, _ComBase3);

  function Table() {
    (0, _classCallCheck3.default)(this, Table);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase3.apply(this, arguments));
  }

  Table.prototype.findColumns = function findColumns() {
    var elements = this.findChildren(Column);
    return elements.map(function (element) {
      return element.props;
    });
  };

  Table.prototype.renderHeadCell = function renderHeadCell(column, index) {
    var content = _common.utils.isNull(column.head) ? column.field : column.head;
    return _react2.default.createElement(
      'th',
      { key: column.field + index,
        className: (0, _common.cname)(column.align),
        style: column.width ? { width: column.width } : null,
        'data-field': column.field || index },
      _common.utils.isFunction(content) ? content(column) : content
    );
  };

  Table.prototype.renderHead = function renderHead(columns) {
    var _this4 = this;

    return _react2.default.createElement(
      'thead',
      null,
      _react2.default.createElement(
        'tr',
        null,
        columns.map(function (column, index) {
          return _this4.renderHeadCell(column, index);
        })
      )
    );
  };

  Table.prototype.renderRowCell = function renderRowCell(column, row, index) {
    var value = row[column.field || ''];
    var content = column.cell || value || '';
    return _react2.default.createElement(
      'td',
      { key: column.field + index,
        className: (0, _common.cname)(column.align),
        'data-field': column.field || index },
      _common.utils.isFunction(content) ? content({ column: column, row: row, value: value }) : content
    );
  };

  Table.prototype.renderRow = function renderRow(columns, row, index) {
    var _this5 = this;

    var _props = this.props,
        _props$keyField = _props.keyField,
        keyField = _props$keyField === undefined ? '' : _props$keyField,
        _props$autoRowKey = _props.autoRowKey,
        autoRowKey = _props$autoRowKey === undefined ? false : _props$autoRowKey;
    //直接用 index 作为 key 在表格数据动增删时会显示错误
    //通过 keyField 可即不出问题，也能够重用 dom
    //但是如果没有 keyField，生成一个 uuid 不重用 dom 也要保证显示无问题

    var keyValue = String(autoRowKey && !keyField ? Table.uuid++ : row[keyField] || '');
    return _react2.default.createElement(
      'tr',
      { key: keyValue + index, 'data-row': index },
      columns.map(function (column, index) {
        return _this5.renderRowCell(column, row, index);
      })
    );
  };

  Table.prototype.renderBody = function renderBody(columns, data) {
    var _this6 = this;

    var rows = void 0;
    if (data && data.length > 0) {
      rows = data.map(function (row, index) {
        return _this6.renderRow(columns, row, index);
      });
    } else {
      var _props$empty = this.props.empty,
          empty = _props$empty === undefined ? this.findChildren(Empty) : _props$empty;

      rows = empty && empty.length > 0 ? _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { className: (0, _common.cname)('empty'),
            colSpan: columns.length },
          empty
        )
      ) : null;
    }
    return _react2.default.createElement(
      'tbody',
      null,
      rows
    );
  };

  Table.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        _props2$columns = _props2.columns,
        columns = _props2$columns === undefined ? this.findColumns() : _props2$columns,
        data = _props2.data,
        others = (0, _objectWithoutProperties3.default)(_props2, ['className', 'columns', 'data']);

    var classNames = (0, _common.cname)(['table', 'widget', 'aniTransition'], className);
    return _react2.default.createElement(
      'table',
      (0, _extends3.default)({}, (0, _common.transportProps)(others), { className: classNames }),
      this.renderHead(columns),
      this.renderBody(columns, data)
    );
  };

  return Table;
}(_common.ComBase), _class2.uuid = 0, _class2.Column = Column, _class2.Empty = Empty, _temp2);
exports.default = Table;
module.exports = exports['default'];

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(246);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tabPanel = __webpack_require__(247);

var _tabPanel2 = _interopRequireDefault(_tabPanel);

var _tabBar = __webpack_require__(248);

var _tabBar2 = _interopRequireDefault(_tabBar);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tabs = function (_ComBase) {
  (0, _inherits3.default)(Tabs, _ComBase);

  function Tabs() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = {
      activeKey: undefined
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Tabs.prototype.onTabChange = function onTabChange(key) {
    var _props$onChange = this.props.onChange,
        onChange = _props$onChange === undefined ? function () {} : _props$onChange;
    var activeKey = this.props.activeKey;

    if (activeKey === undefined) {
      // activeKey未从Props传进来，使用state里面的值
      activeKey = this.state.activeKey;
      this.setState({ activeKey: key });
    } else {// 从props进来，受控组件
    }
    onChange(key);
  };

  Tabs.prototype.getActiveKey = function getActiveKey() {
    var _props = this.props,
        activeKey = _props.activeKey,
        defaultActiveKey = _props.defaultActiveKey;

    if (activeKey === undefined) {
      activeKey = this.state.activeKey;
    }
    if (activeKey === undefined) {
      activeKey = defaultActiveKey;
    }
    return activeKey;
  };

  Tabs.prototype.render = function render() {
    var _cname;

    var _props2 = this.props,
        _props2$children = _props2.children,
        children = _props2$children === undefined ? [] : _props2$children,
        type = _props2.type,
        tabAlign = _props2.tabAlign,
        tabPosition = _props2.tabPosition,
        className = _props2.className,
        transparent = _props2.transparent,
        tabWrapperWidth = _props2.tabWrapperWidth,
        size = _props2.size;

    if (!Array.isArray(children)) {
      children = [children];
    }
    var activeKey = this.getActiveKey();
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)((_cname = {
          'tab': true
        }, _cname[className] = !!className, _cname['tab-position-' + tabPosition] = true, _cname)) },
      _react2.default.createElement(
        _tabBar2.default,
        { transparent: transparent,
          type: type,
          size: size,
          tabPosition: tabPosition,
          activeKey: activeKey,
          onTabChange: this.onTabChange.bind(this),
          tabAlign: tabAlign,
          wrapperWidth: tabWrapperWidth },
        children.map(function (child) {
          var key = child.key,
              label = child.props.label;

          return _react2.default.createElement(
            'span',
            { className: (0, _common.cname)({
                'tab-label-inner': true
              }), key: key },
            label
          );
        })
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)({
            'tab-pannel-wrapper': true
          }) },
        children.map(function (child) {
          var key = child.key;

          return key === activeKey ? child : '';
        })
      )
    );
  };

  return Tabs;
}(_common.ComBase);

Tabs.propTypes = {
  /**
   * 是否可见
   */
  visible: _propTypes2.default.bool.isRequired,
  /**
   * 是否禁用
   */
  disabled: _propTypes2.default.bool.isRequired,
  /**
   * 是否为透明的Tab
   */
  transparent: _propTypes2.default.bool.isRequired,
  /**
   * Tab的基本样式，值有：锚点型anchor、普通型normal、卡片型card、胶囊型capsule、文本型text
   */
  type: _propTypes2.default.oneOf(['anchor', 'normal', 'card', 'capsule', 'text']).isRequired,
  /**
   * Tab的尺寸，值有：xs, small，normal，large
   */
  size: _propTypes2.default.oneOf(['xs', 'small', 'normal', 'large']).isRequired,
  /**
   * Tab的位置，值有'left', 'top'
   */
  tabPosition: _propTypes2.default.oneOf(['left', 'top']).isRequired,
  /**
   * Tab的对齐方式：有'left', 'right', 'center', 'full',该属性仅对tabPosition为top或bottom的Tab有效
   */
  tabAlign: _propTypes2.default.oneOf(['left', 'center', 'right', 'full']).isRequired,
  /**
   * 激活的Tab的key
   */
  activeKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * 默认选中Tab的key
   */
  defaultActiveKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Tab发生切换的时候触发的事件
   */
  onChange: _propTypes2.default.func,
  /**
   * TabBar容器的内宽度
   */
  tabWrapperWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Tabs.defaultProps = {
  visible: true,
  disabled: false,
  transparent: false,
  type: 'normal',
  size: 'normal',
  tabPosition: 'top',
  tabAlign: 'center',
  tabWrapperWidth: '100%',
  tabWrapperHeight: 'auto'
};

Tabs.TabPanel = _tabPanel2.default;

exports.default = Tabs;
module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabPanel = function (_ComBase) {
  (0, _inherits3.default)(TabPanel, _ComBase);

  function TabPanel() {
    (0, _classCallCheck3.default)(this, TabPanel);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  TabPanel.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        activeKey = _props.activeKey,
        height = _props.height;
    var key = this.key;

    return _react2.default.createElement(
      'div',
      { style: { height: height }, className: (0, _common.cname)({
          'tab-panel': true,
          'tab-panel-active': key === activeKey
        }) },
      children
    );
  };

  return TabPanel;
}(_common.ComBase);

TabPanel.propTypes = {
  /**
   * Tab的标签
   */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired,
  /**
   * Tab的内容的高度
   */
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

exports.default = TabPanel;
module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabBar = function (_ComBase) {
  (0, _inherits3.default)(TabBar, _ComBase);

  function TabBar() {
    (0, _classCallCheck3.default)(this, TabBar);
    return (0, _possibleConstructorReturn3.default)(this, _ComBase.apply(this, arguments));
  }

  TabBar.prototype.getWrapperWidth = function getWrapperWidth() {
    var _props = this.props,
        wrapperWidth = _props.wrapperWidth,
        tabPosition = _props.tabPosition;

    if (tabPosition === 'left' && wrapperWidth.indexOf('%') >= 0) {
      //垂直Tab布局下，禁用百分比，一律auto
      wrapperWidth = undefined;
    }
    return wrapperWidth;
  };

  TabBar.prototype.render = function render() {
    var _cname;

    var _props2 = this.props,
        children = _props2.children,
        activeKey = _props2.activeKey,
        type = _props2.type,
        tabAlign = _props2.tabAlign,
        onTabChange = _props2.onTabChange,
        className = _props2.className,
        transparent = _props2.transparent,
        size = _props2.size;

    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)((_cname = {
          'tab-bar': true
        }, _cname[className] = !!className, _cname['tab-bar-type-' + type] = true, _cname['tab-bar-align-' + tabAlign] = true, _cname['tab-bar-size-' + size] = true, _cname['tab-bar-transparent'] = transparent, _cname)) },
      _react2.default.createElement(
        'div',
        { className: (0, _common.cname)({
            'tab-bar-wrapper': true
          }), style: {
            width: this.getWrapperWidth()
          } },
        _react2.default.createElement(
          'div',
          { className: (0, _common.cname)({
              'tab-item-wrapper': true
            }) },
          children.map(function (child) {
            var _cname2;

            var key = child.key;

            return _react2.default.createElement(
              'div',
              { key: key, className: (0, _common.cname)((_cname2 = {
                  'tab-label': true,
                  'tab-label-active': key === activeKey
                }, _cname2['tab-label-col-' + children.length] = true, _cname2)), onClick: function onClick() {
                  onTabChange(key);
                } },
              child
            );
          })
        )
      )
    );
  };

  return TabBar;
}(_common.ComBase);

TabBar.propTypes = {
  /**
   * Tab的基本样式，值有：锚点型anchor、普通型normal、卡片型card、胶囊型capsule、文本型text
   */
  type: _propTypes2.default.oneOf(['anchor', 'normal', 'card', 'capsule', 'text']).isRequired,
  /**
   * Tab的尺寸，值有：small，normal，large
   */
  size: _propTypes2.default.oneOf(['xs', 'small', 'normal', 'large']),
  /**
   * 是否透明
   */
  transparent: _propTypes2.default.bool.isRequired,
  /**
   * 激活的Tab的key
   */
  activeKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Tab的对齐方式：有'left', 'right', 'center', 'full',该属性仅对tabPosition为top或bottom的Tab有效
   */
  tabAlign: _propTypes2.default.oneOf(['left', 'center', 'right', 'full']).isRequired,
  /**
   * Tab切的时候触发的事件
   */
  onTabChange: _propTypes2.default.func.isRequired,
  /**
   * TabBar容器的内宽度
   */
  wrapperWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Tab的位置，值有'left', 'top'
   */
  tabPosition: _propTypes2.default.oneOf(['left', 'top']).isRequired
};

exports.default = TabBar;
module.exports = exports['default'];

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _Tag2 = __webpack_require__(103);

var _Tag3 = _interopRequireDefault(_Tag2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(251);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

var _common = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tags = function (_ComBase) {
  (0, _inherits3.default)(Tags, _ComBase);

  function Tags(props) {
    (0, _classCallCheck3.default)(this, Tags);

    var _this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call(this, props));

    _this.onCloseSomeTag = function (e, p) {
      _this.props.onRemove(e, p);
    };

    _this.state = {
      items: _this.props.items || []
    };
    return _this;
  }

  Tags.prototype.render = function render() {
    var _cname,
        _this2 = this;

    var items = this.state.items;
    var className = this.props.className;

    var names = (0, _common.cname)((_cname = {
      Tags: true
    }, _cname[className] = true, _cname));
    return _react2.default.createElement(
      'div',
      { className: names },
      items.map(function (tag, index) {
        var colorField = tag.colorField,
            closable = tag.closable,
            content = tag.content;

        return _react2.default.createElement(
          _Tag3.default,
          { key: index, index: index, colorField: colorField, closable: closable, onClose: _this2.onCloseSomeTag },
          content
        );
      })
    );
  };

  return Tags;
}(_common.ComBase);

exports.default = Tags;
module.exports = exports['default'];

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _Proxy2 = __webpack_require__(27);

var _Proxy3 = _interopRequireDefault(_Proxy2);

var _Popover2 = __webpack_require__(19);

var _Popover3 = _interopRequireDefault(_Popover2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

__webpack_require__(253);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tooltip = function (_ComBase) {
  (0, _inherits3.default)(Tooltip, _ComBase);

  function Tooltip() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { visible: false, mount: false }, _this.onDocumentClick = function (event) {
      var triggerType = _this.props.triggerType;

      if (triggerType !== 'click') return;
      var follow = _this.getFollow();
      var visible = _common.utils.contains(_this.domNode, event.target) || _common.utils.contains(follow, event.target) || _common.utils.contains(_this.panel, event.target);
      _this.setState({ visible: visible });
    }, _this.onDocumentMouseMove = function (event) {
      if (_this.moveTimer) {
        clearTimeout(_this.moveTimer);
        _this.moveTimer = null;
      }
      var _this$props$triggerTy = _this.props.triggerType,
          triggerType = _this$props$triggerTy === undefined ? 'hover' : _this$props$triggerTy;

      if (triggerType !== 'hover') return;
      var follow = _this.getFollow();
      var visible = _common.utils.contains(_this.domNode, event.target) || _common.utils.contains(follow, event.target) || _common.utils.contains(_this.panel, event.target);
      var handler = function handler() {
        _this.setState({ visible: visible });
        _this.moveTimer = null;
      };
      var hoverDelay = _this.props.hoverDelay;

      if (!hoverDelay || visible) return handler();
      _this.moveTimer = setTimeout(handler, hoverDelay);
    }, _this.getFollow = function () {
      if (_this._followNode) return _this._followNode;
      var follow = _this._element ? _this.domNode : _this._follow;
      if (_common.utils.isComponent(follow)) follow = follow.domNode;
      if (_common.utils.isString(follow)) follow = document.querySelector(follow);
      _this._followNode = follow;
      return _this._followNode;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Tooltip.prototype.componentDidMount = function componentDidMount() {
    this.setState({ mount: true });
  };

  Tooltip.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        visible = _state.visible,
        mount = _state.mount;
    var _props = this.props,
        trigger = _props.trigger,
        children = _props.children,
        className = _props.className,
        opts = (0, _objectWithoutProperties3.default)(_props, ['trigger', 'children', 'className']);

    this._follow = _common.utils.isFunction(trigger) ? trigger() : trigger;
    if (!mount) return _react2.default.createElement('span', { className: (0, _common.cname)('hidden') });
    this._element = _common.utils.isReactElement(this._follow) ? this._follow : null;
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('tooltip') },
      this._element,
      _react2.default.createElement(
        _Popover3.default,
        (0, _extends3.default)({
          visible: visible
        }, opts, {
          ref: function ref(_ref) {
            return _this2.panel = _ref;
          },
          overlay: false,
          follow: this.getFollow,
          className: (0, _common.cname)('tooltip-popover', className) }),
        _react2.default.createElement('div', { className: (0, _common.cname)('tooltip-arrow') }),
        _react2.default.createElement(
          'div',
          { className: (0, _common.cname)('tooltip-inner') },
          children
        )
      ),
      _react2.default.createElement(_Proxy3.default, { target: document,
        onClick: this.onDocumentClick,
        onMouseMove: this.onDocumentMouseMove })
    );
  };

  return Tooltip;
}(_common.ComBase);

exports.default = Tooltip;
module.exports = exports['default'];

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

__webpack_require__(255);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {
  return false;
};

var Upload = (_temp2 = _class = function (_ComBase) {
  (0, _inherits3.default)(Upload, _ComBase);

  function Upload() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Upload);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { files: [], status: 'normal', loaded: 0, total: 0 }, _this.onChange = function (event) {
      if (_this.xhr) {
        _this.xhr.abort();
        _this.xhr = null;
      }
      var files = [].slice.call(event.target.files);
      _this.setState({ files: files, status: 'ready', loaded: 0, total: 0 });
      var _this$props = _this.props,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === undefined ? noop : _this$props$onChange,
          _this$props$auto = _this$props.auto,
          auto = _this$props$auto === undefined ? true : _this$props$auto,
          url = _this$props.url;

      onChange({ event: event, files: files });
      if (auto) _this.send(url);
    }, _this.send = function (url) {
      var formData = new FormData(_this.domNode);
      var xhr = _this.xhr = new XMLHttpRequest();
      if (xhr.upload && xhr.upload.addEventListener) {
        xhr.upload.addEventListener('progress', function (event) {
          return _this.onProgress(event);
        });
      }
      xhr.open('POST', url || _this.props.url, true);
      xhr.onload = function (event) {
        return _this.onUpload(event);
      };
      setTimeout(function () {
        return xhr.send(formData);
      }, 300);
    }, _this.onUpload = function (event) {
      if (!_this.xhr) return;
      var _this2 = _this,
          xhr = _this2.xhr;
      var files = _this.state.files;
      var _this$props2 = _this.props,
          _this$props2$onDone = _this$props2.onDone,
          onDone = _this$props2$onDone === undefined ? noop : _this$props2$onDone,
          _this$props2$checkSta = _this$props2.checkStatus,
          checkStatus = _this$props2$checkSta === undefined ? Upload.checkStatus : _this$props2$checkSta;

      onDone({ event: event, xhr: xhr, files: files });
      if (checkStatus({ event: event, xhr: xhr, files: files })) {
        _this.onSuccess(event);
      } else {
        _this.onError(event);
      }
    }, _this.onProgress = function (event) {
      if (!_this.xhr) return;
      var _this3 = _this,
          xhr = _this3.xhr;
      var files = _this.state.files;
      var _this$props$onProgres = _this.props.onProgress,
          onProgress = _this$props$onProgres === undefined ? noop : _this$props$onProgres;

      onProgress({ event: event, xhr: xhr, files: files });
      var loaded = event.loaded,
          total = event.total;

      _this.setState({ status: 'progress', loaded: loaded, total: total });
    }, _this.onSuccess = function (event) {
      if (!_this.xhr) return;
      var _this4 = _this,
          xhr = _this4.xhr;
      var files = _this.state.files;
      var _this$props$onSuccess = _this.props.onSuccess,
          onSuccess = _this$props$onSuccess === undefined ? noop : _this$props$onSuccess;

      onSuccess({ event: event, xhr: xhr, files: files });
      _this.setState({ status: 'success' });
    }, _this.onError = function (event) {
      if (!_this.xhr) return;
      var _this5 = _this,
          xhr = _this5.xhr;
      var files = _this.state.files;
      var _this$props$onError = _this.props.onError,
          onError = _this$props$onError === undefined ? noop : _this$props$onError;

      onError({ event: event, xhr: xhr, files: files });
      _this.setState({ status: 'error' });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Upload.prototype.render = function render() {
    var _cname;

    var _props = this.props,
        className = _props.className,
        _props$visible = _props.visible,
        visible = _props$visible === undefined ? true : _props$visible,
        _props$size = _props.size,
        size = _props$size === undefined ? 'medium' : _props$size,
        others = (0, _objectWithoutProperties3.default)(_props, ['className', 'visible', 'size']);

    var classNames = (0, _common.cname)((_cname = {
      upload: true,
      widget: true
    }, _cname['size-' + size] = size, _cname.aniTransition = true, _cname.stateHidden = !visible, _cname.stateVisible = visible, _cname), className);
    return _react2.default.createElement(
      'form',
      (0, _extends3.default)({}, (0, _common.transportProps)(others), {
        'data-status': this.state.status,
        className: classNames,
        encType: 'multipart/form-data' }),
      this.renderFilePicker(),
      this.renderContent(),
      this.renderProgress()
    );
  };

  Upload.prototype.renderFilePicker = function renderFilePicker() {
    var _props2 = this.props,
        className = _props2.className,
        style = _props2.style,
        others = (0, _objectWithoutProperties3.default)(_props2, ['className', 'style']); //eslint-disable-line

    return _react2.default.createElement('input', (0, _extends3.default)({}, (0, _common.transportProps)(others), {
      onChange: this.onChange,
      className: (0, _common.cname)('file'),
      type: 'file' }));
  };

  Upload.prototype.renderContent = function renderContent() {
    var _props3 = this.props,
        _props3$text = _props3.text,
        text = _props3$text === undefined ? '选择文件...' : _props3$text,
        children = _props3.children;
    var files = this.state.files;

    if (children) return children;
    var fileNames = files.map(function (file) {
      return file.name;
    }).join('/');
    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('content') },
      fileNames && fileNames.length > 0 ? fileNames : text
    );
  };

  Upload.prototype.renderProgress = function renderProgress() {
    var _state = this.state,
        loaded = _state.loaded,
        total = _state.total;

    return _react2.default.createElement('div', { className: (0, _common.cname)('progress  aniTransition'),
      style: { width: loaded / total * 100 + '%' } });
  };

  return Upload;
}(_common.ComBase), _class.checkStatus = function (_ref) {
  var xhr = _ref.xhr;

  return xhr.status == 200;
}, _temp2);
exports.default = Upload;
module.exports = exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.default = undefined;

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _class, _temp;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _rules = __webpack_require__(257);

var _rules2 = _interopRequireDefault(_rules);

__webpack_require__(258);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Verification = function () {
  Verification.fromElement = function fromElement(element) {
    var _element$props = element.props,
        children = _element$props.children,
        rule = _element$props.rule,
        others = (0, _objectWithoutProperties3.default)(_element$props, ['children', 'rule']);

    if (!rule) {
      var elements = _common.utils.findChildren(Validator, children);
      rule = elements.map(function (child) {
        return Verification.fromElement(child);
      });
    }
    return new Verification((0, _extends3.default)({}, others, { rule: rule }));
  };

  function Verification(props) {
    (0, _classCallCheck3.default)(this, Verification);
    var _props$logic = props.logic,
        logic = _props$logic === undefined ? 'and' : _props$logic,
        _props$rule = props.rule,
        rule = _props$rule === undefined ? [] : _props$rule,
        _props$fail = props.fail,
        fail = _props$fail === undefined ? '' : _props$fail,
        _props$success = props.success,
        success = _props$success === undefined ? '' : _props$success;

    this.logic = logic;
    this.rule = _common.utils.isArray(rule) ? rule : [rule];
    this.fail = fail;
    this.success = success;
  }

  Verification.prototype.exec = function exec(rule, value) {
    rule.test = rule.test || rule;
    var result = _common.utils.isFunction(rule.test) ? rule.test(value) : rule.test === value;
    return result === true || result && result.status === true;
  };

  Verification.prototype.test = function test(value) {
    var logic = this.logic;

    return this[logic](value);
  };

  Verification.prototype.and = function and(value) {
    var _this = this;

    var rule = this.rule,
        fail = this.fail,
        success = this.success;

    var item = rule.find(function (item) {
      return !_this.exec(item, value);
    });
    var status = !item;
    var message = status ? success : item.fail || fail;
    return { status: status, message: message };
  };

  Verification.prototype.or = function or(value) {
    var _this2 = this;

    var rule = this.rule,
        fail = this.fail,
        success = this.success;

    var item = rule.find(function (item) {
      return _this2.exec(item, value);
    });
    var status = !!item;
    var message = status ? item.success || success : fail;
    return { status: status, message: message };
  };

  return Verification;
}();

var Validator = (_temp = _class = function (_ComBase) {
  (0, _inherits3.default)(Validator, _ComBase);

  function Validator() {
    (0, _classCallCheck3.default)(this, Validator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this3 = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args)));

    _this3.verification = Verification.fromElement(_this3);
    _this3.times = 0;
    return _this3;
  }

  Validator.prototype.componentDidMount = function componentDidMount() {
    this.checkUpdate(this.props);
    this._mounted = true;
  };

  Validator.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.checkUpdate(nextProps);
  };

  Validator.prototype.checkUpdate = function checkUpdate(props) {
    var nextValue = props.value;
    if (_common.utils.isObject(nextValue)) nextValue = (0, _stringify2.default)(nextValue);
    var shouldUpdate = this.prevValue !== nextValue;
    this.prevValue = nextValue;
    return shouldUpdate;
  };

  Validator.prototype.updateContainer = function updateContainer(status) {
    if (!this._container) {
      this._container = this.domNode && this.domNode.parentNode;
    }
    if (!this._container) return;
    if (status) {
      this._container.classList.add((0, _common.cname)('success'));
      this._container.classList.remove((0, _common.cname)('fail'));
    } else {
      this._container.classList.add((0, _common.cname)('fail'));
      this._container.classList.remove((0, _common.cname)('success'));
    }
  };

  Validator.prototype.render = function render() {
    var _this4 = this;

    var _props = this.props,
        value = _props.value,
        ignoreInit = _props.ignoreInit,
        className = _props.className,
        onValidate = _props.onValidate,
        _props$should = _props.should,
        should = _props$should === undefined ? this._mounted || !ignoreInit : _props$should;

    var _verification$test = this.verification.test(value),
        status = _verification$test.status,
        message = _verification$test.message;

    var shouldValidate = _common.utils.isFunction(should) ? should() : should;
    var times = this.times++;
    setTimeout(function () {
      if (onValidate) onValidate({ status: status, message: message, times: times });
      if (shouldValidate) _this4.updateContainer(status);
    }, 0);
    var classNames = (0, _common.cname)({
      validator: true,
      success: status,
      fail: !status,
      stateVisible: shouldValidate,
      stateHidden: !shouldValidate
    }, className);
    return _react2.default.createElement(
      'div',
      { className: classNames },
      message
    );
  };

  return Validator;
}(_common.ComBase), _class.Verification = Verification, _class.rules = _rules2.default, _temp);
exports.default = Validator;
module.exports = exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _common = __webpack_require__(0);

exports.default = {
  required: function required(value) {
    return value && /.+/.test(value);
  },
  array: function array(value) {
    return _common.utils.isArray(value);
  },
  email: /[a-z0-9\-\_\.]+\@[a-z0-9\-\_\.]+/,
  number: function number(num) {
    return !isNaN(num);
  },
  len: function len(min, max) {
    return function (arr) {
      return arr && arr.length >= min && arr.length <= max;
    };
  },
  range: function range(min, max) {
    return function (num) {
      return num >= min && num <= max;
    };
  },
  lt: function lt(num) {
    return function (value) {
      return value < num;
    };
  },
  gt: function gt(num) {
    return function (value) {
      return value > num;
    };
  },
  lte: function lte(num) {
    return function (value) {
      return value <= num;
    };
  },
  gte: function gte(num) {
    return function (value) {
      return value >= num;
    };
  }
};
module.exports = exports['default'];

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _alert = __webpack_require__(104);

var _alert2 = _interopRequireDefault(_alert);

var _confirm = __webpack_require__(260);

var _confirm2 = _interopRequireDefault(_confirm);

var _toast = __webpack_require__(261);

var _toast2 = _interopRequireDefault(_toast);

var _i18n = __webpack_require__(66);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { alert: _alert2.default, confirm: _confirm2.default, toast: _toast2.default, i18n: _i18n2.default };
module.exports = exports['default'];

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _create = __webpack_require__(34);

var _create2 = _interopRequireDefault(_create);

exports.default = confirm;

var _alert = __webpack_require__(104);

var _alert2 = _interopRequireDefault(_alert);

var _i18n = __webpack_require__(66);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function confirm(content, opts) {
  opts = opts || (0, _create2.default)(null);
  opts.title = opts.title || _i18n2.default.current.confirm;
  opts.buttons = opts.buttons || [{
    text: _i18n2.default.current.cancel,
    shape: 'ghost'
  }, {
    text: _i18n2.default.current.ok,
    type: 'primary'
  }];
  return (0, _alert2.default)(content, opts);
}
module.exports = exports['default'];

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _regenerator = __webpack_require__(28);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(29);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Alert2 = __webpack_require__(71);

var _Alert3 = _interopRequireDefault(_Alert2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _Icon2 = __webpack_require__(10);

var _Icon3 = _interopRequireDefault(_Icon2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(2);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(0);

var _components = __webpack_require__(6);

__webpack_require__(262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_DELAY = 25;
var SHOW_DURATION = 1500;
var COLLECT_DELAY = 300;
var HIDE_MIN_INTERVAL = 600;

//toast 框

var Toast = function (_ComBase) {
  (0, _inherits3.default)(Toast, _ComBase);

  function Toast() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Toast);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _ComBase.call.apply(_ComBase, [this].concat(args))), _this), _this.state = { visible: false, collect: false }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Toast.prototype.render = function render() {
    var _cname;

    var names = (0, _common.cname)((_cname = {
      toast: true,
      aniTransition: true,
      widget: true,
      widgetShadow: true,
      cornerTl: true,
      cornerTr: true,
      cornerBl: true,
      cornerBr: true,
      stateHidden: !this.state.visible,
      stateVisible: this.state.visible,
      stateCollect: this.state.collect
    }, _cname['align-' + (this.props.align || 'right')] = true, _cname), this.props.className);
    return _react2.default.createElement(
      _Alert3.default,
      (0, _extends3.default)({}, this.props, {
        className: names, shadow: true }),
      _react2.default.createElement(_Icon3.default, { type: 'close', onClick: this.hide.bind(this) }),
      this.props.children || this.props.content
    );
  };

  Toast.prototype.show = function show() {
    this.setState({ visible: true });
  };

  Toast.prototype.hide = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.setState({ visible: false });
              _context.next = 3;
              return (0, _common.sleep)(COLLECT_DELAY);

            case 3:
              this.setState({ collect: true });
              if (this.props.onHide) {
                this.props.onHide(new _common.EventArgs(this, {
                  item: this,
                  dataItem: this.props.dataItem
                }));
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function hide() {
      return _ref.apply(this, arguments);
    }

    return hide;
  }();

  Toast.prototype.componentDidMount = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _common.sleep)(SHOW_DELAY);

            case 2:
              this.show();

              if (!(this.props.duration > 0)) {
                _context2.next = 7;
                break;
              }

              _context2.next = 6;
              return (0, _common.sleep)(this.props.duration);

            case 6:
              this.hide();

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function componentDidMount() {
      return _ref2.apply(this, arguments);
    }

    return componentDidMount;
  }();

  return Toast;
}(_common.ComBase);

var stack = void 0; //显示栈单例
var prevTime = 0;
var prevDuration = 0;

//toast 显示栈

var Stack = function (_ComBase2) {
  (0, _inherits3.default)(Stack, _ComBase2);

  function Stack() {
    var _temp2, _this2, _ret2;

    (0, _classCallCheck3.default)(this, Stack);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, _ComBase2.call.apply(_ComBase2, [this].concat(args))), _this2), _this2.state = { items: [] }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }

  Stack.prototype.render = function render() {
    var _this3 = this;

    return _react2.default.createElement(
      'div',
      { className: (0, _common.cname)('toast-stack') },
      this.state.items.map(function (item) {
        return _react2.default.createElement(
          Toast,
          (0, _extends3.default)({ key: item.key
          }, item, {
            dataItem: item,
            onHide: _this3.onHide.bind(_this3, item) }),
          item.content
        );
      })
    );
  };

  Stack.prototype.onHide = function onHide(item) {
    item.removed = true;
  };

  Stack.prototype.add = function add(newItem) {
    //拿到所有正在显示的项
    var items = this.state.items.filter(function (item) {
      return !item.removed;
    });
    //处理新项
    newItem.key = _common.utils.newGuid();
    newItem.duration = newItem.duration || SHOW_DURATION;
    //无论 duration 多少都确保先显示的先消失
    var prevPemainingTime = prevDuration - (Date.now() - prevTime);
    if (items.length > 0 && prevDuration > 0 && prevPemainingTime > 0 && newItem.duration - prevPemainingTime < HIDE_MIN_INTERVAL) {
      newItem.duration += HIDE_MIN_INTERVAL - (newItem.duration - prevPemainingTime);
    }
    items.push(newItem);
    this.setState({ items: items });
    //记录上次信息
    prevDuration = newItem.duration;
    prevTime = Date.now();
  };

  return Stack;
}(_common.ComBase);

// toast 方法


exports.default = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(content, opts) {
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (stack) {
              _context3.next = 4;
              break;
            }

            _context3.next = 3;
            return (0, _common.render)(_react2.default.createElement(Stack, null));

          case 3:
            stack = _context3.sent;

          case 4:
            opts = opts || {};
            opts.content = content || '';
            stack.add(opts);

          case 7:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  function toast(_x, _x2) {
    return _ref3.apply(this, arguments);
  }

  return toast;
}();

module.exports = exports['default'];

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
});
//# sourceMappingURL=aps.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(101), __esModule: true };

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(16) && !__webpack_require__(21)(function () {
  return Object.defineProperty(__webpack_require__(35)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(24);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(7);
var core = __webpack_require__(1);
var fails = __webpack_require__(21);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {



/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(25);
var $export = __webpack_require__(7);
var redefine = __webpack_require__(66);
var hide = __webpack_require__(17);
var Iterators = __webpack_require__(26);
var $iterCreate = __webpack_require__(111);
var setToStringTag = __webpack_require__(33);
var getPrototypeOf = __webpack_require__(115);
var ITERATOR = __webpack_require__(3)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(17);


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(18);
var toIObject = __webpack_require__(19);
var arrayIndexOf = __webpack_require__(113)(false);
var IE_PROTO = __webpack_require__(42)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(40);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(2).document;
module.exports = document && document.documentElement;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(24);
var TAG = __webpack_require__(3)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(70);
var ITERATOR = __webpack_require__(3)('iterator');
var Iterators = __webpack_require__(26);
module.exports = __webpack_require__(1).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(29);
var SPECIES = __webpack_require__(3)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(23);
var invoke = __webpack_require__(124);
var html = __webpack_require__(69);
var cel = __webpack_require__(35);
var global = __webpack_require__(2);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(24)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var isObject = __webpack_require__(15);
var newPromiseCapability = __webpack_require__(47);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _nextIcon = __webpack_require__(34);

var _nextIcon2 = _interopRequireDefault(_nextIcon);

var _classnames = __webpack_require__(12);

var _classnames2 = _interopRequireDefault(_classnames);

var _nextUtil = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Button = (_temp = _class = function (_Component) {
    _inherits(Button, _Component);

    function Button() {
        _classCallCheck(this, Button);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Button.prototype.onMouseUp = function onMouseUp(e) {
        _reactDom2['default'].findDOMNode(this).blur();

        if (this.props.onMouseUp) {
            this.props.onMouseUp(e);
        }
    };

    Button.prototype.getType = function getType() {
        var shape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'normal';
        var type = arguments[1];

        var typeMap = {
            ghost: {
                primary: 'dark',
                secondary: 'dark',
                normal: 'light',
                dark: 'dark',
                light: 'light'
            },
            warning: {
                primary: 'primary',
                secondary: 'normal',
                normal: 'normal',
                dark: 'primary',
                light: 'normal'
            },
            normal: {
                primary: 'primary',
                secondary: 'secondary',
                normal: 'normal',
                dark: 'primary',
                light: 'normal'
            }
        };
        var shapeMap = typeMap[shape] || typeMap.normal;

        return shapeMap[type];
    };

    Button.prototype.render = function render() {
        var _classNames;

        var _props = this.props,
            className = _props.className,
            type = _props.type,
            size = _props.size,
            htmlType = _props.htmlType,
            loading = _props.loading,
            children = _props.children,
            shape = _props.shape,
            component = _props.component,
            others = _objectWithoutProperties(_props, ['className', 'type', 'size', 'htmlType', 'loading', 'children', 'shape', 'component']);

        var prefix = this.context.prefix || this.props.prefix;
        var pickProps = (0, _nextUtil.pickAttrs)(others);
        var realType = this.getType(shape, type);

        // 样式
        var btnCls = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefix + 'btn', true), _defineProperty(_classNames, prefix + 'btn-' + shape, shape), _defineProperty(_classNames, prefix + 'btn-' + realType, realType), _defineProperty(_classNames, prefix + 'btn-' + size, size), _defineProperty(_classNames, prefix + 'btn-loading', loading), _defineProperty(_classNames, className, className), _classNames));

        var count = _react.Children.count(children);
        var cloneChildren = _react.Children.map(children, function (child, index) {
            if (child && child.type === _nextIcon2['default']) {
                var _classNames2;

                var iconCls = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, prefix + 'icon-first', count > 1 && index === 0), _defineProperty(_classNames2, prefix + 'icon-last', count > 1 && index === count - 1), _defineProperty(_classNames2, prefix + 'icon-alone', count === 1), _defineProperty(_classNames2, child.props.className, !!child.props.className), _classNames2));

                var iconSize = {
                    large: 'small',
                    medium: 'xs',
                    small: 'xs'
                }[size];

                return _react2['default'].cloneElement(child, {
                    className: iconCls,
                    size: child.props.size || iconSize
                });
            }

            return child;
        });

        // 自定义属性
        var TagName = component;
        var finalAttrs = {
            type: htmlType,
            className: btnCls
        };

        if (TagName === 'a') {
            delete finalAttrs.type;

            // a 标签在禁用状态下无跳转
            if (pickProps.disabled && pickProps.href) {
                delete pickProps.href;
            }
        }

        // 设置特殊tag name没有浏览器默认禁用行为
        if (pickProps.disabled) {
            delete pickProps.onClick;
        }

        return _react2['default'].createElement(
            TagName,
            _extends({}, pickProps, finalAttrs, { onMouseUp: this.onMouseUp.bind(this) }),
            cloneChildren
        );
    };

    return Button;
}(_react.Component), _class.propTypes = {
    prefix: _react.PropTypes.string,
    type: _react.PropTypes.oneOf(['primary', 'secondary', 'normal', 'dark', 'light']),
    size: _react.PropTypes.oneOf(['small', 'medium', 'large']),
    shape: _react.PropTypes.oneOf(['ghost', 'text', 'warning']),
    htmlType: _react.PropTypes.string,
    component: _react.PropTypes.oneOf(['button', 'span', 'a', 'div']),
    loading: _react.PropTypes.bool,
    onClick: _react.PropTypes.func,
    className: _react.PropTypes.string
}, _class.defaultProps = {
    prefix: 'next-',
    type: 'normal',
    size: 'medium',
    htmlType: 'button',
    component: 'button',
    loading: false,
    onClick: function onClick() {}
}, _class.contextTypes = {
    prefix: _react.PropTypes.string
}, _temp);
Button.displayName = 'Button';
exports['default'] = Button;
module.exports = exports['default'];

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.makeChain = function (left, right) {
    var args = [].slice.call(arguments, 0);
    if (args.length == 2 && !right || args.length == 1) {
        return left;
    }
    return function () {
        for (var i = args.length - 1; i >= 0; i--) {
            if (args[i] && typeof args[i] == 'function') {
                args[i].apply(this, arguments);
            }
        }
    };
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(12);

var _classnames2 = _interopRequireDefault(_classnames);

var _nextUtil = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ButtonGroup = (_temp = _class = function (_Component) {
    _inherits(ButtonGroup, _Component);

    function ButtonGroup() {
        _classCallCheck(this, ButtonGroup);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ButtonGroup.prototype.render = function render() {
        var _classNames;

        var _props = this.props,
            className = _props.className,
            children = _props.children,
            size = _props.size,
            others = _objectWithoutProperties(_props, ['className', 'children', 'size']);

        var prefix = this.context.prefix || this.props.prefix;

        var groupCls = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefix + 'btn-group', true), _defineProperty(_classNames, className, className), _classNames));

        var cloneChildren = _react.Children.map(children, function (child) {
            if (child) {
                return _react2['default'].cloneElement(child, {
                    size: size
                });
            }
        });

        return _react2['default'].createElement(
            'div',
            _extends({}, (0, _nextUtil.pickAttrs)(others), { className: groupCls }),
            cloneChildren
        );
    };

    return ButtonGroup;
}(_react.Component), _class.propTypes = {
    prefix: _react.PropTypes.string,
    size: _react.PropTypes.string
}, _class.defaultProps = {
    prefix: 'next-',
    size: 'medium'
}, _class.contextTypes = {
    prefix: _react.PropTypes.string
}, _temp);
ButtonGroup.displayName = 'ButtonGroup';
exports['default'] = ButtonGroup;
module.exports = exports['default'];

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _nextDom = __webpack_require__(51);

var _nextUtil = __webpack_require__(22);

var _position = __webpack_require__(82);

var _position2 = _interopRequireDefault(_position);

var _classnames3 = __webpack_require__(12);

var _classnames4 = _interopRequireDefault(_classnames3);

var _manager = __webpack_require__(152);

var _manager2 = _interopRequireDefault(_manager);

var _gateway = __webpack_require__(83);

var _gateway2 = _interopRequireDefault(_gateway);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PropTypes = _react2['default'].PropTypes,
    Children = _react2['default'].Children,
    noop = function noop() {},
    saveLastFocusNode = _nextUtil.focus.saveLastFocusNode,
    getFocusNodeList = _nextUtil.focus.getFocusNodeList,
    backLastFocusNode = _nextUtil.focus.backLastFocusNode,
    ANIMATION_CLS = 'animated';

// <Overlay>
//  <content></content>
// </Overlay>
var Overlay = (_temp = _class = function (_React$Component) {
    _inherits(Overlay, _React$Component);

    Overlay.prototype.getPrefix = function getPrefix() {
        return this.context.prefix || this.props.prefix;
    };

    function Overlay(props, context) {
        _classCallCheck(this, Overlay);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

        _this.state = {
            visible: props.visible
        };
        _this.Manager = _manager2['default'];
        _this._onDocumentKeyDown = _this._onDocumentKeyDown.bind(_this);
        _this._onDocumentClick = _this._onDocumentClick.bind(_this);
        _this._onMaskClick = _this._onMaskClick.bind(_this);
        _this._safeClickNode = [];
        return _this;
    }

    Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.animation) {
            if (!this.state.visible && nextProps.visible) {
                this.enter();
            } else if (this.state.visible && !nextProps.visible) {
                this.leave();
            } else if (this.hasEntered) {
                this.keep();
            }
        } else {
            this.setState({
                visible: nextProps.visible
            });
        }
    };

    Overlay.prototype.componentWillMount = function componentWillMount() {
        if (this.props.visible && this.props.animation) {
            this.enter();
        }
        this.onAnimateEnd = this.onAnimateEnd.bind(this);
        this._throwPropEvents(this.props, this.state);
    };

    Overlay.prototype._initAnimationEvents = function _initAnimationEvents() {
        var node = this.getContentNode();
        if (node && this.props.animation) {
            if (_nextUtil.support.animation) {
                this._animation = _nextDom.events.on(node, _nextUtil.support.animation.end, this.onAnimateEnd);
            } else {
                if (this._animation) {
                    clearTimeout(this._animation);
                }
                this._animation = setTimeout(this.onAnimateEnd, 10);
            }
        }
    };

    Overlay.prototype.enter = function enter() {
        var _this2 = this;

        this.setState({
            visible: true,
            animationType: 'in'
        }, function () {
            _this2.onEntering && _this2.onEntering();
        });
    };

    Overlay.prototype.leave = function leave() {
        if (this._animation) {
            this.setState({
                animationType: 'out'
            });
            this.onLeaving && this.onLeaving();
        } else {
            this.setState({
                visible: false
            });
        }
    };

    Overlay.prototype.keep = function keep() {
        this.setState({
            animationType: 'none'
        });
    };

    Overlay.prototype.onAnimateEnd = function onAnimateEnd() {
        if (this.state.animationType === 'out') {
            this.setState({
                visible: false
            });
            this.onLeaved && this.onLeaved();
            this.hasEntered = false;
        } else {
            this.onEntered && this.onEntered();
            this.hasEntered = true;
        }
    };

    Overlay.prototype.getAnimationCls = function getAnimationCls(config) {
        var className = void 0;
        switch (this.state.animationType) {
            case 'in':
                className = ANIMATION_CLS + ' ' + config['in'];
                break;
            case 'out':
                className = ANIMATION_CLS + ' ' + config.out;
                break;
            case 'none':
                className = '';
        }
        return className;
    };

    Overlay.prototype.getContentNode = function getContentNode() {
        return _reactDom2['default'].findDOMNode(this.getContent());
    };

    Overlay.prototype.getContent = function getContent() {
        return this.refs[this.contentRef];
    };

    Overlay.prototype.getWrapperNode = function getWrapperNode() {
        return this.refs.gateway.getContentNode();
    };

    Overlay.prototype.getContentRef = function getContentRef(child) {
        return child.ref ? child.ref : 'content';
    };

    Overlay.prototype.render = function render() {
        /* eslint-disable no-unused-vars */
        var _props = this.props,
            animation = _props.animation,
            cache = _props.cache,
            container = _props.container,
            className = _props.className,
            hasMask = _props.hasMask,
            shouldUpdatePosition = _props.shouldUpdatePosition,
            target = _props.target,
            offset = _props.offset,
            align = _props.align,
            onPosition = _props.onPosition,
            beforePosition = _props.beforePosition,
            needAdjust = _props.needAdjust,
            children = _props.children,
            safeId = _props.safeId,
            canCloseByOutSideClick = _props.canCloseByOutSideClick,
            canCloseByEsc = _props.canCloseByEsc,
            visible = _props.visible,
            beforeOpen = _props.beforeOpen,
            beforeClose = _props.beforeClose,
            afterOpen = _props.afterOpen,
            afterClose = _props.afterClose,
            onOpen = _props.onOpen,
            onClose = _props.onClose,
            onRequestClose = _props.onRequestClose,
            wrapperCls = _props.wrapperClassName,
            others = _objectWithoutProperties(_props, ['animation', 'cache', 'container', 'className', 'hasMask', 'shouldUpdatePosition', 'target', 'offset', 'align', 'onPosition', 'beforePosition', 'needAdjust', 'children', 'safeId', 'canCloseByOutSideClick', 'canCloseByEsc', 'visible', 'beforeOpen', 'beforeClose', 'afterOpen', 'afterClose', 'onOpen', 'onClose', 'onRequestClose', 'wrapperClassName']),
            prefix = this.getPrefix(),
            animationCls = void 0,
            cls = void 0,
            child = void 0,
            wrapperClassName = void 0,
            style = {
            display: this.state.visible ? '' : 'none'
        };

        children = this.state.visible || cache && this._isMounted ? children : null;

        if (animation) {
            animationCls = this.getAnimationCls(animation);
        } else {
            animationCls = false;
        }
        if (children) {
            var _classnames, _classnames2;

            child = Children.only(children);
            cls = (0, _classnames4['default'])((_classnames = {}, _defineProperty(_classnames, prefix + 'overlay-inner', true), _defineProperty(_classnames, animationCls, animationCls), _defineProperty(_classnames, child.props.className, child.props.className), _defineProperty(_classnames, className, className), _classnames)), wrapperClassName = (0, _classnames4['default'])((_classnames2 = {}, _defineProperty(_classnames2, prefix + 'overlay-wrapper', true), _defineProperty(_classnames2, wrapperCls, wrapperCls), _classnames2));

            this.contentRef = this.getContentRef(child);

            children = _react2['default'].cloneElement(child, {
                className: cls,
                ref: this.contentRef,
                id: child.props.id ? child.props.id : safeId
            });

            if (this.state.animationType === 'out') {
                shouldUpdatePosition = false;
            }

            if (this.props.align) {
                children = _react2['default'].createElement(
                    _position2['default'],
                    {
                        target: target,
                        offset: offset,
                        align: align,
                        beforePosition: beforePosition,
                        onPosition: onPosition,
                        needAdjust: needAdjust,
                        shouldUpdatePosition: shouldUpdatePosition },
                    children
                );
            }
            children = _react2['default'].createElement(
                'div',
                { className: wrapperClassName, style: style },
                hasMask ? _react2['default'].createElement('div', { className: prefix + 'overlay-backdrop', onClick: this._onMaskClick }) : null,
                children
            );
        }
        return _react2['default'].createElement(
            _gateway2['default'],
            { container: container, ref: 'gateway' },
            children
        );
    };

    Overlay.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
        this._throwPropEvents(nextProps, nextState);
        this._isMounted = true;
    };

    Overlay.prototype._throwPropEvents = function _throwPropEvents(props, state) {
        if (state.visible) {
            props.beforeOpen();
        } else {
            props.beforeClose();
        }
    };

    Overlay.prototype.componentDidMount = function componentDidMount() {
        if (this.props.canCloseByEsc) {
            _nextDom.events.on(document, 'keydown', this._onDocumentKeyDown);
        }

        if (this.props.canCloseByOutSideClick) {
            _nextDom.events.on(document, 'click', this._onDocumentClick);
        }
        //如果设置了动画，需要等到动画执行完毕再设置焦点
        //使用onEntered方法
        this.componentDidUpdate();
    };

    Overlay.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var wrapperNode = this.getWrapperNode();
        if (!this.props.animation) {
            this._setFocusNode(prevProps, prevState);
            if (this.state.visible) {
                this.props.onOpen();
                this.props.afterOpen();
                wrapperNode && _nextDom.classList.addClass(wrapperNode, 'opened');
                _manager2['default'].addOverlay(this);
            } else if (prevState && prevState.visible === true) {
                this.props.onClose();
                this.props.afterClose();
                wrapperNode && _nextDom.classList.removeClass(wrapperNode, 'opened');
                _manager2['default'].removeOverlay(this);
            }
        }
        this.prevProps = prevProps;
        this.prevState = prevState;
        this._initAnimationEvents();
    };

    Overlay.prototype.onEntering = function onEntering() {
        var wrapperNode = this.getWrapperNode();
        this.props.onOpen();
        _nextDom.classList.addClass(wrapperNode, 'opened');
    };

    Overlay.prototype.onLeaving = function onLeaving() {
        var wrapperNode = this.getWrapperNode();
        this.props.onClose();
        _nextDom.classList.removeClass(wrapperNode, 'opened');
    };

    Overlay.prototype.onEntered = function onEntered() {
        this._setFocusNode(this.prevProps, this.prevState);
        this.props.afterOpen();
        _manager2['default'].addOverlay(this);
    };

    Overlay.prototype.onLeaved = function onLeaved() {
        this._setFocusNode(this.prevProps, this.prevState);
        this.props.afterClose();
        _manager2['default'].removeOverlay(this);
    };

    //保留弹出层之前的焦点
    //当弹层消失的时候返回之前的焦点


    Overlay.prototype._setFocusNode = function _setFocusNode(prevProps, prevState) {
        var _this3 = this;

        var oldState = prevState || {};
        if (this.props.autoFocus) {
            if (this.state.visible && !this._hasFocused) {
                saveLastFocusNode();
                //这个时候很可能上一个弹层的关闭事件还未触发，导致焦点已经back触发的元素
                //这里延时处理一下，延时的时间为document.click捕获触发的延时时间
                this.focusTimeout = setTimeout(function () {
                    var node = _this3.getContentNode();

                    if (node) {
                        var focusNodeList = getFocusNodeList(node);
                        if (focusNodeList.length) {
                            focusNodeList[0].focus();
                        }
                        _this3._hasFocused = true;
                    }
                }, 100);
            } else if (!this.state.visible && this._hasFocused) {
                backLastFocusNode();
                this._hasFocused = false;
            }
        }
    };

    Overlay.prototype.componentWillUnmount = function componentWillUnmount() {
        _manager2['default'].removeOverlay(this);
        this._isMounted = false;
        if (this.props.canCloseByEsc) {
            _nextDom.events.off(document, 'keydown', this._onDocumentKeyDown);
        }
        if (this.props.canCloseByOutSideClick) {
            _nextDom.events.off(document, 'click', this._onDocumentClick);
        }
        if (this.focusTimeout) {
            clearTimeout(this.focusTimeout);
        }
        if (this._animation) {
            if (this._animation.off) {
                this._animation.off();
            } else {
                clearTimeout(this._animation);
            }
            this._animation = null;
        }
    };

    Overlay.prototype._onMaskClick = function _onMaskClick(e) {
        if (this.props.canCloseByMask) {
            this.props.onRequestClose('maskClick', e);
        }
    };

    Overlay.prototype._getSafeNode = function _getSafeNode(safeNode) {
        if (typeof safeNode === 'function') {
            safeNode = safeNode(this.props);
        }
        if (typeof safeNode === 'string') {
            safeNode = document.getElementById(safeNode);
        } else {
            try {
                safeNode = _reactDom2['default'].findDOMNode(safeNode);
            } catch (e) {}
        }

        return safeNode;
    };

    Overlay.prototype._onDocumentKeyDown = function _onDocumentKeyDown(e) {
        if (e.keyCode === 27 && this.state.visible) {
            if (this.Manager && this.Manager.isCurrentOverlay(this) || !this.Manager) {
                this.props.onRequestClose('keyboard', e);
            }
        }
    };

    Overlay.prototype._onDocumentClick = function _onDocumentClick(e) {

        if (this.state.visible) {
            this.initSafeNode();
            for (var i = 0; i < this._safeClickNode.length; i++) {
                var node = this._safeClickNode[i],
                    nodeGroup = node.getAttribute('data-overlay-group'),
                    _target = e.target,
                    targetGroup = _target.getAttribute && _target.getAttribute('data-overlay-group') || '';
                if (node.contains(_target) || nodeGroup === targetGroup || node === _target || !document.documentElement.contains(e.target)) {
                    return;
                }
            }
            this.props.onRequestClose('docClick', e);
        }
    };

    Overlay.prototype.initSafeNode = function initSafeNode() {
        var node = this.getWrapperNode && this.getWrapperNode() || _reactDom2['default'].findDOMNode(this),
            safeNode = this.props.safeNode;


        if (Array.isArray(safeNode)) {
            safeNode.push(node);
        } else {
            safeNode = [node, safeNode];
        }
        this.addNodeForSafeClick(safeNode);
    };

    Overlay.prototype.addNodeForSafeClick = function addNodeForSafeClick(node) {
        var _this4 = this;

        if (Array.isArray(node)) {
            node.forEach(function (n) {
                _this4.addNodeForSafeClick(n);
            });
        } else {
            var safeNode = this._getSafeNode(node);
            if (safeNode && this._safeClickNode.indexOf(safeNode) == -1) {
                this._safeClickNode.push(safeNode);
            }
        }
    };

    return Overlay;
}(_react2['default'].Component), _class.propTypes = {
    visible: PropTypes.bool,
    canCloseByEsc: PropTypes.bool,
    canCloseByOutSideClick: PropTypes.bool,
    canCloseByMask: PropTypes.bool,
    animation: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    target: PropTypes.any,
    align: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    offset: PropTypes.array,
    beforeClose: PropTypes.func,
    afterClose: PropTypes.func,
    beforeOpen: PropTypes.func,
    afterOpen: PropTypes.func,
    onRequestClose: PropTypes.func,
    onPosition: PropTypes.func,
    autoFocus: PropTypes.bool,
    hasMask: PropTypes.bool,
    prefix: PropTypes.string,
    cache: PropTypes.bool,
    safeId: PropTypes.string,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    safeNode: PropTypes.any,
    wrapperClassName: PropTypes.string
}, _class.defaultProps = {
    align: 'tl bl',
    offset: [0, 0],
    visible: false,
    canCloseByEsc: true,
    canCloseByOutSideClick: true,
    canCloseByMask: true,
    target: _position2['default'].VIEWPORT,
    animation: {
        'in': 'expandInDown',
        out: 'expandOutUp'
    },
    beforeClose: noop,
    afterClose: noop,
    onRequestClose: noop,
    beforeOpen: noop,
    onOpen: noop,
    onClose: noop,
    afterOpen: noop,
    onPosition: noop,
    autoFocus: false,
    hasMask: false,
    prefix: 'next-',
    cache: false,
    safeId: null
}, _class.contextTypes = {
    prefix: PropTypes.string
}, _temp);
Overlay.displayName = 'Overlay';
exports['default'] = Overlay;
module.exports = exports['default'];

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PIXEL_PATTERN = /margin|padding|width|height|max|min|offset/;

var getComputedStyle = function getComputedStyle(node) {
    return node.nodeType == 1 ? node.ownerDocument.defaultView.getComputedStyle(node, null) : {};
},
    removePixel = {
    left: true,
    top: true
},
    getStyleValue = function getStyleValue(node, type, value) {
    type = type.toLowerCase();
    if (value === 'auto') {
        if (type === 'height') {
            return node.offsetHeight;
        }
        if (type === 'width') {
            return node.offsetWidth;
        }
    }
    if (!(type in removePixel)) {
        removePixel[type] = PIXEL_PATTERN.test(type);
    }
    return removePixel[type] ? parseFloat(value) || 0 : value;
},
    floatMap = {
    cssFloat: 1,
    styleFloat: 1,
    float: 1
};

function camelize(name) {
    return name.replace(/-(.)/g, function ($0, $1) {
        return $1.toUpperCase();
    });
}

function hyphenate(name) {
    return name.replace(/[A-Z]/g, function ($1) {
        return '-' + $1.toLowerCase();
    });
}

function getStyle(node, name) {
    var length = arguments.length,
        style = getComputedStyle(node);

    name = floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;

    return length === 1 ? style : getStyleValue(node, name, style.getPropertyValue(hyphenate(name)) || node.style[camelize(name)]);
}

function setStyle(node, name, value) {
    var length = arguments.length;
    name = floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
    if (length === 3) {
        if (typeof value === 'number' && PIXEL_PATTERN.test(name)) {
            value = value + 'px';
        }
        return node.style[camelize(name)] = value; // IE8 support.
    }
    for (var x in name) {
        setStyle(node, x, name[x]);
    }
    return getComputedStyle(node);
}

function getOuterWidth(el) {
    if (el === document.body) {
        return document.documentElement.clientWidth;
    }
    return el.offsetWidth;
}

function getOuterHeight(el) {
    if (el === document.body) {
        return window.innerHeight || document.documentElement.clientHeight;
    }
    return el.offsetHeight;
}

function getDocSize() {
    var width = Math.max(document.documentElement.scrollWidth, document.body.scrollWidth),
        height = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);

    return {
        width: width,
        height: height
    };
}

function getClientSize() {
    var width = document.documentElement.clientWidth,
        height = window.innerHeight || document.documentElement.clientHeight;

    return {
        width: width,
        height: height
    };
}

function getScroll() {
    return {
        scrollLeft: Math.max(document.documentElement.scrollLeft, document.body.scrollLeft),
        scrollTop: Math.max(document.documentElement.scrollTop, document.body.scrollTop)
    };
}

function getOffset(node) {
    var box = node.getBoundingClientRect(),
        docElem = document.documentElement;

    return {
        left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
        top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
    };
}

module.exports = {
    set: setStyle,
    get: getStyle,
    getOuterWidth: getOuterWidth,
    getOuterHeight: getOuterHeight,
    getDocSize: getDocSize,
    getClientSize: getClientSize,
    getScroll: getScroll,
    getOffset: getOffset
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _nextDom = __webpack_require__(51);

var _classnames2 = __webpack_require__(12);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PropTypes = _react2['default'].PropTypes,
    Children = _react2['default'].Children,
    place = _nextDom.position.place,
    noop = function noop() {};

var Position = (_temp = _class = function (_React$Component) {
    _inherits(Position, _React$Component);

    function Position(props) {
        _classCallCheck(this, Position);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        ['resize', 'setPosition'].forEach(function (method) {
            _this[method] = _this[method].bind(_this);
        });
        return _this;
    }

    Position.prototype.resize = function resize() {
        var _this2 = this;

        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(function () {
            _this2.setPosition();
        }, 200);
    };

    Position.prototype.render = function render() {
        var _classnames;

        var child = Children.only(this.props.children),
            propClassName = this.props.className,
            childClassName = child.props.className,
            className = (0, _classnames3['default'])((_classnames = {}, _defineProperty(_classnames, propClassName, propClassName), _defineProperty(_classnames, childClassName, childClassName), _classnames));

        return _react2['default'].cloneElement(child, {
            className: className
        });
    };

    Position.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if ('align' in nextProps && nextProps.align !== this.props.align || nextProps.shouldUpdatePosition) {
            this.shouldUpdatePosition = true;
        }
    };

    Position.prototype.componentDidMount = function componentDidMount() {
        this.setPosition();
        if (this.props.needListenResize) {
            _nextDom.events.on(window, 'resize', this.resize);
        }
    };

    Position.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.props.needListenResize) {
            _nextDom.events.off(window, 'resize', this.resize);
        }
    };

    Position.prototype.componentDidUpdate = function componentDidUpdate() {
        if (this.shouldUpdatePosition) {
            this.setPosition();
            this.shouldUpdatePosition = false;
        }
    };

    Position.prototype.setPosition = function setPosition() {
        var align = this.props.align,
            offset = this.props.offset,
            contentNode = this.getContentNode(),
            target = this.getTarget();

        this.props.beforePosition();
        if (target && contentNode) {
            var resultAlign = place(contentNode, target, align, offset, this.props.needAdjust, this.props.isRtl);
            var left = _nextDom.style.get(contentNode, 'left'),
                top = _nextDom.style.get(contentNode, 'top');

            this.props.onPosition({
                left: left,
                top: top,
                align: resultAlign.split(' ')
            }, contentNode);
        }
    };

    Position.prototype.getContentNode = function getContentNode() {
        return _reactDom2['default'].findDOMNode(this);
    };

    Position.prototype.getTarget = function getTarget() {
        var target = this.props.target;
        if (!target) {
            return null;
        }
        if (typeof target === 'function') {
            target = target(this.props);
        }
        if (typeof target === 'string' && target !== _nextDom.position.VIEWPORT) {
            target = document.getElementById(target);
        } else {
            try {
                target = _reactDom2['default'].findDOMNode(target);
            } catch (err) {}
        }
        return target;
    };

    return Position;
}(_react2['default'].Component), _class.propTypes = {
    target: PropTypes.any,
    contentNode: PropTypes.any,
    align: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    offset: PropTypes.array,
    beforePosition: PropTypes.func,
    onPosition: PropTypes.func,
    needAdjust: PropTypes.bool,
    needListenResize: PropTypes.bool,
    shouldUpdatePosition: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.any,
    isRtl: PropTypes.bool
}, _class.defaultProps = {
    align: 'tl bl',
    offset: [0, 0],
    isRtl: false,
    beforePosition: noop,
    onPosition: noop,
    needAdjust: true,
    needListenResize: true,
    shouldUpdatePosition: false
}, _temp);
Position.displayName = 'Position';
exports['default'] = Position;


Position.VIEWPORT = _nextDom.position.VIEWPORT;
module.exports = exports['default'];

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _class, _temp; //将DOM元素渲染到指定的容器

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PropTypes = _react2['default'].PropTypes,
    Children = _react2['default'].Children;

//<body> [containerNode]
//  <div>
//      <content></content>  [contentNode]
// </div>  [wrapperNode]
// </body>

var Gateway = (_temp = _class = function (_React$Component) {
    _inherits(Gateway, _React$Component);

    function Gateway() {
        _classCallCheck(this, Gateway);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    Gateway.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
        if (this.wrapper && newProps.container !== this.props.container) {
            this.getContainerNode(newProps).appendChild(this.wrapper);
        }
    };

    Gateway.prototype.componentDidMount = function componentDidMount() {
        this._renderOverlay();
    };

    Gateway.prototype.componentDidUpdate = function componentDidUpdate() {
        this._renderOverlay();
    };

    Gateway.prototype.componentWillUnmount = function componentWillUnmount() {
        this._unRenderWrapper();
    };

    Gateway.prototype._renderOverlay = function _renderOverlay() {
        var children = this.props.children ? Children.only(this.props.children) : null;
        if (children) {
            this._renderWrapper();
            this._overlay = _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, children, this.wrapper);
        } else {
            this._unRenderWrapper();
        }
    };

    Gateway.prototype._renderWrapper = function _renderWrapper() {
        if (!this.wrapper) {
            this.wrapper = document.createElement('div');
            this.getContainerNode().appendChild(this.wrapper);
        }
    };

    Gateway.prototype._unRenderWrapper = function _unRenderWrapper() {
        if (this.wrapper) {
            _reactDom2['default'].unmountComponentAtNode(this.wrapper);
            this.getContainerNode().removeChild(this.wrapper);
            this._overlay = null;
            this.wrapper = null;
        }
    };

    Gateway.prototype.getContainerNode = function getContainerNode(props) {
        var _ref = props || this.props,
            container = _ref.container;

        if (typeof container === 'function') {
            container = container();
        }
        if (typeof container === 'string') {
            container = document.getElementById(container);
        } else {
            try {
                container = _reactDom2['default'].findDOMNode(container);
            } catch (err) {}
        }
        return container;
    };

    Gateway.prototype.getContentNode = function getContentNode() {
        if (this._overlay) {
            return _reactDom2['default'].findDOMNode(this._overlay);
        }
    };

    Gateway.prototype.getWrapperNode = function getWrapperNode() {
        return this.wrapper;
    };

    Gateway.prototype.render = function render() {
        return null;
    };

    return Gateway;
}(_react2['default'].Component), _class.propTypes = {
    container: PropTypes.any,
    children: PropTypes.any
}, _class.defaultProps = {
    container: function container() {
        return document.body;
    }
}, _temp);
Gateway.displayName = 'Gateway';
exports['default'] = Gateway;
module.exports = exports['default'];

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _classnames = __webpack_require__(12);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _nextIcon = __webpack_require__(34);

var _nextIcon2 = _interopRequireDefault(_nextIcon);

var _nextUtil = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PropTypes = _react2['default'].PropTypes,
    Children = _react2['default'].Children,
    noop = function noop() {},
    getPrivateDialogProperty = function getPrivateDialogProperty(name) {
    return '_dialog' + (name.charAt(0).toUpperCase() + name.substr(1)) + 'Id';
};
var uuid = 0;

var DialogInner = (_temp = _class = function (_React$Component) {
    _inherits(DialogInner, _React$Component);

    function DialogInner(props, context) {
        _classCallCheck(this, DialogInner);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

        ['header', 'body', 'footer'].forEach(function (name) {
            _this[getPrivateDialogProperty(name)] = 'dialog-' + name + '-' + uuid++;
        });
        return _this;
    }

    DialogInner.prototype.render = function render() {
        var _classNames;

        var _props = this.props,
            children = _props.children,
            className = _props.className,
            footerAlign = _props.footerAlign,
            closable = _props.closable,
            role = _props.role,
            others = _objectWithoutProperties(_props, ['children', 'className', 'footerAlign', 'closable', 'role']),
            prefix = this.context.prefix || this.props.prefix,
            content = this._getContent(),
            cls = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefix + 'dialog', true), _defineProperty(_classNames, footerAlign, footerAlign), _defineProperty(_classNames, className, className), _classNames)),
            closeContent = closable ? _react2['default'].createElement(
            'a',
            { href: 'javascript:;', className: prefix + 'dialog-close',
                onClick: this.onClose.bind(this) },
            _react2['default'].createElement(_nextIcon2['default'], { type: 'close', size: 'small' })
        ) : null;

        others = (0, _nextUtil.pickAttrs)(others);

        return _react2['default'].createElement(
            'div',
            _extends({}, others, {
                className: cls,
                role: role,
                'aria-labelledby': content.header ? content.header.props.id : '' }),
            content.header,
            content.body,
            content.footer,
            closeContent
        );
    };

    DialogInner.prototype._getContent = function _getContent() {
        var _this2 = this;

        var children = this.props.children,
            result = {};

        Children.forEach(children, function (child) {
            if (child && child.type.dialogMark) {
                var name = child.type.dialogMark.toLowerCase();
                result[name] = _react2['default'].cloneElement(child, {
                    ref: name,
                    id: _this2[getPrivateDialogProperty(name)]
                });
            }
        });
        return result;
    };

    DialogInner.prototype.getHeader = function getHeader() {
        return _reactDom2['default'].findDOMNode(this.refs.header);
    };

    DialogInner.prototype.getBody = function getBody() {
        return _reactDom2['default'].findDOMNode(this.refs.body);
    };

    DialogInner.prototype.getFooter = function getFooter() {
        return _reactDom2['default'].findDOMNode(this.refs.footer);
    };

    DialogInner.prototype.onClose = function onClose(e) {
        this.props.onClose('fromCloseBtn');
        e.preventDefault();
    };

    return DialogInner;
}(_react2['default'].Component), _class.propTypes = {
    prefix: PropTypes.string,
    footerAlign: PropTypes.oneOf(['left', 'center', 'right']),
    className: PropTypes.string,
    closable: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    children: PropTypes.any,
    onClose: PropTypes.func
}, _class.defaultProps = {
    prefix: 'next-',
    onClose: noop,
    footerAlign: 'right',
    role: 'dialog',
    closable: true
}, _class.contextTypes = {
    prefix: PropTypes.string
}, _temp);
DialogInner.displayName = 'DialogInner';
exports['default'] = DialogInner;
module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var LOCALE_CACHE = 'zh-cn';

var COMPONENTS_LOCALE_CACHE = {};

var getDisplayName = function getDisplayName(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' ? Component : 'Component');
};

var Locale = function Locale(Component) {
    var LocaleProvider = function (_React$Component) {
        _inherits(LocaleProvider, _React$Component);

        function LocaleProvider() {
            _classCallCheck(this, LocaleProvider);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        LocaleProvider.prototype.render = function render() {
            var _props = this.props,
                language = _props.language,
                locale = _props.locale,
                others = _objectWithoutProperties(_props, ['language', 'locale']);

            var defaultLocale = void 0,
                displayName = void 0,
                cacheLocale = void 0,
                resultLocale = void 0;

            if (!language) {
                language = Locale.get();
            }

            // 获取组件挂载的默认多语言文案，增加英文兜底
            defaultLocale = LocaleProvider.LOCALE && (LocaleProvider.LOCALE[language] || LocaleProvider.LOCALE['en-us']);

            // 组件名称
            displayName = getDisplayName(Component);

            // 缓存的多语言文案
            cacheLocale = COMPONENTS_LOCALE_CACHE[displayName] ? COMPONENTS_LOCALE_CACHE[displayName] : {};

            // 最终的多语言文案
            resultLocale = locale ? _extends({}, defaultLocale, cacheLocale, locale) : _extends({}, defaultLocale, cacheLocale);

            others.ref = this._getInstance.bind(this);

            return _react2['default'].createElement(Component, _extends({ locale: resultLocale, language: language }, others));
        };

        LocaleProvider.prototype._getInstance = function _getInstance(componentInstance) {
            if (componentInstance) {
                this.refs = componentInstance.refs;
                this._instance = componentInstance;
            }
        };

        LocaleProvider.prototype.getInstance = function getInstance() {
            return this._instance;
        };

        return LocaleProvider;
    }(_react2['default'].Component);

    LocaleProvider.displayName = 'LocaleProvider';


    Locale.init(LocaleProvider);
    LocaleProvider.displayName = 'LocaleProvider(' + getDisplayName(Component) + ')';

    return LocaleProvider;
};

Locale.init = function (Component) {
    Component.LOCALE = Component.LOCALE || {};
};

Locale.set = function (lang) {
    LOCALE_CACHE = lang;
};

Locale.get = function () {
    return LOCALE_CACHE;
};

Locale.setComponents = function (locales) {
    COMPONENTS_LOCALE_CACHE = _extends({}, COMPONENTS_LOCALE_CACHE, locales);
};

exports['default'] = Locale;
module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _nextIcon = __webpack_require__(34);

var _nextIcon2 = _interopRequireDefault(_nextIcon);

var _classnames = __webpack_require__(12);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var typesMap = {
    success: 'success',
    prompt: 'warning',
    error: 'error',
    help: 'help',
    loading: 'loading'
};

var ieVersion = typeof document === 'undefined' ? false : document.documentMode;

var Feedback = (_temp = _class = function (_Component) {
    _inherits(Feedback, _Component);

    function Feedback() {
        _classCallCheck(this, Feedback);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Feedback.prototype.render = function render() {
        var _classNames;

        var prefix = this.context.prefix || this.props.prefix;
        /* eslint-disable no-unused-vars */

        var _props = this.props,
            propsPrefix = _props.prefix,
            type = _props.type,
            shape = _props.shape,
            size = _props.size,
            visible = _props.visible,
            title = _props.title,
            children = _props.children,
            className = _props.className,
            others = _objectWithoutProperties(_props, ['prefix', 'type', 'shape', 'size', 'visible', 'title', 'children', 'className']);
        /* eslint-enable */


        var feedbackPrefix = prefix + 'feedback';
        var iconType = typesMap[type];
        var classes = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, feedbackPrefix, true), _defineProperty(_classNames, feedbackPrefix + '-' + type, type), _defineProperty(_classNames, feedbackPrefix + '-' + shape, shape), _defineProperty(_classNames, feedbackPrefix + '-' + size, size), _defineProperty(_classNames, feedbackPrefix + '-title-content', !!title), _defineProperty(_classNames, feedbackPrefix + '-only-content', !title && !!children), _defineProperty(_classNames, feedbackPrefix + '-ie8', ieVersion === 8), _defineProperty(_classNames, feedbackPrefix + '-hide', !visible), _defineProperty(_classNames, className, className), _classNames));

        return _react2['default'].createElement(
            'div',
            _extends({}, others, { className: classes }),
            _react2['default'].createElement(_nextIcon2['default'], { className: feedbackPrefix + '-symbol', type: iconType }),
            title && _react2['default'].createElement(
                'div',
                { className: feedbackPrefix + '-title' },
                title
            ),
            children && _react2['default'].createElement(
                'div',
                { className: feedbackPrefix + '-content' },
                children
            )
        );
    };

    return Feedback;
}(_react.Component), _class.contextTypes = {
    prefix: _react2['default'].PropTypes.string
}, _class.propTypes = {
    prefix: _react2['default'].PropTypes.string,
    type: _react2['default'].PropTypes.oneOf(['success', 'error', 'prompt', 'help', 'loading']),
    shape: _react2['default'].PropTypes.oneOf(['inline', 'addon', 'toast']),
    size: _react2['default'].PropTypes.oneOf(['medium', 'large']),
    visible: _react2['default'].PropTypes.bool,
    className: _react2['default'].PropTypes.string,
    title: _react2['default'].PropTypes.any,
    children: _react2['default'].PropTypes.any
}, _class.defaultProps = {
    prefix: 'next-',
    type: 'success',
    shape: 'inline',
    size: 'medium',
    visible: true,
    title: ''
}, _temp);
Feedback.displayName = 'Feedback';
exports['default'] = Feedback;
module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    'en-us': {
        ok: 'Ok',
        cancel: 'Cancel'
    },
    'zh-cn': {
        ok: '确认',
        cancel: '取消'
    },
    'zh-tw': {
        ok: '確認',
        cancel: '取消'
    }
};
module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(161), __esModule: true };

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(162), __esModule: true };

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(67);
var hiddenKeys = __webpack_require__(44).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(172), __esModule: true };

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(4);
var settle = __webpack_require__(191);
var buildURL = __webpack_require__(193);
var parseHeaders = __webpack_require__(194);
var isURLSameOrigin = __webpack_require__(195);
var createError = __webpack_require__(94);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(196);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if (process.env.NODE_ENV !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(197);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(192);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.5+7f2b526d
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var TRY_CATCH_ERROR = { error: null };

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    TRY_CATCH_ERROR.error = error;
    return TRY_CATCH_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === TRY_CATCH_ERROR) {
      reject(promise, TRY_CATCH_ERROR.error);
      TRY_CATCH_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(76)))

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _defineProperty = __webpack_require__(60);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(103);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(132);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

var _mobx = __webpack_require__(48);

var _dashboardService = __webpack_require__(133);

var dashboardService = _interopRequireWildcard(_dashboardService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var _window$$ACE = window.$ACE,
    Account = _window$$ACE.Account,
    Tracker = _window$$ACE.Tracker;

//去重

function unique(arr) {
  var newArr = [];
  for (var i = 0; i < arr.length; i++) {
    if (newArr.indexOf(arr[i]) == -1) {
      newArr.push(arr[i]);
    }
  }
  return newArr;
}
//移除数组某一项
function remove(arr, val) {
  var index = arr.indexOf(val);
  if (index > -1) {
    arr.splice(index, 1);
  }
}

var DashboardStore = (_class = function () {
  function DashboardStore() {
    var _this = this;

    (0, _classCallCheck3.default)(this, DashboardStore);

    _initDefineProp(this, 'dialogContent', _descriptor, this);

    _initDefineProp(this, 'price', _descriptor2, this);

    _initDefineProp(this, 'cardStatus', _descriptor3, this);

    _initDefineProp(this, 'productCodeList', _descriptor4, this);

    _initDefineProp(this, 'productCodeListLength', _descriptor5, this);

    _initDefineProp(this, 'loading', _descriptor6, this);

    _initDefineProp(this, 'cartIndex', _descriptor7, this);

    _initDefineProp(this, 'isLogin', _descriptor8, this);

    this.init = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchLoginState();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    _initDefineProp(this, 'fetchLoginState', _descriptor9, this);

    _initDefineProp(this, 'handleNotLogin', _descriptor10, this);
  } //用来计算总价的数组
  //用来控制卡片选中状态的数组

  //判断是否登陆

  //跳转登陆页面


  DashboardStore.prototype.fetchDialogData = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var response;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return dashboardService.fetchDialogData();

            case 3:
              response = _context2.sent;

              this.dialogContent = response;
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2['catch'](0);
              throw _context2.t0;

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 7]]);
    }));

    function fetchDialogData() {
      return _ref2.apply(this, arguments);
    }

    return fetchDialogData;
  }();

  DashboardStore.prototype.chooseCard = function chooseCard(status) {
    if (this.cardStatus[status]) {
      this.cardStatus[status] = 0;
    } else {
      this.cardStatus[status] = 1;
    }
  };

  DashboardStore.prototype.chooseCardPopUpConfig = function chooseCardPopUpConfig(status) {
    //选择详细配置后就会选中
    this.cardStatus[status] = 1;
  };

  //改变总价


  DashboardStore.prototype.changeTotalPrice = function changeTotalPrice(index, price) {
    this.price = this.price.map(function (item, idx) {
      if (idx == index) {
        return price;
      } else {
        return item;
      }
    });
  };
  //添加商品


  DashboardStore.prototype.addProduct = function addProduct(productCode) {
    //console.log(productCode, 'productCode');
    this.productCodeList.push(productCode);
    this.productCodeListLength = unique((0, _mobx.toJS)(this.productCodeList)).length;
  };
  //移除商品


  DashboardStore.prototype.removeProduct = function removeProduct(productCode, index) {
    remove(this.productCodeList, productCode);
    remove(this.cartIndex, index);
    this.productCodeListLength = unique((0, _mobx.toJS)(this.productCodeList)).length;
  };

  DashboardStore.prototype.changeLoading = function changeLoading(flag) {
    this.loading = flag;
  };

  //要批量加入购物车的产品


  DashboardStore.prototype.addCart = function addCart(status) {
    this.cartIndex.push(status);
  };

  //去除要加入购物车的产品


  DashboardStore.prototype.removeCart = function removeCart(status) {
    remove(this.cartIndex, status);
  };

  //加入购物车清空选中状态


  DashboardStore.prototype.clearCart = function clearCart() {
    this.cardStatus = [0, 0, 0, 0, 0, 0, 0, 0]; //选中回到初始状态
    this.price = [0, 0, 0, 0, 0, 0, 0, 0]; //金额回到初始状态
    this.productCodeList = []; //选择的产品总数回到初始状态
    this.productCodeListLength = 0; //满减规则回到0的初始状态   
    this.cartIndex = []; //购物车回到初始状态
  };

  //获得的总价


  (0, _createClass3.default)(DashboardStore, [{
    key: 'totalPrice',
    get: function get() {
      var _this2 = this;

      var sum = 0;
      this.price.filter(function (item, idx) {
        return _this2.cardStatus[idx] == 1;
      }).forEach(function (item) {
        //console.log(item,"item");

        sum += item;
      });
      return sum;
    }
    //获得的总的产品个数

  }, {
    key: 'totalProduct',
    get: function get() {
      var totalLength = unique((0, _mobx.toJS)(this.productCodeList));
      return totalLength.length;
    }
  }]);
  return DashboardStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'dialogContent', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'price', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [0, 0, 0, 0, 0, 0, 0, 0];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'cardStatus', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [0, 0, 0, 0, 0, 0, 0, 0];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'productCodeList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'productCodeListLength', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'loading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'cartIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'isLogin', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'fetchLoginState', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
      var isLogin;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Account.isLogin();

            case 2:
              isLogin = _context3.sent;

              _this3.isLogin = isLogin;

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }));
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'handleNotLogin', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    return function () {
      var loginUrl = 'https://account.aliyun.com/login/login.htm?oauth_callback=';
      var callBackUrl = encodeURIComponent(window.location.href);
      var redirectUrl = Tracker.addSpm(loginUrl + callBackUrl, 'body');
      return window.location.href = redirectUrl;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'fetchDialogData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'fetchDialogData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'chooseCard', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'chooseCard'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'chooseCardPopUpConfig', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'chooseCardPopUpConfig'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeTotalPrice', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changeTotalPrice'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addProduct', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addProduct'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeProduct', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'removeProduct'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeLoading', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changeLoading'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addCart', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addCart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeCart', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'removeCart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearCart', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'clearCart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'totalPrice', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'totalPrice'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'totalProduct', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'totalProduct'), _class.prototype)), _class);

var dashboardStore = new DashboardStore();
exports.default = dashboardStore;
module.exports = exports['default'];

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(102);
var $Object = __webpack_require__(1).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(7);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperty: __webpack_require__(14).f });


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(104), __esModule: true };

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105);
var $Object = __webpack_require__(1).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(19);
var $getOwnPropertyDescriptor = __webpack_require__(38).f;

__webpack_require__(63)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(107);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 107 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(109), __esModule: true };

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64);
__webpack_require__(39);
__webpack_require__(46);
__webpack_require__(119);
__webpack_require__(130);
__webpack_require__(131);
module.exports = __webpack_require__(1).Promise;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(40);
var defined = __webpack_require__(37);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(41);
var descriptor = __webpack_require__(30);
var setToStringTag = __webpack_require__(33);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(17)(IteratorPrototype, __webpack_require__(3)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var anObject = __webpack_require__(8);
var getKeys = __webpack_require__(27);

module.exports = __webpack_require__(16) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(19);
var toLength = __webpack_require__(68);
var toAbsoluteIndex = __webpack_require__(114);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(40);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(18);
var toObject = __webpack_require__(45);
var IE_PROTO = __webpack_require__(42)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(117);
var step = __webpack_require__(118);
var Iterators = __webpack_require__(26);
var toIObject = __webpack_require__(19);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(65)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(25);
var global = __webpack_require__(2);
var ctx = __webpack_require__(23);
var classof = __webpack_require__(70);
var $export = __webpack_require__(7);
var isObject = __webpack_require__(15);
var aFunction = __webpack_require__(29);
var anInstance = __webpack_require__(120);
var forOf = __webpack_require__(121);
var speciesConstructor = __webpack_require__(72);
var task = __webpack_require__(73).set;
var microtask = __webpack_require__(125)();
var newPromiseCapabilityModule = __webpack_require__(47);
var perform = __webpack_require__(74);
var userAgent = __webpack_require__(126);
var promiseResolve = __webpack_require__(75);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(3)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(127)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(33)($Promise, PROMISE);
__webpack_require__(128)(PROMISE);
Wrapper = __webpack_require__(1)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(129)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(23);
var call = __webpack_require__(122);
var isArrayIter = __webpack_require__(123);
var anObject = __webpack_require__(8);
var toLength = __webpack_require__(68);
var getIterFn = __webpack_require__(71);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(8);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(26);
var ITERATOR = __webpack_require__(3)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 124 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var macrotask = __webpack_require__(73).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(24)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(17);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var core = __webpack_require__(1);
var dP = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(16);
var SPECIES = __webpack_require__(3)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(3)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(7);
var core = __webpack_require__(1);
var global = __webpack_require__(2);
var speciesConstructor = __webpack_require__(72);
var promiseResolve = __webpack_require__(75);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(7);
var newPromiseCapability = __webpack_require__(47);
var perform = __webpack_require__(74);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(60);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.fetchDialogData = exports.fetchData = undefined;

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var fetchData = exports.fetchData = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data, options) {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _request.get)('/dashboard/list.json', data, options);

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetchDialogData = exports.fetchDialogData = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(data, options) {
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _request.get)('https://query.aliyun.com/rest/aliyun_index.package-refund.rule', data, options);

          case 2:
            return _context2.abrupt('return', _context2.sent);

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchDialogData(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var _request = __webpack_require__(134);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _button = __webpack_require__(135);

var _button2 = _interopRequireDefault(_button);

var _dialog = __webpack_require__(154);

var _dialog2 = _interopRequireDefault(_dialog);

var _stringify = __webpack_require__(88);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(28);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(91);

var _keys2 = _interopRequireDefault(_keys);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _extends2 = __webpack_require__(181);

var _extends3 = _interopRequireDefault(_extends2);

exports.addHandler = addHandler;
exports.request = request;
exports.post = post;
exports.get = get;
exports.jsonp = jsonp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _axios = __webpack_require__(186);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(98).polyfill(); //import AliyunRiskControl from '../common/riskControl';

//const fetchJsonp = require('fetch-jsonp');
var fetchJsonp = __webpack_require__(205);
// const REQUEST_TIMEOUT = 10000;
//const aliyunRiskControl = new AliyunRiskControl();
var message_lang = {
  zh: {
    warning: '提示',
    confirm: '确定',
    session_timeout: '您当前的会话已超时，请重新登录。',
    go_to_login: '还没有登录，请前往',
    login: '登录',
    cancel: '取消',
    ok: '好',
    try_later: '服务出错，请稍后再试'
  },
  en: {
    warning: 'prompt',
    session_timeout: 'Your current session has timed out. Please log in again.',
    go_to_login: 'Not yet logged in, please go ',
    login: 'login',
    cancel: 'cancel',
    confirm: 'confirm',
    ok: 'OK',
    try_later: 'Service error, please try again later'
  }
};

// ====== Request Class ======
var lang = window.CURRENT_LANG || 'zh';
var message = message_lang[lang] || {};
var defaultOptions = {
  // ignoreError: false
  withCredentials: true
};
/**
 * TODO 针对特定key增加处理函数
 * @param {string} key 针对某种key的处理函数
 * @param {Function} fn 处理函数
 * @return {void};
 */
function addHandler(key, fn) {
  ErrorHandlers[key] = fn;
}
/**
 * Requests a URL, returning a promise.
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
function request(url, options) {
  // setDefault
  options = (0, _extends3.default)({}, defaultOptions, options);
  return (0, _axios2.default)(url, options).then(checkStatus)
  //.then(parseJSON)
  // .then((response) => riskControl(response, url, options))
  .then(function (res) {
    return checkResponse(res, options);
  }) // 接口通信成功，处理返回值
  .catch(function (err) {
    return handleError(err, options);
  }); // 发生异常，进行兜底处理
}

/**
 * 发送请求
 * @param {string} url - 请求的接口地址
 * @param {object} data - 请求参数
 * @param {object} options 传递给fetch API的参数
 * @return {promise} 返回promise
 */
function post(url, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return (0, _axios2.default)(url, (0, _extends3.default)({
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: stringify((0, _extends3.default)({}, data, {
      sec_token: (window.ALIYUN_CONSOLE_CONFIG || {}).SEC_TOKEN
    }))
  }, options)).then(function (res) {
    var result = checkResponse(res.data, options);
    return result;
  }) // 接口通信成功，处理返回值
  .catch(function (err) {
    return handleError(err, options);
  }); // 发生异常，进行兜底处理
}

/**
 * get请求
 * @param {string} url 请求的接口地址
 * @param {object} params 请求参数
 * @param {object} options 传递给fetch API的参数
 * @return {promise} 返回promise
 */
function get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return (0, _axios2.default)(url, {
    params: params
  }).then(checkStatus)
  //.then(parseJSON)
  // .then((response) => riskControl(response, url, options))
  .then(function (res) {
    return checkResponse(res.data, options);
  }) // 接口通信成功，处理返回值
  .catch(function (err) {
    return console.log(err);
  }); // 发生异常，进行兜底处理


  // return request(`${url}?${stringify(data)}`, {
  //   method: 'GET',
  //   credentials: 'same-origin',
  //   ...options
  // });
}

function jsonp(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // setDefault
  options = (0, _extends3.default)({}, defaultOptions, options);

  return fetchJsonp(url + '?' + stringify(params), options).then(function (res) {
    var result = checkResponse(res, options);
    return result;
  }) // 接口通信成功，处理返回值
  .catch(function (err) {
    return handleError(err, options);
  }); // 发生异常，进行兜底处理
}

// ====== Response Class ======

var AbstractResponse = function AbstractResponse(response, error) {
  (0, _classCallCheck3.default)(this, AbstractResponse);

  if (response) {
    this.code = response.code;
    this.data = response.data;
  }
  this.error = error || null;
};

/**
 * 错误时候的响应对象
 */
// class ErrorResponse extends AbstractResponse {
//   constructor(error) {
//     super(null, error);
//   }
// }

/**
 * 接口正常时的返回对象
 */


var SuccessResponse = function (_AbstractResponse) {
  (0, _inherits3.default)(SuccessResponse, _AbstractResponse);

  function SuccessResponse(response) {
    (0, _classCallCheck3.default)(this, SuccessResponse);
    return (0, _possibleConstructorReturn3.default)(this, _AbstractResponse.call(this, response, null));
  }

  return SuccessResponse;
}(AbstractResponse);

// ====== Util ======

//{ a: 1, b: 2} ==> a=1&b=2


function stringify() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _keys2.default)(obj).filter(function (k) {
    return obj[k] || +obj[k] === 0;
  }).map(function (k) {
    var value = obj[k];
    if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) == 'object') {
      value = encodeURIComponent((0, _stringify2.default)(value));
    } else {
      value = encodeURIComponent(value);
    }
    return encodeURIComponent(k) + '=' + value;
  }).join('&');
}

// ====== 接口返回值处理具体逻辑 ======

var SUCCESS_CODE = '200';
var ErrorHandlers = {
  'verifyCodeInvalid': function verifyCodeInvalid() {},
  'NoPermission.Directory': function NoPermissionDirectory() {
    //TODO: do nothing
  },
  'default': function _default(response) {

    createMessage(response.message || message.try_later);
  },
  '-99': function _(response) {
    //eslint-disable-line
    var dialog = _dialog2.default.alert({
      needWrapper: false,
      title: message['warning'],
      footer: _react2.default.createElement(
        _button2.default,
        { type: 'primary', onClick: function onClick() {
            return dialog.hide();
          } },
        message['confirm']
      ),
      content: _react2.default.createElement('div', { dangerouslySetInnerHTML: {
          __html: '<span style="color:#FF8A00">' + '<span class="k-iconfont  icon-jingshi " style="float:left;margin:-4px 6px 0 0"></span>' + message.go_to_login + '<a href="//account.aliyun.com/login/login.htm?oauth_callback=' + encodeURIComponent(location.href) + '">' + message.login + '</a></span>'
        } })
    });
  }
};

/**
 * 接口返回值处理逻辑，如果未捕获到匹配的处置方案，则抛出异常
 * @param {*} response 响应
 * @param {*} options 配置可选项，如忽略错误
 * @return {response}  返回响应
 */
function checkResponse(response, options) {
  var data = response.data;

  options = options || {};

  //不一定会有
  var errorMessage = response.message;
  var code = response.code;

  if (code == SUCCESS_CODE && data) {
    return new SuccessResponse(response);
  }
  if (!options.ignoreError) {
    code = response.code || 'default';
    var errorHandler = ErrorHandlers[code];
    if (!errorHandler) {
      throw new Error(errorMessage || code);
    }

    return response;
    // throw new ErrorResponse(response);
  } else {
    return new SuccessResponse(response);
  }
}

// function parseJSON(response) {
//   return response.json();
// }

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  var error = new Error(response.statusText);
  error.response = response;
  throw error;
}

function createMessage(err) {
  var dialogInstance = _dialog2.default.alert({
    needWrapper: false,
    title: message['warning'],
    content: _react2.default.createElement('div', { dangerouslySetInnerHTML: {
        __html: '<span style="color:#FF8A00">' + '<span class="k-iconfont  icon-jingshi " style="float:left;margin:-4px 6px 0 0"></span>' + err + '</span>'
      } }),
    footer: _react2.default.createElement(
      _button2.default,
      { type: 'primary', onClick: function onClick() {
          return dialogInstance.hide();
        } },
      message['confirm']
    ),
    afterClose: function afterClose() {
      dialogInstance = null;
    }
  });
}
// 兜底的错误处理
function handleError(err, options) {
  options = options || {};
  // console.log('[REQUEST_ERROR] ', err);
  if (!options.ignoreError) {
    createMessage(err);
  }
  //throw new ErrorResponse(err);
}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(49);

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(12);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Icon = (_temp = _class = function (_Component) {
    _inherits(Icon, _Component);

    function Icon() {
        _classCallCheck(this, Icon);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Icon.prototype.render = function render() {
        var _cx;

        var prefix = this.context.prefix || this.props.prefix;
        // eslint-disable-next-line

        var _props = this.props,
            propsPrefix = _props.prefix,
            type = _props.type,
            size = _props.size,
            className = _props.className,
            other = _objectWithoutProperties(_props, ['prefix', 'type', 'size', 'className']);

        var sizeCls = {
            xxs: 'xxs',
            xs: 'xs',
            small: 'small',
            medium: 'medium',
            large: 'large',
            xl: 'xl',
            xxl: 'xxl',
            xxxl: 'xxxl'
        }[size];

        var classes = (0, _classnames2['default'])((_cx = {}, _defineProperty(_cx, prefix + 'icon', true), _defineProperty(_cx, prefix + 'icon-' + type, !!type), _defineProperty(_cx, prefix + 'icon-' + sizeCls, !!size), _defineProperty(_cx, className, !!className), _cx));
        return _react2['default'].createElement('i', _extends({}, other, { className: classes }));
    };

    return Icon;
}(_react.Component), _class.contextTypes = {
    prefix: _react.PropTypes.string
}, _class.propTypes = {
    prefix: _react.PropTypes.string,
    type: _react.PropTypes.string,
    size: _react.PropTypes.oneOf(['xxs', 'xs', 'small', 'medium', 'large', 'xl', 'xxl', 'xxxl']),
    className: _react.PropTypes.string
}, _class.defaultProps = {
    prefix: 'next-',
    size: 'medium'
}, _temp);
Icon.displayName = 'Icon';
exports['default'] = Icon;
module.exports = exports['default'];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function hidden(node) {
    return node.style.display == 'none';
}

function visible(node) {
    while (node) {
        if (node === document.body) {
            break;
        }
        if (hidden(node)) {
            return false;
        }
        node = node.parentNode;
    }
    return true;
}

function focusable(node) {
    var nodeName = node.nodeName.toLowerCase(),
        tabIndex = parseInt(node.getAttribute('tabindex'), 10),
        hasTabIndex = !isNaN(tabIndex) && tabIndex > -1;

    if (visible(node)) {
        if (['input', 'select', 'textarea', 'button'].indexOf(nodeName) > -1) {
            return !node.disabled;
        } else if (nodeName == 'a') {
            return node.getAttribute('href') || hasTabIndex;
        } else {
            return hasTabIndex;
        }
    }
}

function getFocusNodeList(node) {
    var res = [],
        nodeList = node.querySelectorAll('*'),
        length = nodeList.length;

    for (var i = 0; i < length; i++) {
        var item = nodeList[i];
        if (focusable(item)) {
            var method = item.getAttribute('data-auto-focus') ? 'unshift' : 'push';
            res[method](item);
        }
    }

    if (focusable(node)) {
        res.unshift(node);
    }
    return res;
}

var lastFocusElement = null;

function saveLastFocusNode() {
    lastFocusElement = document.activeElement;
}

function clearLastFocusNode() {
    lastFocusElement = null;
}

function backLastFocusNode() {
    if (lastFocusElement) {
        try {
            // 元素可能已经被移动了
            lastFocusElement.focus();
        } catch (e) {}
    }
}

function limitTabRange(node, e) {
    if (e.keyCode == 9) {
        var tabNodeList = getFocusNodeList(node),
            lastTabNode = tabNodeList[e.shiftKey ? 0 : tabNodeList.length - 1],
            leavingTab = lastTabNode === document.activeElement || node === document.activeElement;

        if (leavingTab) {
            var target = tabNodeList[e.shiftKey ? tabNodeList.length - 1 : 0];
            target.focus();
            e.preventDefault();
        }
    }
}

exports.saveLastFocusNode = saveLastFocusNode;
exports.clearLastFocusNode = clearLastFocusNode;
exports.backLastFocusNode = backLastFocusNode;
exports.getFocusNodeList = getFocusNodeList;
exports.limitTabRange = limitTabRange;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESCAPE: 27,
    SPACE: 32,
    END: 35,
    HOME: 36,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var attributes = 'accept acceptCharset accessKey action allowFullScreen allowTransparency\nalt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\ncharSet checked classID className colSpan cols content contentEditable contextMenu\ncontrols coords crossOrigin data dateTime default defer dir disabled download draggable\nencType form formAction formEncType formMethod formNoValidate formTarget frameBorder\nheaders height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\nis keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\nmediaGroup method min minLength multiple muted name noValidate nonce open\noptimum pattern placeholder poster preload radioGroup readOnly rel required\nreversed role rowSpan rows sandbox scope scoped scrolling seamless selected\nshape size sizes span spellCheck src srcDoc srcLang srcSet start step style\nsummary tabIndex target title type useMap value width wmode wrap'.replace(/\s+/g, ' ').replace(/\t|\n|\r/g, '').split(' ');

var eventsName = 'onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError'.replace(/\s+/g, ' ').replace(/\t|\n|\r/g, '').split(' ');

var attrsPrefix = ['data-', 'aria-'];

module.exports = function (props) {
    var attrs = {};
    for (var key in props) {
        if (attributes.indexOf(key) > -1 || eventsName.indexOf(key) > -1) {
            attrs[key] = props[key];
        } else if (attrsPrefix.map(function (prefix) {
            return new RegExp('^' + prefix);
        }).some(function (reg) {
            return key.replace(reg, '') != key;
        })) {
            attrs[key] = props[key];
        }
    }
    return attrs;
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    var scrollDiv = document.createElement('div'),
        scrollbarWidth,
        scrollbarHeight;

    scrollDiv.style.position = 'absolute';
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.top = '-9999px';

    document.body.appendChild(scrollDiv);
    scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    //TODO: adapter old verison.
    return {
        width: scrollbarWidth,
        height: scrollbarWidth
    };
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var canUseDOM = __webpack_require__(142);

var animationEndEventNames = {
    'WebkitAnimation': 'webkitAnimationEnd',
    'OAnimation': 'oAnimationEnd',
    'animation': 'animationend'
};
var transitionEventNames = {
    'WebkitTransition': 'webkitTransitionEnd',
    'OTransition': 'oTransitionEnd',
    'transition': 'transitionend'
};

function supportEnd(names) {
    var el = document.createElement('div');
    for (var name in names) {
        if (names.hasOwnProperty(name) && el.style[name] !== undefined) {
            return {
                end: names[name]
            };
        }
    }
    return false;
}

function supportCss(names) {
    var el = document.createElement('div');
    var ret = false;

    for (var key in names) {
        names[key].forEach(function (item) {
            // It will be throw error when set unknown property under IE8.
            try {
                el.style[key] = item;
                ret = ret || el.style[key] == item;
            } catch (e) {}
        });
    }

    return ret;
}

var support = exports;

if (canUseDOM()) {
    support.animation = supportEnd(animationEndEventNames);
    support.transition = supportEnd(transitionEventNames);
    support.flex = supportCss({
        'display': ['flex', '-webkit-flex', '-moz-flex', '-ms-flexbox']
    });
} else {
    support.animation = false;
    support.transition = false;
    support.flex = false;
}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.deprecated = function (props, instead, component) {
    if (window && window.console && window.console.error) {
        window.console.error('Warning: ' + props + ' is deprecated at [ ' + component + ' ], use [ ' + instead + ' ] instead of it.');
    }
};

exports.warning = function (msg) {
    if (window && window.console && window.console.error) {
        window.console.error('Warning: ' + msg);
    }
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (Class, props) {
    var propTypes = Class.propTypes;
    var others = {};
    for (var key in props) {
        if (!(key in propTypes)) {
            others[key] = props[key];
        }
    }
    return others;
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function getPrototype(value) {
    if (Object.getPrototypeOf) {
        return Object.getPrototypeOf(value);
    }
    if (_typeof('test'.__proto__) === 'object') {
        return value.__proto__;
    }
    return false;
}

var toString = Object.prototype.toString;
var hasOwn = Object.prototype.hasOwnProperty;

function isPlainObject(o) {
    if (!o || toString.call(o) !== '[object Object]' || o.nodeType || o === o.window) {
        return false;
    }

    var proto = getPrototype(o),
        funcToString = Function.prototype.toString,
        objectCtorString = funcToString.call(Object),
        constructor = void 0;

    if (proto === null) {
        return true;
    }
    var Ctor = hasOwn.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor === 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

exports.isPlainObject = isPlainObject;

function equal(objA, objB, compare, compareContext, deep) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) {
        return !!ret;
    }
    if (objA === objB) {
        return true;
    }
    if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    var len = keysA.length;

    if (len !== keysB.length) {
        return false;
    }
    compareContext = compareContext || null;
    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < len; i++) {
        var key = keysA[i];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];

        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (deep) {
            if (_ret === false || _ret === void 0 && equal(valueA, valueB, compare, compareContext, deep)) {
                return false;
            }
        } else {
            if (_ret === false || _ret === void 0 && valueA !== valueB) {
                return false;
            }
        }
    }
    return true;
}

exports.shallowEqual = function (objA, objB, compare, compareContext) {
    return equal(objA, objB, compare, compareContext, false);
};

exports.deepEqual = function (objA, objB, compare, compareContext) {
    return equal(objA, objB, compare, compareContext, true);
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.toArray = function (children) {
    var ret = [];
    _react2['default'].Children.forEach(children, function (child) {
        ret.push(child);
    });
    return ret;
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(12);

var _classnames2 = _interopRequireDefault(_classnames);

var _nextIcon = __webpack_require__(34);

var _nextIcon2 = _interopRequireDefault(_nextIcon);

var _nextDropdown = __webpack_require__(148);

var _nextDropdown2 = _interopRequireDefault(_nextDropdown);

var _button = __webpack_require__(77);

var _button2 = _interopRequireDefault(_button);

var _group = __webpack_require__(79);

var _group2 = _interopRequireDefault(_group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var SplitButton = (_temp = _class = function (_Component) {
    _inherits(SplitButton, _Component);

    function SplitButton() {
        _classCallCheck(this, SplitButton);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SplitButton.prototype.render = function render() {
        var _classNames;

        var _props = this.props,
            className = _props.className,
            type = _props.type,
            shape = _props.shape,
            menu = _props.menu,
            size = _props.size,
            disabled = _props.disabled,
            trigger = _props.trigger,
            align = _props.align,
            offset = _props.offset,
            children = _props.children,
            onClick = _props.onClick,
            others = _objectWithoutProperties(_props, ['className', 'type', 'shape', 'menu', 'size', 'disabled', 'trigger', 'align', 'offset', 'children', 'onClick']);

        var prefix = this.context.prefix || this.props.prefix;

        var splitCls = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefix + 'btn-split', true), _defineProperty(_classNames, className, className), _classNames));
        var iconSize = {
            large: 'small',
            medium: 'xs',
            small: 'xs'
        }[size];
        var splitTrigger = _react2['default'].createElement(
            _button2['default'],
            { type: type, disabled: disabled, size: size, shape: shape },
            _react2['default'].createElement(_nextIcon2['default'], { type: 'arrow-down', size: iconSize, className: prefix + 'icon-split' })
        );

        return _react2['default'].createElement(
            _group2['default'],
            _extends({}, others, { size: size, className: splitCls }),
            _react2['default'].createElement(
                _button2['default'],
                _extends({ type: type, disabled: disabled, shape: shape, onClick: onClick.bind(this) }, others),
                children
            ),
            _react2['default'].createElement(
                _nextDropdown2['default'],
                { align: align, offset: offset, triggerType: trigger, trigger: splitTrigger },
                menu
            )
        );
    };

    return SplitButton;
}(_react.Component), _class.propTypes = {
    prefix: _react.PropTypes.string,
    align: _react.PropTypes.string,
    offset: _react.PropTypes.array,
    type: _react.PropTypes.oneOf(['primary', 'secondary', 'normal', 'dark', 'light']),
    shape: _react.PropTypes.oneOf(['ghost', 'text', 'warning']),
    size: _react.PropTypes.oneOf(['small', 'medium', 'large']),
    trigger: _react.PropTypes.oneOf(['click', 'hover']),
    menu: _react.PropTypes.any,
    onClick: _react.PropTypes.func
}, _class.defaultProps = {
    prefix: 'next-',
    align: 'tr br',
    offset: [0, 4],
    type: 'normal',
    size: 'medium',
    trigger: 'click',
    onClick: function onClick() {}
}, _class.contextTypes = {
    prefix: _react.PropTypes.string
}, _temp);
SplitButton.displayName = 'SplitButton';
exports['default'] = SplitButton;
module.exports = exports['default'];

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _nextOverlay = __webpack_require__(50);

var _nextOverlay2 = _interopRequireDefault(_nextOverlay);

var _func = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PropTypes = _react2.default.PropTypes,
    Children = _react2.default.Children,
    Popup = _nextOverlay2.default.Popup,
    noop = function noop() {};

var Dropdown = (_temp = _class = function (_React$Component) {
	_inherits(Dropdown, _React$Component);

	function Dropdown(props) {
		_classCallCheck(this, Dropdown);

		var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

		_this.state = {
			visible: props.visible || props.defaultVisible || false
		};
		return _this;
	}

	Dropdown.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if ('visible' in nextProps) {
			this.setState({ visible: nextProps.visible });
		}
	};

	Dropdown.prototype.render = function render() {
		var child = Children.only(this.props.children),
		    content = _react2.default.cloneElement(child, {
			onClick: (0, _func.makeChain)(this.onMenuClick.bind(this), child.props.onClick)
		});

		return _react2.default.createElement(
			Popup,
			_extends({}, this.props, {
				canCloseByOutSideClick: true,
				visible: this.state.visible,
				onVisibleChange: this.onVisibleChange.bind(this)
			}),
			content
		);
	};

	Dropdown.prototype.onMenuClick = function onMenuClick() {
		if (!('visible' in this.props)) {
			this.setState({
				visible: false
			});
		}
		this.props.onVisibleChange(false, 'fromContent');
	};

	Dropdown.prototype.onVisibleChange = function onVisibleChange(visible) {
		if (!('visible' in this.props)) {
			this.setState({ visible: visible });
		}
		this.props.onVisibleChange(visible);
	};

	return Dropdown;
}(_react2.default.Component), _class.propTypes = {
	trigger: PropTypes.any,
	onVisibleChange: PropTypes.func,
	align: PropTypes.string
}, _class.defaultProps = {
	prefix: 'next-',
	onVisibleChange: noop
}, _temp);
Dropdown.displayName = 'Dropdown';
exports.default = Dropdown;
module.exports = exports['default'];

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function addClass(node, className) {
    if (node.classList) {
        node.classList.add(className);
    } else if (!hasClass(node, className)) {
        node.className = node.className + ' ' + className;
    }
}

function hasClass(node, className) {
    if (node.classList) {
        return node.classList.contains(className);
    } else {
        return node.className.indexOf(className) > -1;
    }
}

function removeClass(node, className) {
    if (node.classList) {
        node.classList.remove(className);
    } else if (hasClass(node, className)) {
        node.className = node.className.replace(className, '').replace(/\s+/g, ' ').trim();
    }
}

module.exports = {
    hasClass: hasClass,
    addClass: addClass,
    removeClass: removeClass
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EVENT_PREFIX = 'next-';

function on(node, eventName, handler, useCapture) {
    if (node.addEventListener) {
        node.addEventListener(eventName, handler, useCapture);
    } else if (node.attachEvent) {
        var nextEvent = getNextEventName(eventName);
        if (Array.isArray(node[nextEvent])) {
            if (node[nextEvent].indexOf(handler) === -1) {
                node[nextEvent].push(handler);
            }
        } else {
            node[nextEvent] = [handler];
            node.attachEvent('on' + eventName, function () {
                node[nextEvent].forEach(function (handler) {
                    handler && handler.call(node, shimEvent(window.event, node));
                });
            });
        }
    }

    return {
        off: function off() {
            _off(node, eventName, handler, useCapture);
        }
    };
}

function _off(node, eventName, handler, useCapture) {
    if (node.removeEventListener) {
        node.removeEventListener(eventName, handler, useCapture);
    } else {
        var nextEvent = getNextEventName(eventName);
        if (Array.isArray(node[nextEvent])) {
            var index = node[nextEvent].indexOf(handler);
            if (index > -1) {
                node[nextEvent].splice(index, 1);
            }
        }
    }
}

function shimEvent(e, currentTarget) {
    if (!e.target) {
        e.target = e.srcElement;
        e.currentTarget = currentTarget;
        e.relatedTarge = e.type === 'mouseover' ? e.fromElement : e.toElement;
        e.stopPropagation = function () {
            e.cancelBubble = true;
        };
        e.preventDefault = function () {
            e.returnValue = false;
        };
    }

    return e;
}

function getNextEventName(eventName) {
    return '' + EVENT_PREFIX + eventName;
}

module.exports = {
    on: on,
    off: _off
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _class, _temp;

var _css = __webpack_require__(81);

var _css2 = _interopRequireDefault(_css);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VIEWPORT = 'viewport';

// IE8 not support pageXOffset
var getPageX = function getPageX() {
    return window.pageXOffset || document.documentElement.scrollLeft;
};
var getPageY = function getPageY() {
    return window.pageYOffset || document.documentElement.scrollTop;
};

var getElementRect = function getElementRect(elem) {
    var offsetTop = 0,
        offsetLeft = 0,
        offsetHeight = elem.offsetHeight,
        offsetWidth = elem.offsetWidth;

    do {
        if (!isNaN(elem.offsetTop)) {
            offsetTop += elem.offsetTop;
        }
        if (!isNaN(elem.offsetLeft)) {
            offsetLeft += elem.offsetLeft;
        }
    } while ((elem = elem.offsetParent) !== null);

    return {
        top: offsetTop - (document.documentElement.scrollTop || document.body.scrollTop),
        left: offsetLeft - (document.documentElement.scrollLeft || document.body.scrollLeft),
        height: offsetHeight,
        width: offsetWidth
    };
};

var Position = (_temp = _class = function () {
    function Position(config) {
        _classCallCheck(this, Position);

        this.pinElement = config.pinElement;
        this.baseElement = config.baseElement;
        this.align = config.align || 'tl tl';
        this.offset = config.offset || [0, 0];
        this.needAdjust = config.needAdjust || false;
        this.isRtl = config.isRtl || false;
    }

    Position.prototype.setPosition = function setPosition() {
        var pinElement = this.pinElement;
        var baseElement = this.baseElement;
        var expectedAlign = this._getExpectedAlign();
        var isPinFixed = void 0,
            isBaseFixed = void 0,
            firstPositionResult = void 0;
        if (pinElement === VIEWPORT) {
            return;
        }
        if (_css2['default'].get(pinElement, 'position') !== 'fixed') {
            _css2['default'].set(pinElement, 'position', 'absolute');
            isPinFixed = false;
        } else {
            isPinFixed = true;
        }
        if (baseElement === VIEWPORT || _css2['default'].get(baseElement, 'position') !== 'fixed') {
            isBaseFixed = false;
        } else {
            isBaseFixed = true;
        }
        // 根据期望的定位
        for (var i = 0; i < expectedAlign.length; i++) {
            var align = expectedAlign[i];
            var pinElementPoints = this._normalizePosition(pinElement, align.split(' ')[0], isPinFixed);
            var baseElementPoints = this._normalizePosition(baseElement, align.split(' ')[1], isPinFixed);
            var pinElementParentOffset = this._getParentOffset(pinElement);
            var baseElementOffset = isPinFixed && isBaseFixed ? this._getLeftTop(baseElement) : baseElementPoints.offset();
            var top = baseElementOffset.top + baseElementPoints.y - pinElementParentOffset.top - pinElementPoints.y + this.offset[1];
            var left = baseElementOffset.left + baseElementPoints.x - pinElementParentOffset.left - pinElementPoints.x + this.offset[0];
            _css2['default'].set(pinElement, {
                left: left + 'px',
                top: top + 'px'
            });
            if (!firstPositionResult) {
                firstPositionResult = {
                    left: left,
                    top: top
                };
            }
            if (this._isInViewport(pinElement)) {
                return align;
            }
        }

        var inViewportLeft = this._makeElementInViewport(pinElement, firstPositionResult.left, 'Left', isPinFixed);
        var inViewportTop = this._makeElementInViewport(pinElement, firstPositionResult.top, 'Top', isPinFixed);

        _css2['default'].set(pinElement, {
            left: inViewportLeft + 'px',
            top: inViewportTop + 'px'
        });

        return expectedAlign[0];
    };

    Position.prototype._getParentOffset = function _getParentOffset(element) {
        var parent = element.offsetParent || document.documentElement;
        var offset = void 0;
        if (parent === document.body && _css2['default'].get(parent, 'position') === 'static') {
            offset = {
                top: 0,
                left: 0
            };
        } else {
            offset = this._getElementOffset(parent);
        }

        offset.top += parseFloat(_css2['default'].get(parent, 'border-top-width'), 10);
        offset.left += parseFloat(_css2['default'].get(parent, 'border-left-width'), 10);

        return offset;
    };

    Position.prototype._makeElementInViewport = function _makeElementInViewport(pinElement, number, type, isPinFixed) {
        var result = number,
            docElement = document.documentElement,
            offsetParent = pinElement.offsetParent || document.documentElement;

        if (result < 0) {
            if (isPinFixed) {
                result = 0;
            } else if (offsetParent === document.body && _css2['default'].get(offsetParent, 'position') === 'static') {
                //Only when div's offsetParent is document.body, we set new position result.
                result = Math.max(docElement['scroll' + type], document.body['scroll' + type]);
            }
        }
        return result;
    };

    Position.prototype._normalizePosition = function _normalizePosition(element, align, isPinFixed) {
        var points = this._normalizeElement(element, isPinFixed);
        this._normalizeXY(points, align);
        return points;
    };

    Position.prototype._normalizeXY = function _normalizeXY(points, align) {
        var x = align.split('')[1];
        var y = align.split('')[0];
        points.x = this._xyConverter(x, points, 'width');
        points.y = this._xyConverter(y, points, 'height');
        return points;
    };

    Position.prototype._xyConverter = function _xyConverter(align, points, type) {
        var res = align.replace(/t|l/gi, '0%').replace(/c/gi, '50%').replace(/b|r/gi, '100%').replace(/(\d+)%/gi, function (m, d) {
            return points.size()[type] * (d / 100);
        });
        return parseFloat(res, 10) || 0;
    };

    Position.prototype._getLeftTop = function _getLeftTop(element) {
        return {
            left: parseFloat(_css2['default'].get(element, 'left')) || 0,
            top: parseFloat(_css2['default'].get(element, 'top')) || 0
        };
    };

    Position.prototype._normalizeElement = function _normalizeElement(element, isPinFixed) {
        var _this = this;

        var result = {
            element: element,
            x: 0,
            y: 0
        },
            isViewport = element === VIEWPORT,
            docElement = document.documentElement;

        result.offset = function () {
            if (isPinFixed) {
                return {
                    left: 0,
                    top: 0
                };
            } else if (isViewport) {
                return {
                    left: getPageX(),
                    top: getPageY()
                };
            } else {
                return _this._getElementOffset(element);
            }
        };

        result.size = function () {
            if (isViewport) {
                return {
                    width: docElement.clientWidth,
                    height: docElement.clientHeight
                };
            } else {
                return {
                    width: element.offsetWidth,
                    height: element.offsetHeight
                };
            }
        };
        return result;
    };

    Position.prototype._getElementOffset = function _getElementOffset(element) {
        var rect = element.getBoundingClientRect();
        var docElement = document.documentElement;
        var body = document.body;
        var docClientLeft = docElement.clientLeft || body.clientLeft || 0;
        var docClientTop = docElement.clientTop || body.clientTop || 0;

        return {
            left: rect.left + (getPageX() - docClientLeft),
            top: rect.top + (getPageY() - docClientTop)
        };
    };
    // According to the location of the overflow to calculate the desired positioning


    Position.prototype._getExpectedAlign = function _getExpectedAlign() {
        var align = this.isRtl ? this._replaceAlignDir(this.align, /l|r/g, { l: 'r', r: 'l' }) : this.align;
        var expectedAlign = [align];

        if (this.needAdjust) {
            if (/t|b/g.test(align)) {
                expectedAlign.push(this._replaceAlignDir(align, /t|b/g, { t: 'b', b: 't' }));
            }
            if (/l|r/g.test(align)) {
                expectedAlign.push(this._replaceAlignDir(align, /l|r/g, { l: 'r', r: 'l' }));
            }
            if (/c/g.test(align)) {
                expectedAlign.push(this._replaceAlignDir(align, /c(?= |$)/g, { c: 'l' }));
                expectedAlign.push(this._replaceAlignDir(align, /c(?= |$)/g, { c: 'r' }));
            }
            expectedAlign.push(this._replaceAlignDir(align, /l|r|t|b/g, { l: 'r', r: 'l', t: 'b', b: 't' }));
        }
        return expectedAlign;
    };
    // Transform align order.


    Position.prototype._replaceAlignDir = function _replaceAlignDir(align, regExp, map) {
        return align.replace(regExp, function (res) {
            return map[res];
        });
    };
    // Detecting element is in the window， we want to adjust position later.


    Position.prototype._isInViewport = function _isInViewport(element) {
        var viewportSize = {
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight
        };
        //Avoid animate problem that use offsetWidth instead of getBoundingClientRect.
        var elementRect = getElementRect(element);
        return elementRect.left >= 0 && elementRect.left + element.offsetWidth <= viewportSize.width && elementRect.top >= 0 && elementRect.top + element.offsetHeight <= viewportSize.height;
    };

    return Position;
}(), _class.VIEWPORT = VIEWPORT, _temp);


Position.place = function (pinElement, baseElement, align, offset, needAdjust, isRtl) {
    return new Position({
        pinElement: pinElement,
        baseElement: baseElement,
        align: align,
        offset: offset,
        needAdjust: needAdjust,
        isRtl: isRtl
    }).setPosition();
};

exports['default'] = Position;
module.exports = exports['default'];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Manager = {
    allOverlays: [],

    addOverlay: function addOverlay(overlay) {
        this.removeOverlay(overlay);
        this.allOverlays.push(overlay);
    },
    isCurrentOverlay: function isCurrentOverlay(overlay) {
        return !!this.allOverlays.length && this.allOverlays[this.allOverlays.length - 1] === overlay;
    },
    removeOverlay: function removeOverlay(overlay) {
        var i = this.allOverlays.indexOf(overlay);
        if (i > -1) {
            this.allOverlays.splice(i, 1);
        }
    }
};

exports["default"] = Manager;
module.exports = exports["default"];

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _nextUtil = __webpack_require__(22);

var _overlay = __webpack_require__(80);

var _overlay2 = _interopRequireDefault(_overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PropTypes = _react2['default'].PropTypes,
    Children = _react2['default'].Children,
    noop = function noop() {},
    makeChain = _nextUtil.func.makeChain;

// <Popup trigger={}>
//  <content></content>
// </Popup>

// <PopupMenuItem trigger={}>
//   {menu}
// </PopupMenuItem>
var Popup = (_temp = _class = function (_React$Component) {
    _inherits(Popup, _React$Component);

    function Popup(props) {
        _classCallCheck(this, Popup);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this.state = {
            visible: props.visible || props.defaultVisible
        };

        ['_onTriggerClick', '_onTriggerFocus', '_onTriggerBlur', '_onContentMouseDown', '_onTriggerMouseEnter', '_onTriggerMouseLeave', '_onContentMouseEnter', '_onContentMouseLeave', '_onTriggerKeyDown'].forEach(function (method) {
            _this[method] = _this[method].bind(_this);
        });
        return _this;
    }

    Popup.prototype.handleVisibleChange = function handleVisibleChange(visible, type, e) {
        if (!('visible' in this.props)) {
            this.setState({
                visible: visible
            });
        }

        this.props.onVisibleChange(visible, type, e);
    };

    Popup.prototype.render = function render() {
        return this.getTrigger();
    };

    Popup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if ('visible' in nextProps) {
            this.setState({
                visible: nextProps.visible
            });
        }
    };

    Popup.prototype.componentWillMount = function componentWillMount() {
        this.uniqueOverlayKey = getUniqueKey();
    };

    Popup.prototype.addNodeForSafeClick = function addNodeForSafeClick(node) {
        this.overlay.addNodeForSafeClick(node);
    };

    Popup.prototype.getContent = function getContent() {
        var content = Children.only(this.props.children),
            props = {};

        switch (this.props.triggerType) {
            case 'focus':
                props = {
                    onMouseDown: makeChain(this._onContentMouseDown, content.props.onMouseDown)
                };
                break;
            case 'click':
                props = {};
                break;
            case 'hover':
                props = {
                    onMouseEnter: makeChain(this._onContentMouseEnter, content.props.onMouseEnter),
                    onMouseLeave: makeChain(this._onContentMouseLeave, content.props.onMouseLeave)
                };

        }
        return _react2['default'].cloneElement(content, props);
    };

    Popup.prototype.getTrigger = function getTrigger() {
        var _props = this.props,
            trigger = _props.trigger,
            disabled = _props.disabled,
            props = {};


        if (!disabled) {
            switch (this.props.triggerType) {
                case 'click':
                    props = {
                        onClick: makeChain(this._onTriggerClick, trigger.props.onClick),
                        onKeyDown: makeChain(this._onTriggerKeyDown, trigger.props.onKeyDown),
                        ref: 'trigger'
                    };
                    break;
                case 'focus':
                    props = {
                        onFocus: makeChain(this._onTriggerFocus, trigger.props.onFocus),
                        onBlur: makeChain(this._onTriggerBlur, trigger.props.onBlur),
                        ref: 'trigger'
                    };
                    break;
                case 'hover':
                    props = {
                        onMouseEnter: makeChain(this._onTriggerMouseEnter, trigger.props.onMouseEnter),
                        onMouseLeave: makeChain(this._onTriggerMouseLeave, trigger.props.onMouseLeave),
                        onClick: makeChain(this.clearDocumentTimeout, trigger.props.onClick),
                        ref: 'trigger'
                    };
                    break;
                default:
                    props = {
                        ref: 'trigger'
                    };
            }
        }
        return _react2['default'].cloneElement(trigger, props);
    };

    Popup.prototype.componentDidMount = function componentDidMount() {
        this._renderOverlay();
        this.componentDidUpdate();
    };

    Popup.prototype.componentDidUpdate = function componentDidUpdate() {
        this._renderOverlay();
        this.addNodeForSafeClick(_reactDom2['default'].findDOMNode(this.refs.trigger));
    };

    Popup.prototype.componentWillUnmount = function componentWillUnmount() {
        var _this2 = this;

        ['_timer', '_hideTimer', '_showTimer'].forEach(function (time) {
            _this2[time] && clearTimeout(_this2[time]);
        });
        this._unRenderOverlay();
    };

    Popup.prototype._renderOverlay = function _renderOverlay() {
        var _this3 = this;

        if (!this.wrapper) {
            this.wrapper = document.createElement('div');
        }

        var _props2 = this.props,
            autoFocus = _props2.autoFocus,
            target = _props2.target,
            others = _objectWithoutProperties(_props2, ['autoFocus', 'target']);

        if (typeof target === 'undefined') {
            target = function target() {
                return _this3.refs.trigger;
            };
        }
        var overlay = _react2['default'].createElement(
            _overlay2['default'],
            _extends({}, others, {
                visible: this.state.visible,
                target: target,
                key: this.uniqueOverlayKey,
                autoFocus: autoFocus,
                onRequestClose: function onRequestClose(reason, e) {
                    return _this3.handleVisibleChange(false, reason, e);
                } }),
            this.getContent()
        );

        this.overlay = _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, overlay, this.wrapper);
    };

    Popup.prototype._unRenderOverlay = function _unRenderOverlay() {
        if (this.wrapper) {
            _reactDom2['default'].unmountComponentAtNode(this.wrapper);
            this.wrapper = null;
            this.overlay = null;
        }
    };

    Popup.prototype._onTriggerClick = function _onTriggerClick(event, other) {
        // Hack menu item problem
        // Will be remove at 2.x
        var e = event;
        if (other && other.stopPropagation) {
            e = other;
        }
        e.stopPropagation();
        var target = e.target;
        if (target.tagName.toLowerCase() === 'a') {
            e.preventDefault();
        }
        this.handleVisibleChange(!this.state.visible, 'fromTrigger', e);
    };

    Popup.prototype._onTriggerFocus = function _onTriggerFocus(e) {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
        this.handleVisibleChange(true, 'fromTrigger', e);
        e.stopPropagation();
    };

    Popup.prototype._onTriggerBlur = function _onTriggerBlur(e) {
        var _this4 = this;

        if (this._timer) {
            clearTimeout(this._timer);
        }
        this._timer = setTimeout(function () {
            if (!_this4._isForwardContent) {
                _this4.handleVisibleChange(false, 'fromTrigger', e);
            }
            _this4._isForwardContent = false;
        }, this.props.delay);
    };

    Popup.prototype._onContentMouseDown = function _onContentMouseDown() {
        this._isForwardContent = true;
    };

    Popup.prototype._onTriggerMouseEnter = function _onTriggerMouseEnter(e) {
        var _this5 = this;

        if (this._hideTimer) {
            clearTimeout(this._hideTimer);
            this._hideTimer = null;
        }
        this._showTimer = setTimeout(function () {
            _this5.handleVisibleChange(true, 'fromTrigger', e);
        }, this.props.delay);
    };

    Popup.prototype._onTriggerMouseLeave = function _onTriggerMouseLeave(e, type) {
        var _this6 = this;

        if (this._showTimer) {
            clearTimeout(this._showTimer);
            this._showTimer = null;
        }
        if (this.state.visible) {
            this._hideTimer = setTimeout(function () {
                _this6.handleVisibleChange(false, type || 'fromTrigger', e);
            }, this.props.delay);
        }
    };

    Popup.prototype._onTriggerKeyDown = function _onTriggerKeyDown(e) {
        // space
        // enter
        if (e.keyCode === 32 || e.keyCode === 13) {
            this._onTriggerClick(e);
        }
    };

    Popup.prototype._onContentMouseEnter = function _onContentMouseEnter() {
        clearTimeout(this._hideTimer);
    };

    Popup.prototype._onContentMouseLeave = function _onContentMouseLeave(e) {
        this._onTriggerMouseLeave(e, 'fromContent');
    };

    return Popup;
}(_react2['default'].Component), _class.propTypes = {
    align: PropTypes.string,
    offset: PropTypes.array,
    trigger: PropTypes.any,
    triggerType: PropTypes.node,
    visible: PropTypes.bool,
    defaultVisible: PropTypes.bool,
    disabled: PropTypes.bool,
    delay: PropTypes.number,
    canCloseByOutSideClick: PropTypes.bool,
    onVisibleChange: PropTypes.func,
    children: PropTypes.any,
    autoFocus: PropTypes.bool
}, _class.defaultProps = {
    triggerType: 'hover',
    trigger: _react2['default'].createElement('div', null),
    align: 'tl bl',
    offset: [0, 0],
    disabled: false,
    delay: 200,
    canCloseByOutSideClick: true,
    onVisibleChange: noop
}, _temp);
Popup.displayName = 'Popup';
exports['default'] = Popup;


var uuid = 0;

function getUniqueKey() {
    return 'overlay-' + uuid++;
}
module.exports = exports['default'];

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(155);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialog = __webpack_require__(156);

var _dialog2 = _interopRequireDefault(_dialog);

var _base = __webpack_require__(52);

var _base2 = _interopRequireDefault(_base);

var _content = __webpack_require__(53);

var _inner = __webpack_require__(84);

var _inner2 = _interopRequireDefault(_inner);

var _util = __webpack_require__(157);

var _index = __webpack_require__(87);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_dialog2['default'].Header = _content.Header;
_dialog2['default'].Body = _content.Body;
_dialog2['default'].Footer = _content.Footer;
_dialog2['default'].alert = _util.alert;
_dialog2['default'].confirm = _util.confirm;
_dialog2['default'].Inner = _inner2['default'];
_dialog2['default'].Base = _base2['default'];
_dialog2['default'].LOCALE = _index2['default'];

exports['default'] = _dialog2['default'];
module.exports = exports['default'];

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _class, _temp;

var _base = __webpack_require__(52);

var _base2 = _interopRequireDefault(_base);

var _content = __webpack_require__(53);

var _nextButton = __webpack_require__(49);

var _nextButton2 = _interopRequireDefault(_nextButton);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _nextLocaleProvider = __webpack_require__(85);

var _nextLocaleProvider2 = _interopRequireDefault(_nextLocaleProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PropTypes = _react2['default'].PropTypes,
    noop = function noop() {};

var Dialog = (_temp = _class = function (_Component) {
    _inherits(Dialog, _Component);

    function Dialog() {
        _classCallCheck(this, Dialog);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Dialog.prototype.render = function render() {
        /* eslint-disable no-unused-vars, react/prop-types */
        var _props = this.props,
            title = _props.title,
            children = _props.children,
            footer = _props.footer,
            onOk = _props.onOk,
            onCancel = _props.onCancel,
            locale = _props.locale,
            others = _objectWithoutProperties(_props, ['title', 'children', 'footer', 'onOk', 'onCancel', 'locale']),
            prefix = this.context.prefix || this.props.prefix,
            buttons = _react2['default'].createElement(
            'span',
            null,
            _react2['default'].createElement(
                _nextButton2['default'],
                { type: 'primary', onClick: onOk },
                locale.ok
            ),
            _react2['default'].createElement(
                _nextButton2['default'],
                { onClick: onCancel },
                locale.cancel
            )
        ),
            headerNode = title ? _react2['default'].createElement(
            _content.Header,
            null,
            title
        ) : null,
            footerNode = footer === false ? null : _react2['default'].createElement(
            _content.Footer,
            null,
            footer ? footer : buttons
        );

        return _react2['default'].createElement(
            _base2['default'],
            others,
            headerNode,
            _react2['default'].createElement(
                _content.Body,
                null,
                children
            ),
            footerNode
        );
    };

    return Dialog;
}(_react.Component), _class.propTypes = {
    prefix: PropTypes.string,
    title: PropTypes.any,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    locale: PropTypes.object
}, _class.defaultProps = {
    onOk: noop,
    onCancel: noop
}, _class.contextTypes = {
    prefix: PropTypes.string
}, _temp);
Dialog.displayName = 'Dialog';
exports['default'] = (0, _nextLocaleProvider2['default'])(Dialog);
module.exports = exports['default'];

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _nextButton = __webpack_require__(49);

var _nextButton2 = _interopRequireDefault(_nextButton);

var _nextFeedback = __webpack_require__(158);

var _nextFeedback2 = _interopRequireDefault(_nextFeedback);

var _nextLocaleProvider = __webpack_require__(85);

var _nextLocaleProvider2 = _interopRequireDefault(_nextLocaleProvider);

var _base = __webpack_require__(52);

var _base2 = _interopRequireDefault(_base);

var _content = __webpack_require__(53);

var _index = __webpack_require__(87);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var wrapper = function wrapper(fn, callback) {
    return function () {
        var res = void 0;
        if (typeof fn === 'function') {
            res = fn();
        }
        if (res && res.then) {
            res.then(function (result) {
                if (result !== false) {
                    callback();
                }
            });
        } else if (res !== false) {
            callback();
        }
    };
},
    feedbackMaps = {
    alert: 'prompt',
    confirm: 'help'
};

var Modal = (_temp = _class = function (_React$Component) {
    _inherits(Modal, _React$Component);

    function Modal(props) {
        _classCallCheck(this, Modal);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this.state = {
            visible: false
        };
        _this.close = _this.close.bind(_this);
        return _this;
    }
    /* eslint-disable react/no-did-mount-set-state */
    // preact compat
    // see https://github.com/developit/preact/issues/556
    // 我们通过触发componentWillReceiveProps绕过这个问题


    Modal.prototype.componentDidMount = function componentDidMount() {
        this.setState({
            visible: true
        });
    };

    Modal.prototype.render = function render() {
        /* eslint-disable react/prop-types */
        var _props = this.props,
            onOk = _props.onOk,
            onCancel = _props.onCancel,
            afterClose = _props.afterClose,
            className = _props.className,
            title = _props.title,
            type = _props.type,
            content = _props.content,
            locale = _props.locale,
            onClose = _props.onClose,
            needWrapper = _props.needWrapper,
            footer = _props.footer,
            others = _objectWithoutProperties(_props, ['onOk', 'onCancel', 'afterClose', 'className', 'title', 'type', 'content', 'locale', 'onClose', 'needWrapper', 'footer']);

        locale = locale || {
            ok: 'Ok',
            cancel: 'Cancel'
        };

        var Ok = wrapper(onOk, this.close),
            Cancel = wrapper(onCancel, this.close),
            Close = wrapper(onClose, this.close);

        return _react2['default'].createElement(
            _base2['default'],
            _extends({ onClose: Close,
                visible: this.state.visible,
                className: className,
                afterClose: afterClose,
                role: 'alertdialog'
            }, others),
            _react2['default'].createElement(
                _content.Header,
                null,
                title
            ),
            _react2['default'].createElement(
                _content.Body,
                null,
                _react2['default'].createElement(
                    'div',
                    { className: 'next-dialog-' + type },
                    needWrapper ? _react2['default'].createElement(_nextFeedback2['default'], { type: feedbackMaps[type], size: 'large', shape: 'addon', title: content }) : content
                )
            ),
            _react2['default'].createElement(
                _content.Footer,
                null,
                footer ? footer : [_react2['default'].createElement(
                    _nextButton2['default'],
                    { type: 'primary', onClick: Ok, key: 'ok' },
                    locale.ok
                ), type === 'confirm' ? _react2['default'].createElement(
                    _nextButton2['default'],
                    { type: 'normal', onClick: Cancel, key: 'cancel' },
                    locale.cancel
                ) : null]
            )
        );
    };

    Modal.prototype.close = function close() {
        if (this.state.visible) {
            this.setState({
                visible: false
            });
        }
    };

    return Modal;
}(_react2['default'].Component), _class.propTypes = {
    needWrapper: _react.PropTypes.bool
}, _class.defaultProps = {
    needWrapper: true
}, _temp);
Modal.displayName = 'Modal';


var LocaleModal = (0, _nextLocaleProvider2['default'])(Modal);
LocaleModal.LOCALE = _index2['default'];

var render = function render(config) {
    var container = document.createElement('div');
    var unMount = function unMount() {
        if (config && config.afterClose && typeof config.afterClose === 'function') {
            config.afterClose();
        }
        _reactDom2['default'].unmountComponentAtNode(container);
        container.parentNode.removeChild(container);
    };
    var instance = void 0;
    document.body.appendChild(container);
    _reactDom2['default'].render(_react2['default'].createElement(LocaleModal, _extends({}, config, { afterClose: unMount })), container, function () {
        instance = this;
    });
    return {
        hide: function hide() {
            var inc = instance && instance.getInstance();
            inc && inc.close();
        }
    };
};

Object.keys(feedbackMaps).forEach(function (method) {
    exports[method] = function (config) {
        config = config || {};
        config.type = method;
        return render(config);
    };
});

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _feedback = __webpack_require__(86);

var _feedback2 = _interopRequireDefault(_feedback);

var _toast = __webpack_require__(159);

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_feedback2['default'].toast = _toast2['default'];

exports['default'] = _feedback2['default'];
module.exports = exports['default'];

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _mask = __webpack_require__(160);

var _mask2 = _interopRequireDefault(_mask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var instance = void 0;
var hidingToast = void 0;

function handleConfig(config, type) {
    var newConfig = {};

    if (typeof config === 'string' || (0, _react.isValidElement)(config)) {
        newConfig.content = config;
    } else if (isObject(config)) {
        newConfig = _extends({}, config);
    }
    if (typeof newConfig.duration !== 'number') {
        newConfig.duration = 3000;
    }
    if (type) {
        newConfig.type = type;
    }

    return newConfig;
}

function isObject(obj) {
    return {}.toString.call(obj) === '[object Object]';
}

function open(config, type) {
    close();
    config = handleConfig(config, type);
    instance = _mask2['default'].create(config);
    if (config.duration > 0) {
        hidingToast && clearTimeout(hidingToast);
        hidingToast = setTimeout(close, config.duration);
    }
}

function close() {
    instance && instance.destroy();
    instance = null;
}

var toast = {
    show: function show(config) {
        open(config);
    },
    hide: function hide() {
        close();
    }
};
var types = ['success', 'prompt', 'error', 'help', 'loading'];
types.forEach(function (type) {
    toast[type] = function (config) {
        return open(config, type);
    };
});

exports['default'] = toast;
module.exports = exports['default'];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _nextOverlay = __webpack_require__(50);

var _nextOverlay2 = _interopRequireDefault(_nextOverlay);

var _feedback = __webpack_require__(86);

var _feedback2 = _interopRequireDefault(_feedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Mask = (_temp2 = _class = function (_React$Component) {
    _inherits(Mask, _React$Component);

    function Mask() {
        var _temp, _this, _ret;

        _classCallCheck(this, Mask);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            visible: true
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Mask.prototype.render = function render() {
        var prefix = this.context.prefix || this.props.prefix;
        /* eslint-disable no-unused-vars */

        var _props = this.props,
            propsPrefix = _props.prefix,
            type = _props.type,
            content = _props.content,
            align = _props.align,
            offset = _props.offset,
            hasMask = _props.hasMask,
            afterClose = _props.afterClose,
            others = _objectWithoutProperties(_props, ['prefix', 'type', 'content', 'align', 'offset', 'hasMask', 'afterClose']);
        /* eslint-enable */


        var visible = this.state.visible;

        return _react2['default'].createElement(
            _nextOverlay2['default'],
            { visible: visible, align: align, offset: offset, hasMask: hasMask, afterClose: afterClose },
            _react2['default'].createElement(_feedback2['default'], _extends({}, others, { type: type, shape: 'toast',
                title: content, className: prefix + 'feedback-wrapper' }))
        );
    };

    return Mask;
}(_react2['default'].Component), _class.contextTypes = {
    prefix: _react2['default'].PropTypes.string
}, _class.propTypes = {
    prefix: _react2['default'].PropTypes.string,
    type: _react2['default'].PropTypes.string,
    content: _react2['default'].PropTypes.node,
    align: _react2['default'].PropTypes.string,
    offset: _react2['default'].PropTypes.array,
    hasMask: _react2['default'].PropTypes.bool,
    afterClose: _react2['default'].PropTypes.func
}, _class.defaultProps = {
    prefix: 'next-',
    align: 'cc cc',
    offset: [0, 0],
    hasMask: false
}, _temp2);
Mask.displayName = 'Mask';
exports['default'] = Mask;


Mask.create = function (props) {
    /* eslint-disable no-unused-vars */
    var duration = props.duration,
        afterClose = props.afterClose,
        others = _objectWithoutProperties(props, ['duration', 'afterClose']);
    /* eslint-enable no-unused-vars */

    var div = document.createElement('div');
    document.body.appendChild(div);

    var closeChain = function closeChain() {
        _reactDom2['default'].unmountComponentAtNode(div);
        document.body.removeChild(div);

        afterClose && afterClose();
    };

    var mask = void 0;
    _reactDom2['default'].render(_react2['default'].createElement(Mask, _extends({ afterClose: closeChain }, others)), div, function () {
        mask = this;
    });

    return {
        component: mask,
        destroy: function destroy() {
            return mask && mask.setState({
                visible: false
            });
        }
    };
};
module.exports = exports['default'];

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(1);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39);
__webpack_require__(46);
module.exports = __webpack_require__(54).f('iterator');


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(164), __esModule: true };

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(165);
__webpack_require__(64);
__webpack_require__(170);
__webpack_require__(171);
module.exports = __webpack_require__(1).Symbol;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(2);
var has = __webpack_require__(18);
var DESCRIPTORS = __webpack_require__(16);
var $export = __webpack_require__(7);
var redefine = __webpack_require__(66);
var META = __webpack_require__(166).KEY;
var $fails = __webpack_require__(21);
var shared = __webpack_require__(43);
var setToStringTag = __webpack_require__(33);
var uid = __webpack_require__(32);
var wks = __webpack_require__(3);
var wksExt = __webpack_require__(54);
var wksDefine = __webpack_require__(55);
var enumKeys = __webpack_require__(167);
var isArray = __webpack_require__(168);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(15);
var toIObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(36);
var createDesc = __webpack_require__(30);
var _create = __webpack_require__(41);
var gOPNExt = __webpack_require__(169);
var $GOPD = __webpack_require__(38);
var $DP = __webpack_require__(14);
var $keys = __webpack_require__(27);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(90).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(31).f = $propertyIsEnumerable;
  __webpack_require__(56).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(25)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(17)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(32)('meta');
var isObject = __webpack_require__(15);
var has = __webpack_require__(18);
var setDesc = __webpack_require__(14).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(21)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(27);
var gOPS = __webpack_require__(56);
var pIE = __webpack_require__(31);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(24);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(19);
var gOPN = __webpack_require__(90).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('asyncIterator');


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(55)('observable');


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(173);
module.exports = __webpack_require__(1).Object.keys;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(45);
var $keys = __webpack_require__(27);

__webpack_require__(63)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(175), __esModule: true };

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(176);
module.exports = __webpack_require__(1).Object.setPrototypeOf;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(7);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(177).set });


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(15);
var anObject = __webpack_require__(8);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(23)(Function.call, __webpack_require__(38).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(179), __esModule: true };

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180);
var $Object = __webpack_require__(1).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(7);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(41) });


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(182);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(183), __esModule: true };

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(184);
module.exports = __webpack_require__(1).Object.assign;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(7);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(185) });


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(27);
var gOPS = __webpack_require__(56);
var pIE = __webpack_require__(31);
var toObject = __webpack_require__(45);
var IObject = __webpack_require__(62);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(21)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(187);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var bind = __webpack_require__(92);
var Axios = __webpack_require__(189);
var defaults = __webpack_require__(57);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(96);
axios.CancelToken = __webpack_require__(203);
axios.isCancel = __webpack_require__(95);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(204);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(57);
var utils = __webpack_require__(4);
var InterceptorManager = __webpack_require__(198);
var dispatchRequest = __webpack_require__(199);
var isAbsoluteURL = __webpack_require__(201);
var combineURLs = __webpack_require__(202);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(94);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var transformData = __webpack_require__(200);
var isCancel = __webpack_require__(95);
var defaults = __webpack_require__(57);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(96);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 205 */
/***/ (function(module, exports) {



/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(207);

var _H = __webpack_require__(208);

var _H2 = _interopRequireDefault(_H);

var _Pc = __webpack_require__(216);

var _Pc2 = _interopRequireDefault(_Pc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashBoard = function (_Component) {
  (0, _inherits3.default)(DashBoard, _Component);

  function DashBoard() {
    (0, _classCallCheck3.default)(this, DashBoard);
    return (0, _possibleConstructorReturn3.default)(this, _Component.call(this));
  }

  DashBoard.prototype.render = function render() {
    if (window.innerWidth <= 768) {
      return _react2.default.createElement(_H2.default, null);
    } else {
      return _react2.default.createElement(_Pc2.default, null);
    }
  };

  return DashBoard;
}(_react.Component);

exports.default = DashBoard;
module.exports = exports['default'];

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
//import CardContent from '../../components/CardContent';


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(209);

var _h = __webpack_require__(210);

var _h2 = _interopRequireDefault(_h);

var _h3 = __webpack_require__(211);

var _h4 = _interopRequireDefault(_h3);

var _h5 = __webpack_require__(214);

var _h6 = _interopRequireDefault(_h5);

var _mobxReact = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Computer = (_dec = (0, _mobxReact.inject)('dashboardStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(Computer, _Component);

  function Computer() {
    (0, _classCallCheck3.default)(this, Computer);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this));

    _this.state = {
      data: null
    };
    return _this;
  }

  Computer.prototype.componentDidMount = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var Content, goods;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return window.$ACE.get('Content');

            case 2:
              Content = _context.sent;
              _context.next = 5;
              return Content.fetchGoods(window.tms.moduleinfo.id);

            case 5:
              goods = _context.sent;

              this.setState({
                data: goods
              });
              _context.next = 9;
              return this.props.dashboardStore.init();

            case 9:
              if (this.props.dashboardStore.isLogin) {
                $.ajax({
                  url: '//page.aliyun.com/form/open/set_manjian/submit',
                  type: 'post',
                  data: {
                    'zhanghao': '12'
                  },
                  xhrFields: {
                    withCredentials: true
                  },
                  success: function success(res) {
                    var code = res.code;
                    if (code == 200 || code == '200') {
                      console.log('successs');
                    } else {
                      console.warn(res);
                    }
                  },
                  error: function error(XMLHttpRequest, textStatus, errorThrown) {
                    console.log(XMLHttpRequest, textStatus, errorThrown);
                  }
                });
              }

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function componentDidMount() {
      return _ref.apply(this, arguments);
    }

    return componentDidMount;
  }();

  Computer.prototype.render = function render() {
    //本次只上一版，所以把锚点和其他的模块先注释掉
    if (this.state.data) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_h2.default, null),
        _react2.default.createElement(_h4.default, null),
        _react2.default.createElement(_h6.default, this.state.data)
      );
    } else {
      return null;
    }
  };

  return Computer;
}(_react.Component)) || _class) || _class);
exports.default = Computer;
module.exports = exports['default'];

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(13);

__webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dialog = window.DN.Modal.dialog;
var Banner = (_dec = (0, _mobxReact.inject)('dashboardStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(Banner, _Component);

  function Banner(props) {
    (0, _classCallCheck3.default)(this, Banner);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.showDialog = function () {
      dialog({
        title: '活动规则',
        content: _this.props.dashboardStore.dialogContent,
        size: 'middle',
        button: [{
          text: '好的'
        }]
      });
    };

    _this.state = {};
    return _this;
  }

  Banner.prototype.componentDidMount = function componentDidMount() {
    this.props.dashboardStore.fetchDialogData();
  };

  //banner图和活动规则的展示
  Banner.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      { className: 'banner-wrap-h5' },
      _react2.default.createElement(
        'div',
        { className: 'banner' },
        _react2.default.createElement(
          'div',
          { className: 'small-title' },
          window.tms.moduleinfo.mainTitle
        ),
        _react2.default.createElement(
          'div',
          { className: 'rule-btn', onClick: this.showDialog, 'data-spm-click': 'gostr=/aliyun;locaid=showDialogH5' },
          '\u6D3B\u52A8\u89C4\u5219'
        )
      )
    );
  };

  return Banner;
}(_react.Component)) || _class) || _class);
exports.default = Banner;
module.exports = exports['default'];

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; /* eslint-disable */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(13);

__webpack_require__(212);

var _clipboardCopy = __webpack_require__(213);

var _clipboardCopy2 = _interopRequireDefault(_clipboardCopy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JumpPc = (_dec = (0, _mobxReact.inject)('dashboardStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	(0, _inherits3.default)(JumpPc, _Component);

	function JumpPc(props) {
		var _this2 = this;

		(0, _classCallCheck3.default)(this, JumpPc);

		var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

		_this.shareOut = function () {
			var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(url) {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								(0, _clipboardCopy2.default)(url);

							case 1:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}));

			return function (_x) {
				return _ref.apply(this, arguments);
			};
		}();

		_this.state = {};
		return _this;
	}

	JumpPc.prototype.componentDidMount = function componentDidMount() {};

	//banner图和活动规则的展示
	JumpPc.prototype.render = function render() {
		var _this3 = this;

		return _react2.default.createElement(
			'div',
			{ className: 'jump-pc-h5-wrap' },
			_react2.default.createElement(
				'div',
				{ className: 'jump-pc-h5' },
				_react2.default.createElement(
					'div',
					{ className: 'jump-top' },
					window.tms.moduleinfo.h5FirstCombo ? _react2.default.createElement(
						'div',
						{ className: 'jump-top-title' },
						_react2.default.createElement(
							'span',
							{ className: 'jump-top-desc-left' },
							window.tms.moduleinfo.h5FirstCombo
						),
						_react2.default.createElement(
							'span',
							{ className: 'jump-top-desc-right' },
							'\u79CD\u5957\u9910'
						)
					) : null,
					_react2.default.createElement(
						'div',
						{ className: 'jump-top-title' },
						_react2.default.createElement(
							'span',
							{ className: 'jump-top-desc-left' },
							window.tms.moduleinfo.h5FirstProduct
						),
						_react2.default.createElement(
							'span',
							{ className: 'jump-top-desc-right' },
							'\u6B3E\u4EA7\u54C1'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'jump-top-title' },
						_react2.default.createElement(
							'span',
							{ className: 'jump-top-desc-left' },
							window.tms.moduleinfo.h5FirstDiscount
						),
						_react2.default.createElement(
							'span',
							{ className: 'jump-top-desc-right' },
							'\u6298\u8D77'
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'jump-bottom' },
					_react2.default.createElement(
						'p',
						{ className: 'first-desc' },
						'\u672C\u6D3B\u52A8\u4EC5\u80FD\u5728\u7535\u8111\u7AEF\u53C2\u4E0E\uFF0C'
					),
					_react2.default.createElement(
						'p',
						{ className: 'second-desc' },
						'\u60A8\u53EF\u4EE5\u70B9\u6B64',
						_react2.default.createElement(
							'span',
							{ className: 'jump-desc', onClick: function onClick() {
									return _this3.shareOut('https://promotion.aliyun.com/ntms/act/package-refund.html');
								} },
							'\u590D\u5236\u6D3B\u52A8\u94FE\u63A5'
						),
						'\u5E76\u7528\u7535\u8111\u6D4F\u89C8\u5668\u6253\u5F00'
					)
				)
			)
		);
	};

	return JumpPc;
}(_react.Component)) || _class) || _class);
exports.default = JumpPc;
module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = clipboardCopy

function clipboardCopy (text) {
  // Use the Async Clipboard API when available
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(text)
  }

  // ...Otherwise, use document.execCommand() fallback

  // Put the text to copy into a <span>
  var span = document.createElement('span')
  span.textContent = text

  // Preserve consecutive spaces and newlines
  span.style.whiteSpace = 'pre'

  // An <iframe> isolates the <span> from the page's styles
  var iframe = document.createElement('iframe')
  iframe.sandbox = 'allow-same-origin'

  // Add the <iframe> to the page
  document.body.appendChild(iframe)
  var win = iframe.contentWindow

  // Add the <span> to the <iframe>
  win.document.body.appendChild(span)

  // Get a Selection object representing the range of text selected by the user
  var selection = win.getSelection()

  // Fallback for Firefox which fails to get a selection from an <iframe>
  if (!selection) {
    win = window
    selection = win.getSelection()
    document.body.appendChild(span)
  }

  var range = win.document.createRange()
  selection.removeAllRanges()
  range.selectNode(span)
  selection.addRange(range)

  var success = false
  try {
    success = win.document.execCommand('copy')
  } catch (err) {}

  selection.removeAllRanges()
  win.document.body.removeChild(span)
  document.body.removeChild(iframe)

  // The Async Clipboard API returns a promise that may reject with `undefined` so we
  // match that here for consistency.
  return success
    ? Promise.resolve()
    : Promise.reject() // eslint-disable-line prefer-promise-reject-errors
}


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; /* eslint-disable */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(13);

__webpack_require__(215);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var H5Card = (_dec = (0, _mobxReact.inject)('dashboardStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	(0, _inherits3.default)(H5Card, _Component);

	function H5Card(props) {
		(0, _classCallCheck3.default)(this, H5Card);

		var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

		_this.state = {};
		return _this;
	}

	H5Card.prototype.componentDidMount = function componentDidMount() {};

	H5Card.prototype.render = function render() {
		var h5List = window.tms.firstDescListLeft;
		var h5DiscountList = window.tms.firstDiscountsExplainList;
		var textArr = this.props.goods;
		textArr = textArr.filter(function (item) {
			return item.exts.keys && item.exts.keys.value;
		}); //去掉没有配置的项
		return _react2.default.createElement(
			'div',
			{ className: 'h5-card-wrap' },
			_react2.default.createElement(
				'div',
				{ className: 'h5-card' },
				_react2.default.createElement(
					'div',
					{ className: 'h5-card-top' },
					_react2.default.createElement(
						'p',
						{ className: 'h5-card-title' },
						window.tms.moduleinfo.fristFloor
					),
					_react2.default.createElement(
						'p',
						{ className: 'h5-card-second-title' },
						window.tms.moduleinfo.firstTitle
					),
					_react2.default.createElement(
						'div',
						{ className: 'h5-card-desc' },
						_react2.default.createElement(
							'ul',
							{ className: 'desc-left' },
							h5List.map(function (item, index) {
								return _react2.default.createElement(
									'li',
									{ className: 'desc-left-li', key: index },
									_react2.default.createElement(
										'span',
										{ className: 'point' },
										'\xB7'
									),
									_react2.default.createElement(
										'span',
										{ className: 'point-desc' },
										item.descLeft
									)
								);
							})
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'h5-card-bottom' },
					_react2.default.createElement(
						'h3',
						{ className: 'big-bottom-title' },
						'\u5957\u9910\u4EA7\u54C1'
					),
					textArr.map(function (item) {
						return _react2.default.createElement(
							'div',
							{ key: item.id },
							_react2.default.createElement(
								'p',
								{ className: 'bottom-title' },
								item.name
							),
							_react2.default.createElement(
								'p',
								{ className: 'bottom-desc' },
								item.description
							)
						);
					}),
					_react2.default.createElement(
						'h3',
						{ className: 'big-bottom-title' },
						'\u4F18\u60E0\u89C4\u5219'
					),
					h5DiscountList.map(function (item, index) {
						return _react2.default.createElement(
							'p',
							{ className: 'bottom-desc-discount', key: index },
							index + 1,
							'\u3001',
							item.discount
						);
					})
				)
			)
		);
	};

	return H5Card;
}(_react.Component)) || _class) || _class);
exports.default = H5Card;
module.exports = exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(217);

var _Banner = __webpack_require__(218);

var _Banner2 = _interopRequireDefault(_Banner);

var _CardContent = __webpack_require__(219);

var _CardContent2 = _interopRequireDefault(_CardContent);

var _mobxReact = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Computer = (_dec = (0, _mobxReact.inject)('dashboardStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(Computer, _Component);

  function Computer() {
    (0, _classCallCheck3.default)(this, Computer);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this));

    _this.state = {
      data: null
    };
    return _this;
  }

  Computer.prototype.componentDidMount = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var Content, goods;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return window.$ACE.get('Content');

            case 2:
              Content = _context.sent;
              _context.next = 5;
              return Content.fetchGoods(window.tms.moduleinfo.id);

            case 5:
              goods = _context.sent;
              _context.next = 8;
              return this.props.dashboardStore.init();

            case 8:
              this.setState({
                data: goods
              });
              if (this.props.dashboardStore.isLogin) {
                $.ajax({
                  url: '//page.aliyun.com/form/open/set_manjian/submit',
                  type: 'post',
                  data: {
                    'zhanghao': '12'
                  },
                  xhrFields: {
                    withCredentials: true
                  },
                  success: function success(res) {
                    var code = res.code;
                    if (code == 200 || code == '200') {
                      console.log('successs');
                    } else {
                      console.warn(res);
                    }
                  },
                  error: function error(XMLHttpRequest, textStatus, errorThrown) {
                    console.log(XMLHttpRequest, textStatus, errorThrown);
                  }
                });
              }

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function componentDidMount() {
      return _ref.apply(this, arguments);
    }

    return componentDidMount;
  }();

  Computer.prototype.render = function render() {
    //本次只上一版，所以把锚点和其他的模块先注释掉
    if (this.state.data) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Banner2.default, null),
        _react2.default.createElement(_CardContent2.default, this.state.data)
      );
    } else {
      return null;
    }
  };

  return Computer;
}(_react.Component)) || _class) || _class);
exports.default = Computer;
module.exports = exports['default'];

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(13);

__webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dialog = window.DN.Modal.dialog;
var Banner = (_dec = (0, _mobxReact.inject)('dashboardStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(Banner, _Component);

  function Banner(props) {
    (0, _classCallCheck3.default)(this, Banner);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.showDialog = function () {
      dialog({
        title: '活动规则',
        content: _this.props.dashboardStore.dialogContent,
        size: 'middle',
        button: [{
          text: '好的'
        }]
      });
    };

    _this.state = {};
    return _this;
  }

  Banner.prototype.componentDidMount = function componentDidMount() {
    this.props.dashboardStore.fetchDialogData();
  };

  //banner图和活动规则的展示
  Banner.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      { className: 'banner-wrap' },
      _react2.default.createElement(
        'div',
        { className: 'banner' },
        _react2.default.createElement(
          'div',
          { className: 'small-title' },
          window.tms.moduleinfo.mainTitle
        ),
        _react2.default.createElement(
          'div',
          { className: 'rule-btn', onClick: this.showDialog, 'data-spm-click': 'gostr=/aliyun;locaid=showDialog' },
          '\u6D3B\u52A8\u89C4\u5219'
        )
      )
    );
  };

  return Banner;
}(_react.Component)) || _class) || _class);
exports.default = Banner;
module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _stringify = __webpack_require__(88);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(91);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(28);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = __webpack_require__(220);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _iterator2 = __webpack_require__(89);

var _iterator3 = _interopRequireDefault(_iterator2);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _dec, _dec2, _class;

var runPromiseByQueue = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(myPromises) {
    var _iterator, _isArray, _i, _ref2, value;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (myPromises && (typeof myPromises[_iterator3.default] === 'function' || Array.isArray(myPromises))) {
              _context.next = 2;
              break;
            }

            throw new TypeError('Expected myPromises to be iterable, got ' + _inspect(myPromises));

          case 2:
            _iterator = myPromises, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);

          case 3:
            if (!_isArray) {
              _context.next = 9;
              break;
            }

            if (!(_i >= _iterator.length)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt('break', 18);

          case 6:
            _ref2 = _iterator[_i++];
            _context.next = 13;
            break;

          case 9:
            _i = _iterator.next();

            if (!_i.done) {
              _context.next = 12;
              break;
            }

            return _context.abrupt('break', 18);

          case 12:
            _ref2 = _i.value;

          case 13:
            value = _ref2;
            _context.next = 16;
            return value();

          case 16:
            _context.next = 3;
            break;

          case 18:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function runPromiseByQueue(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(13);

__webpack_require__(223);

var _Card = __webpack_require__(224);

var _Card2 = _interopRequireDefault(_Card);

var _reactUtil = __webpack_require__(225);

__webpack_require__(229);

__webpack_require__(230);

__webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spmC = _reactUtil.Tracker.spmC;
var CardContent = (_dec = spmC(), _dec2 = (0, _mobxReact.inject)('dashboardStore'), _dec(_class = _dec2(_class = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(CardContent, _Component);

  function CardContent(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, CardContent);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.addToCart = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
      var goodsList, requestList;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (_this.props.dashboardStore.isLogin) {
                _context3.next = 4;
                break;
              }

              _this.props.dashboardStore.handleNotLogin();
              _context3.next = 11;
              break;

            case 4:
              _this.setState({
                loading: true
              });
              goodsList = _this.props.dashboardStore.cartIndex.map(function (item) {
                return _this.props.goods[item];
              });
              //console.log(goodsList,"goodsList");

              requestList = goodsList.map(function (goods) {
                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                  return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return goods.product.addCart();

                        case 2:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                }));
              });
              _context3.next = 9;
              return runPromiseByQueue(requestList);

            case 9:
              _this.setState({
                loading: false
              });
              _this.props.dashboardStore.clearCart();

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    _this.leftPrice = function (productCodeListLength) {
      var firstRule = window.tms.moduleinfo.firstRule;
      if (productCodeListLength == 1) {
        return {
          leftPrice: firstRule.one.leftPrice,
          rightText: firstRule.one.rightText
        };
      } else if (productCodeListLength == 2) {
        return {
          leftPrice: firstRule.two.leftPrice,
          rightText: firstRule.two.rightText
        };
      } else if (productCodeListLength == 3) {
        return {
          leftPrice: firstRule.three.leftPrice,
          rightText: firstRule.three.rightText
        };
      } else if (productCodeListLength == 4) {
        return {
          leftPrice: firstRule.four.leftPrice,
          rightText: firstRule.four.rightText
        };
      } else if (productCodeListLength == 5 || productCodeListLength > 5) {
        return {
          leftPrice: firstRule.five.leftPrice,
          rightText: firstRule.five.rightText
        };
      } else {
        return {
          leftPrice: 0,
          rightText: '选2种产品，即可享受95折，最高可满减2500元'
        };
      }
    };

    _this.state = {
      loading: false
    };
    return _this;
  }
  // 批量加入购物车

  //根据满减规则配置的映射关系


  CardContent.prototype.componentDidMount = function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              $('.card-list').each(function () {
                var title = $(this).children().text();
                if ($(this)[0].offsetWidth < $(this)[0].scrollWidth) {
                  $(this).tooltipster({
                    theme: 'tooltipster-shadow',
                    delay: 100,
                    content: title
                  });
                }
              });

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function componentDidMount() {
      return _ref5.apply(this, arguments);
    }

    return componentDidMount;
  }();

  CardContent.prototype.render = function render() {
    var textArr = this.props.goods;
    textArr = textArr.filter(function (item) {
      return item.exts.keys && item.exts.keys.value;
    }); //去掉没有配置的项
    var textArrLength = textArr.length;
    var totalPrice = Number(this.props.dashboardStore.totalPrice).toFixed(2);
    var _props$dashboardStore = this.props.dashboardStore,
        totalProduct = _props$dashboardStore.totalProduct,
        loading = _props$dashboardStore.loading;

    var leftPrice = this.props.dashboardStore.productCodeListLength;
    leftPrice = this.leftPrice(leftPrice); //得到满减规则映射关系的对象

    return _react2.default.createElement(
      'div',
      { className: 'card-wrap' },
      _react2.default.createElement(
        'p',
        { className: 'first-title' },
        window.tms.moduleinfo.fristFloor
      ),
      _react2.default.createElement(
        'div',
        { className: 'card-content' },
        _react2.default.createElement(
          'div',
          { className: 'card-top' },
          _react2.default.createElement('img', { className: 'left-img', src: 'https://img.alicdn.com/tfs/TB14f6QAMHqK1RjSZFgXXa7JXXa-400-400.png', alt: '' }),
          _react2.default.createElement(
            'div',
            { className: 'card-left' },
            _react2.default.createElement(
              'div',
              { className: 'card-title' },
              window.tms.moduleinfo.firstTitle
            ),
            _react2.default.createElement(
              'div',
              { className: 'card-list-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'card-left-list' },
                window.tms.firstDescListLeft.map(function (item, index) {
                  return _react2.default.createElement(
                    'li',
                    { className: 'card-list', key: index },
                    '\xB7',
                    _react2.default.createElement(
                      'span',
                      { className: 'left-point' },
                      item.descLeft
                    )
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'card-right-list' },
                window.tms.firstDescListRight.map(function (item, index) {
                  return _react2.default.createElement(
                    'li',
                    { className: 'card-list', key: index },
                    '\xB7',
                    _react2.default.createElement(
                      'span',
                      { className: 'left-point' },
                      item.descRight
                    )
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'card-right' },
            _react2.default.createElement(
              'div',
              { className: 'card-title' },
              '\u4F18\u60E0\u8BF4\u660E'
            ),
            _react2.default.createElement(
              'ul',
              { className: 'card-list-wrap' },
              window.tms.firstDiscountsExplainList.map(function (item, index) {
                return _react2.default.createElement(
                  'li',
                  { className: 'card-list',
                    key: index },
                  _react2.default.createElement(
                    'span',
                    { className: 'point' },
                    index + 1,
                    '\u3001',
                    item.discount
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'card-bottom' },
          _react2.default.createElement('img', { className: 'right-img',
            src: 'https://img.alicdn.com/tfs/TB1dUnNAQvoK1RjSZFNXXcxMVXa-400-400.png', alt: '' }),
          _react2.default.createElement(
            'div',
            { className: 'card-module-top' },
            textArr.map(function (item, index) {
              return _react2.default.createElement(_Card2.default, { product: item.product, status: index, key: item.id,
                exts: item.exts, productCode: item.productCode, goods: item, textArrLength: textArrLength });
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'card-module-bottom' },
            _react2.default.createElement(
              'div',
              { className: 'card-module-bottom-left' },
              _react2.default.createElement(
                'span',
                { className: 'first-small-title' },
                '\u5DF2\u9009\u4EA7\u54C1:'
              ),
              _react2.default.createElement(
                'span',
                { className: 'first-small-desc' },
                totalProduct
              ),
              _react2.default.createElement(
                'span',
                { className: 'second-small-title' },
                '\u6700\u9AD8\u53EF\u4EAB\u6EE1\u51CF:'
              ),
              _react2.default.createElement(
                'span',
                { className: 'second-small-desc' },
                '\uFFE5',
                leftPrice.leftPrice
              ),
              _react2.default.createElement(
                'span',
                { className: 'third-btn' },
                leftPrice.rightText
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'card-module-bottom-right' },
              _react2.default.createElement(
                'div',
                { className: 'card-module-inner-left' },
                _react2.default.createElement(
                  'p',
                  { className: 'cart-desc' },
                  '\u5408\u8BA1:',
                  _react2.default.createElement(
                    'span',
                    { className: 'cart-num' },
                    loading ? _react2.default.createElement(
                      'span',
                      null,
                      '\u8BA1\u7B97\u4E2D...'
                    ) : _react2.default.createElement(
                      'span',
                      null,
                      '\uFFE5',
                      totalPrice
                    )
                  )
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'cart-second-desc' },
                  window.tms.moduleinfo.firstCartExplain
                )
              ),
              this.state.loading ? _react2.default.createElement(
                'div',
                { className: 'card-module-inner-right' },
                '\u52A0\u5165\u4E2D...'
              ) : _react2.default.createElement(
                'div',
                { className: (totalProduct ? '' : 'gray') + ' card-module-inner-right',
                  onClick: this.addToCart, 'data-spm-click': 'gostr=/aliyun;locaid=cart' },
                '\u52A0\u5165\u8D2D\u7269\u8F66'
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        'p',
        { className: 'tips' },
        window.tms.moduleinfo.firstTips,
        _react2.default.createElement(
          'a',
          { className: 'jump',
            href: window.tms.moduleinfo.firstJumpUrl, target: '_blank' },
          window.tms.moduleinfo.firstJumpTips
        )
      )
    );
  };

  return CardContent;
}(_react.Component)) || _class) || _class) || _class);
exports.default = CardContent;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(221), __esModule: true };

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
__webpack_require__(39);
module.exports = __webpack_require__(222);


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var get = __webpack_require__(71);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(20);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; /* eslint-disable */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(13);

var _mobx = __webpack_require__(48);

var _aps = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _aps.Select.Option;
var Card = (_dec = (0, _mobxReact.inject)('dashboardStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(Card, _Component);

  function Card(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, Card);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.popUpConfig = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.props.dashboardStore.isLogin) {
                _context.next = 12;
                break;
              }

              _context.next = 3;
              return _this.props.product.popUpConfig();

            case 3:
              _context.next = 5;
              return _this.queryPrice();

            case 5:
              _context.next = 7;
              return _this.props.dashboardStore.chooseCardPopUpConfig(_this.props.status);

            case 7:
              _this.props.dashboardStore.addProduct(_this.props.productCode);
              _this.props.dashboardStore.addCart(_this.props.status);
              _this.props.dashboardStore.changeTotalPrice(_this.props.status, _this.state.initPrice);
              _context.next = 13;
              break;

            case 12:
              _this.props.dashboardStore.handleNotLogin();

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.format = function (value) {
      var valueArr = [];
      valueArr = value.split(":");
      var showText = '';
      if (valueArr[1] == "Month") {
        showText = "月";
      } else {
        showText = "年";
      }
      showText = valueArr[0] + showText + '';
      return showText;
    };

    _this.removeUndefined = function (price) {
      if (price === undefined) {
        return 0;
      } else {
        return price;
      }
    };

    _this.queryPrice = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var priceObj, defaultValue;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.props.dashboardStore.changeLoading(true);
              _this.setState({
                loading: true
              });
              _context2.next = 4;
              return _this.product.getAllPrice();

            case 4:
              priceObj = _context2.sent;
              _context2.next = 7;
              return _this.product.getValue();

            case 7:
              defaultValue = _context2.sent;

              //console.log(priceObj, 'priceObj', defaultValue)

              if (defaultValue.ord_time) {
                _this.showText = _this.format(defaultValue.ord_time);
              }
              //console.log(this.showText, "showText")
              _this.setState({
                initPrice: _this.removeUndefined(priceObj.price),
                isServer: priceObj.isServer,
                discountPrice: _this.removeUndefined(priceObj.discountPrice)
              });
              _this.props.dashboardStore.changeTotalPrice(_this.props.status, _this.removeUndefined(priceObj.price)); //改变价格
              _this.props.dashboardStore.changeLoading(false);
              _this.setState({
                loading: false
              });

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.product = props.product;
    _this.showText = '';
    _this.exts = [];
    _this.readKeys = [];
    if (props.exts && props.exts.keys) {
      _this.exts = props.exts.keys.value.split('|');
    }
    if (props.exts && props.exts.readKeys) {
      _this.readKeys = props.exts.readKeys.value.split('|');
    }
    _this.state = {
      defaultValue: null, //通过product获取的默认选项
      selectArr: null, //通过exts匹配过后的列表选项
      initPrice: null, //没有询价前得到的默认价格
      discountPrice: null, //没有询价前得到的默认折扣价格
      loading: false,
      isServer: true
    };
    return _this;
  }

  Card.prototype.componentDidMount = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.props.product.setValueWithConstranit();

            case 2:
              _context3.next = 4;
              return this.queryPrice();

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function componentDidMount() {
      return _ref3.apply(this, arguments);
    }

    return componentDidMount;
  }();
  //处理售罄的情况price为undefined的情况


  Card.prototype.onChange = function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(key, event) {
      var _props$product$setVal;

      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              this.setState({
                loading: true
              });
              _context4.next = 3;
              return this.props.product.setValueWithConstranit((_props$product$setVal = {}, _props$product$setVal[key] = event.target.value, _props$product$setVal));

            case 3:
              this.queryPrice();

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function onChange(_x, _x2) {
      return _ref4.apply(this, arguments);
    }

    return onChange;
  }();

  Card.prototype.chooseCard = function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(productCode) {
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (this.props.dashboardStore.isLogin) {
                _context5.next = 4;
                break;
              }

              this.props.dashboardStore.handleNotLogin();
              _context5.next = 7;
              break;

            case 4:
              _context5.next = 6;
              return this.props.dashboardStore.chooseCard(this.props.status);

            case 6:
              if (this.props.dashboardStore.cardStatus[this.props.status]) {
                this.props.dashboardStore.addProduct(productCode);
                this.props.dashboardStore.addCart(this.props.status);
                this.props.dashboardStore.changeTotalPrice(this.props.status, this.state.initPrice); //选中的时候把价格改为当时的价格
              } else {
                this.props.dashboardStore.removeProduct(productCode, this.props.status); //移除这个商品
                this.props.dashboardStore.changeTotalPrice(this.props.status, 0); //把价格改为0
                this.props.dashboardStore.removeCart(this.props.status); //把这个商品从购物车移除      
              }

            case 7:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function chooseCard(_x3) {
      return _ref5.apply(this, arguments);
    }

    return chooseCard;
  }();

  Card.prototype.render = function render() {
    var _this3 = this;

    //console.log(this.sellOut,"this.sellOut")
    var productCode = this.props.productCode;
    var _props$goods = this.props.goods,
        name = _props$goods.name,
        description = _props$goods.description,
        product = _props$goods.product;

    var nowConfig = product.getValue();
    //console.log(nowConfig,"nowConfig")
    // 选项
    var nowOptions = this.props.product.getOptions();
    var selectArr = [];
    this.exts.map(function (item) {
      var abc = nowOptions.find(function (element) {
        return element.label == item;
      });
      selectArr.push(abc);
    });
    // end 选项
    var initPrice = Number(this.state.initPrice).toFixed(2);
    var discountPrice = Number(this.state.discountPrice).toFixed(2);
    var textArrLength = this.props.textArrLength;
    var cardStatus = this.props.dashboardStore.cardStatus;

    var status = this.props.status;
    var cardWidth = 1120 / textArrLength - 8 + "px";
    cardWidth = { width: cardWidth };
    var sellOut = this.props.product.hasSetValue && !this.state.isServer && !this.state.loading;
    var readKeys = this.readKeys;
    //console.log(this.readKeys,"this.readKeys",selectArr,"selectArr");

    return _react2.default.createElement(
      'div',
      { className: '' + (cardStatus[status] ? "card-inner-active" : 'card-inner'), style: cardWidth },
      _react2.default.createElement(
        'div',
        { className: 'card-inner-top', onClick: function onClick() {
            return _this3.chooseCard(productCode);
          } },
        cardStatus[status] ? _react2.default.createElement(
          'div',
          { className: 'img-wrap' },
          _react2.default.createElement('img', { className: 'arrow-img', src: 'https://img.alicdn.com/tfs/TB16OGsAFzqK1RjSZFoXXbfcXXa-28-20.png', alt: '' })
        ) : null,
        _react2.default.createElement('div', { className: 'hover-block' }),
        _react2.default.createElement(
          'p',
          { className: 'card-inner-top-title' },
          name ? name : ""
        ),
        _react2.default.createElement(
          'p',
          { className: 'card-inner-top-desc' },
          description ? description : ""
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'card-inner-middle' },
        selectArr ? selectArr.map(function (item, index) {
          if (readKeys.indexOf(item.label) != -1) {
            //console.log(item,"item");
            var abc = item.value.find(function (element) {
              return element.value == nowConfig[item.key];
            });
            return _react2.default.createElement(
              'div',
              { className: 'card-inner-middle-select', key: index },
              _react2.default.createElement(
                'span',
                { className: 'card-inner-middle-title' },
                item.label
              ),
              _react2.default.createElement(
                'span',
                { className: 'card-inner-middle-desc' },
                abc.text
              )
            );
          } else {
            return _react2.default.createElement(
              'div',
              { className: 'card-inner-middle-select', key: index },
              _react2.default.createElement(
                'span',
                { className: 'card-inner-middle-title' },
                item.label
              ),
              _react2.default.createElement(
                _aps.Select,
                {
                  value: nowConfig[item.key],
                  onChange: _this3.onChange.bind(_this3, item.key),
                  size: 'small', style: { flex: '1', width: '100%' } },
                item.value.map(function (item) {
                  return _react2.default.createElement(
                    Option,
                    { value: item.value, key: item.value },
                    item.text
                  );
                })
              )
            );
          }
        }) : null,
        sellOut ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { className: 'price' },
            _react2.default.createElement(
              'span',
              null,
              '\u5DF2\u552E\u7F44'
            )
          )
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { className: 'price' },
            this.state.loading ? _react2.default.createElement(
              'span',
              null,
              '\u8BA1\u7B97\u4E2D...'
            ) : _react2.default.createElement(
              'span',
              null,
              initPrice,
              '\u5143/',
              this.showText
            )
          ),
          _react2.default.createElement(
            'p',
            { className: 'discount' },
            this.state.loading ? _react2.default.createElement(
              'span',
              null,
              '\u8BA1\u7B97\u4E2D...'
            ) : _react2.default.createElement(
              'span',
              null,
              '\u7701',
              discountPrice,
              '\u5143/',
              this.showText
            )
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'card-inner-bottom', onClick: this.popUpConfig, 'data-spm-click': 'gostr=/aliyun;locaid=' + this.props.status },
        '\u9009\u62E9\u8BE6\u7EC6\u914D\u7F6E'
      )
    );
  };

  return Card;
}(_react.Component)) || _class) || _class);
exports.default = Card;
module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyShare = exports.QQShare = exports.WeiBoShare = exports.Tracker = exports.WeiXinShare = exports.DingShare = undefined;

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.online = online;
exports.offline = offline;

var _react = __webpack_require__(0);

var _tracker = __webpack_require__(226);

var _tracker2 = _interopRequireDefault(_tracker);

var _aps = __webpack_require__(59);

__webpack_require__(99);

__webpack_require__(227);

var _qrCode = __webpack_require__(228);

var ShareComponent = _interopRequireWildcard(_qrCode);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// const { Util: { timer } } = window.$ACE;


var DingShare = exports.DingShare = ShareComponent.DingShare;
var WeiXinShare = exports.WeiXinShare = ShareComponent.WeiXinShare;

var timer = function timer(time, cb) {
  var target = new Date(time);
  var flag = Date.now() >= target;
  if (!flag) {
    var interval = setInterval(function () {
      if (Date.now() >= target) {
        cb();
        clearInterval(interval);
      }
    }, 1000);
  } else {
    cb();
  }
  return flag;
};
// 上线组件
function online(time) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var Offline = function (_BaseComponent) {
      _inherits(Offline, _BaseComponent);

      function Offline(props) {
        _classCallCheck(this, Offline);

        var _this = _possibleConstructorReturn(this, (Offline.__proto__ || Object.getPrototypeOf(Offline)).call(this, props));

        _this.state = {
          component: null
        };
        return _this;
      }

      _createClass(Offline, [{
        key: 'componentDidMount',
        value: function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var _this2 = this;

            var isArrived;
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    isArrived = timer(time, function () {
                      console.log('到达上线时间', time);
                      _this2.setState({
                        component: factory(_this2.props)
                      });
                    });

                    if (!isArrived) {
                      console.log('未到上线时间');
                    }

                  case 2:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          function componentDidMount() {
            return _ref.apply(this, arguments);
          }

          return componentDidMount;
        }()
      }, {
        key: 'render',
        value: function render() {
          return this.state.component;
        }
      }]);

      return Offline;
    }(BaseComponent);

    return Offline;
  };
}
// 下线组件
function offline(time) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var Offline = function (_BaseComponent2) {
      _inherits(Offline, _BaseComponent2);

      function Offline(props) {
        _classCallCheck(this, Offline);

        var _this3 = _possibleConstructorReturn(this, (Offline.__proto__ || Object.getPrototypeOf(Offline)).call(this, props));

        _this3.state = {
          component: null
        };
        return _this3;
      }

      _createClass(Offline, [{
        key: 'componentDidMount',
        value: function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var _this4 = this;

            var isArrived;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    isArrived = timer(time, function () {
                      console.log('到达下线时间', time);
                      _this4.setState({
                        component: null
                      });
                    });

                    if (!isArrived) {
                      console.log('未到下线时间');
                      this.setState({
                        component: factory(this.props)
                      });
                    }

                  case 2:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          function componentDidMount() {
            return _ref2.apply(this, arguments);
          }

          return componentDidMount;
        }()
      }, {
        key: 'render',
        value: function render() {
          return this.state.component;
        }
      }]);

      return Offline;
    }(BaseComponent);

    return Offline;
  };
}
var Tracker = exports.Tracker = _tracker2.default;

var WeiBoShare = exports.WeiBoShare = function (_Component) {
  _inherits(WeiBoShare, _Component);

  function WeiBoShare() {
    _classCallCheck(this, WeiBoShare);

    return _possibleConstructorReturn(this, (WeiBoShare.__proto__ || Object.getPrototypeOf(WeiBoShare)).apply(this, arguments));
  }

  _createClass(WeiBoShare, [{
    key: 'render',
    value: function render() {
      var _this6 = this;

      return React.createElement(
        'div',
        { className: 'share-button-wrapper', onClick: function onClick() {
            var shareInstance = window.$ACE.Share.create(_extends({}, _this6.props));
            var PC = shareInstance.createPC();
            window.open(PC.weibo());
          } },
        this.props.children
      );
    }
  }]);

  return WeiBoShare;
}(_react.Component);

var QQShare = exports.QQShare = function (_Component2) {
  _inherits(QQShare, _Component2);

  function QQShare() {
    _classCallCheck(this, QQShare);

    return _possibleConstructorReturn(this, (QQShare.__proto__ || Object.getPrototypeOf(QQShare)).apply(this, arguments));
  }

  _createClass(QQShare, [{
    key: 'render',
    value: function render() {
      var _this8 = this;

      return React.createElement(
        'div',
        { className: 'share-button-wrapper', onClick: function onClick() {
            var shareInstance = window.$ACE.Share.create(_extends({}, _this8.props));
            var PC = shareInstance.createPC();
            window.open(PC.qq());
          } },
        this.props.children
      );
    }
  }]);

  return QQShare;
}(_react.Component);

var CopyShare = exports.CopyShare = function (_Component3) {
  _inherits(CopyShare, _Component3);

  function CopyShare(props) {
    _classCallCheck(this, CopyShare);

    var _this9 = _possibleConstructorReturn(this, (CopyShare.__proto__ || Object.getPrototypeOf(CopyShare)).call(this, props));

    _this9.state = {
      visible: false
    };
    return _this9;
  }

  _createClass(CopyShare, [{
    key: 'render',
    value: function render() {
      var _this10 = this;

      return React.createElement(
        'div',
        { className: 'share-button-wrapper', onClick: function onClick() {
            var shareInstance = window.$ACE.Share.create(_extends({}, _this10.props));
            var PC = shareInstance.createPC();
            PC.copyLink().then();
            _this10.setState({
              visible: true
            });
            setTimeout(function () {
              _this10.setState({
                visible: false
              });
            }, 2000);
          } },
        React.createElement(
          _aps.Tooltip,
          {
            visible: this.state.visible,
            trigger: this.props.children
          },
          '\u590D\u5236\u6210\u529F\uFF0C\u5FEB\u53BB\u5206\u4EAB\u5427~'
        )
      );
    }
  }]);

  return CopyShare;
}(_react.Component);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = {
  setSPM: function setSPM(spmA, spmB) {
    return function (WrappedComponent) {
      var SetSpm = function (_Component) {
        _inherits(SetSpm, _Component);

        function SetSpm() {
          _classCallCheck(this, SetSpm);

          return _possibleConstructorReturn(this, (SetSpm.__proto__ || Object.getPrototypeOf(SetSpm)).apply(this, arguments));
        }

        _createClass(SetSpm, [{
          key: 'render',
          value: function render() {
            return React.createElement(WrappedComponent, this.props);
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (window.$ACE) {
              window.$ACE.Tracker.setPageSPM(spmA, spmB);
            }
          }
        }]);

        return SetSpm;
      }(_react.Component);

      return SetSpm;
    };
  },
  spmC: function spmC(_spmC) {
    return function (WrappedComponent) {
      var SpmC = function (_Component2) {
        _inherits(SpmC, _Component2);

        function SpmC() {
          _classCallCheck(this, SpmC);

          return _possibleConstructorReturn(this, (SpmC.__proto__ || Object.getPrototypeOf(SpmC)).apply(this, arguments));
        }

        _createClass(SpmC, [{
          key: 'render',
          value: function render() {
            var name = WrappedComponent.displayName || WrappedComponent.name || 'Component';
            return React.createElement(
              'div',
              { 'data-spm': _spmC ? _spmC : name },
              React.createElement(WrappedComponent, this.props)
            );
          }
        }]);

        return SpmC;
      }(_react.Component);

      return SpmC;
    };
  }
};

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DingShare = exports.WeiXinShare = undefined;

var _regenerator = __webpack_require__(11);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _aps = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QrCodeShare = function (_Component) {
  _inherits(QrCodeShare, _Component);

  function QrCodeShare(props) {
    _classCallCheck(this, QrCodeShare);

    var _this = _possibleConstructorReturn(this, (QrCodeShare.__proto__ || Object.getPrototypeOf(QrCodeShare)).call(this, props));

    _this.state = {
      img: null,
      click: false,
      loading: null
    };
    return _this;
  }

  _createClass(QrCodeShare, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var shareInstance, PC;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                shareInstance = window.$ACE.Share.create();
                PC = shareInstance.createPC();

                this.PC = PC;
                this.setImage(this.props.url);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'track',
    value: function track() {
      if (this.type == 'weixin') {
        // 悬浮框点击后，才会去发起打点请求
        this.PC.weixinTrack();
      } else {
        // 悬浮框点击后，才会去发起打点请求
        this.PC.dingTrack();
      }
    }
  }, {
    key: 'setImage',
    value: function setImage(url) {
      if (this.type == 'weixin') {
        this.setState({ img: this.PC.weixin({ url: url }) });
        if (this.click) {
          // 悬浮框点击后，才会去发起打点请求
          this.PC.weixinTrack();
        }
      } else {
        this.setState({ img: this.PC.ding({ url: url }) });
        if (this.click) {
          // 悬浮框点击后，才会去发起打点请求
          this.PC.dingTrack();
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.url != this.props.url) {
        var url = nextProps.url;
        if (!url) {
          return this.setState({ img: null });
        }
        this.setImage(url);
      }
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      return _react2.default.createElement(
        'div',
        { style: { textAlign: 'center', paddingTop: '20px' } },
        _react2.default.createElement(_aps.Icon, { type: 'loading', spin: true }),
        _react2.default.createElement(
          'p',
          null,
          '\u52A0\u8F7D\u4E2D...'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { onClick: function onClick() {
            _this2.props.onClick && _this2.props.onClick();
          }, className: 'share-button-wrapper' },
        _react2.default.createElement(
          _aps.Tooltip,
          {
            theme: 'light',
            direction: 'top',
            align: 'center',
            triggerType: 'click',
            trigger: _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  _this2.track();
                } },
              this.props.children
            )
          },
          _react2.default.createElement(
            'div',
            { className: 'qrcode-wrapper' },
            !this.props.loading ? _react2.default.createElement('img', { src: this.state.img, style: { display: this.state.img ? 'block' : 'none' } }) : this.renderLoading()
          )
        )
      );
    }
  }]);

  return QrCodeShare;
}(_react.Component);

var WeiXinShare = exports.WeiXinShare = function (_QrCodeShare) {
  _inherits(WeiXinShare, _QrCodeShare);

  function WeiXinShare(props) {
    _classCallCheck(this, WeiXinShare);

    var _this3 = _possibleConstructorReturn(this, (WeiXinShare.__proto__ || Object.getPrototypeOf(WeiXinShare)).call(this, props));

    _this3.type = 'weixin';
    return _this3;
  }

  return WeiXinShare;
}(QrCodeShare);

var DingShare = exports.DingShare = function (_QrCodeShare2) {
  _inherits(DingShare, _QrCodeShare2);

  function DingShare(props) {
    _classCallCheck(this, DingShare);

    var _this4 = _possibleConstructorReturn(this, (DingShare.__proto__ || Object.getPrototypeOf(DingShare)).call(this, props));

    _this4.type = 'ding';
    return _this4;
  }

  return DingShare;
}(QrCodeShare);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof2 = __webpack_require__(28);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var defaults = {
  animation: 'fade',
  animationDuration: 350,
  content: null,
  contentAsHTML: false,
  contentCloning: false,
  debug: true,
  delay: 300,
  delayTouch: [300, 500],
  functionInit: null,
  functionBefore: null,
  functionReady: null,
  functionAfter: null,
  functionFormat: null,
  IEmin: 6,
  interactive: false,
  multiple: false,
  // must be 'body' for now, or an element positioned at (0, 0)
  // in the document, typically like the very top views of an app.
  parent: 'body',
  plugins: ['sideTip'],
  repositionOnScroll: false,
  restoration: 'none',
  selfDestruction: true,
  theme: [],
  timer: 0,
  trackerInterval: 500,
  trackOrigin: false,
  trackTooltip: false,
  trigger: 'hover',
  triggerClose: {
    click: false,
    mouseleave: false,
    originClick: false,
    scroll: false,
    tap: false,
    touchleave: false
  },
  triggerOpen: {
    click: false,
    mouseenter: false,
    tap: false,
    touchstart: false
  },
  updateAnimation: 'rotate',
  zIndex: 9999999
},

// we'll avoid using the 'window' global as a good practice but npm's
// jquery@<2.1.0 package actually requires a 'window' global, so not sure
// it's useful at all
win = typeof window != 'undefined' ? window : null,

// env will be proxied by the core for plugins to have access its properties
env = {
  // detect if this device can trigger touch events. Better have a false
  // positive (unused listeners, that's ok) than a false negative.
  // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js
  // http://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
  hasTouchCapability: !!(win && ('ontouchstart' in win || win.DocumentTouch && win.document instanceof win.DocumentTouch || win.navigator.maxTouchPoints)),
  hasTransitions: transitionSupport(),
  IE: false,
  // don't set manually, it will be updated by a build task after the manifest
  semVer: '4.1.6',
  window: win
},
    core = function core() {
  // core variables

  // the core emitters
  this.__$emitterPrivate = $({});
  this.__$emitterPublic = $({});
  this.__instancesLatestArr = [];
  // collects plugin constructors
  this.__plugins = {};
  // proxy env variables for plugins who might use them
  this._env = env;
};

// core methods
core.prototype = {
  /**
   * A function to proxy the public methods of an object onto another
   *
   * @param {object} constructor The constructor to bridge
   * @param {object} obj The object that will get new methods (an instance or the core)
   * @param {string} pluginName A plugin name for the console log message
   * @return {core}
   * @private
   */
  __bridge: function __bridge(constructor, obj, pluginName) {
    // if it's not already bridged
    if (!obj[pluginName]) {
      var fn = function fn() {};
      fn.prototype = constructor;

      var pluginInstance = new fn();

      // the _init method has to exist in instance constructors but might be missing
      // in core constructors
      if (pluginInstance.__init) {
        pluginInstance.__init(obj);
      }

      $.each(constructor, function (methodName, fn) {
        // don't proxy "private" methods, only "protected" and public ones
        if (methodName.indexOf('__') != 0) {
          // if the method does not exist yet
          if (!obj[methodName]) {
            obj[methodName] = function () {
              return pluginInstance[methodName].apply(pluginInstance, Array.prototype.slice.apply(arguments));
            };

            // remember to which plugin this method corresponds (several plugins may
            // have methods of the same name, we need to be sure)
            obj[methodName].bridged = pluginInstance;
          } else if (defaults.debug) {
            console.log('The ' + methodName + ' method of the ' + pluginName + ' plugin conflicts with another plugin or native methods');
          }
        }
      });

      obj[pluginName] = pluginInstance;
    }

    return this;
  },

  /**
   * For mockup in Node env if need be, for testing purposes
   *
   * @return {core}
   * @private
   */
  __setWindow: function __setWindow(window) {
    env.window = window;
    return this;
  },

  /**
   * Returns a ruler, a tool to help measure the size of a tooltip under
   * various settings. Meant for plugins
   *
   * @see Ruler
   * @return {object} A Ruler instance
   * @protected
   */
  _getRuler: function _getRuler($tooltip) {
    return new Ruler($tooltip);
  },

  /**
   * For internal use by plugins, if needed
   *
   * @return {core}
   * @protected
   */
  _off: function _off() {
    this.__$emitterPrivate.off.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
    return this;
  },

  /**
   * For internal use by plugins, if needed
   *
   * @return {core}
   * @protected
   */
  _on: function _on() {
    this.__$emitterPrivate.on.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
    return this;
  },

  /**
   * For internal use by plugins, if needed
   *
   * @return {core}
   * @protected
   */
  _one: function _one() {
    this.__$emitterPrivate.one.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
    return this;
  },

  /**
   * Returns (getter) or adds (setter) a plugin
   *
   * @param {string|object} plugin Provide a string (in the full form
   * "namespace.name") to use as as getter, an object to use as a setter
   * @return {object|core}
   * @protected
   */
  _plugin: function _plugin(plugin) {
    var self = this;

    // getter
    if (typeof plugin == 'string') {
      var _pluginName = plugin,
          p = null;

      // if the namespace is provided, it's easy to search
      if (_pluginName.indexOf('.') > 0) {
        p = self.__plugins[_pluginName];
      } else {
        // otherwise, return the first name that matches
        $.each(self.__plugins, function (i, plugin) {
          if (plugin.name.substring(plugin.name.length - _pluginName.length - 1) == '.' + _pluginName) {
            p = plugin;
            return false;
          }
        });
      }

      return p;
    } else {
      // setter
      // force namespaces
      if (plugin.name.indexOf('.') < 0) {
        throw new Error('Plugins must be namespaced');
      }

      self.__plugins[plugin.name] = plugin;

      // if the plugin has core features
      if (plugin.core) {
        // bridge non-private methods onto the core to allow new core methods
        self.__bridge(plugin.core, self, plugin.name);
      }

      return this;
    }
  },

  /**
   * Trigger events on the core emitters
   *
   * @returns {core}
   * @protected
   */
  _trigger: function _trigger() {
    var args = Array.prototype.slice.apply(arguments);

    if (typeof args[0] == 'string') {
      args[0] = { type: args[0] };
    }

    // note: the order of emitters matters
    this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate, args);
    this.__$emitterPublic.trigger.apply(this.__$emitterPublic, args);

    return this;
  },

  /**
   * Returns instances of all tooltips in the page or an a given element
   *
   * @param {string|HTML object collection} selector optional Use this
   * parameter to restrict the set of objects that will be inspected
   * for the retrieval of instances. By default, all instances in the
   * page are returned.
   * @return {array} An array of instance objects
   * @public
   */
  instances: function instances(selector) {
    var instances = [],
        sel = selector || '.tooltipstered';

    $(sel).each(function () {
      var $this = $(this),
          ns = $this.data('tooltipster-ns');

      if (ns) {
        $.each(ns, function (i, namespace) {
          instances.push($this.data(namespace));
        });
      }
    });

    return instances;
  },

  /**
   * Returns the Tooltipster objects generated by the last initializing call
   *
   * @return {array} An array of instance objects
   * @public
   */
  instancesLatest: function instancesLatest() {
    return this.__instancesLatestArr;
  },

  /**
   * For public use only, not to be used by plugins (use ::_off() instead)
   *
   * @return {core}
   * @public
   */
  off: function off() {
    this.__$emitterPublic.off.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
    return this;
  },

  /**
   * For public use only, not to be used by plugins (use ::_on() instead)
   *
   * @return {core}
   * @public
   */
  on: function on() {
    this.__$emitterPublic.on.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
    return this;
  },

  /**
   * For public use only, not to be used by plugins (use ::_one() instead)
   *
   * @return {core}
   * @public
   */
  one: function one() {
    this.__$emitterPublic.one.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
    return this;
  },

  /**
   * Returns all HTML elements which have one or more tooltips
   *
   * @param {string} selector optional Use this to restrict the results
   * to the descendants of an element
   * @return {array} An array of HTML elements
   * @public
   */
  origins: function origins(selector) {
    var sel = selector ? selector + ' ' : '';

    return $(sel + '.tooltipstered').toArray();
  },

  /**
   * Change default options for all future instances
   *
   * @param {object} d The options that should be made defaults
   * @return {core}
   * @public
   */
  setDefaults: function setDefaults(d) {
    $.extend(defaults, d);
    return this;
  },

  /**
   * For users to trigger their handlers on the public emitter
   *
   * @returns {core}
   * @public
   */
  triggerHandler: function triggerHandler() {
    this.__$emitterPublic.triggerHandler.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
    return this;
  }
};

// $.tooltipster will be used to call core methods
$.tooltipster = new core();

// the Tooltipster instance class (mind the capital T)
$.Tooltipster = function (element, options) {
  // list of instance variables

  // stack of custom callbacks provided as parameters to API methods
  this.__callbacks = {
    close: [],
    open: []
  };
  // the schedule time of DOM removal
  this.__closingTime;
  // this will be the user content shown in the tooltip. A capital "C" is used
  // because there is also a method called content()
  this.__Content;
  // for the size tracker
  this.__contentBcr;
  // to disable the tooltip once the destruction has begun
  this.__destroyed = false;
  this.__destroying = false;
  // we can't emit directly on the instance because if a method with the same
  // name as the event exists, it will be called by jQuery. Se we use a plain
  // object as emitter. This emitter is for internal use by plugins,
  // if needed.
  this.__$emitterPrivate = $({});
  // this emitter is for the user to listen to events without risking to mess
  // with our internal listeners
  this.__$emitterPublic = $({});
  this.__enabled = true;
  // the reference to the gc interval
  this.__garbageCollector;
  // various position and size data recomputed before each repositioning
  this.__Geometry;
  // the tooltip position, saved after each repositioning by a plugin
  this.__lastPosition;
  // a unique namespace per instance
  this.__namespace = 'tooltipster-' + Math.round(Math.random() * 1000000);
  this.__options;
  // will be used to support origins in scrollable areas
  this.__$originParents;
  this.__pointerIsOverOrigin = false;
  // to remove themes if needed
  this.__previousThemes = [];
  // the state can be either: appearing, stable, disappearing, closed
  this.__state = 'closed';
  // timeout references
  this.__timeouts = {
    close: [],
    open: null
  };
  // store touch events to be able to detect emulated mouse events
  this.__touchEvents = [];
  // the reference to the tracker interval
  this.__tracker = null;
  // the element to which this tooltip is associated
  this._$origin;
  // this will be the tooltip element (jQuery wrapped HTML element).
  // It's the job of a plugin to create it and append it to the DOM
  this._$tooltip;

  // launch
  this.__init(element, options);
};

$.Tooltipster.prototype = {
  /**
   * @param origin
   * @param options
   * @private
   */
  __init: function __init(origin, options) {
    var self = this;

    self._$origin = $(origin);
    self.__options = $.extend(true, {}, defaults, options);

    // some options may need to be reformatted
    self.__optionsFormat();

    // don't run on old IE if asked no to
    if (!env.IE || env.IE >= self.__options.IEmin) {
      // note: the content is null (empty) by default and can stay that
      // way if the plugin remains initialized but not fed any content. The
      // tooltip will just not appear.

      // let's save the initial value of the title attribute for later
      // restoration if need be.
      var initialTitle = null;

      // it will already have been saved in case of multiple tooltips
      if (self._$origin.data('tooltipster-initialTitle') === undefined) {
        initialTitle = self._$origin.attr('title');

        // we do not want initialTitle to be "undefined" because
        // of how jQuery's .data() method works
        if (initialTitle === undefined) initialTitle = null;

        self._$origin.data('tooltipster-initialTitle', initialTitle);
      }

      // If content is provided in the options, it has precedence over the
      // title attribute.
      // Note: an empty string is considered content, only 'null' represents
      // the absence of content.
      // Also, an existing title="" attribute will result in an empty string
      // content
      if (self.__options.content !== null) {
        self.__contentSet(self.__options.content);
      } else {
        var selector = self._$origin.attr('data-tooltip-content'),
            $el = void 0;

        if (selector) {
          $el = $(selector);
        }

        if ($el && $el[0]) {
          self.__contentSet($el.first());
        } else {
          self.__contentSet(initialTitle);
        }
      }

      self._$origin
      // strip the title off of the element to prevent the default tooltips
      // from popping up
      .removeAttr('title')
      // to be able to find all instances on the page later (upon window
      // events in particular)
      .addClass('tooltipstered');

      // set listeners on the origin
      self.__prepareOrigin();

      // set the garbage collector
      self.__prepareGC();

      // init plugins
      $.each(self.__options.plugins, function (i, pluginName) {
        self._plug(pluginName);
      });

      // to detect swiping
      if (env.hasTouchCapability) {
        $('body').on('touchmove.' + self.__namespace + '-triggerOpen', function (event) {
          self._touchRecordEvent(event);
        });
      }

      self
      // prepare the tooltip when it gets created. This event must
      // be fired by a plugin
      ._on('created', function () {
        self.__prepareTooltip();
      })
      // save position information when it's sent by a plugin
      ._on('repositioned', function (e) {
        self.__lastPosition = e.position;
      });
    } else {
      self.__options.disabled = true;
    }
  },

  /**
   * Insert the content into the appropriate HTML element of the tooltip
   *
   * @returns {self}
   * @private
   */
  __contentInsert: function __contentInsert() {
    var self = this,
        $el = self._$tooltip.find('.tooltipster-content'),
        formattedContent = self.__Content,
        format = function format(content) {
      formattedContent = content;
    };

    self._trigger({
      type: 'format',
      content: self.__Content,
      format: format
    });

    if (self.__options.functionFormat) {
      formattedContent = self.__options.functionFormat.call(self, self, { origin: self._$origin[0] }, self.__Content);
    }

    if (typeof formattedContent === 'string' && !self.__options.contentAsHTML) {
      $el.text(formattedContent);
    } else {
      $el.empty().append(formattedContent);
    }

    return self;
  },

  /**
   * Save the content, cloning it beforehand if need be
   *
   * @param content
   * @returns {self}
   * @private
   */
  __contentSet: function __contentSet(content) {
    // clone if asked. Cloning the object makes sure that each instance has its
    // own version of the content (in case a same object were provided for several
    // instances)
    // reminder: typeof null === object
    if (content instanceof $ && this.__options.contentCloning) {
      content = content.clone(true);
    }

    this.__Content = content;

    this._trigger({
      type: 'updated',
      content: content
    });

    return this;
  },

  /**
   * Error message about a method call made after destruction
   *
   * @private
   */
  __destroyError: function __destroyError() {
    throw new Error('This tooltip has been destroyed and cannot execute your method call.');
  },

  /**
   * Gather all information about dimensions and available space,
   * called before every repositioning
   *
   * @private
   * @returns {object}
   */
  __geometry: function __geometry() {
    var self = this,
        $target = self._$origin,
        originIsArea = self._$origin.is('area');

    // if this._$origin is a map area, the target we'll need
    // the dimensions of is actually the image using the map,
    // not the area itself
    if (originIsArea) {
      var mapName = self._$origin.parent().attr('name');

      $target = $('img[usemap="#' + mapName + '"]');
    }

    var bcr = $target[0].getBoundingClientRect(),
        $document = $(env.window.document),
        $window = $(env.window),
        $parent = $target,

    // some useful properties of important elements
    geo = {
      // available space for the tooltip, see down below
      available: {
        document: null,
        window: null
      },
      document: {
        size: {
          height: $document.height(),
          width: $document.width()
        }
      },
      window: {
        scroll: {
          // the second ones are for IE compatibility
          left: env.window.scrollX || env.window.document.documentElement.scrollLeft,
          top: env.window.scrollY || env.window.document.documentElement.scrollTop
        },
        size: {
          height: $window.height(),
          width: $window.width()
        }
      },
      origin: {
        // the origin has a fixed lineage if itself or one of its
        // ancestors has a fixed position
        fixedLineage: false,
        // relative to the document
        offset: {},
        size: {
          height: bcr.bottom - bcr.top,
          width: bcr.right - bcr.left
        },
        usemapImage: originIsArea ? $target[0] : null,
        // relative to the window
        windowOffset: {
          bottom: bcr.bottom,
          left: bcr.left,
          right: bcr.right,
          top: bcr.top
        }
      }
    },
        geoFixed = false;

    // if the element is a map area, some properties may need
    // to be recalculated
    if (originIsArea) {
      var shape = self._$origin.attr('shape'),
          coords = self._$origin.attr('coords');

      if (coords) {
        coords = coords.split(',');

        $.map(coords, function (val, i) {
          coords[i] = parseInt(val);
        });
      }

      // if the image itself is the area, nothing more to do
      if (shape != 'default') {
        switch (shape) {
          case 'circle':
            var circleCenterLeft = coords[0],
                circleCenterTop = coords[1],
                circleRadius = coords[2],
                areaTopOffset = circleCenterTop - circleRadius,
                areaLeftOffset = circleCenterLeft - circleRadius;

            geo.origin.size.height = circleRadius * 2;
            geo.origin.size.width = geo.origin.size.height;

            geo.origin.windowOffset.left += areaLeftOffset;
            geo.origin.windowOffset.top += areaTopOffset;

            break;

          case 'rect':
            var areaLeft = coords[0],
                areaTop = coords[1],
                areaRight = coords[2],
                areaBottom = coords[3];

            geo.origin.size.height = areaBottom - areaTop;
            geo.origin.size.width = areaRight - areaLeft;

            geo.origin.windowOffset.left += areaLeft;
            geo.origin.windowOffset.top += areaTop;

            break;

          case 'poly':
            var areaSmallestX = 0,
                areaSmallestY = 0,
                areaGreatestX = 0,
                areaGreatestY = 0,
                arrayAlternate = 'even';

            for (var i = 0; i < coords.length; i++) {
              var areaNumber = coords[i];

              if (arrayAlternate == 'even') {
                if (areaNumber > areaGreatestX) {
                  areaGreatestX = areaNumber;

                  if (i === 0) {
                    areaSmallestX = areaGreatestX;
                  }
                }

                if (areaNumber < areaSmallestX) {
                  areaSmallestX = areaNumber;
                }

                arrayAlternate = 'odd';
              } else {
                if (areaNumber > areaGreatestY) {
                  areaGreatestY = areaNumber;

                  if (i == 1) {
                    areaSmallestY = areaGreatestY;
                  }
                }

                if (areaNumber < areaSmallestY) {
                  areaSmallestY = areaNumber;
                }

                arrayAlternate = 'even';
              }
            }

            geo.origin.size.height = areaGreatestY - areaSmallestY;
            geo.origin.size.width = areaGreatestX - areaSmallestX;

            geo.origin.windowOffset.left += areaSmallestX;
            geo.origin.windowOffset.top += areaSmallestY;

            break;
        }
      }
    }

    // user callback through an event
    var edit = function edit(r) {
      geo.origin.size.height = r.height, geo.origin.windowOffset.left = r.left, geo.origin.windowOffset.top = r.top, geo.origin.size.width = r.width;
    };

    self._trigger({
      type: 'geometry',
      edit: edit,
      geometry: {
        height: geo.origin.size.height,
        left: geo.origin.windowOffset.left,
        top: geo.origin.windowOffset.top,
        width: geo.origin.size.width
      }
    });

    // calculate the remaining properties with what we got

    geo.origin.windowOffset.right = geo.origin.windowOffset.left + geo.origin.size.width;
    geo.origin.windowOffset.bottom = geo.origin.windowOffset.top + geo.origin.size.height;

    geo.origin.offset.left = geo.origin.windowOffset.left + geo.window.scroll.left;
    geo.origin.offset.top = geo.origin.windowOffset.top + geo.window.scroll.top;
    geo.origin.offset.bottom = geo.origin.offset.top + geo.origin.size.height;
    geo.origin.offset.right = geo.origin.offset.left + geo.origin.size.width;

    // the space that is available to display the tooltip relatively to the document
    geo.available.document = {
      bottom: {
        height: geo.document.size.height - geo.origin.offset.bottom,
        width: geo.document.size.width
      },
      left: {
        height: geo.document.size.height,
        width: geo.origin.offset.left
      },
      right: {
        height: geo.document.size.height,
        width: geo.document.size.width - geo.origin.offset.right
      },
      top: {
        height: geo.origin.offset.top,
        width: geo.document.size.width
      }
    };

    // the space that is available to display the tooltip relatively to the viewport
    // (the resulting values may be negative if the origin overflows the viewport)
    geo.available.window = {
      bottom: {
        // the inner max is here to make sure the available height is no bigger
        // than the viewport height (when the origin is off screen at the top).
        // The outer max just makes sure that the height is not negative (when
        // the origin overflows at the bottom).
        height: Math.max(geo.window.size.height - Math.max(geo.origin.windowOffset.bottom, 0), 0),
        width: geo.window.size.width
      },
      left: {
        height: geo.window.size.height,
        width: Math.max(geo.origin.windowOffset.left, 0)
      },
      right: {
        height: geo.window.size.height,
        width: Math.max(geo.window.size.width - Math.max(geo.origin.windowOffset.right, 0), 0)
      },
      top: {
        height: Math.max(geo.origin.windowOffset.top, 0),
        width: geo.window.size.width
      }
    };

    while ($parent[0].tagName.toLowerCase() != 'html') {
      if ($parent.css('position') == 'fixed') {
        geo.origin.fixedLineage = true;
        break;
      }

      $parent = $parent.parent();
    }

    return geo;
  },

  /**
   * Some options may need to be formated before being used
   *
   * @returns {self}
   * @private
   */
  __optionsFormat: function __optionsFormat() {
    if (typeof this.__options.animationDuration == 'number') {
      this.__options.animationDuration = [this.__options.animationDuration, this.__options.animationDuration];
    }

    if (typeof this.__options.delay == 'number') {
      this.__options.delay = [this.__options.delay, this.__options.delay];
    }

    if (typeof this.__options.delayTouch == 'number') {
      this.__options.delayTouch = [this.__options.delayTouch, this.__options.delayTouch];
    }

    if (typeof this.__options.theme == 'string') {
      this.__options.theme = [this.__options.theme];
    }

    // determine the future parent
    if (typeof this.__options.parent == 'string') {
      this.__options.parent = $(this.__options.parent);
    }

    if (this.__options.trigger == 'hover') {
      this.__options.triggerOpen = {
        mouseenter: true,
        touchstart: true
      };

      this.__options.triggerClose = {
        mouseleave: true,
        originClick: true,
        touchleave: true
      };
    } else if (this.__options.trigger == 'click') {
      this.__options.triggerOpen = {
        click: true,
        tap: true
      };

      this.__options.triggerClose = {
        click: true,
        tap: true
      };
    }

    // for the plugins
    this._trigger('options');

    return this;
  },

  /**
   * Schedules or cancels the garbage collector task
   *
   * @returns {self}
   * @private
   */
  __prepareGC: function __prepareGC() {
    var self = this;

    // in case the selfDestruction option has been changed by a method call
    if (self.__options.selfDestruction) {
      // the GC task
      self.__garbageCollector = setInterval(function () {
        var now = new Date().getTime();

        // forget the old events
        self.__touchEvents = $.grep(self.__touchEvents, function (event, i) {
          // 1 minute
          return now - event.time > 60000;
        });

        // auto-destruct if the origin is gone
        if (!bodyContains(self._$origin)) {
          self.destroy();
        }
      }, 20000);
    } else {
      clearInterval(self.__garbageCollector);
    }

    return self;
  },

  /**
   * Sets listeners on the origin if the open triggers require them.
   * Unlike the listeners set at opening time, these ones
   * remain even when the tooltip is closed. It has been made a
   * separate method so it can be called when the triggers are
   * changed in the options. Closing is handled in _open()
   * because of the bindings that may be needed on the tooltip
   * itself
   *
   * @returns {self}
   * @private
   */
  __prepareOrigin: function __prepareOrigin() {
    var self = this;

    // in case we're resetting the triggers
    self._$origin.off('.' + self.__namespace + '-triggerOpen');

    // if the device is touch capable, even if only mouse triggers
    // are asked, we need to listen to touch events to know if the mouse
    // events are actually emulated (so we can ignore them)
    if (env.hasTouchCapability) {
      self._$origin.on('touchstart.' + self.__namespace + '-triggerOpen ' + 'touchend.' + self.__namespace + '-triggerOpen ' + 'touchcancel.' + self.__namespace + '-triggerOpen', function (event) {
        self._touchRecordEvent(event);
      });
    }

    // mouse click and touch tap work the same way
    if (self.__options.triggerOpen.click || self.__options.triggerOpen.tap && env.hasTouchCapability) {
      var eventNames = '';
      if (self.__options.triggerOpen.click) {
        eventNames += 'click.' + self.__namespace + '-triggerOpen ';
      }
      if (self.__options.triggerOpen.tap && env.hasTouchCapability) {
        eventNames += 'touchend.' + self.__namespace + '-triggerOpen';
      }

      self._$origin.on(eventNames, function (event) {
        if (self._touchIsMeaningfulEvent(event)) {
          self._open(event);
        }
      });
    }

    // mouseenter and touch start work the same way
    if (self.__options.triggerOpen.mouseenter || self.__options.triggerOpen.touchstart && env.hasTouchCapability) {
      var eventNames = '';
      if (self.__options.triggerOpen.mouseenter) {
        eventNames += 'mouseenter.' + self.__namespace + '-triggerOpen ';
      }
      if (self.__options.triggerOpen.touchstart && env.hasTouchCapability) {
        eventNames += 'touchstart.' + self.__namespace + '-triggerOpen';
      }

      self._$origin.on(eventNames, function (event) {
        if (self._touchIsTouchEvent(event) || !self._touchIsEmulatedEvent(event)) {
          self.__pointerIsOverOrigin = true;
          self._openShortly(event);
        }
      });
    }

    // info for the mouseleave/touchleave close triggers when they use a delay
    if (self.__options.triggerClose.mouseleave || self.__options.triggerClose.touchleave && env.hasTouchCapability) {
      var eventNames = '';
      if (self.__options.triggerClose.mouseleave) {
        eventNames += 'mouseleave.' + self.__namespace + '-triggerOpen ';
      }
      if (self.__options.triggerClose.touchleave && env.hasTouchCapability) {
        eventNames += 'touchend.' + self.__namespace + '-triggerOpen touchcancel.' + self.__namespace + '-triggerOpen';
      }

      self._$origin.on(eventNames, function (event) {
        if (self._touchIsMeaningfulEvent(event)) {
          self.__pointerIsOverOrigin = false;
        }
      });
    }

    return self;
  },

  /**
   * Do the things that need to be done only once after the tooltip
   * HTML element it has been created. It has been made a separate
   * method so it can be called when options are changed. Remember
   * that the tooltip may actually exist in the DOM before it is
   * opened, and present after it has been closed: it's the display
   * plugin that takes care of handling it.
   *
   * @returns {self}
   * @private
   */
  __prepareTooltip: function __prepareTooltip() {
    var self = this,
        p = self.__options.interactive ? 'auto' : '';

    // this will be useful to know quickly if the tooltip is in
    // the DOM or not
    self._$tooltip.attr('id', self.__namespace).css({
      // pointer events
      'pointer-events': p,
      zIndex: self.__options.zIndex
    });

    // themes
    // remove the old ones and add the new ones
    $.each(self.__previousThemes, function (i, theme) {
      self._$tooltip.removeClass(theme);
    });
    $.each(self.__options.theme, function (i, theme) {
      self._$tooltip.addClass(theme);
    });

    self.__previousThemes = $.merge([], self.__options.theme);

    return self;
  },

  /**
   * Handles the scroll on any of the parents of the origin (when the
   * tooltip is open)
   *
   * @param {object} event
   * @returns {self}
   * @private
   */
  __scrollHandler: function __scrollHandler(event) {
    var self = this;

    if (self.__options.triggerClose.scroll) {
      self._close(event);
    } else {
      // if the scroll happened on the window
      if (event.target === env.window.document) {
        // if the origin has a fixed lineage, window scroll will have no
        // effect on its position nor on the position of the tooltip
        if (!self.__Geometry.origin.fixedLineage) {
          // we don't need to do anything unless repositionOnScroll is true
          // because the tooltip will already have moved with the window
          // (and of course with the origin)
          if (self.__options.repositionOnScroll) {
            self.reposition(event);
          }
        }
      } else {
        // if the scroll happened on another parent of the tooltip, it means
        // that it's in a scrollable area and now needs to have its position
        // adjusted or recomputed, depending ont the repositionOnScroll
        // option. Also, if the origin is partly hidden due to a parent that
        // hides its overflow, we'll just hide (not close) the tooltip.
        var g = self.__geometry(),
            overflows = false;

        // a fixed position origin is not affected by the overflow hiding
        // of a parent
        if (self._$origin.css('position') != 'fixed') {
          self.__$originParents.each(function (i, el) {
            var $el = $(el),
                overflowX = $el.css('overflow-x'),
                overflowY = $el.css('overflow-y');

            if (overflowX != 'visible' || overflowY != 'visible') {
              var bcr = el.getBoundingClientRect();

              if (overflowX != 'visible') {
                if (g.origin.windowOffset.left < bcr.left || g.origin.windowOffset.right > bcr.right) {
                  overflows = true;
                  return false;
                }
              }

              if (overflowY != 'visible') {
                if (g.origin.windowOffset.top < bcr.top || g.origin.windowOffset.bottom > bcr.bottom) {
                  overflows = true;
                  return false;
                }
              }
            }

            // no need to go further if fixed, for the same reason as above
            if ($el.css('position') == 'fixed') {
              return false;
            }
          });
        }

        if (overflows) {
          self._$tooltip.css('visibility', 'hidden');
        } else {
          self._$tooltip.css('visibility', 'visible');

          // reposition
          if (self.__options.repositionOnScroll) {
            self.reposition(event);
          } else {
            // or just adjust offset
            // we have to use offset and not windowOffset because this way,
            // only the scroll distance of the scrollable areas are taken into
            // account (the scrolltop value of the main window must be
            // ignored since the tooltip already moves with it)
            var offsetLeft = g.origin.offset.left - self.__Geometry.origin.offset.left,
                offsetTop = g.origin.offset.top - self.__Geometry.origin.offset.top;

            // add the offset to the position initially computed by the display plugin
            self._$tooltip.css({
              left: self.__lastPosition.coord.left + offsetLeft,
              top: self.__lastPosition.coord.top + offsetTop
            });
          }
        }
      }

      self._trigger({
        type: 'scroll',
        event: event
      });
    }

    return self;
  },

  /**
   * Changes the state of the tooltip
   *
   * @param {string} state
   * @returns {self}
   * @private
   */
  __stateSet: function __stateSet(state) {
    this.__state = state;

    this._trigger({
      type: 'state',
      state: state
    });

    return this;
  },

  /**
   * Clear appearance timeouts
   *
   * @returns {self}
   * @private
   */
  __timeoutsClear: function __timeoutsClear() {
    // there is only one possible open timeout: the delayed opening
    // when the mouseenter/touchstart open triggers are used
    clearTimeout(this.__timeouts.open);
    this.__timeouts.open = null;

    // ... but several close timeouts: the delayed closing when the
    // mouseleave close trigger is used and the timer option
    $.each(this.__timeouts.close, function (i, timeout) {
      clearTimeout(timeout);
    });
    this.__timeouts.close = [];

    return this;
  },

  /**
   * Start the tracker that will make checks at regular intervals
   *
   * @returns {self}
   * @private
   */
  __trackerStart: function __trackerStart() {
    var self = this,
        $content = self._$tooltip.find('.tooltipster-content');

    // get the initial content size
    if (self.__options.trackTooltip) {
      self.__contentBcr = $content[0].getBoundingClientRect();
    }

    self.__tracker = setInterval(function () {
      // if the origin or tooltip elements have been removed.
      // Note: we could destroy the instance now if the origin has
      // been removed but we'll leave that task to our garbage collector
      if (!bodyContains(self._$origin) || !bodyContains(self._$tooltip)) {
        self._close();
      } else {
        // if everything is alright
        // compare the former and current positions of the origin to reposition
        // the tooltip if need be
        if (self.__options.trackOrigin) {
          var g = self.__geometry(),
              identical = false;

          // compare size first (a change requires repositioning too)
          if (areEqual(g.origin.size, self.__Geometry.origin.size)) {
            // for elements that have a fixed lineage (see __geometry()), we track the
            // top and left properties (relative to window)
            if (self.__Geometry.origin.fixedLineage) {
              if (areEqual(g.origin.windowOffset, self.__Geometry.origin.windowOffset)) {
                identical = true;
              }
            } else {
              // otherwise, track total offset (relative to document)
              if (areEqual(g.origin.offset, self.__Geometry.origin.offset)) {
                identical = true;
              }
            }
          }

          if (!identical) {
            // close the tooltip when using the mouseleave close trigger
            // (see https://github.com/iamceege/tooltipster/pull/253)
            if (self.__options.triggerClose.mouseleave) {
              self._close();
            } else {
              self.reposition();
            }
          }
        }

        if (self.__options.trackTooltip) {
          var currentBcr = $content[0].getBoundingClientRect();

          if (currentBcr.height !== self.__contentBcr.height || currentBcr.width !== self.__contentBcr.width) {
            self.reposition();
            self.__contentBcr = currentBcr;
          }
        }
      }
    }, self.__options.trackerInterval);

    return self;
  },

  /**
   * Closes the tooltip (after the closing delay)
   *
   * @param event
   * @param callback
   * @returns {self}
   * @protected
   */
  _close: function _close(event, callback) {
    var self = this,
        ok = true;

    self._trigger({
      type: 'close',
      event: event,
      stop: function stop() {
        ok = false;
      }
    });

    // a destroying tooltip may not refuse to close
    if (ok || self.__destroying) {
      // save the method custom callback and cancel any open method custom callbacks
      if (callback) self.__callbacks.close.push(callback);
      self.__callbacks.open = [];

      // clear open/close timeouts
      self.__timeoutsClear();

      var finishCallbacks = function finishCallbacks() {
        // trigger any close method custom callbacks and reset them
        $.each(self.__callbacks.close, function (i, c) {
          c.call(self, self, {
            event: event,
            origin: self._$origin[0]
          });
        });

        self.__callbacks.close = [];
      };

      if (self.__state != 'closed') {
        var necessary = true,
            d = new Date(),
            now = d.getTime(),
            newClosingTime = now + self.__options.animationDuration[1];

        // the tooltip may already already be disappearing, but if a new
        // call to close() is made after the animationDuration was changed
        // to 0 (for example), we ought to actually close it sooner than
        // previously scheduled. In that case it should be noted that the
        // browser will not adapt the animation duration to the new
        // animationDuration that was set after the start of the closing
        // animation.
        // Note: the same thing could be considered at opening, but is not
        // really useful since the tooltip is actually opened immediately
        // upon a call to _open(). Since it would not make the opening
        // animation finish sooner, its sole impact would be to trigger the
        // state event and the open callbacks sooner than the actual end of
        // the opening animation, which is not great.
        if (self.__state == 'disappearing') {
          if (newClosingTime > self.__closingTime) {
            necessary = false;
          }
        }

        if (necessary) {
          self.__closingTime = newClosingTime;

          if (self.__state != 'disappearing') {
            self.__stateSet('disappearing');
          }

          var finish = function finish() {
            // stop the tracker
            clearInterval(self.__tracker);

            // a "beforeClose" option has been asked several times but would
            // probably useless since the content element is still accessible
            // via ::content(), and because people can always use listeners
            // inside their content to track what's going on. For the sake of
            // simplicity, this has been denied. Bur for the rare people who
            // really need the option (for old browsers or for the case where
            // detaching the content is actually destructive, for file or
            // password inputs for example), this event will do the work.
            self._trigger({
              type: 'closing',
              event: event
            });

            // unbind listeners which are no longer needed

            self._$tooltip.off('.' + self.__namespace + '-triggerClose').removeClass('tooltipster-dying');

            // orientationchange, scroll and resize listeners
            $(env.window).off('.' + self.__namespace + '-triggerClose');

            // scroll listeners
            self.__$originParents.each(function (i, el) {
              $(el).off('scroll.' + self.__namespace + '-triggerClose');
            });
            // clear the array to prevent memory leaks
            self.__$originParents = null;

            $('body').off('.' + self.__namespace + '-triggerClose');

            self._$origin.off('.' + self.__namespace + '-triggerClose');

            self._off('dismissable');

            // a plugin that would like to remove the tooltip from the
            // DOM when closed should bind on this
            self.__stateSet('closed');

            // trigger event
            self._trigger({
              type: 'after',
              event: event
            });

            // call our constructor custom callback function
            if (self.__options.functionAfter) {
              self.__options.functionAfter.call(self, self, {
                event: event,
                origin: self._$origin[0]
              });
            }

            // call our method custom callbacks functions
            finishCallbacks();
          };

          if (env.hasTransitions) {
            self._$tooltip.css({
              '-moz-animation-duration': self.__options.animationDuration[1] + 'ms',
              '-ms-animation-duration': self.__options.animationDuration[1] + 'ms',
              '-o-animation-duration': self.__options.animationDuration[1] + 'ms',
              '-webkit-animation-duration': self.__options.animationDuration[1] + 'ms',
              'animation-duration': self.__options.animationDuration[1] + 'ms',
              'transition-duration': self.__options.animationDuration[1] + 'ms'
            });

            self._$tooltip
            // clear both potential open and close tasks
            .clearQueue().removeClass('tooltipster-show')
            // for transitions only
            .addClass('tooltipster-dying');

            if (self.__options.animationDuration[1] > 0) {
              self._$tooltip.delay(self.__options.animationDuration[1]);
            }

            self._$tooltip.queue(finish);
          } else {
            self._$tooltip.stop().fadeOut(self.__options.animationDuration[1], finish);
          }
        }
      } else {
        // if the tooltip is already closed, we still need to trigger
        // the method custom callbacks
        finishCallbacks();
      }
    }

    return self;
  },

  /**
   * For internal use by plugins, if needed
   *
   * @returns {self}
   * @protected
   */
  _off: function _off() {
    this.__$emitterPrivate.off.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
    return this;
  },

  /**
   * For internal use by plugins, if needed
   *
   * @returns {self}
   * @protected
   */
  _on: function _on() {
    this.__$emitterPrivate.on.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
    return this;
  },

  /**
   * For internal use by plugins, if needed
   *
   * @returns {self}
   * @protected
   */
  _one: function _one() {
    this.__$emitterPrivate.one.apply(this.__$emitterPrivate, Array.prototype.slice.apply(arguments));
    return this;
  },

  /**
   * Opens the tooltip right away
   *
   * @param event
   * @param callback
   * @returns {self}
   * @protected
   */
  _open: function _open(event, callback) {
    var self = this;

    // if the destruction process has not begun and if this was not
    // triggered by an unwanted emulated click event
    if (!self.__destroying) {
      // check that the origin is still in the DOM
      if (bodyContains(self._$origin) &&
      // if the tooltip is enabled
      self.__enabled) {
        var ok = true;

        // if the tooltip is not open yet, we need to call functionBefore.
        // otherwise we can jst go on
        if (self.__state == 'closed') {
          // trigger an event. The event.stop function allows the callback
          // to prevent the opening of the tooltip
          self._trigger({
            type: 'before',
            event: event,
            stop: function stop() {
              ok = false;
            }
          });

          if (ok && self.__options.functionBefore) {
            // call our custom function before continuing
            ok = self.__options.functionBefore.call(self, self, {
              event: event,
              origin: self._$origin[0]
            });
          }
        }

        if (ok !== false) {
          // if there is some content
          if (self.__Content !== null) {
            // save the method callback and cancel close method callbacks
            if (callback) {
              self.__callbacks.open.push(callback);
            }
            self.__callbacks.close = [];

            // get rid of any appearance timeouts
            self.__timeoutsClear();

            var extraTime = void 0,
                finish = function finish() {
              if (self.__state != 'stable') {
                self.__stateSet('stable');
              }

              // trigger any open method custom callbacks and reset them
              $.each(self.__callbacks.open, function (i, c) {
                c.call(self, self, {
                  origin: self._$origin[0],
                  tooltip: self._$tooltip[0]
                });
              });

              self.__callbacks.open = [];
            };

            // if the tooltip is already open
            if (self.__state !== 'closed') {
              // the timer (if any) will start (or restart) right now
              extraTime = 0;

              // if it was disappearing, cancel that
              if (self.__state === 'disappearing') {
                self.__stateSet('appearing');

                if (env.hasTransitions) {
                  self._$tooltip.clearQueue().removeClass('tooltipster-dying').addClass('tooltipster-show');

                  if (self.__options.animationDuration[0] > 0) {
                    self._$tooltip.delay(self.__options.animationDuration[0]);
                  }

                  self._$tooltip.queue(finish);
                } else {
                  // in case the tooltip was currently fading out, bring it back
                  // to life
                  self._$tooltip.stop().fadeIn(finish);
                }
              } else if (self.__state == 'stable') {
                // if the tooltip is already open, we still need to trigger the method
                // custom callback
                finish();
              }
            } else {
              // if the tooltip isn't already open, open it
              // a plugin must bind on this and store the tooltip in this._$tooltip
              self.__stateSet('appearing');

              // the timer (if any) will start when the tooltip has fully appeared
              // after its transition
              extraTime = self.__options.animationDuration[0];

              // insert the content inside the tooltip
              self.__contentInsert();

              // reposition the tooltip and attach to the DOM
              self.reposition(event, true);

              // animate in the tooltip. If the display plugin wants no css
              // animations, it may override the animation option with a
              // dummy value that will produce no effect
              if (env.hasTransitions) {
                // note: there seems to be an issue with start animations which
                // are randomly not played on fast devices in both Chrome and FF,
                // couldn't find a way to solve it yet. It seems that applying
                // the classes before appending to the DOM helps a little, but
                // it messes up some CSS transitions. The issue almost never
                // happens when delay[0]==0 though
                self._$tooltip.addClass('tooltipster-' + self.__options.animation).addClass('tooltipster-initial').css({
                  '-moz-animation-duration': self.__options.animationDuration[0] + 'ms',
                  '-ms-animation-duration': self.__options.animationDuration[0] + 'ms',
                  '-o-animation-duration': self.__options.animationDuration[0] + 'ms',
                  '-webkit-animation-duration': self.__options.animationDuration[0] + 'ms',
                  'animation-duration': self.__options.animationDuration[0] + 'ms',
                  'transition-duration': self.__options.animationDuration[0] + 'ms'
                });

                setTimeout(function () {
                  // a quick hover may have already triggered a mouseleave
                  if (self.__state != 'closed') {
                    self._$tooltip.addClass('tooltipster-show').removeClass('tooltipster-initial');

                    if (self.__options.animationDuration[0] > 0) {
                      self._$tooltip.delay(self.__options.animationDuration[0]);
                    }

                    self._$tooltip.queue(finish);
                  }
                }, 0);
              } else {
                // old browsers will have to live with this
                self._$tooltip.css('display', 'none').fadeIn(self.__options.animationDuration[0], finish);
              }

              // checks if the origin is removed while the tooltip is open
              self.__trackerStart();

              // NOTE: the listeners below have a '-triggerClose' namespace
              // because we'll remove them when the tooltip closes (unlike
              // the '-triggerOpen' listeners). So some of them are actually
              // not about close triggers, rather about positioning.

              $(env.window)
              // reposition on resize
              .on('resize.' + self.__namespace + '-triggerClose', function (e) {
                var $ae = $(document.activeElement);

                // reposition only if the resize event was not triggered upon the opening
                // of a virtual keyboard due to an input field being focused within the tooltip
                // (otherwise the repositioning would lose the focus)
                if (!$ae.is('input') && !$ae.is('textarea') || !$.contains(self._$tooltip[0], $ae[0])) {
                  self.reposition(e);
                }
              })
              // same as below for parents
              .on('scroll.' + self.__namespace + '-triggerClose', function (e) {
                self.__scrollHandler(e);
              });

              self.__$originParents = self._$origin.parents();

              // scrolling may require the tooltip to be moved or even
              // repositioned in some cases
              self.__$originParents.each(function (i, parent) {
                $(parent).on('scroll.' + self.__namespace + '-triggerClose', function (e) {
                  self.__scrollHandler(e);
                });
              });

              if (self.__options.triggerClose.mouseleave || self.__options.triggerClose.touchleave && env.hasTouchCapability) {
                // we use an event to allow users/plugins to control when the mouseleave/touchleave
                // close triggers will come to action. It allows to have more triggering elements
                // than just the origin and the tooltip for example, or to cancel/delay the closing,
                // or to make the tooltip interactive even if it wasn't when it was open, etc.
                self._on('dismissable', function (event) {
                  if (event.dismissable) {
                    if (event.delay) {
                      timeout = setTimeout(function () {
                        // event.event may be undefined
                        self._close(event.event);
                      }, event.delay);

                      self.__timeouts.close.push(timeout);
                    } else {
                      self._close(event);
                    }
                  } else {
                    clearTimeout(timeout);
                  }
                });

                // now set the listeners that will trigger 'dismissable' events
                var $elements = self._$origin,
                    eventNamesIn = '',
                    eventNamesOut = '',
                    timeout = null;

                // if we have to allow interaction, bind on the tooltip too
                if (self.__options.interactive) {
                  $elements = $elements.add(self._$tooltip);
                }

                if (self.__options.triggerClose.mouseleave) {
                  eventNamesIn += 'mouseenter.' + self.__namespace + '-triggerClose ';
                  eventNamesOut += 'mouseleave.' + self.__namespace + '-triggerClose ';
                }
                if (self.__options.triggerClose.touchleave && env.hasTouchCapability) {
                  eventNamesIn += 'touchstart.' + self.__namespace + '-triggerClose';
                  eventNamesOut += 'touchend.' + self.__namespace + '-triggerClose touchcancel.' + self.__namespace + '-triggerClose';
                }

                $elements
                // close after some time spent outside of the elements
                .on(eventNamesOut, function (event) {
                  // it's ok if the touch gesture ended up to be a swipe,
                  // it's still a "touch leave" situation
                  if (self._touchIsTouchEvent(event) || !self._touchIsEmulatedEvent(event)) {
                    var delay = event.type == 'mouseleave' ? self.__options.delay : self.__options.delayTouch;

                    self._trigger({
                      delay: delay[1],
                      dismissable: true,
                      event: event,
                      type: 'dismissable'
                    });
                  }
                })
                // suspend the mouseleave timeout when the pointer comes back
                // over the elements
                .on(eventNamesIn, function (event) {
                  // it's also ok if the touch event is a swipe gesture
                  if (self._touchIsTouchEvent(event) || !self._touchIsEmulatedEvent(event)) {
                    self._trigger({
                      dismissable: false,
                      event: event,
                      type: 'dismissable'
                    });
                  }
                });
              }

              // close the tooltip when the origin gets a mouse click (common behavior of
              // native tooltips)
              if (self.__options.triggerClose.originClick) {
                self._$origin.on('click.' + self.__namespace + '-triggerClose', function (event) {
                  // we could actually let a tap trigger this but this feature just
                  // does not make sense on touch devices
                  if (!self._touchIsTouchEvent(event) && !self._touchIsEmulatedEvent(event)) {
                    self._close(event);
                  }
                });
              }

              // set the same bindings for click and touch on the body to close the tooltip
              if (self.__options.triggerClose.click || self.__options.triggerClose.tap && env.hasTouchCapability) {
                // don't set right away since the click/tap event which triggered this method
                // (if it was a click/tap) is going to bubble up to the body, we don't want it
                // to close the tooltip immediately after it opened
                setTimeout(function () {
                  if (self.__state != 'closed') {
                    var eventNames = '';
                    if (self.__options.triggerClose.click) {
                      eventNames += 'click.' + self.__namespace + '-triggerClose ';
                    }
                    if (self.__options.triggerClose.tap && env.hasTouchCapability) {
                      eventNames += 'touchend.' + self.__namespace + '-triggerClose';
                    }

                    $('body').on(eventNames, function (event) {
                      if (self._touchIsMeaningfulEvent(event)) {
                        self._touchRecordEvent(event);

                        if (!self.__options.interactive || !$.contains(self._$tooltip[0], event.target)) {
                          self._close(event);
                        }
                      }
                    });

                    // needed to detect and ignore swiping
                    if (self.__options.triggerClose.tap && env.hasTouchCapability) {
                      $('body').on('touchstart.' + self.__namespace + '-triggerClose', function (event) {
                        self._touchRecordEvent(event);
                      });
                    }
                  }
                }, 0);
              }

              self._trigger('ready');

              // call our custom callback
              if (self.__options.functionReady) {
                self.__options.functionReady.call(self, self, {
                  origin: self._$origin[0],
                  tooltip: self._$tooltip[0]
                });
              }
            }

            // if we have a timer set, let the countdown begin
            if (self.__options.timer > 0) {
              var timeout = setTimeout(function () {
                self._close();
              }, self.__options.timer + extraTime);

              self.__timeouts.close.push(timeout);
            }
          }
        }
      }
    }

    return self;
  },

  /**
   * When using the mouseenter/touchstart open triggers, this function will
   * schedule the opening of the tooltip after the delay, if there is one
   *
   * @param event
   * @returns {self}
   * @protected
   */
  _openShortly: function _openShortly(event) {
    var self = this,
        ok = true;

    if (self.__state != 'stable' && self.__state != 'appearing') {
      // if a timeout is not already running
      if (!self.__timeouts.open) {
        self._trigger({
          type: 'start',
          event: event,
          stop: function stop() {
            ok = false;
          }
        });

        if (ok) {
          var delay = event.type.indexOf('touch') == 0 ? self.__options.delayTouch : self.__options.delay;

          if (delay[0]) {
            self.__timeouts.open = setTimeout(function () {
              self.__timeouts.open = null;

              // open only if the pointer (mouse or touch) is still over the origin.
              // The check on the "meaningful event" can only be made here, after some
              // time has passed (to know if the touch was a swipe or not)
              if (self.__pointerIsOverOrigin && self._touchIsMeaningfulEvent(event)) {
                // signal that we go on
                self._trigger('startend');

                self._open(event);
              } else {
                // signal that we cancel
                self._trigger('startcancel');
              }
            }, delay[0]);
          } else {
            // signal that we go on
            self._trigger('startend');

            self._open(event);
          }
        }
      }
    }

    return self;
  },

  /**
   * Meant for plugins to get their options
   *
   * @param {string} pluginName The name of the plugin that asks for its options
   * @param {object} defaultOptions The default options of the plugin
   * @returns {object} The options
   * @protected
   */
  _optionsExtract: function _optionsExtract(pluginName, defaultOptions) {
    var self = this,
        options = $.extend(true, {}, defaultOptions);

    // if the plugin options were isolated in a property named after the
    // plugin, use them (prevents conflicts with other plugins)
    var pluginOptions = self.__options[pluginName];

    // if not, try to get them as regular options
    if (!pluginOptions) {
      pluginOptions = {};

      $.each(defaultOptions, function (optionName, value) {
        var o = self.__options[optionName];

        if (o !== undefined) {
          pluginOptions[optionName] = o;
        }
      });
    }

    // let's merge the default options and the ones that were provided. We'd want
    // to do a deep copy but not let jQuery merge arrays, so we'll do a shallow
    // extend on two levels, that will be enough if options are not more than 1
    // level deep
    $.each(options, function (optionName, value) {
      if (pluginOptions[optionName] !== undefined) {
        if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) == 'object' && !(value instanceof Array) && value != null && (0, _typeof3.default)(pluginOptions[optionName]) == 'object' && !(pluginOptions[optionName] instanceof Array) && pluginOptions[optionName] != null) {
          $.extend(options[optionName], pluginOptions[optionName]);
        } else {
          options[optionName] = pluginOptions[optionName];
        }
      }
    });

    return options;
  },

  /**
   * Used at instantiation of the plugin, or afterwards by plugins that activate themselves
   * on existing instances
   *
   * @param {object} pluginName
   * @returns {self}
   * @protected
   */
  _plug: function _plug(pluginName) {
    var plugin = $.tooltipster._plugin(pluginName);

    if (plugin) {
      // if there is a constructor for instances
      if (plugin.instance) {
        // proxy non-private methods on the instance to allow new instance methods
        $.tooltipster.__bridge(plugin.instance, this, plugin.name);
      }
    } else {
      throw new Error('The "' + pluginName + '" plugin is not defined');
    }

    return this;
  },

  /**
   * This will return true if the event is a mouse event which was
   * emulated by the browser after a touch event. This allows us to
   * really dissociate mouse and touch triggers.
   *
   * There is a margin of error if a real mouse event is fired right
   * after (within the delay shown below) a touch event on the same
   * element, but hopefully it should not happen often.
   *
   * @returns {boolean}
   * @protected
   */
  _touchIsEmulatedEvent: function _touchIsEmulatedEvent(event) {
    var isEmulated = false,
        now = new Date().getTime();

    for (var i = this.__touchEvents.length - 1; i >= 0; i--) {
      var e = this.__touchEvents[i];

      // delay, in milliseconds. It's supposed to be 300ms in
      // most browsers (350ms on iOS) to allow a double tap but
      // can be less (check out FastClick for more info)
      if (now - e.time < 500) {
        if (e.target === event.target) {
          isEmulated = true;
        }
      } else {
        break;
      }
    }

    return isEmulated;
  },

  /**
   * Returns false if the event was an emulated mouse event or
   * a touch event involved in a swipe gesture.
   *
   * @param {object} event
   * @returns {boolean}
   * @protected
   */
  _touchIsMeaningfulEvent: function _touchIsMeaningfulEvent(event) {
    return this._touchIsTouchEvent(event) && !this._touchSwiped(event.target) || !this._touchIsTouchEvent(event) && !this._touchIsEmulatedEvent(event);
  },

  /**
   * Checks if an event is a touch event
   *
   * @param {object} event
   * @returns {boolean}
   * @protected
   */
  _touchIsTouchEvent: function _touchIsTouchEvent(event) {
    return event.type.indexOf('touch') == 0;
  },

  /**
   * Store touch events for a while to detect swiping and emulated mouse events
   *
   * @param {object} event
   * @returns {self}
   * @protected
   */
  _touchRecordEvent: function _touchRecordEvent(event) {
    if (this._touchIsTouchEvent(event)) {
      event.time = new Date().getTime();
      this.__touchEvents.push(event);
    }

    return this;
  },

  /**
   * Returns true if a swipe happened after the last touchstart event fired on
   * event.target.
   *
   * We need to differentiate a swipe from a tap before we let the event open
   * or close the tooltip. A swipe is when a touchmove (scroll) event happens
   * on the body between the touchstart and the touchend events of an element.
   *
   * @param {object} target The HTML element that may have triggered the swipe
   * @returns {boolean}
   * @protected
   */
  _touchSwiped: function _touchSwiped(target) {
    var swiped = false;

    for (var i = this.__touchEvents.length - 1; i >= 0; i--) {
      var e = this.__touchEvents[i];

      if (e.type == 'touchmove') {
        swiped = true;
        break;
      } else if (e.type == 'touchstart' && target === e.target) {
        break;
      }
    }

    return swiped;
  },

  /**
   * Triggers an event on the instance emitters
   *
   * @returns {self}
   * @protected
   */
  _trigger: function _trigger() {
    var args = Array.prototype.slice.apply(arguments);

    if (typeof args[0] == 'string') {
      args[0] = { type: args[0] };
    }

    // add properties to the event
    args[0].instance = this;
    args[0].origin = this._$origin ? this._$origin[0] : null;
    args[0].tooltip = this._$tooltip ? this._$tooltip[0] : null;

    // note: the order of emitters matters
    this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate, args);
    $.tooltipster._trigger.apply($.tooltipster, args);
    this.__$emitterPublic.trigger.apply(this.__$emitterPublic, args);

    return this;
  },

  /**
   * Deactivate a plugin on this instance
   *
   * @returns {self}
   * @protected
   */
  _unplug: function _unplug(pluginName) {
    var self = this;

    // if the plugin has been activated on this instance
    if (self[pluginName]) {
      var plugin = $.tooltipster._plugin(pluginName);

      // if there is a constructor for instances
      if (plugin.instance) {
        // unbridge
        $.each(plugin.instance, function (methodName, fn) {
          // if the method exists (privates methods do not) and comes indeed from
          // this plugin (may be missing or come from a conflicting plugin).
          if (self[methodName] && self[methodName].bridged === self[pluginName]) {
            delete self[methodName];
          }
        });
      }

      // destroy the plugin
      if (self[pluginName].__destroy) {
        self[pluginName].__destroy();
      }

      // remove the reference to the plugin instance
      delete self[pluginName];
    }

    return self;
  },

  /**
   * @see self::_close
   * @returns {self}
   * @public
   */
  close: function close(callback) {
    if (!this.__destroyed) {
      this._close(null, callback);
    } else {
      this.__destroyError();
    }

    return this;
  },

  /**
   * Sets or gets the content of the tooltip
   *
   * @returns {mixed|self}
   * @public
   */
  content: function content(_content) {
    var self = this;

    // getter method
    if (_content === undefined) {
      return self.__Content;
    } else {
      // setter method
      if (!self.__destroyed) {
        // change the content
        self.__contentSet(_content);

        if (self.__Content !== null) {
          // update the tooltip if it is open
          if (self.__state !== 'closed') {
            // reset the content in the tooltip
            self.__contentInsert();

            // reposition and resize the tooltip
            self.reposition();

            // if we want to play a little animation showing the content changed
            if (self.__options.updateAnimation) {
              if (env.hasTransitions) {
                // keep the reference in the local scope
                var animation = self.__options.updateAnimation;

                self._$tooltip.addClass('tooltipster-update-' + animation);

                // remove the class after a while. The actual duration of the
                // update animation may be shorter, it's set in the CSS rules
                setTimeout(function () {
                  if (self.__state != 'closed') {
                    self._$tooltip.removeClass('tooltipster-update-' + animation);
                  }
                }, 1000);
              } else {
                self._$tooltip.fadeTo(200, 0.5, function () {
                  if (self.__state != 'closed') {
                    self._$tooltip.fadeTo(200, 1);
                  }
                });
              }
            }
          }
        } else {
          self._close();
        }
      } else {
        self.__destroyError();
      }

      return self;
    }
  },

  /**
   * Destroys the tooltip
   *
   * @returns {self}
   * @public
   */
  destroy: function destroy() {
    var self = this;

    if (!self.__destroyed) {
      if (!self.__destroying) {
        self.__destroying = true;

        self._close(null, function () {
          self._trigger('destroy');

          self.__destroying = false;
          self.__destroyed = true;

          self._$origin.removeData(self.__namespace)
          // remove the open trigger listeners
          .off('.' + self.__namespace + '-triggerOpen');

          // remove the touch listener
          $('body').off('.' + self.__namespace + '-triggerOpen');

          var ns = self._$origin.data('tooltipster-ns');

          // if the origin has been removed from DOM, its data may
          // well have been destroyed in the process and there would
          // be nothing to clean up or restore
          if (ns) {
            // if there are no more tooltips on this element
            if (ns.length === 1) {
              // optional restoration of a title attribute
              var title = null;
              if (self.__options.restoration == 'previous') {
                title = self._$origin.data('tooltipster-initialTitle');
              } else if (self.__options.restoration == 'current') {
                // old school technique to stringify when outerHTML is not supported
                title = typeof self.__Content == 'string' ? self.__Content : $('<div></div>').append(self.__Content).html();
              }

              if (title) {
                self._$origin.attr('title', title);
              }

              // final cleaning

              self._$origin.removeClass('tooltipstered');

              self._$origin.removeData('tooltipster-ns').removeData('tooltipster-initialTitle');
            } else {
              // remove the instance namespace from the list of namespaces of
              // tooltips present on the element
              ns = $.grep(ns, function (el, i) {
                return el !== self.__namespace;
              });
              self._$origin.data('tooltipster-ns', ns);
            }
          }

          // last event
          self._trigger('destroyed');

          // unbind private and public event listeners
          self._off();
          self.off();

          // remove external references, just in case
          self.__Content = null;
          self.__$emitterPrivate = null;
          self.__$emitterPublic = null;
          self.__options.parent = null;
          self._$origin = null;
          self._$tooltip = null;

          // make sure the object is no longer referenced in there to prevent
          // memory leaks
          $.tooltipster.__instancesLatestArr = $.grep($.tooltipster.__instancesLatestArr, function (el, i) {
            return self !== el;
          });

          clearInterval(self.__garbageCollector);
        });
      }
    } else {
      self.__destroyError();
    }

    // we return the scope rather than true so that the call to
    // .tooltipster('destroy') actually returns the matched elements
    // and applies to all of them
    return self;
  },

  /**
   * Disables the tooltip
   *
   * @returns {self}
   * @public
   */
  disable: function disable() {
    if (!this.__destroyed) {
      // close first, in case the tooltip would not disappear on
      // its own (no close trigger)
      this._close();
      this.__enabled = false;

      return this;
    } else {
      this.__destroyError();
    }

    return this;
  },

  /**
   * Returns the HTML element of the origin
   *
   * @returns {self}
   * @public
   */
  elementOrigin: function elementOrigin() {
    if (!this.__destroyed) {
      return this._$origin[0];
    } else {
      this.__destroyError();
    }
  },

  /**
   * Returns the HTML element of the tooltip
   *
   * @returns {self}
   * @public
   */
  elementTooltip: function elementTooltip() {
    return this._$tooltip ? this._$tooltip[0] : null;
  },

  /**
   * Enables the tooltip
   *
   * @returns {self}
   * @public
   */
  enable: function enable() {
    this.__enabled = true;
    return this;
  },

  /**
   * Alias, deprecated in 4.0.0
   *
   * @param {function} callback
   * @returns {self}
   * @public
   */
  hide: function hide(callback) {
    return this.close(callback);
  },

  /**
   * Returns the instance
   *
   * @returns {self}
   * @public
   */
  instance: function instance() {
    return this;
  },

  /**
   * For public use only, not to be used by plugins (use ::_off() instead)
   *
   * @returns {self}
   * @public
   */
  off: function off() {
    if (!this.__destroyed) {
      this.__$emitterPublic.off.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
    }

    return this;
  },

  /**
   * For public use only, not to be used by plugins (use ::_on() instead)
   *
   * @returns {self}
   * @public
   */
  on: function on() {
    if (!this.__destroyed) {
      this.__$emitterPublic.on.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
    } else {
      this.__destroyError();
    }

    return this;
  },

  /**
   * For public use only, not to be used by plugins
   *
   * @returns {self}
   * @public
   */
  one: function one() {
    if (!this.__destroyed) {
      this.__$emitterPublic.one.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
    } else {
      this.__destroyError();
    }

    return this;
  },

  /**
   * @see self::_open
   * @returns {self}
   * @public
   */
  open: function open(callback) {
    if (!this.__destroyed && !this.__destroying) {
      this._open(null, callback);
    } else {
      this.__destroyError();
    }

    return this;
  },

  /**
   * Get or set options. For internal use and advanced users only.
   *
   * @param {string} o Option name
   * @param {mixed} val optional A new value for the option
   * @return {mixed|self} If val is omitted, the value of the option
   * is returned, otherwise the instance itself is returned
   * @public
   */

  option: function option(o, val) {
    // getter
    if (val === undefined) {
      return this.__options[o];
    } else {
      // setter
      if (!this.__destroyed) {
        // change value
        this.__options[o] = val;

        // format
        this.__optionsFormat();

        // re-prepare the triggers if needed
        if ($.inArray(o, ['trigger', 'triggerClose', 'triggerOpen']) >= 0) {
          this.__prepareOrigin();
        }

        if (o === 'selfDestruction') {
          this.__prepareGC();
        }
      } else {
        this.__destroyError();
      }

      return this;
    }
  },

  /**
   * This method is in charge of setting the position and size properties of the tooltip.
   * All the hard work is delegated to the display plugin.
   * Note: The tooltip may be detached from the DOM at the moment the method is called
   * but must be attached by the end of the method call.
   *
   * @param {object} event For internal use only. Defined if an event such as
   * window resizing triggered the repositioning
   * @param {boolean} tooltipIsDetached For internal use only. Set this to true if you
   * know that the tooltip not being in the DOM is not an issue (typically when the
   * tooltip element has just been created but has not been added to the DOM yet).
   * @returns {self}
   * @public
   */
  reposition: function reposition(event, tooltipIsDetached) {
    var self = this;

    if (!self.__destroyed) {
      // if the tooltip is still open and the origin is still in the DOM
      if (self.__state != 'closed' && bodyContains(self._$origin)) {
        // if the tooltip has not been removed from DOM manually (or if it
        // has been detached on purpose)
        if (tooltipIsDetached || bodyContains(self._$tooltip)) {
          if (!tooltipIsDetached) {
            // detach in case the tooltip overflows the window and adds
            // scrollbars to it, so __geometry can be accurate
            self._$tooltip.detach();
          }

          // refresh the geometry object before passing it as a helper
          self.__Geometry = self.__geometry();

          // let a plugin fo the rest
          self._trigger({
            type: 'reposition',
            event: event,
            helper: {
              geo: self.__Geometry
            }
          });
        }
      }
    } else {
      self.__destroyError();
    }

    return self;
  },

  /**
   * Alias, deprecated in 4.0.0
   *
   * @param callback
   * @returns {self}
   * @public
   */
  show: function show(callback) {
    return this.open(callback);
  },

  /**
   * Returns some properties about the instance
   *
   * @returns {object}
   * @public
   */
  status: function status() {
    return {
      destroyed: this.__destroyed,
      destroying: this.__destroying,
      enabled: this.__enabled,
      open: this.__state !== 'closed',
      state: this.__state
    };
  },

  /**
   * For public use only, not to be used by plugins
   *
   * @returns {self}
   * @public
   */
  triggerHandler: function triggerHandler() {
    if (!this.__destroyed) {
      this.__$emitterPublic.triggerHandler.apply(this.__$emitterPublic, Array.prototype.slice.apply(arguments));
    } else {
      this.__destroyError();
    }

    return this;
  }
};

$.fn.tooltipster = function () {
  // for using in closures
  var args = Array.prototype.slice.apply(arguments),

  // common mistake: an HTML element can't be in several tooltips at the same time
  contentCloningWarning = 'You are using a single HTML element as content for several tooltips. You probably want to set the contentCloning option to TRUE.';

  // this happens with $(sel).tooltipster(...) when $(sel) does not match anything
  if (this.length === 0) {
    // still chainable
    return this;
  } else {
    // this happens when calling $(sel).tooltipster('methodName or options')
    // where $(sel) matches one or more elements
    // method calls
    if (typeof args[0] === 'string') {
      var v = '#*$~&';

      this.each(function () {
        // retrieve the namepaces of the tooltip(s) that exist on that element.
        // We will interact with the first tooltip only.
        var ns = $(this).data('tooltipster-ns'),

        // self represents the instance of the first tooltipster plugin
        // associated to the current HTML object of the loop
        self = ns ? $(this).data(ns[0]) : null;

        // if the current element holds a tooltipster instance
        if (self) {
          if (typeof self[args[0]] === 'function') {
            if (this.length > 1 && args[0] == 'content' && (args[1] instanceof $ || (0, _typeof3.default)(args[1]) == 'object' && args[1] != null && args[1].tagName) && !self.__options.contentCloning && self.__options.debug) {
              console.log(contentCloningWarning);
            }

            // note : args[1] and args[2] may not be defined
            var resp = self[args[0]](args[1], args[2]);
          } else {
            throw new Error('Unknown method "' + args[0] + '"');
          }

          // if the function returned anything other than the instance
          // itself (which implies chaining, except for the `instance` method)
          if (resp !== self || args[0] === 'instance') {
            v = resp;

            // return false to stop .each iteration on the first element
            // matched by the selector
            return false;
          }
        } else {
          throw new Error('You called Tooltipster\'s "' + args[0] + '" method on an uninitialized element');
        }
      });

      return v !== '#*$~&' ? v : this;
    } else {
      // first argument is undefined or an object: the tooltip is initializing
      // reset the array of last initialized objects
      $.tooltipster.__instancesLatestArr = [];

      // is there a defined value for the multiple option in the options object ?
      var multipleIsSet = args[0] && args[0].multiple !== undefined,

      // if the multiple option is set to true, or if it's not defined but
      // set to true in the defaults
      multiple = multipleIsSet && args[0].multiple || !multipleIsSet && defaults.multiple,

      // same for content
      contentIsSet = args[0] && args[0].content !== undefined,
          content = contentIsSet && args[0].content || !contentIsSet && defaults.content,

      // same for contentCloning
      contentCloningIsSet = args[0] && args[0].contentCloning !== undefined,
          contentCloning = contentCloningIsSet && args[0].contentCloning || !contentCloningIsSet && defaults.contentCloning,

      // same for debug
      debugIsSet = args[0] && args[0].debug !== undefined,
          debug = debugIsSet && args[0].debug || !debugIsSet && defaults.debug;

      if (this.length > 1 && (content instanceof $ || (typeof content === 'undefined' ? 'undefined' : (0, _typeof3.default)(content)) == 'object' && content != null && content.tagName) && !contentCloning && debug) {
        console.log(contentCloningWarning);
      }

      // create a tooltipster instance for each element if it doesn't
      // already have one or if the multiple option is set, and attach the
      // object to it
      this.each(function () {
        var go = false,
            $this = $(this),
            ns = $this.data('tooltipster-ns'),
            obj = null;

        if (!ns) {
          go = true;
        } else if (multiple) {
          go = true;
        } else if (debug) {
          console.log('Tooltipster: one or more tooltips are already attached to the element below. Ignoring.');
        }

        if (go) {
          obj = new $.Tooltipster(this, args[0]);

          // save the reference of the new instance
          if (!ns) ns = [];
          ns.push(obj.__namespace);
          $this.data('tooltipster-ns', ns);

          // save the instance itself
          $this.data(obj.__namespace, obj);

          // call our constructor custom function.
          // we do this here and not in ::init() because we wanted
          // the object to be saved in $this.data before triggering
          // it
          if (obj.__options.functionInit) {
            obj.__options.functionInit.call(obj, obj, {
              origin: this
            });
          }

          // and now the event, for the plugins and core emitter
          obj._trigger('init');
        }

        $.tooltipster.__instancesLatestArr.push(obj);
      });

      return this;
    }
  }
};

// Utilities

/**
 * A class to check if a tooltip can fit in given dimensions
 *
 * @param {object} $tooltip The jQuery wrapped tooltip element, or a clone of it
 */
function Ruler($tooltip) {
  // list of instance variables

  this.$container;
  this.constraints = null;
  this.__$tooltip;

  this.__init($tooltip);
}

Ruler.prototype = {
  /**
   * Move the tooltip into an invisible div that does not allow overflow to make
   * size tests. Note: the tooltip may or may not be attached to the DOM at the
   * moment this method is called, it does not matter.
   *
   * @param {object} $tooltip The object to test. May be just a clone of the
   * actual tooltip.
   * @private
   */
  __init: function __init($tooltip) {
    this.__$tooltip = $tooltip;

    this.__$tooltip.css({
      // for some reason we have to specify top and left 0
      left: 0,
      // any overflow will be ignored while measuring
      overflow: 'hidden',
      // positions at (0,0) without the div using 100% of the available width
      position: 'absolute',
      top: 0
    })
    // overflow must be auto during the test. We re-set this in case
    // it were modified by the user
    .find('.tooltipster-content').css('overflow', 'auto');

    this.$container = $('<div class="tooltipster-ruler"></div>').append(this.__$tooltip).appendTo('body');
  },

  /**
   * Force the browser to redraw (re-render) the tooltip immediately. This is required
   * when you changed some CSS properties and need to make something with it
   * immediately, without waiting for the browser to redraw at the end of instructions.
   *
   * @see http://stackoverflow.com/questions/3485365/how-can-i-force-webkit-to-redraw-repaint-to-propagate-style-changes
   * @private
   */
  __forceRedraw: function __forceRedraw() {
    // note: this would work but for Webkit only
    //this.__$tooltip.close();
    //this.__$tooltip[0].offsetHeight;
    //this.__$tooltip.open();

    // works in FF too
    var $p = this.__$tooltip.parent();
    this.__$tooltip.detach();
    this.__$tooltip.appendTo($p);
  },

  /**
   * Set maximum dimensions for the tooltip. A call to ::measure afterwards
   * will tell us if the content overflows or if it's ok
   *
   * @param {int} width
   * @param {int} height
   * @return {Ruler}
   * @public
   */
  constrain: function constrain(width, height) {
    this.constraints = {
      width: width,
      height: height
    };

    this.__$tooltip.css({
      // we disable display:flex, otherwise the content would overflow without
      // creating horizontal scrolling (which we need to detect).
      display: 'block',
      // reset any previous height
      height: '',
      // we'll check if horizontal scrolling occurs
      overflow: 'auto',
      // we'll set the width and see what height is generated and if there
      // is horizontal overflow
      width: width
    });

    return this;
  },

  /**
   * Reset the tooltip content overflow and remove the test container
   *
   * @returns {Ruler}
   * @public
   */
  destroy: function destroy() {
    // in case the element was not a clone
    this.__$tooltip.detach().find('.tooltipster-content').css({
      // reset to CSS value
      display: '',
      overflow: ''
    });

    this.$container.remove();
  },

  /**
   * Removes any constraints
   *
   * @returns {Ruler}
   * @public
   */
  free: function free() {
    this.constraints = null;

    // reset to natural size
    this.__$tooltip.css({
      display: '',
      height: '',
      overflow: 'visible',
      width: ''
    });

    return this;
  },

  /**
   * Returns the size of the tooltip. When constraints are applied, also returns
   * whether the tooltip fits in the provided dimensions.
   * The idea is to see if the new height is small enough and if the content does
   * not overflow horizontally.
   *
   * @param {int} width
   * @param {int} height
   * @returns {object} An object with a bool `fits` property and a `size` property
   * @public
   */
  measure: function measure() {
    this.__forceRedraw();

    var tooltipBcr = this.__$tooltip[0].getBoundingClientRect(),
        result = {
      size: {
        // bcr.width/height are not defined in IE8- but in this
        // case, bcr.right/bottom will have the same value
        // except in iOS 8+ where tooltipBcr.bottom/right are wrong
        // after scrolling for reasons yet to be determined
        height: tooltipBcr.height || tooltipBcr.bottom,
        width: tooltipBcr.width || tooltipBcr.right
      }
    };

    if (this.constraints) {
      // note: we used to use offsetWidth instead of boundingRectClient but
      // it returned rounded values, causing issues with sub-pixel layouts.

      // note2: noticed that the bcrWidth of text content of a div was once
      // greater than the bcrWidth of its container by 1px, causing the final
      // tooltip box to be too small for its content. However, evaluating
      // their widths one against the other (below) surprisingly returned
      // equality. Happened only once in Chrome 48, was not able to reproduce
      // => just having fun with float position values...

      var $content = this.__$tooltip.find('.tooltipster-content'),
          height = this.__$tooltip.outerHeight(),
          contentBcr = $content[0].getBoundingClientRect(),
          fits = {
        height: height <= this.constraints.height,
        width:
        // this condition accounts for min-width property that
        // may apply
        tooltipBcr.width <= this.constraints.width &&
        // the -1 is here because scrollWidth actually returns
        // a rounded value, and may be greater than bcr.width if
        // it was rounded up. This may cause an issue for contents
        // which actually really overflow  by 1px or so, but that
        // should be rare. Not sure how to solve this efficiently.
        // See http://blogs.msdn.com/b/ie/archive/2012/02/17/sub-pixel-rendering-and-the-css-object-model.aspx
        contentBcr.width >= $content[0].scrollWidth - 1
      };

      result.fits = fits.height && fits.width;
    }

    // old versions of IE get the width wrong for some reason and it causes
    // the text to be broken to a new line, so we round it up. If the width
    // is the width of the screen though, we can assume it is accurate.
    if (env.IE && env.IE <= 11 && result.size.width !== env.window.document.documentElement.clientWidth) {
      result.size.width = Math.ceil(result.size.width) + 1;
    }

    return result;
  }
};

// quick & dirty compare function, not bijective nor multidimensional
function areEqual(a, b) {
  var same = true;
  $.each(a, function (i, _) {
    if (b[i] === undefined || a[i] !== b[i]) {
      same = false;
      return false;
    }
  });
  return same;
}

/**
 * A fast function to check if an element is still in the DOM. It
 * tries to use an id as ids are indexed by the browser, or falls
 * back to jQuery's `contains` method. May fail if two elements
 * have the same id, but so be it
 *
 * @param {object} $obj A jQuery-wrapped HTML element
 * @return {boolean}
 */
function bodyContains($obj) {
  var id = $obj.attr('id'),
      el = id ? env.window.document.getElementById(id) : null;
  // must also check that the element with the id is the one we want
  return el ? el === $obj[0] : $.contains(env.window.document.body, $obj[0]);
}

// detect IE versions for dirty fixes
var uA = navigator.userAgent.toLowerCase();
if (uA.indexOf('msie') != -1) env.IE = parseInt(uA.split('msie')[1]);else if (uA.toLowerCase().indexOf('trident') !== -1 && uA.indexOf(' rv:11') !== -1) env.IE = 11;else if (uA.toLowerCase().indexOf('edge/') != -1) env.IE = parseInt(uA.toLowerCase().split('edge/')[1]);

// detecting support for CSS transitions
function transitionSupport() {
  // env.window is not defined yet when this is called
  if (!win) return false;

  var b = win.document.body || win.document.documentElement,
      s = b.style,
      p = 'transition',
      v = ['Moz', 'Webkit', 'Khtml', 'O', 'ms'];

  if (typeof s[p] == 'string') {
    return true;
  }

  p = p.charAt(0).toUpperCase() + p.substr(1);
  for (var i = 0; i < v.length; i++) {
    if (typeof s[v[i] + p] == 'string') {
      return true;
    }
  }
  return false;
}

// we'll return jQuery for plugins not to have to declare it as a dependency,
// but it's done by a build task since it should be included only once at the
// end when we concatenate the core file with a plugin
// sideTip is Tooltipster's default plugin.
// This file will be UMDified by a build task.

var pluginName = 'tooltipster.sideTip';

$.tooltipster._plugin({
  name: pluginName,
  instance: {
    /**
     * Defaults are provided as a function for an easy override by inheritance
     *
     * @return {object} An object with the defaults options
     * @private
     */
    __defaults: function __defaults() {
      return {
        // if the tooltip should display an arrow that points to the origin
        arrow: true,
        // the distance in pixels between the tooltip and the origin
        distance: 6,
        // allows to easily change the position of the tooltip
        functionPosition: null,
        maxWidth: null,
        // used to accomodate the arrow of tooltip if there is one.
        // First to make sure that the arrow target is not too close
        // to the edge of the tooltip, so the arrow does not overflow
        // the tooltip. Secondly when we reposition the tooltip to
        // make sure that it's positioned in such a way that the arrow is
        // still pointing at the target (and not a few pixels beyond it).
        // It should be equal to or greater than half the width of
        // the arrow (by width we mean the size of the side which touches
        // the side of the tooltip).
        minIntersection: 16,
        minWidth: 0,
        // deprecated in 4.0.0. Listed for _optionsExtract to pick it up
        position: null,
        side: 'top',
        // set to false to position the tooltip relatively to the document rather
        // than the window when we open it
        viewportAware: true
      };
    },

    /**
     * Run once: at instantiation of the plugin
     *
     * @param {object} instance The tooltipster object that instantiated this plugin
     * @private
     */
    __init: function __init(instance) {
      var self = this;

      // list of instance variables

      self.__instance = instance;
      self.__namespace = 'tooltipster-sideTip-' + Math.round(Math.random() * 1000000);
      self.__previousState = 'closed';
      self.__options;

      // initial formatting
      self.__optionsFormat();

      self.__instance._on('state.' + self.__namespace, function (event) {
        if (event.state == 'closed') {
          self.__close();
        } else if (event.state == 'appearing' && self.__previousState == 'closed') {
          self.__create();
        }

        self.__previousState = event.state;
      });

      // reformat every time the options are changed
      self.__instance._on('options.' + self.__namespace, function () {
        self.__optionsFormat();
      });

      self.__instance._on('reposition.' + self.__namespace, function (e) {
        self.__reposition(e.event, e.helper);
      });
    },

    /**
     * Called when the tooltip has closed
     *
     * @private
     */
    __close: function __close() {
      // detach our content object first, so the next jQuery's remove()
      // call does not unbind its event handlers
      if (this.__instance.content() instanceof $) {
        this.__instance.content().detach();
      }

      // remove the tooltip from the DOM
      this.__instance._$tooltip.remove();
      this.__instance._$tooltip = null;
    },

    /**
     * Creates the HTML element of the tooltip.
     *
     * @private
     */
    __create: function __create() {
      // note: we wrap with a .tooltipster-box div to be able to set a margin on it
      // (.tooltipster-base must not have one)
      var $html = $('<div class="tooltipster-base tooltipster-sidetip">' + '<div class="tooltipster-box">' + '<div class="tooltipster-content"></div>' + '</div>' + '<div class="tooltipster-arrow">' + '<div class="tooltipster-arrow-uncropped">' + '<div class="tooltipster-arrow-border"></div>' + '<div class="tooltipster-arrow-background"></div>' + '</div>' + '</div>' + '</div>');

      // hide arrow if asked
      if (!this.__options.arrow) {
        $html.find('.tooltipster-box').css('margin', 0).end().find('.tooltipster-arrow').hide();
      }

      // apply min/max width if asked
      if (this.__options.minWidth) {
        $html.css('min-width', this.__options.minWidth + 'px');
      }
      if (this.__options.maxWidth) {
        $html.css('max-width', this.__options.maxWidth + 'px');
      }

      this.__instance._$tooltip = $html;

      // tell the instance that the tooltip element has been created
      this.__instance._trigger('created');
    },

    /**
     * Used when the plugin is to be unplugged
     *
     * @private
     */
    __destroy: function __destroy() {
      this.__instance._off('.' + self.__namespace);
    },

    /**
     * (Re)compute this.__options from the options declared to the instance
     *
     * @private
     */
    __optionsFormat: function __optionsFormat() {
      var self = this;

      // get the options
      self.__options = self.__instance._optionsExtract(pluginName, self.__defaults());

      // for backward compatibility, deprecated in v4.0.0
      if (self.__options.position) {
        self.__options.side = self.__options.position;
      }

      // options formatting

      // format distance as a four-cell array if it ain't one yet and then make
      // it an object with top/bottom/left/right properties
      if ((0, _typeof3.default)(self.__options.distance) != 'object') {
        self.__options.distance = [self.__options.distance];
      }
      if (self.__options.distance.length < 4) {
        if (self.__options.distance[1] === undefined) self.__options.distance[1] = self.__options.distance[0];
        if (self.__options.distance[2] === undefined) self.__options.distance[2] = self.__options.distance[0];
        if (self.__options.distance[3] === undefined) self.__options.distance[3] = self.__options.distance[1];

        self.__options.distance = {
          top: self.__options.distance[0],
          right: self.__options.distance[1],
          bottom: self.__options.distance[2],
          left: self.__options.distance[3]
        };
      }

      // let's transform:
      // 'top' into ['top', 'bottom', 'right', 'left']
      // 'right' into ['right', 'left', 'top', 'bottom']
      // 'bottom' into ['bottom', 'top', 'right', 'left']
      // 'left' into ['left', 'right', 'top', 'bottom']
      if (typeof self.__options.side == 'string') {
        var opposites = {
          top: 'bottom',
          right: 'left',
          bottom: 'top',
          left: 'right'
        };

        self.__options.side = [self.__options.side, opposites[self.__options.side]];

        if (self.__options.side[0] == 'left' || self.__options.side[0] == 'right') {
          self.__options.side.push('top', 'bottom');
        } else {
          self.__options.side.push('right', 'left');
        }
      }

      // misc
      // disable the arrow in IE6 unless the arrow option was explicitly set to true
      if ($.tooltipster._env.IE === 6 && self.__options.arrow !== true) {
        self.__options.arrow = false;
      }
    },

    /**
     * This method must compute and set the positioning properties of the
     * tooltip (left, top, width, height, etc.). It must also make sure the
     * tooltip is eventually appended to its parent (since the element may be
     * detached from the DOM at the moment the method is called).
     *
     * We'll evaluate positioning scenarios to find which side can contain the
     * tooltip in the best way. We'll consider things relatively to the window
     * (unless the user asks not to), then to the document (if need be, or if the
     * user explicitly requires the tests to run on the document). For each
     * scenario, measures are taken, allowing us to know how well the tooltip
     * is going to fit. After that, a sorting function will let us know what
     * the best scenario is (we also allow the user to choose his favorite
     * scenario by using an event).
     *
     * @param {object} helper An object that contains variables that plugin
     * creators may find useful (see below)
     * @param {object} helper.geo An object with many layout properties
     * about objects of interest (window, document, origin). This should help
     * plugin users compute the optimal position of the tooltip
     * @private
     */
    __reposition: function __reposition(event, helper) {
      var self = this,
          finalResult = void 0,

      // to know where to put the tooltip, we need to know on which point
      // of the x or y axis we should center it. That coordinate is the target
      targets = self.__targetFind(helper),
          testResults = [];

      // make sure the tooltip is detached while we make tests on a clone
      self.__instance._$tooltip.detach();

      // we could actually provide the original element to the Ruler and
      // not a clone, but it just feels right to keep it out of the
      // machinery.
      var $clone = self.__instance._$tooltip.clone(),

      // start position tests session
      ruler = $.tooltipster._getRuler($clone),
          satisfied = false,
          animation = self.__instance.option('animation');

      // an animation class could contain properties that distort the size
      if (animation) {
        $clone.removeClass('tooltipster-' + animation);
      }

      // start evaluating scenarios
      $.each(['window', 'document'], function (i, container) {
        var _takeTest = null;

        // let the user decide to keep on testing or not
        self.__instance._trigger({
          container: container,
          helper: helper,
          satisfied: satisfied,
          takeTest: function takeTest(bool) {
            _takeTest = bool;
          },
          results: testResults,
          type: 'positionTest'
        });

        if (_takeTest == true || _takeTest != false && satisfied == false && (
        // skip the window scenarios if asked. If they are reintegrated by
        // the callback of the positionTest event, they will have to be
        // excluded using the callback of positionTested
        container != 'window' || self.__options.viewportAware)) {
          // for each allowed side
          for (var i = 0; i < self.__options.side.length; i++) {
            var distance = {
              horizontal: 0,
              vertical: 0
            },
                side = self.__options.side[i];

            if (side == 'top' || side == 'bottom') {
              distance.vertical = self.__options.distance[side];
            } else {
              distance.horizontal = self.__options.distance[side];
            }

            // this may have an effect on the size of the tooltip if there are css
            // rules for the arrow or something else
            self.__sideChange($clone, side);

            $.each(['natural', 'constrained'], function (i, mode) {
              _takeTest = null;

              // emit an event on the instance
              self.__instance._trigger({
                container: container,
                event: event,
                helper: helper,
                mode: mode,
                results: testResults,
                satisfied: satisfied,
                side: side,
                takeTest: function takeTest(bool) {
                  _takeTest = bool;
                },
                type: 'positionTest'
              });

              if (_takeTest == true || _takeTest != false && satisfied == false) {
                var testResult = {
                  container: container,
                  // we let the distance as an object here, it can make things a little easier
                  // during the user's calculations at positionTest/positionTested
                  distance: distance,
                  // whether the tooltip can fit in the size of the viewport (does not mean
                  // that we'll be able to make it initially entirely visible, see 'whole')
                  fits: null,
                  mode: mode,
                  outerSize: null,
                  side: side,
                  size: null,
                  target: targets[side],
                  // check if the origin has enough surface on screen for the tooltip to
                  // aim at it without overflowing the viewport (this is due to the thickness
                  // of the arrow represented by the minIntersection length).
                  // If not, the tooltip will have to be partly or entirely off screen in
                  // order to stay docked to the origin. This value will stay null when the
                  // container is the document, as it is not relevant
                  whole: null
                };

                // get the size of the tooltip with or without size constraints
                var rulerConfigured = mode == 'natural' ? ruler.free() : ruler.constrain(helper.geo.available[container][side].width - distance.horizontal, helper.geo.available[container][side].height - distance.vertical),
                    rulerResults = rulerConfigured.measure();

                testResult.size = rulerResults.size;
                testResult.outerSize = {
                  height: rulerResults.size.height + distance.vertical,
                  width: rulerResults.size.width + distance.horizontal
                };

                if (mode == 'natural') {
                  if (helper.geo.available[container][side].width >= testResult.outerSize.width && helper.geo.available[container][side].height >= testResult.outerSize.height) {
                    testResult.fits = true;
                  } else {
                    testResult.fits = false;
                  }
                } else {
                  testResult.fits = rulerResults.fits;
                }

                if (container == 'window') {
                  if (!testResult.fits) {
                    testResult.whole = false;
                  } else if (side == 'top' || side == 'bottom') {
                    testResult.whole = helper.geo.origin.windowOffset.right >= self.__options.minIntersection && helper.geo.window.size.width - helper.geo.origin.windowOffset.left >= self.__options.minIntersection;
                  } else {
                    testResult.whole = helper.geo.origin.windowOffset.bottom >= self.__options.minIntersection && helper.geo.window.size.height - helper.geo.origin.windowOffset.top >= self.__options.minIntersection;
                  }
                }

                testResults.push(testResult);

                // we don't need to compute more positions if we have one fully on screen
                if (testResult.whole) {
                  satisfied = true;
                } else {
                  // don't run the constrained test unless the natural width was greater
                  // than the available width, otherwise it's pointless as we know it
                  // wouldn't fit either
                  if (testResult.mode == 'natural' && (testResult.fits || testResult.size.width <= helper.geo.available[container][side].width)) {
                    return false;
                  }
                }
              }
            });
          }
        }
      });

      // the user may eliminate the unwanted scenarios from testResults, but he's
      // not supposed to alter them at this point. functionPosition and the
      // position event serve that purpose.
      self.__instance._trigger({
        edit: function edit(r) {
          testResults = r;
        },
        event: event,
        helper: helper,
        results: testResults,
        type: 'positionTested'
      });

      /**
       * Sort the scenarios to find the favorite one.
       *
       * The favorite scenario is when we can fully display the tooltip on screen,
       * even if it means that the middle of the tooltip is no longer centered on
       * the middle of the origin (when the origin is near the edge of the screen
       * or even partly off screen). We want the tooltip on the preferred side,
       * even if it means that we have to use a constrained size rather than a
       * natural one (as long as it fits). When the origin is off screen at the top
       * the tooltip will be positioned at the bottom (if allowed), if the origin
       * is off screen on the right, it will be positioned on the left, etc.
       * If there are no scenarios where the tooltip can fit on screen, or if the
       * user does not want the tooltip to fit on screen (viewportAware == false),
       * we fall back to the scenarios relative to the document.
       *
       * When the tooltip is bigger than the viewport in either dimension, we stop
       * looking at the window scenarios and consider the document scenarios only,
       * with the same logic to find on which side it would fit best.
       *
       * If the tooltip cannot fit the document on any side, we force it at the
       * bottom, so at least the user can scroll to see it.
       */
      testResults.sort(function (a, b) {
        // best if it's whole (the tooltip fits and adapts to the viewport)
        if (a.whole && !b.whole) {
          return -1;
        } else if (!a.whole && b.whole) {
          return 1;
        } else if (a.whole && b.whole) {
          var ai = self.__options.side.indexOf(a.side),
              bi = self.__options.side.indexOf(b.side);

          // use the user's sides fallback array
          if (ai < bi) {
            return -1;
          } else if (ai > bi) {
            return 1;
          } else {
            // will be used if the user forced the tests to continue
            return a.mode == 'natural' ? -1 : 1;
          }
        } else {
          // better if it fits
          if (a.fits && !b.fits) {
            return -1;
          } else if (!a.fits && b.fits) {
            return 1;
          } else if (a.fits && b.fits) {
            var ai = self.__options.side.indexOf(a.side),
                bi = self.__options.side.indexOf(b.side);

            // use the user's sides fallback array
            if (ai < bi) {
              return -1;
            } else if (ai > bi) {
              return 1;
            } else {
              // will be used if the user forced the tests to continue
              return a.mode == 'natural' ? -1 : 1;
            }
          } else {
            // if everything failed, this will give a preference to the case where
            // the tooltip overflows the document at the bottom
            if (a.container == 'document' && a.side == 'bottom' && a.mode == 'natural') {
              return -1;
            } else {
              return 1;
            }
          }
        }
      });

      finalResult = testResults[0];

      // now let's find the coordinates of the tooltip relatively to the window
      finalResult.coord = {};

      switch (finalResult.side) {
        case 'left':
        case 'right':
          finalResult.coord.top = Math.floor(finalResult.target - finalResult.size.height / 2);
          break;

        case 'bottom':
        case 'top':
          finalResult.coord.left = Math.floor(finalResult.target - finalResult.size.width / 2);
          break;
      }

      switch (finalResult.side) {
        case 'left':
          finalResult.coord.left = helper.geo.origin.windowOffset.left - finalResult.outerSize.width;
          break;

        case 'right':
          finalResult.coord.left = helper.geo.origin.windowOffset.right + finalResult.distance.horizontal;
          break;

        case 'top':
          finalResult.coord.top = helper.geo.origin.windowOffset.top - finalResult.outerSize.height;
          break;

        case 'bottom':
          finalResult.coord.top = helper.geo.origin.windowOffset.bottom + finalResult.distance.vertical;
          break;
      }

      // if the tooltip can potentially be contained within the viewport dimensions
      // and that we are asked to make it fit on screen
      if (finalResult.container == 'window') {
        // if the tooltip overflows the viewport, we'll move it accordingly (then it will
        // not be centered on the middle of the origin anymore). We only move horizontally
        // for top and bottom tooltips and vice versa.
        if (finalResult.side == 'top' || finalResult.side == 'bottom') {
          // if there is an overflow on the left
          if (finalResult.coord.left < 0) {
            // prevent the overflow unless the origin itself gets off screen (minus the
            // margin needed to keep the arrow pointing at the target)
            if (helper.geo.origin.windowOffset.right - this.__options.minIntersection >= 0) {
              finalResult.coord.left = 0;
            } else {
              finalResult.coord.left = helper.geo.origin.windowOffset.right - this.__options.minIntersection - 1;
            }
          } else if (finalResult.coord.left > helper.geo.window.size.width - finalResult.size.width) {
            // or an overflow on the right
            if (helper.geo.origin.windowOffset.left + this.__options.minIntersection <= helper.geo.window.size.width) {
              finalResult.coord.left = helper.geo.window.size.width - finalResult.size.width;
            } else {
              finalResult.coord.left = helper.geo.origin.windowOffset.left + this.__options.minIntersection + 1 - finalResult.size.width;
            }
          }
        } else {
          // overflow at the top
          if (finalResult.coord.top < 0) {
            if (helper.geo.origin.windowOffset.bottom - this.__options.minIntersection >= 0) {
              finalResult.coord.top = 0;
            } else {
              finalResult.coord.top = helper.geo.origin.windowOffset.bottom - this.__options.minIntersection - 1;
            }
          } else if (finalResult.coord.top > helper.geo.window.size.height - finalResult.size.height) {
            // or at the bottom
            if (helper.geo.origin.windowOffset.top + this.__options.minIntersection <= helper.geo.window.size.height) {
              finalResult.coord.top = helper.geo.window.size.height - finalResult.size.height;
            } else {
              finalResult.coord.top = helper.geo.origin.windowOffset.top + this.__options.minIntersection + 1 - finalResult.size.height;
            }
          }
        }
      } else {
        // there might be overflow here too but it's easier to handle. If there has
        // to be an overflow, we'll make sure it's on the right side of the screen
        // (because the browser will extend the document size if there is an overflow
        // on the right, but not on the left). The sort function above has already
        // made sure that a bottom document overflow is preferred to a top overflow,
        // so we don't have to care about it.

        // if there is an overflow on the right
        if (finalResult.coord.left > helper.geo.window.size.width - finalResult.size.width) {
          // this may actually create on overflow on the left but we'll fix it in a sec
          finalResult.coord.left = helper.geo.window.size.width - finalResult.size.width;
        }

        // if there is an overflow on the left
        if (finalResult.coord.left < 0) {
          // don't care if it overflows the right after that, we made our best
          finalResult.coord.left = 0;
        }
      }

      // submit the positioning proposal to the user function which may choose to change
      // the side, size and/or the coordinates

      // first, set the rules that corresponds to the proposed side: it may change
      // the size of the tooltip, and the custom functionPosition may want to detect the
      // size of something before making a decision. So let's make things easier for the
      // implementor
      self.__sideChange($clone, finalResult.side);

      // add some variables to the helper
      helper.tooltipClone = $clone[0];
      helper.tooltipParent = self.__instance.option('parent').parent[0];
      // move informative values to the helper
      helper.mode = finalResult.mode;
      helper.whole = finalResult.whole;
      // add some variables to the helper for the functionPosition callback (these
      // will also be added to the event fired by self.__instance._trigger but that's
      // ok, we're just being consistent)
      helper.origin = self.__instance._$origin[0];
      helper.tooltip = self.__instance._$tooltip[0];

      // leave only the actionable values in there for functionPosition
      delete finalResult.container;
      delete finalResult.fits;
      delete finalResult.mode;
      delete finalResult.outerSize;
      delete finalResult.whole;

      // keep only the distance on the relevant side, for clarity
      finalResult.distance = finalResult.distance.horizontal || finalResult.distance.vertical;

      // beginners may not be comfortable with the concept of editing the object
      //  passed by reference, so we provide an edit function and pass a clone
      var finalResultClone = $.extend(true, {}, finalResult);

      // emit an event on the instance
      self.__instance._trigger({
        edit: function edit(result) {
          finalResult = result;
        },
        event: event,
        helper: helper,
        position: finalResultClone,
        type: 'position'
      });

      if (self.__options.functionPosition) {
        var result = self.__options.functionPosition.call(self, self.__instance, helper, finalResultClone);

        if (result) finalResult = result;
      }

      // end the positioning tests session (the user might have had a
      // use for it during the position event, now it's over)
      ruler.destroy();

      // compute the position of the target relatively to the tooltip root
      // element so we can place the arrow and make the needed adjustments
      var arrowCoord = void 0,
          maxVal = void 0;

      if (finalResult.side == 'top' || finalResult.side == 'bottom') {
        arrowCoord = {
          prop: 'left',
          val: finalResult.target - finalResult.coord.left
        };
        maxVal = finalResult.size.width - this.__options.minIntersection;
      } else {
        arrowCoord = {
          prop: 'top',
          val: finalResult.target - finalResult.coord.top
        };
        maxVal = finalResult.size.height - this.__options.minIntersection;
      }

      // cannot lie beyond the boundaries of the tooltip, minus the
      // arrow margin
      if (arrowCoord.val < this.__options.minIntersection) {
        arrowCoord.val = this.__options.minIntersection;
      } else if (arrowCoord.val > maxVal) {
        arrowCoord.val = maxVal;
      }

      var originParentOffset = void 0;

      // let's convert the window-relative coordinates into coordinates relative to the
      // future positioned parent that the tooltip will be appended to
      if (helper.geo.origin.fixedLineage) {
        // same as windowOffset when the position is fixed
        originParentOffset = helper.geo.origin.windowOffset;
      } else {
        // this assumes that the parent of the tooltip is located at
        // (0, 0) in the document, typically like when the parent is
        // <body>.
        // If we ever allow other types of parent, .tooltipster-ruler
        // will have to be appended to the parent to inherit css style
        // values that affect the display of the text and such.
        originParentOffset = {
          left: helper.geo.origin.windowOffset.left + helper.geo.window.scroll.left,
          top: helper.geo.origin.windowOffset.top + helper.geo.window.scroll.top
        };
      }

      finalResult.coord = {
        left: originParentOffset.left + (finalResult.coord.left - helper.geo.origin.windowOffset.left),
        top: originParentOffset.top + (finalResult.coord.top - helper.geo.origin.windowOffset.top)
      };

      // set position values on the original tooltip element

      self.__sideChange(self.__instance._$tooltip, finalResult.side);

      if (helper.geo.origin.fixedLineage) {
        self.__instance._$tooltip.css('position', 'fixed');
      } else {
        // CSS default
        self.__instance._$tooltip.css('position', '');
      }

      self.__instance._$tooltip.css({
        left: finalResult.coord.left,
        top: finalResult.coord.top,
        // we need to set a size even if the tooltip is in its natural size
        // because when the tooltip is positioned beyond the width of the body
        // (which is by default the width of the window; it will happen when
        // you scroll the window horizontally to get to the origin), its text
        // content will otherwise break lines at each word to keep up with the
        // body overflow strategy.
        height: finalResult.size.height,
        width: finalResult.size.width
      }).find('.tooltipster-arrow').css({
        left: '',
        top: ''
      }).css(arrowCoord.prop, arrowCoord.val);

      // append the tooltip HTML element to its parent
      self.__instance._$tooltip.appendTo(self.__instance.option('parent'));

      self.__instance._trigger({
        type: 'repositioned',
        event: event,
        position: finalResult
      });
    },

    /**
     * Make whatever modifications are needed when the side is changed. This has
     * been made an independant method for easy inheritance in custom plugins based
     * on this default plugin.
     *
     * @param {object} $obj
     * @param {string} side
     * @private
     */
    __sideChange: function __sideChange($obj, side) {
      $obj.removeClass('tooltipster-bottom').removeClass('tooltipster-left').removeClass('tooltipster-right').removeClass('tooltipster-top').addClass('tooltipster-' + side);
    },

    /**
     * Returns the target that the tooltip should aim at for a given side.
     * The calculated value is a distance from the edge of the window
     * (left edge for top/bottom sides, top edge for left/right side). The
     * tooltip will be centered on that position and the arrow will be
     * positioned there (as much as possible).
     *
     * @param {object} helper
     * @return {integer}
     * @private
     */
    __targetFind: function __targetFind(helper) {
      var target = {},
          rects = this.__instance._$origin[0].getClientRects();

      // these lines fix a Chrome bug (issue #491)
      if (rects.length > 1) {
        var opacity = this.__instance._$origin.css('opacity');
        if (opacity == 1) {
          this.__instance._$origin.css('opacity', 0.99);
          rects = this.__instance._$origin[0].getClientRects();
          this.__instance._$origin.css('opacity', 1);
        }
      }

      // by default, the target will be the middle of the origin
      if (rects.length < 2) {
        target.top = Math.floor(helper.geo.origin.windowOffset.left + helper.geo.origin.size.width / 2);
        target.bottom = target.top;

        target.left = Math.floor(helper.geo.origin.windowOffset.top + helper.geo.origin.size.height / 2);
        target.right = target.left;
      } else {
        // if multiple client rects exist, the element may be text split
        // up into multiple lines and the middle of the origin may not be
        // best option anymore. We need to choose the best target client rect
        // top: the first
        var targetRect = rects[0];
        target.top = Math.floor(targetRect.left + (targetRect.right - targetRect.left) / 2);

        // right: the middle line, rounded down in case there is an even
        // number of lines (looks more centered => check out the
        // demo with 4 split lines)
        if (rects.length > 2) {
          targetRect = rects[Math.ceil(rects.length / 2) - 1];
        } else {
          targetRect = rects[0];
        }
        target.right = Math.floor(targetRect.top + (targetRect.bottom - targetRect.top) / 2);

        // bottom: the last
        targetRect = rects[rects.length - 1];
        target.bottom = Math.floor(targetRect.left + (targetRect.right - targetRect.left) / 2);

        // left: the middle line, rounded up
        if (rects.length > 2) {
          targetRect = rects[Math.ceil((rects.length + 1) / 2) - 1];
        } else {
          targetRect = rects[rects.length - 1];
        }

        target.left = Math.floor(targetRect.top + (targetRect.bottom - targetRect.top) / 2);
      }

      return target;
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */,
/* 233 */,
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(235);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var _reactDom = __webpack_require__(5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DashboardStore = __webpack_require__(100);

var _DashboardStore2 = _interopRequireDefault(_DashboardStore);

var _mobxReact = __webpack_require__(13);

__webpack_require__(99);

var _DashBoard = __webpack_require__(206);

var _DashBoard2 = _interopRequireDefault(_DashBoard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.Promise = window.Promise || __webpack_require__(98);
//如果需要动态根据路由打包js，请用这种方式——注意：不要为了偷懒把这个方法简化，变成传路径，经验告诉你，不生效！！！！
// const DashBoard = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./containers/DashBoard'));
//   }, 'dashboard') ; 
// };
//如果不需要动态加载用下面的，但注意route得相应改成component={}

window.tms = {
  'moduleinfo': {
    'id': 1181572,
    'firstCartExplain': '此处为满减前价格，具体优惠金额以加入购物车结算时为准',
    'mainTitle': '购买产品种类越多，越享更低折扣，新年套餐5种产品，低至8折',
    'fristFloor': '交易类网站场景',
    'firstTips': '【我的专享活动】联系您的专属客户经理领取【优惠码】，还可享受多种云产品满减，立即前往',
    'firstJumpTips': '冬日满减分会场>>',
    'firstJumpUrl': 'https://promotion.aliyun.com/ntms/act/dec-sales.html',
    'firstTitle': '解决业务痛点',
    'h5FirstCombo': '',
    'h5FirstProduct': '5',
    'h5FirstDiscount': '8',
    'firstRule': {
      'one': {
        'leftPrice': '0',
        'rightText': '再多选1种，可享受95折，最高可满减2500元'
      },
      'two': {
        'leftPrice': '2500',
        'rightText': '再多选1种，可享受9折，最高可满减5000元'
      },
      'three': {
        'leftPrice': '5000',
        'rightText': '再多选1种，可享受8.5折，最高可满减7500元'
      },
      'four': {
        'leftPrice': '7500',
        'rightText': '再多选1种，可享受8折，最高可满减10000元'
      },
      'five': {
        'leftPrice': '10000',
        'rightText': '您已享受最高档优惠，立即加入购物车结算吧'
      }
    }
  },
  'firstDescListLeft': [{ 'descLeft': '网站动态交互多，需优化访问体验' }, { 'descLeft': '活动时段并发量高，应用服务器和数据库负载压力大' }, { 'descLeft': '交易订单量突增，数据库读写并发量大' }],
  'firstDescListRight': [{ 'descRight': '交易支付场景验证码，短信使用量大，稳定性要求高' }, { 'descRight': '需要满足低时延、稳定的用户营销触达' }],
  'firstDiscountsExplainList': [{ 'discount': '页面勾选多款产品，加入购物车，结算时即享满减优惠' }, { 'discount': '购买套餐中2-5种产品，订单金额每满2000，可减100-400，最高满减10000元' }, { 'discount': '四档满减，同一用户最多可享受4档，每档1次' }]

};
var store = {
  dashboardStore: _DashboardStore2.default
};
(0, _reactDom.render)(_react2.default.createElement(
  _mobxReact.Provider,
  store,
  _react2.default.createElement(_DashBoard2.default, null)
), document.getElementById('stage'));

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scripts/index.js